const area_city = ["宜蘭縣", "花蓮縣", "台東縣", "基隆市", "台北市", "新北市", "桃園市", "新竹市", "新竹縣", "苗栗縣", "雲林縣", "嘉義市", "嘉義縣", "台南市", "高雄市", "屏東縣", "澎湖縣", "金門縣", "台中市", "彰化縣", "南投縣", ];
const area_district = [["宜蘭市", "頭城鎮", "礁溪鄉", "壯圍鄉", "員山鄉", "羅東鎮", "三星鄉", "大同鄉", "五結鄉", "冬山鄉", "蘇澳鎮", "南澳鄉", ], ["花蓮市", "新城鄉", "秀林鄉", "吉安鄉", "壽豐鄉", "光復鄉", "瑞穗鄉", "玉里鎮", ], ["台東市", "綠島鄉", "卑南鄉", "鹿野鄉", "關山鎮", "池上鄉", "成功鎮", "太麻里鄉", "達仁鄉", ], ["仁愛區", "信義區", "中正區", "中山區", "安樂區", "暖暖區", "七堵區", ], ["中正區", "大同區", "中山區", "松山區", "大安區", "萬華區", "信義區", "士林區", "北投區", "內湖區", "南港區", "文山區", ], ["萬里區", "金山區", "板橋區", "汐止區", "深坑區", "石碇區", "瑞芳區", "平溪區", "貢寮區", "新店區", "坪林區", "烏來區", "永和區", "中和區", "土城區", "三峽區", "樹林區", "鶯歌區", "三重區", "新莊區", "泰山區", "林口區", "蘆洲區", "五股區", "八里區", "淡水區", "三芝區", "石門區", ], ["中壢區", "平鎮區", "龍潭區", "楊梅區", "新屋區", "觀音區", "桃園區", "龜山區", "八德區", "大溪區", "大園區", "蘆竹區", ], ["北區", "東區", "香山區", ], ["竹北市", "湖口鄉", "新豐鄉", "新埔鎮", "關西鎮", "芎林鄉", "竹東鎮", "橫山鄉", ], ["竹南鎮", "頭份市", "南庄鄉", "獅潭鄉", "後龍鎮", "通霄鎮", "苑裡鎮", "苗栗市", "造橋鄉", "頭屋鄉", "公館鄉", "大湖鄉", "銅鑼鄉", "卓蘭鎮", ], ["斗南鎮", "大埤鄉", "虎尾鎮", "土庫鎮", "褒忠鄉", "東勢鄉", "台西鄉", "崙背鄉", "麥寮鄉", "斗六市", "林內鄉", "古坑鄉", "莿桐鄉", "西螺鎮", "二崙鄉", "北港鎮", "水林鄉", "元長鄉", ], ["西區", "東區", ], ["番路鄉", "梅山鄉", "竹崎鄉", "中埔鄉", "水上鄉", "鹿草鄉", "太保市", "朴子市", "東石鄉", "六腳鄉", "新港鄉", "民雄鄉", "大林鎮", "布袋鎮", ], ["中西區", "東區", "南區", "北區", "安平區", "安南區", "永康區", "歸仁區", "新化區", "玉井區", "仁德區", "關廟區", "官田區", "麻豆區", "佳里區", "西港區", "學甲區", "新營區", "後壁區", "白河區", "六甲區", "下營區", "柳營區", "鹽水區", "善化區", "新市區", "安定區", ], ["新興區", "前金區", "苓雅區", "鹽埕區", "鼓山區", "前鎮區", "三民區", "楠梓區", "小港區", "左營區", "仁武區", "大社區", "岡山區", "路竹區", "阿蓮區", "燕巢區", "橋頭區", "梓官區", "彌陀區", "永安區", "湖內區", "鳳山區", "大寮區", "林園區", "鳥松區", "大樹區", "旗山區", "美濃區", "六龜區", "杉林區", "茄萣區", ], ["屏東市", "九如鄉", "里港鄉", "高樹鄉", "鹽埔鄉", "長治鄉", "麟洛鄉", "竹田鄉", "內埔鄉", "萬丹鄉", "潮州鎮", "萬巒鄉", "崁頂鄉", "新埤鄉", "南州鄉", "林邊鄉", "東港鎮", "琉球鄉", "佳冬鄉", "新園鄉", "枋寮鄉", "枋山鄉", "獅子鄉", "車城鄉", "恆春鎮", ], ["馬公市", "西嶼鄉", "望安鄉", "七美鄉", "白沙鄉", "湖西鄉", ], [], ["中區", "東區", "南區", "西區", "北區", "北屯區", "西屯區", "南屯區", "太平區", "大里區", "霧峰區", "烏日區", "豐原區", "后里區", "石岡區", "東勢區", "和平區", "新社區", "潭子區", "大雅區", "神岡區", "大肚區", "沙鹿區", "龍井區", "梧棲區", "清水區", "大甲區", "外埔區", "大安區", ], ["彰化市", "芬園鄉", "花壇鄉", "秀水鄉", "鹿港鎮", "福興鄉", "線西鄉", "和美鎮", "伸港鄉", "員林市", "社頭鄉", "永靖鄉", "埔心鄉", "溪湖鎮", "大村鄉", "田中鎮", "北斗鎮", "田尾鄉", "埤頭鄉", "溪州鄉", "二林鎮", "大城鄉", "芳苑鄉", ], ["南投市", "中寮鄉", "草屯鎮", "國姓鄉", "埔里鎮", "仁愛鄉", "名間鄉", "集集鎮", "魚池鄉", "竹山鎮", "鹿谷鄉", ], ];
const area_store = [[[{
    "name": "全家宜蘭大福店",
    "addr": "宜蘭縣宜蘭市大福路一段43號，45號",
    "pkey": "011935",
    "tel": "03-9301476"
}, {
    "name": "全家宜蘭學府店",
    "addr": "宜蘭縣宜蘭市女中路三段239號一樓",
    "pkey": "015803",
    "tel": "03-9359495"
}, {
    "name": "全家宜蘭中山店",
    "addr": "宜蘭縣宜蘭市中山路三段210號一樓",
    "pkey": "017064",
    "tel": "03-9312463"
}, {
    "name": "全家宜蘭南館店",
    "addr": "宜蘭縣宜蘭市中山路三段20、22號1樓",
    "pkey": "017252",
    "tel": "03-9367350"
}, {
    "name": "全家宜蘭新吳沙店",
    "addr": "宜蘭縣宜蘭市中山路五段81號一樓",
    "pkey": "014691",
    "tel": "03-9289296"
}, {
    "name": "全家宜蘭凱旋店",
    "addr": "宜蘭縣宜蘭市公園路1號",
    "pkey": "017176",
    "tel": "03-9255043"
}, {
    "name": "全家宜蘭文昌店",
    "addr": "宜蘭縣宜蘭市文昌路120號",
    "pkey": "015317",
    "tel": "03-9356428"
}, {
    "name": "全家宜蘭民族店",
    "addr": "宜蘭縣宜蘭市民族路281號一樓",
    "pkey": "017526",
    "tel": "03-9334306"
}, {
    "name": "全家宜蘭延平店",
    "addr": "宜蘭縣宜蘭市延平路38之40號1樓",
    "pkey": "017214",
    "tel": "03-9373841"
}, {
    "name": "全家宜蘭東港店",
    "addr": "宜蘭縣宜蘭市東港路84號、86號一樓",
    "pkey": "017107",
    "tel": "03-9373859"
}, {
    "name": "全家宜蘭進士店",
    "addr": "宜蘭縣宜蘭市南橋路427號",
    "pkey": "013577",
    "tel": "03-9253745"
}, {
    "name": "全家宜蘭陽大店",
    "addr": "宜蘭縣宜蘭市校舍路169號B1",
    "pkey": "016307",
    "tel": "03-9385194"
}, {
    "name": "全家宜蘭福泰店",
    "addr": "宜蘭縣宜蘭市泰山路83號",
    "pkey": "017253",
    "tel": "03-9324868"
}, {
    "name": "全家宜蘭新泰山店",
    "addr": "宜蘭縣宜蘭市泰山路535號1樓",
    "pkey": "017924",
    "tel": "03-9313137"
}, {
    "name": "全家宜蘭神農店",
    "addr": "宜蘭縣宜蘭市神農路一段102號；農權路257，25",
    "pkey": "017715",
    "tel": "03-9313478"
}, {
    "name": "全家宜蘭嵐峰店",
    "addr": "宜蘭縣宜蘭市嵐峰路一段110號1樓",
    "pkey": "016765",
    "tel": "03-9326479"
}, {
    "name": "全家宜蘭陽明店",
    "addr": "宜蘭縣宜蘭市新民路148號",
    "pkey": "015110",
    "tel": "03-9324729"
}, ], [{
    "name": "全家頭城車頭店",
    "addr": "宜蘭縣頭城鎮民鋒路32號",
    "pkey": "017368",
    "tel": "03-9782455"
}, {
    "name": "全家宜蘭二城店",
    "addr": "宜蘭縣頭城鎮青雲路一段238號1樓",
    "pkey": "013576",
    "tel": "03-9870089"
}, {
    "name": "全家宜蘭大溪店",
    "addr": "宜蘭縣頭城鎮濱海路五段470號472號",
    "pkey": "016092",
    "tel": "03-9781195"
}, ], [{
    "name": "全家宜蘭礁溪店",
    "addr": "宜蘭縣礁溪鄉中山路二段144號",
    "pkey": "015027",
    "tel": "03-9870468"
}, {
    "name": "全家礁溪仁愛店",
    "addr": "宜蘭縣礁溪鄉仁愛路16號1樓",
    "pkey": "017270",
    "tel": "03-9872033"
}, {
    "name": "全家礁溪健康店",
    "addr": "宜蘭縣礁溪鄉健康路50號1樓之1",
    "pkey": "016312",
    "tel": "03-9874587"
}, {
    "name": "全家礁溪精華店",
    "addr": "宜蘭縣礁溪鄉礁溪路五段118號1樓",
    "pkey": "013114",
    "tel": "03-9888237"
}, {
    "name": "全家礁溪協天店",
    "addr": "宜蘭縣礁溪鄉礁溪路四段30號",
    "pkey": "017397",
    "tel": "03-9888097"
}, ], [{
    "name": "全家壯圍吉祥店",
    "addr": "宜蘭縣壯圍鄉壯五路278號1樓",
    "pkey": "013979",
    "tel": "03-9388144"
}, {
    "name": "全家壯圍美功店",
    "addr": "宜蘭縣壯圍鄉美功路一段168號",
    "pkey": "014302",
    "tel": "03-9309263"
}, ], [{
    "name": "全家宜蘭內城店",
    "addr": "宜蘭縣員山鄉內城路455號1樓",
    "pkey": "012587",
    "tel": "03-9230814"
}, {
    "name": "全家宜蘭員山店",
    "addr": "宜蘭縣員山鄉員山路一段122號1樓",
    "pkey": "017106",
    "tel": "03-9233360"
}, {
    "name": "全家宜蘭內員山店",
    "addr": "宜蘭縣員山鄉溫泉路10號、10之1號",
    "pkey": "012955",
    "tel": "03-9233004"
}, ], [{
    "name": "全家羅東南豪店",
    "addr": "宜蘭縣羅東鎮中正南路19號壹樓",
    "pkey": "011439",
    "tel": "03-9578051"
}, {
    "name": "全家羅東南門店",
    "addr": "宜蘭縣羅東鎮中正路1號",
    "pkey": "010900",
    "tel": "03-9574266"
}, {
    "name": "全家羅東公正店",
    "addr": "宜蘭縣羅東鎮公正路551號．553號．555號",
    "pkey": "014626",
    "tel": "03-9511509"
}, {
    "name": "全家羅東站前店",
    "addr": "宜蘭縣羅東鎮公正路61號",
    "pkey": "014481",
    "tel": "03-9561480"
}, {
    "name": "全家羅東北城店",
    "addr": "宜蘭縣羅東鎮四育路71號",
    "pkey": "017630",
    "tel": "03-9616687"
}, {
    "name": "全家羅東天祥店",
    "addr": "宜蘭縣羅東鎮南昌東街39號1樓",
    "pkey": "017109",
    "tel": "03-9534547"
}, {
    "name": "全家羅東新興東店",
    "addr": "宜蘭縣羅東鎮純精路一段236號一樓",
    "pkey": "014107",
    "tel": "03-9545949"
}, {
    "name": "全家羅東復興店",
    "addr": "宜蘭縣羅東鎮復興路二段102號1樓",
    "pkey": "013765",
    "tel": "03-9559720"
}, {
    "name": "全家羅東倉前店",
    "addr": "宜蘭縣羅東鎮興東路161號一樓",
    "pkey": "015898",
    "tel": "03-9578240"
}, {
    "name": "全家羅東金鼎店",
    "addr": "宜蘭縣羅東鎮興東路8之1號1樓",
    "pkey": "013928",
    "tel": "03-9578277"
}, ], [{
    "name": "全家宜蘭天送埤店",
    "addr": "宜蘭縣三星鄉三星路七段322號",
    "pkey": "016888",
    "tel": "03-9894021"
}, ], [{
    "name": "全家大同南山店",
    "addr": "宜蘭縣大同鄉泰雅路七段137號",
    "pkey": "015852",
    "tel": "03-9809056"
}, ], [{
    "name": "全家五結國道店",
    "addr": "宜蘭縣五結鄉中興路一段177號1樓",
    "pkey": "017505",
    "tel": "03-9604824"
}, {
    "name": "全家宜蘭五結店",
    "addr": "宜蘭縣五結鄉五結中路17、19號",
    "pkey": "015435",
    "tel": "03-9603371"
}, {
    "name": "全家五結興盛店",
    "addr": "宜蘭縣五結鄉五結路三段751號1F",
    "pkey": "012415",
    "tel": "03-9553470"
}, {
    "name": "全家五結濱海店",
    "addr": "宜蘭縣五結鄉季新村五濱路二段230號一樓",
    "pkey": "017110",
    "tel": "03-9503632"
}, {
    "name": "全家五結鑫利成店",
    "addr": "宜蘭縣五結鄉利成路一段5-1號",
    "pkey": "014597",
    "tel": "03-9603740"
}, {
    "name": "全家五結利澤店",
    "addr": "宜蘭縣五結鄉利澤村利成路二段390號一樓",
    "pkey": "015123",
    "tel": "03-9604483"
}, {
    "name": "全家宜蘭薪傳店",
    "addr": "宜蘭縣五結鄉傳藝路二段156號一樓及停車場",
    "pkey": "017312",
    "tel": "03-9601397"
}, ], [{
    "name": "全家冬山群英店",
    "addr": "宜蘭縣冬山鄉冬山路三段595號",
    "pkey": "015068",
    "tel": "03-9583538"
}, {
    "name": "全家冬山永興店",
    "addr": "宜蘭縣冬山鄉永興路一段1號1樓",
    "pkey": "015067",
    "tel": "03-9587433"
}, {
    "name": "全家冬山義新店",
    "addr": "宜蘭縣冬山鄉義成路三段409號",
    "pkey": "014568",
    "tel": "03-9587507"
}, {
    "name": "全家冬山義成店",
    "addr": "宜蘭縣冬山鄉義成路三段三一六號一樓",
    "pkey": "016142",
    "tel": "03-9585625"
}, {
    "name": "全家宜蘭廣源店",
    "addr": "宜蘭縣冬山鄉廣興路48號",
    "pkey": "016970",
    "tel": "03-9517357"
}, {
    "name": "全家宜蘭廣鑫店",
    "addr": "宜蘭縣冬山鄉廣興路267號",
    "pkey": "011685",
    "tel": "03-9518485"
}, ], [{
    "name": "全家蘇澳馬賽店",
    "addr": "宜蘭縣蘇澳鎮大同路7號1樓",
    "pkey": "017552",
    "tel": "03-9909822"
}, {
    "name": "全家蘇澳車頭店",
    "addr": "宜蘭縣蘇澳鎮中山路一段63號一樓",
    "pkey": "011059",
    "tel": "03-9952603"
}, {
    "name": "全家蘇澳聖湖店",
    "addr": "宜蘭縣蘇澳鎮中山路二段31號一樓",
    "pkey": "010799",
    "tel": "03-9954216"
}, ], [{
    "name": "全家宜蘭東澳店",
    "addr": "宜蘭縣南澳鄉東岳村蘇花路三段201號一樓",
    "pkey": "016616",
    "tel": "03-9986229"
}, ], ], [[{
    "name": "全家花蓮富強店",
    "addr": "花蓮縣花蓮市中山路708號1樓",
    "pkey": "014382",
    "tel": "03-8465247"
}, {
    "name": "全家花蓮國安店",
    "addr": "花蓮縣花蓮市中山路406-2號",
    "pkey": "016927",
    "tel": "03-8311590"
}, {
    "name": "全家花蓮建中店",
    "addr": "花蓮縣花蓮市中山路547-2號",
    "pkey": "015553",
    "tel": "03-8315576"
}, {
    "name": "全家花蓮大愛店",
    "addr": "花蓮縣花蓮市中央路三段707號（大愛樓地下室超商）",
    "pkey": "012048",
    "tel": "03-8466456"
}, {
    "name": "全家花蓮慈濟店",
    "addr": "花蓮縣花蓮市中央路三段707號3樓",
    "pkey": "014869",
    "tel": "03-8571610"
}, {
    "name": "全家花蓮榮正店",
    "addr": "花蓮縣花蓮市中正路207號．209號",
    "pkey": "013551",
    "tel": "03-8336312"
}, {
    "name": "全家花蓮正義店",
    "addr": "花蓮縣花蓮市中正路413號1樓",
    "pkey": "015690",
    "tel": "03-8326265"
}, {
    "name": "全家花蓮正明店",
    "addr": "花蓮縣花蓮市中正路633號",
    "pkey": "015793",
    "tel": "03-8335750"
}, {
    "name": "全家花蓮正國店",
    "addr": "花蓮縣花蓮市中正路569號",
    "pkey": "017489",
    "tel": "03-8358084"
}, {
    "name": "全家花蓮中福店",
    "addr": "花蓮縣花蓮市中正路268號1樓",
    "pkey": "012231",
    "tel": "03-8320342"
}, {
    "name": "全家花蓮新美店",
    "addr": "花蓮縣花蓮市中興路182號1樓",
    "pkey": "012548",
    "tel": "03-8236890"
}, {
    "name": "全家花蓮光復店",
    "addr": "花蓮縣花蓮市民國路121號",
    "pkey": "017157",
    "tel": "03-8316381"
}, {
    "name": "全家花蓮鑫和店",
    "addr": "花蓮縣花蓮市和平路597號壹樓",
    "pkey": "011221",
    "tel": "03-8310547"
}, {
    "name": "全家花蓮博愛店",
    "addr": "花蓮縣花蓮市林森路250號",
    "pkey": "013206",
    "tel": "03-8352319"
}, {
    "name": "全家吉安建國店",
    "addr": "花蓮縣吉安鄉建國路一段42號",
    "pkey": "017332",
    "tel": "03-8465801"
}, {
    "name": "全家花蓮慈安店",
    "addr": "花蓮縣花蓮市建國路二段876號",
    "pkey": "016203",
    "tel": "03-8463933"
}, {
    "name": "全家花蓮國盛店",
    "addr": "花蓮縣花蓮市國聯五路126、128號1樓",
    "pkey": "010600",
    "tel": "03-8328037"
}, {
    "name": "全家花蓮國興店",
    "addr": "花蓮縣花蓮市國聯五路59號",
    "pkey": "012863",
    "tel": "03-8322092"
}, {
    "name": "全家花蓮德順店",
    "addr": "花蓮縣花蓮市德安一街223號1樓",
    "pkey": "015922",
    "tel": "03-8337071"
}, ], [{
    "name": "全家新城望海店",
    "addr": "花蓮縣新城鄉七星街110號",
    "pkey": "015087",
    "tel": "03-8233371"
}, {
    "name": "全家新城北埔店",
    "addr": "花蓮縣新城鄉北埔路159號一樓",
    "pkey": "014488",
    "tel": "03-8269462"
}, {
    "name": "全家新城佳山店",
    "addr": "花蓮縣新城鄉佳林村佳林105號",
    "pkey": "008350",
    "tel": "03-8268488"
}, {
    "name": "全家新城嘉新店",
    "addr": "花蓮縣新城鄉嘉新村花師街37號一樓",
    "pkey": "012565",
    "tel": "03-8226046"
}, {
    "name": "全家新城康樂店",
    "addr": "花蓮縣新城鄉康樂村康樂路279號",
    "pkey": "017111",
    "tel": "03-8262100"
}, {
    "name": "全家新城太魯閣店",
    "addr": "花蓮縣新城鄉新城村新興路53號1樓",
    "pkey": "016143",
    "tel": "03-8610632"
}, {
    "name": "全家新城民益店",
    "addr": "花蓮縣新城鄉嘉新村嘉新路45號",
    "pkey": "014596",
    "tel": "03-8225610"
}, ], [{
    "name": "全家秀林和平店",
    "addr": "花蓮縣秀林鄉和平村和平路187號一樓",
    "pkey": "015795",
    "tel": "03-8682172"
}, ], [{
    "name": "全家吉安慶豐店",
    "addr": "花蓮縣吉安鄉慶豐村中山路三段450號一樓",
    "pkey": "016999",
    "tel": "03-8521566"
}, {
    "name": "全家吉安仁里店",
    "addr": "花蓮縣吉安鄉中正路一段153號，155號1樓",
    "pkey": "017165",
    "tel": "03-8546913"
}, {
    "name": "全家吉安宜昌店",
    "addr": "花蓮縣吉安鄉中華路二段161號1樓",
    "pkey": "015226",
    "tel": "03-8536892"
}, {
    "name": "全家吉安仁安店",
    "addr": "花蓮縣吉安鄉仁里五街48-1號",
    "pkey": "016826",
    "tel": "03-8546601"
}, {
    "name": "全家吉安鑫莊敬店",
    "addr": "花蓮縣吉安鄉自強路603號",
    "pkey": "015318",
    "tel": "03-8561115"
}, {
    "name": "全家吉安和平店",
    "addr": "花蓮縣吉安鄉自強路395號之1",
    "pkey": "017755",
    "tel": "03-8564431"
}, {
    "name": "全家吉安自強店",
    "addr": "花蓮縣吉安鄉勝安村自強路129號一樓131號",
    "pkey": "011512",
    "tel": "03-8514770"
}, {
    "name": "全家吉安福興店",
    "addr": "花蓮縣吉安鄉福興路232-1號",
    "pkey": "015162",
    "tel": "03-8541041"
}, ], [{
    "name": "全家壽豐東華店",
    "addr": "花蓮縣壽豐鄉大學路二段1號（東華大學六期學生宿舍）",
    "pkey": "010400",
    "tel": "03-8630021"
}, {
    "name": "全家壽豐東華二店",
    "addr": "花蓮縣壽豐鄉大學路二段1號（多容館）",
    "pkey": "015629",
    "tel": "03-8630329"
}, {
    "name": "全家壽豐豐田店",
    "addr": "花蓮縣壽豐鄉豐山村中山路195號",
    "pkey": "015141",
    "tel": "03-8652750"
}, {
    "name": "全家壽豐志學店",
    "addr": "花蓮縣壽豐鄉志學村中正路17號",
    "pkey": "017787",
    "tel": "03-8664996"
}, ], [{
    "name": "全家光復車站店",
    "addr": "花蓮縣光復鄉中山路二段223號",
    "pkey": "016091",
    "tel": "03-8701110"
}, ], [{
    "name": "全家瑞穗車站店",
    "addr": "花蓮縣瑞穗鄉瑞穗村中正北路1號一樓",
    "pkey": "011123",
    "tel": "03-8875375"
}, {
    "name": "全家瑞穗瑞雄店",
    "addr": "花蓮縣瑞穗鄉溫泉路三段179．181號",
    "pkey": "014073",
    "tel": "03-8873982"
}, ], [{
    "name": "全家玉里玉溪店",
    "addr": "花蓮縣玉里鎮中華路177號",
    "pkey": "013096",
    "tel": "03-8980425"
}, ], ], [[{
    "name": "全家台東大同店",
    "addr": "台東縣台東市大同路163號1樓",
    "pkey": "015245",
    "tel": "089360595"
}, {
    "name": "全家台東文化店",
    "addr": "台東縣台東市中山路345號1、2樓",
    "pkey": "013866",
    "tel": "089341912"
}, {
    "name": "全家台東鐵花店",
    "addr": "台東縣台東市中華路一段575號",
    "pkey": "017383",
    "tel": "089338872"
}, {
    "name": "全家台東豐里店",
    "addr": "台東縣台東市中華路三段257號1樓",
    "pkey": "017235",
    "tel": "089318596"
}, {
    "name": "全家台東寶桑店",
    "addr": "台東縣台東市中興路一段211號",
    "pkey": "015621",
    "tel": "089239683"
}, {
    "name": "全家台東中興店",
    "addr": "台東縣台東市中興路二段442號一樓",
    "pkey": "014358",
    "tel": "089239473"
}, {
    "name": "全家台東興昌店",
    "addr": "臺東縣臺東市文昌路2號壹樓",
    "pkey": "016212",
    "tel": "089233387"
}, {
    "name": "全家台東豐樂店",
    "addr": "台東縣台東市正氣北路526號一樓",
    "pkey": "012061",
    "tel": "089325869"
}, {
    "name": "全家台東南京店",
    "addr": "台東縣台東市正氣路384號一樓",
    "pkey": "015109",
    "tel": "089332782"
}, {
    "name": "全家台東志航店",
    "addr": "台東縣台東市志航路三段3號",
    "pkey": "015026",
    "tel": "089236374"
}, {
    "name": "全家台東南王店",
    "addr": "台東縣台東市更生北路603號",
    "pkey": "015777",
    "tel": "089224995"
}, {
    "name": "全家台東維新店",
    "addr": "台東縣台東市更生路575號",
    "pkey": "015220",
    "tel": "089347383"
}, {
    "name": "全家台東知本店",
    "addr": "台東縣台東市青海路四段472號1樓",
    "pkey": "016978",
    "tel": "089512191"
}, {
    "name": "全家台東博愛店",
    "addr": "台東縣台東市博愛路486號",
    "pkey": "015913",
    "tel": "089341217"
}, {
    "name": "全家台東新生店",
    "addr": "台東縣台東市開封街646號1樓",
    "pkey": "011636",
    "tel": "089341973"
}, {
    "name": "全家台東四維店",
    "addr": "台東縣台東市傳廣路399號1樓",
    "pkey": "015081",
    "tel": "089348139"
}, {
    "name": "全家台東豐榮店",
    "addr": "台東縣台東市豐榮路187號",
    "pkey": "011195",
    "tel": "089341938"
}, ], [{
    "name": "全家綠島朝日店",
    "addr": "台東縣綠島鄉南寮村99號",
    "pkey": "014788",
    "tel": "089671146"
}, ], [{
    "name": "全家台東和平店",
    "addr": "台東縣卑南鄉太平村和平路102號一樓",
    "pkey": "012570",
    "tel": "089380790"
}, {
    "name": "全家卑南初鹿店",
    "addr": "台東縣卑南鄉初鹿村忠孝路85號",
    "pkey": "015648",
    "tel": "089570655"
}, {
    "name": "全家台東鎮東店",
    "addr": "臺東縣卑南鄉泰安村泰安路361號（陸軍太平營區）",
    "pkey": "016652",
    "tel": "089381213"
}, {
    "name": "全家台東賓朗店",
    "addr": "台東縣卑南鄉賓朗路292號",
    "pkey": "017326",
    "tel": "089236230"
}, {
    "name": "全家台東龍泉店",
    "addr": "台東縣卑南鄉溫泉村龍泉路55號一樓之1",
    "pkey": "009405",
    "tel": "089514523"
}, ], [{
    "name": "全家台東鹿野店",
    "addr": "台東縣鹿野鄉鹿野村中華路一段98號一樓",
    "pkey": "011319",
    "tel": "089561502"
}, ], [{
    "name": "全家關山民族店",
    "addr": "台東縣關山鎮里壟里民族路53-1號",
    "pkey": "011740",
    "tel": "089814885"
}, {
    "name": "全家台東關山店",
    "addr": "台東縣關山鎮里瓏里民權路1之6號一樓",
    "pkey": "017000",
    "tel": "089814083"
}, ], [{
    "name": "全家池上車站店",
    "addr": "台東縣池上鄉忠孝路269號",
    "pkey": "013173",
    "tel": "089863755"
}, ], [{
    "name": "全家成功中華店",
    "addr": "台東縣成功鎮中華路123號1樓",
    "pkey": "017618",
    "tel": "089853820"
}, ], [{
    "name": "全家台東太麻里店",
    "addr": "台東縣太麻里鄉太麻里街316號",
    "pkey": "016977",
    "tel": "089780150"
}, ], [{
    "name": "全家台東達人店",
    "addr": "台東縣達仁鄉復興路154-2號",
    "pkey": "016455",
    "tel": "089702689"
}, ], ], [[{
    "name": "全家基隆廟口店",
    "addr": "基隆市仁愛區仁三路33號一樓",
    "pkey": "011629",
    "tel": "02-24289166"
}, {
    "name": "全家基隆仁三店",
    "addr": "基隆市仁愛區仁三路59號壹樓",
    "pkey": "017147",
    "tel": "02-24286905"
}, {
    "name": "全家基隆仁四店",
    "addr": "基隆市仁愛區仁四路52號1樓",
    "pkey": "013825",
    "tel": "02-24265932"
}, {
    "name": "全家基隆新站前店",
    "addr": "基隆市仁愛區忠一路19號",
    "pkey": "016144",
    "tel": "02-24273646"
}, {
    "name": "全家基隆忠孝店",
    "addr": "基隆市仁愛區忠二路39號1樓",
    "pkey": "015503",
    "tel": "02-24257478"
}, {
    "name": "全家基隆港口店",
    "addr": "基隆市仁愛區港西街6-2號壹樓",
    "pkey": "017448",
    "tel": "02-24256032"
}, {
    "name": "全家基隆仁愛店",
    "addr": "基隆市仁愛區愛四路56號1樓及夾層",
    "pkey": "013146",
    "tel": "02-24259270"
}, {
    "name": "全家基隆精一店",
    "addr": "基隆市仁愛區精一路41號1樓",
    "pkey": "015066",
    "tel": "02-24249183"
}, ], [{
    "name": "全家基隆新正信店",
    "addr": "基隆市信義區正信路181號",
    "pkey": "015670",
    "tel": "02-24665413"
}, {
    "name": "全家基隆東信店",
    "addr": "基隆市信義區東信路5號",
    "pkey": "014689",
    "tel": "02-24669537"
}, {
    "name": "全家基隆信一店",
    "addr": "基隆市信義區信一路148號",
    "pkey": "017514",
    "tel": "02-24241255"
}, {
    "name": "全家基隆信義店",
    "addr": "基隆市信義區信二路236-2號",
    "pkey": "016213",
    "tel": "02-24255383"
}, {
    "name": "全家基隆新深溪店",
    "addr": "基隆市信義區深溪路59號",
    "pkey": "017150",
    "tel": "02-24664970"
}, {
    "name": "全家基隆新澳坑店",
    "addr": "基隆市信義區深澳坑路107號",
    "pkey": "016283",
    "tel": "02-24683722"
}, ], [{
    "name": "全家基隆新祥豐店",
    "addr": "基隆市中正區中正路623號壹樓",
    "pkey": "014328",
    "tel": "02-24627260"
}, {
    "name": "全家基隆正港店",
    "addr": "基隆市中正區中正路644號",
    "pkey": "013180",
    "tel": "02-24636316"
}, {
    "name": "全家基隆新中船店",
    "addr": "基隆市中正區中船路82號",
    "pkey": "015941",
    "tel": "02-24245729"
}, {
    "name": "全家基隆富港店",
    "addr": "基隆市中正區北寧路250-8號1．2樓",
    "pkey": "017090",
    "tel": "02-24699625"
}, {
    "name": "全家基隆海大店",
    "addr": "基隆市中正區北寧路2號",
    "pkey": "014688",
    "tel": "02-24636566"
}, {
    "name": "全家基隆海洋店",
    "addr": "基隆市中正區北寧路2號",
    "pkey": "014185",
    "tel": "02-24636575"
}, {
    "name": "全家基隆新和一店",
    "addr": "基隆市中正區和一路110號",
    "pkey": "016075",
    "tel": "02-24635157"
}, {
    "name": "全家基隆新義二店",
    "addr": "基隆市中正區義二路34號",
    "pkey": "014086",
    "tel": "02-24267442"
}, {
    "name": "全家基隆觀海店",
    "addr": "基隆市中正區觀海街136號138號一樓",
    "pkey": "014867",
    "tel": "02-24606545"
}, {
    "name": "全家基隆觀山店",
    "addr": "基隆市中正區觀海街61號",
    "pkey": "015396",
    "tel": "02-24607005"
}, ], [{
    "name": "全家基隆中山店",
    "addr": "基隆市中山區中山二路53號．53-1號",
    "pkey": "017306",
    "tel": "02-24285091"
}, {
    "name": "全家基隆囍旺店",
    "addr": "基隆市中山區中和路85巷12號1、2樓",
    "pkey": "016216",
    "tel": "02-24370189"
}, {
    "name": "全家基隆鑫大慶店",
    "addr": "基隆市中山區中和路168巷2弄17號",
    "pkey": "016318",
    "tel": "02-24371195"
}, {
    "name": "全家基隆華復店",
    "addr": "基隆市中山區中華路2號復旦路1號3號一樓",
    "pkey": "017172",
    "tel": "02-24282937"
}, {
    "name": "全家基隆樂華店",
    "addr": "基隆市中山區西定路467號1樓",
    "pkey": "015669",
    "tel": "02-24285782"
}, {
    "name": "全家基隆經國店",
    "addr": "基隆市中山區復興路336-1號",
    "pkey": "010822",
    "tel": "02-24374320"
}, {
    "name": "全家基隆新復興店",
    "addr": "基隆市中山區復興路204-1號",
    "pkey": "016319",
    "tel": "02-24366769"
}, ], [{
    "name": "全家基隆新安和店",
    "addr": "基隆市安樂區安和一街124號",
    "pkey": "016733",
    "tel": "02-24341775"
}, {
    "name": "全家基隆新樂強店",
    "addr": "基隆市安樂區安樂路一段206號1樓",
    "pkey": "017009",
    "tel": "02-24254734"
}, {
    "name": "全家基隆長庚店",
    "addr": "基隆市安樂區安樂路二段157號",
    "pkey": "015586",
    "tel": "02-24326001"
}, {
    "name": "全家基隆武勝店",
    "addr": "基隆市安樂區武訓街72號壹樓",
    "pkey": "017246",
    "tel": "02-24328788"
}, {
    "name": "全家基隆武嶺店",
    "addr": "基隆市安樂區武嶺街181-6號1樓",
    "pkey": "016926",
    "tel": "02-24335573"
}, {
    "name": "全家基隆情人湖店",
    "addr": "基隆市安樂區基金一路208巷200號B1",
    "pkey": "014998",
    "tel": "02-24326530"
}, {
    "name": "全家基隆新國揚店",
    "addr": "基隆市安樂區基金一路121巷14號",
    "pkey": "016317",
    "tel": "02-34012842"
}, {
    "name": "全家基隆大武崙店",
    "addr": "基隆市安樂區基金一路389號",
    "pkey": "015757",
    "tel": "02-24346967"
}, {
    "name": "全家基隆萬金店",
    "addr": "基隆市安樂區基金一路146號之地下室",
    "pkey": "017089",
    "tel": "02-24333875"
}, {
    "name": "全家基隆基金店",
    "addr": "基隆市安樂區基金三路145號",
    "pkey": "016993",
    "tel": "02-24329658"
}, {
    "name": "全家基隆長樂店",
    "addr": "基隆市安樂區麥金路222號地下一樓（基隆長庚醫院）",
    "pkey": "017208",
    "tel": "02-24331198"
}, {
    "name": "全家基隆金城店",
    "addr": "基隆市安樂區麥金路231-1號",
    "pkey": "016582",
    "tel": "02-34012667"
}, {
    "name": "全家基隆樂富店",
    "addr": "基隆市安樂區樂利二街62巷212號一樓",
    "pkey": "016459",
    "tel": "02-24349184"
}, {
    "name": "全家基隆龍騰店",
    "addr": "基隆市安樂區樂利三街8巷16號底四層",
    "pkey": "016218",
    "tel": "02-24334303"
}, {
    "name": "全家基隆新樂群店",
    "addr": "基隆市安樂區樂利三街128號",
    "pkey": "014212",
    "tel": "02-24337917"
}, {
    "name": "全家基隆樂利店",
    "addr": "基隆市安樂區樂利三街32巷12號",
    "pkey": "016603",
    "tel": "02-24322426"
}, ], [{
    "name": "全家基隆暖東店",
    "addr": "基隆市暖暖區暖暖街163號",
    "pkey": "013813",
    "tel": "02-24582882"
}, {
    "name": "全家基隆暖鑫店",
    "addr": "基隆市暖暖區暖暖街461號壹樓",
    "pkey": "016917",
    "tel": "02-24586460"
}, {
    "name": "全家基隆暖錠店",
    "addr": "基隆市暖暖區源遠路189號",
    "pkey": "016023",
    "tel": "02-24594800"
}, {
    "name": "全家基隆暖港店",
    "addr": "基隆市暖暖區過港路254號",
    "pkey": "016259",
    "tel": "02-24574786"
}, {
    "name": "全家基隆吉市店",
    "addr": "基隆市暖暖區碇內街188-9號壹樓及夾層",
    "pkey": "016579",
    "tel": "02-24587239"
}, ], [{
    "name": "全家七堵工明店",
    "addr": "基隆市七堵區工建路1-15號壹樓",
    "pkey": "017681",
    "tel": "02-24519520"
}, {
    "name": "全家七堵永富店",
    "addr": "基隆市七堵區永富路120號、崇智街48號一樓",
    "pkey": "013997",
    "tel": "02-24558170"
}, {
    "name": "全家七堵自治店",
    "addr": "基隆市七堵區自治街6號",
    "pkey": "016497",
    "tel": "02-24554377"
}, {
    "name": "全家七堵新明德店",
    "addr": "基隆市七堵區明德二路15-53號",
    "pkey": "017207",
    "tel": "02-24517467"
}, {
    "name": "全家七堵長安店",
    "addr": "基隆市七堵區長安街212巷2-4號一樓及地下室",
    "pkey": "014635",
    "tel": "02-24519266"
}, {
    "name": "全家七堵大興店",
    "addr": "基隆市七堵區南興路30號1樓",
    "pkey": "015563",
    "tel": "02-24560059"
}, {
    "name": "全家基隆百福店",
    "addr": "基隆市七堵區福二街204號1樓",
    "pkey": "017151",
    "tel": "02-24529098"
}, ], ], [[{
    "name": "全家新德店",
    "addr": "台北市中正區八德路一段43巷2號",
    "pkey": "013575",
    "tel": "02-23214351"
}, {
    "name": "全家台醫店",
    "addr": "台北市中正區中山南路7號1樓",
    "pkey": "006598",
    "tel": "02-23278841"
}, {
    "name": "全家南機場店",
    "addr": "台北市中正區中華路二段311巷1號1樓",
    "pkey": "013547",
    "tel": "02-23039420"
}, {
    "name": "全家新惠安店",
    "addr": "台北市中正區中華路二段307巷46號",
    "pkey": "015956",
    "tel": "02-23036887"
}, {
    "name": "全家新龍口店",
    "addr": "台北市中正區汀州路一段244號",
    "pkey": "017008",
    "tel": "02-23047184"
}, {
    "name": "全家新廈門店",
    "addr": "台北市中正區汀州路二段38號1樓",
    "pkey": "014453",
    "tel": "02-23681443"
}, {
    "name": "全家金門店",
    "addr": "台北市中正區汀州路二段216號1樓",
    "pkey": "016606",
    "tel": "02-23642756"
}, {
    "name": "全家公館店",
    "addr": "台北市中正區汀州路三段251號",
    "pkey": "015201",
    "tel": "02-23688539"
}, {
    "name": "全家文盛店",
    "addr": "台北市中正區汀州路三段173號",
    "pkey": "017605",
    "tel": "02-23681345"
}, {
    "name": "全家水源店",
    "addr": "台北市中正區汀州路三段261號",
    "pkey": "014142",
    "tel": "02-23642257"
}, {
    "name": "全家和鄰店",
    "addr": "台北市中正區和平西路一段82號1樓",
    "pkey": "017366",
    "tel": "02-23628326"
}, {
    "name": "全家寶慶店",
    "addr": "台北市中正區延平南路111號",
    "pkey": "012642",
    "tel": "02-23898700"
}, {
    "name": "全家郡王店",
    "addr": "台北市中正區延平南路68號",
    "pkey": "014575",
    "tel": "02-23719902"
}, {
    "name": "全家和醫店",
    "addr": "台北市中正區延平南路159號1樓",
    "pkey": "016200",
    "tel": "02-23122560"
}, {
    "name": "全家鴻啟店",
    "addr": "台北市中正區忠孝西路一段100號",
    "pkey": "016266",
    "tel": "02-23142878"
}, {
    "name": "全家北捷店",
    "addr": "台北市中正區忠孝西路一段47號B1F",
    "pkey": "017485",
    "tel": "02-23831985"
}, {
    "name": "全家亞慶店",
    "addr": "台北市中正區忠孝西路一段50號1樓",
    "pkey": "016918",
    "tel": "02-23706675"
}, {
    "name": "全家文祥店",
    "addr": "台北市中正區杭州南路一段147號",
    "pkey": "014724",
    "tel": "02-23914884"
}, {
    "name": "全家林森南路店",
    "addr": "台北市中正區林森南路57．59號",
    "pkey": "016799",
    "tel": "02-23519110"
}, {
    "name": "全家南陽店",
    "addr": "台北市中正區信陽街15號",
    "pkey": "015589",
    "tel": "02-23881469"
}, {
    "name": "全家新東門店",
    "addr": "台北市中正區信義路一段1號",
    "pkey": "014785",
    "tel": "02-23564259"
}, {
    "name": "全家金昌店",
    "addr": "台北市中正區南昌路一段135號1樓",
    "pkey": "014665",
    "tel": "02-23432173"
}, {
    "name": "全家大昌店",
    "addr": "臺北市中正區南昌路一段67號",
    "pkey": "017874",
    "tel": "02-23432708"
}, {
    "name": "全家南海店",
    "addr": "臺北市中正區南海路20號",
    "pkey": "014490",
    "tel": "02-23564283"
}, {
    "name": "全家重慶店",
    "addr": "台北市中正區重慶南路一段58號",
    "pkey": "017294",
    "tel": "02-23122797"
}, {
    "name": "全家摩天店",
    "addr": "台北市中正區許昌街26號",
    "pkey": "012817",
    "tel": "02-23148151"
}, {
    "name": "全家東大二店",
    "addr": "台北市中正區貴陽街一段56號B1（東吳大學城區部）",
    "pkey": "013711",
    "tel": "02-23714669"
}, {
    "name": "全家開封店",
    "addr": "台北市中正區開封街一段41號1樓",
    "pkey": "017223",
    "tel": "02-23709020"
}, {
    "name": "全家教育大學店",
    "addr": "台北市中正區愛國西路1號",
    "pkey": "016575",
    "tel": "02-23888317"
}, {
    "name": "全家大孝店",
    "addr": "台北市中正區愛國東路112號1樓．2樓",
    "pkey": "015063",
    "tel": "02-23216231"
}, {
    "name": "全家漢盛店",
    "addr": "台北市中正區漢口街一段18號",
    "pkey": "015850",
    "tel": "02-23117024"
}, {
    "name": "全家福昌店",
    "addr": "台北市中正區福州街10號1樓（部份）",
    "pkey": "017358",
    "tel": "02-23913137"
}, {
    "name": "全家新衡陽店",
    "addr": "台北市中正區衡陽路77號一樓",
    "pkey": "017503",
    "tel": "02-23711130"
}, {
    "name": "全家衡慶店",
    "addr": "台北市中正區衡陽路7號1樓部分（如附圖）",
    "pkey": "017203",
    "tel": "02-23820271"
}, {
    "name": "全家新仟囍店",
    "addr": "台北市中正區館前路36號1樓",
    "pkey": "014430",
    "tel": "02-23822831"
}, {
    "name": "全家齊東店",
    "addr": "台北市中正區濟南路二段3-7號1樓",
    "pkey": "014322",
    "tel": "02-23942076"
}, {
    "name": "全家富陽店",
    "addr": "台北市中正區襄陽路7號1樓",
    "pkey": "017407",
    "tel": "02-23754181"
}, {
    "name": "全家西站店",
    "addr": "台北市中正區懷寧街7之1號",
    "pkey": "016659",
    "tel": "02-23120577"
}, {
    "name": "全家館中店",
    "addr": "台北市中正區羅斯福路三段316巷8弄1號1樓",
    "pkey": "014745",
    "tel": "02-23672204"
}, ], [{
    "name": "全家大龍店",
    "addr": "台北市大同區大龍街133號1樓",
    "pkey": "016547",
    "tel": "02-25980054"
}, {
    "name": "全家蘭州店",
    "addr": "台北市大同區大龍街217號1樓",
    "pkey": "015569",
    "tel": "02-25995380"
}, {
    "name": "全家泰元店",
    "addr": "台北市大同區太原路81號",
    "pkey": "017339",
    "tel": "02-25592980"
}, {
    "name": "全家萬全店",
    "addr": "台北市大同區民生西路63號",
    "pkey": "015590",
    "tel": "02-25576965"
}, {
    "name": "全家福澤店",
    "addr": "台北市大同區民權西路146號",
    "pkey": "014801",
    "tel": "02-25572577"
}, {
    "name": "全家永樂店",
    "addr": "台北市大同區延平北路二段260號之1",
    "pkey": "013118",
    "tel": "02-25529571"
}, {
    "name": "全家新橋店",
    "addr": "臺北市大同區延平北路三段25之3號",
    "pkey": "017794",
    "tel": "02-25996171"
}, {
    "name": "全家國順店",
    "addr": "台北市大同區延平北路三段118號1樓",
    "pkey": "015731",
    "tel": "02-25919787"
}, {
    "name": "全家明真店",
    "addr": "台北市大同區延平北路四段19號",
    "pkey": "017338",
    "tel": "02-25982460"
}, {
    "name": "全家日新店",
    "addr": "台北市大同區承德路二段39＆41號1樓",
    "pkey": "014865",
    "tel": "02-25505051"
}, {
    "name": "全家福安店",
    "addr": "台北市大同區長安西路54號1樓",
    "pkey": "013977",
    "tel": "02-25509755"
}, {
    "name": "全家玉泉店",
    "addr": "台北市大同區長安西路342號1樓",
    "pkey": "017525",
    "tel": "02-25522657"
}, {
    "name": "全家長慶店",
    "addr": "台北市大同區長安西路258號1樓",
    "pkey": "017719",
    "tel": "02-25507756"
}, {
    "name": "全家金慶店",
    "addr": "台北市大同區南京西路308號1樓",
    "pkey": "016893",
    "tel": "02-25564600"
}, {
    "name": "全家慶權店",
    "addr": "台北市大同區重慶北路二段263號1樓",
    "pkey": "010916",
    "tel": "02-25578978"
}, {
    "name": "全家酒泉店",
    "addr": "臺北市大同區庫倫街48之4號",
    "pkey": "017311",
    "tel": "02-25929575"
}, {
    "name": "全家寧夏店",
    "addr": "台北市大同區寧夏路28，30，28—1，28—2號",
    "pkey": "012643",
    "tel": "02-25500930"
}, {
    "name": "全家甘州店",
    "addr": "台北市大同區歸綏街181之2號",
    "pkey": "012952",
    "tel": "02-25505587"
}, ], [{
    "name": "全家京江店",
    "addr": "台北市中山區一江街22號1樓",
    "pkey": "014010",
    "tel": "02-25678224"
}, {
    "name": "全家直學店",
    "addr": "台北市中山區大直街11號",
    "pkey": "017275",
    "tel": "02-25328364"
}, {
    "name": "全家大直店",
    "addr": "台北市中山區大直街33巷1號",
    "pkey": "014277",
    "tel": "02-25328875"
}, {
    "name": "全家市民店",
    "addr": "台北市中山區中山北路一段58號",
    "pkey": "012022",
    "tel": "02-25638109"
}, {
    "name": "全家中賓店",
    "addr": "台北市中山區中山北路二段59之3號1樓",
    "pkey": "005989",
    "tel": "02-25230023"
}, {
    "name": "全家聚葉店",
    "addr": "台北市中山區中山北路二段137巷34號1樓",
    "pkey": "014903",
    "tel": "02-25716328"
}, {
    "name": "全家新國賓店",
    "addr": "台北市中山區中山北路二段75-1號1樓",
    "pkey": "016585",
    "tel": "02-25818863"
}, {
    "name": "全家台鑫店",
    "addr": "台北市中山區中山北路二段44號1樓部份",
    "pkey": "017449",
    "tel": "02-25118851"
}, {
    "name": "全家新吉原店",
    "addr": "台北市中山區中原街16號1樓",
    "pkey": "017553",
    "tel": "02-25113653"
}, {
    "name": "全家錦原店",
    "addr": "台北市中山區中原街101號1樓",
    "pkey": "012585",
    "tel": "02-25412311"
}, {
    "name": "全家五常店",
    "addr": "台北市中山區五常街53巷23號1號",
    "pkey": "012907",
    "tel": "02-25067078"
}, {
    "name": "全家日津店",
    "addr": "台北市中山區天津街47號1樓及地下室",
    "pkey": "012641",
    "tel": "02-25635367"
}, {
    "name": "全家永安店",
    "addr": "台北市中山區北安路630巷7號1樓",
    "pkey": "015568",
    "tel": "02-25322254"
}, {
    "name": "全家美華店",
    "addr": "台北市中山區北安路819之1號",
    "pkey": "015759",
    "tel": "02-85095070"
}, {
    "name": "全家空總店",
    "addr": "台北市中山區北安路387號",
    "pkey": "016175",
    "tel": "02-25338346"
}, {
    "name": "全家新北鄰店",
    "addr": "台北市中山區北安路458巷41弄48號1樓",
    "pkey": "016923",
    "tel": "02-25325010"
}, {
    "name": "全家松平店",
    "addr": "台北市中山區四平街47號",
    "pkey": "014715",
    "tel": "02-25318666"
}, {
    "name": "全家馬偕店",
    "addr": "台北市中山區民生西路29號",
    "pkey": "015295",
    "tel": "02-25316236"
}, {
    "name": "全家福泰店",
    "addr": "台北市中山區民生東路一段36號1樓",
    "pkey": "014538",
    "tel": "02-25413026"
}, {
    "name": "全家玉林店",
    "addr": "台北市中山區民生東路一段27巷15號",
    "pkey": "016028",
    "tel": "02-25222731"
}, {
    "name": "全家鑫泰店",
    "addr": "台北市中山區民生東路一段39號",
    "pkey": "013781",
    "tel": "02-25212132"
}, {
    "name": "全家民佳店",
    "addr": "台北市中山區民生東路二段155號1樓",
    "pkey": "017201",
    "tel": "02-25038763"
}, {
    "name": "全家民族店",
    "addr": "台北市中山區民族東路410巷23弄24號",
    "pkey": "015602",
    "tel": "02-25185693"
}, {
    "name": "全家民權西路店",
    "addr": "台北市中山區民權西路35號1樓",
    "pkey": "016511",
    "tel": "02-25994884"
}, {
    "name": "全家錦民店",
    "addr": "台北市中山區民權東路二段152巷14號",
    "pkey": "012733",
    "tel": "02-25078797"
}, {
    "name": "全家江寧店",
    "addr": "台北市中山區民權東路三段64號1樓",
    "pkey": "016752",
    "tel": "02-25171595"
}, {
    "name": "全家長通店",
    "addr": "台北市中山區伊通街108號1樓",
    "pkey": "016549",
    "tel": "02-25029136"
}, {
    "name": "全家大通店",
    "addr": "台北市中山區伊通街39號1樓",
    "pkey": "014659",
    "tel": "02-25153716"
}, {
    "name": "全家金通店",
    "addr": "台北市中山區伊通街58號",
    "pkey": "013978",
    "tel": "02-25181554"
}, {
    "name": "全家吉林店",
    "addr": "台北市中山區吉林路314號",
    "pkey": "014713",
    "tel": "02-25628106"
}, {
    "name": "全家德惠店",
    "addr": "台北市中山區吉林路448號",
    "pkey": "017273",
    "tel": "02-25953593"
}, {
    "name": "全家合江店",
    "addr": "台北市中山區合江街87號一樓",
    "pkey": "013480",
    "tel": "02-25185276"
}, {
    "name": "全家朱崙店",
    "addr": "台北市中山區朱崙街67號",
    "pkey": "016150",
    "tel": "02-27528615"
}, {
    "name": "全家明水店",
    "addr": "台北市中山區明水路581巷11號1樓",
    "pkey": "017555",
    "tel": "02-85097543"
}, {
    "name": "全家林森北路店",
    "addr": "台北市中山區林森北路119巷49，51號",
    "pkey": "016751",
    "tel": "02-25230561"
}, {
    "name": "全家長林店",
    "addr": "台北市中山區林森北路107巷54號",
    "pkey": "017699",
    "tel": "02-25629310"
}, {
    "name": "全家復林店",
    "addr": "台北市中山區林森北路149-1．149-2號1樓",
    "pkey": "017822",
    "tel": "02-25230478"
}, {
    "name": "全家金林店",
    "addr": "台北市中山區林森北路109號1樓",
    "pkey": "013729",
    "tel": "02-25629847"
}, {
    "name": "全家錦林店",
    "addr": "台北市中山區林森北路399巷10號一樓",
    "pkey": "017752",
    "tel": "02-25239913"
}, {
    "name": "全家金漾店",
    "addr": "台北市中山區林森北路308號",
    "pkey": "016220",
    "tel": "02-25219884"
}, {
    "name": "全家錦富店",
    "addr": "台北市中山區林森北路428號1樓",
    "pkey": "016922",
    "tel": "02-25684923"
}, {
    "name": "全家新林森店",
    "addr": "台北市中山區林森北路630號1樓",
    "pkey": "012544",
    "tel": "02-25977209"
}, {
    "name": "全家林慶店",
    "addr": "台北市中山區林森北路376號1樓",
    "pkey": "017327",
    "tel": "02-25672790"
}, {
    "name": "全家權勝店",
    "addr": "台北市中山區松江路400號1樓及地下室",
    "pkey": "017355",
    "tel": "02-25935820"
}, {
    "name": "全家新松店",
    "addr": "台北市中山區松江路330巷33號",
    "pkey": "014662",
    "tel": "02-25715620"
}, {
    "name": "全家光華店",
    "addr": "台北市中山區松江路24之1號",
    "pkey": "012577",
    "tel": "02-25670175"
}, {
    "name": "全家正義店",
    "addr": "台北市中山區長安東路一段55號",
    "pkey": "011877",
    "tel": "02-25239542"
}, {
    "name": "全家遼寧店",
    "addr": "台北市中山區長安東路二段216號",
    "pkey": "015488",
    "tel": "02-27405515"
}, {
    "name": "全家本部店",
    "addr": "台北市中山區長安東路二段99號1樓及2樓",
    "pkey": "017071",
    "tel": "02-25173149"
}, {
    "name": "全家欣欣店",
    "addr": "台北市中山區長春路100號1樓",
    "pkey": "016364",
    "tel": "02-25314871"
}, {
    "name": "全家長春店",
    "addr": "台北市中山區長春路48號",
    "pkey": "016685",
    "tel": "02-25817796"
}, {
    "name": "全家中捷店",
    "addr": "台北市中山區南京西路16號B1",
    "pkey": "015198",
    "tel": "02-25557010"
}, {
    "name": "全家興亞店",
    "addr": "臺北市中山區南京東路二段26號",
    "pkey": "013570",
    "tel": "02-25312051"
}, {
    "name": "全家京貿店",
    "addr": "台北市中山區南京東路三段65號",
    "pkey": "014957",
    "tel": "02-25066873"
}, {
    "name": "全家建錦店",
    "addr": "台北市中山區建國北路二段131號1樓及部分地下室",
    "pkey": "017357",
    "tel": "02-25065447"
}, {
    "name": "全家濱江店",
    "addr": "台北市中山區建國北路三段111號1樓",
    "pkey": "013511",
    "tel": "02-25159357"
}, {
    "name": "全家新衡山店",
    "addr": "台北市中山區通北街111號",
    "pkey": "015346",
    "tel": "02-25332342"
}, {
    "name": "全家新復店",
    "addr": "台北市中山區復興北路514巷35號",
    "pkey": "013797",
    "tel": "02-25097685"
}, {
    "name": "全家興德店",
    "addr": "台北市中山區復興南路一段38號",
    "pkey": "015566",
    "tel": "02-87725312"
}, {
    "name": "全家鑫通店",
    "addr": "台北市中山區新生北路一段116號",
    "pkey": "015920",
    "tel": "02-25817485"
}, {
    "name": "全家美林店",
    "addr": "台北市中山區新生北路二段62巷38-3號",
    "pkey": "017730",
    "tel": "02-25678382"
}, {
    "name": "全家新晴店",
    "addr": "台北市中山區農安街4-1號",
    "pkey": "017811",
    "tel": "02-25955820"
}, {
    "name": "全家松農店",
    "addr": "台北市中山區農安街160號",
    "pkey": "013427",
    "tel": "02-25028032"
}, {
    "name": "全家新稻江店",
    "addr": "台北市中山區農安街86號1樓",
    "pkey": "015223",
    "tel": "02-25994657"
}, {
    "name": "全家農安店",
    "addr": "台北市中山區農安街249號",
    "pkey": "010883",
    "tel": "02-25042520"
}, {
    "name": "全家新農店",
    "addr": "台北市中山區農安街26之3號一樓",
    "pkey": "012329",
    "tel": "02-25968538"
}, {
    "name": "全家光輝店",
    "addr": "台北市中山區德惠街34之2號一樓",
    "pkey": "012471",
    "tel": "02-25955703"
}, {
    "name": "全家新德城店",
    "addr": "台北市中山區德惠街16-7號",
    "pkey": "013032",
    "tel": "02-25995447"
}, {
    "name": "全家德林店",
    "addr": "台北市中山區德惠街173號",
    "pkey": "012502",
    "tel": "02-25961560"
}, {
    "name": "全家撫順店",
    "addr": "台北市中山區撫順街12之2號1樓",
    "pkey": "013732",
    "tel": "02-25927495"
}, {
    "name": "全家樂群店",
    "addr": "台北市中山區樂群二路186號",
    "pkey": "015060",
    "tel": "02-85095167"
}, {
    "name": "全家美麗店",
    "addr": "台北市中山區樂群二路142號1樓",
    "pkey": "017888",
    "tel": "02-85011290"
}, {
    "name": "全家興安店",
    "addr": "台北市中山區興安街57號",
    "pkey": "011702",
    "tel": "02-25052013"
}, {
    "name": "全家錦江店",
    "addr": "台北市中山區錦州街215號",
    "pkey": "016672",
    "tel": "02-25638875"
}, {
    "name": "全家新北大店",
    "addr": "台北市中山區錦州街427號",
    "pkey": "015161",
    "tel": "02-25172305"
}, {
    "name": "全家錦西店",
    "addr": "台北市中山區錦西街8號",
    "pkey": "017032",
    "tel": "02-25673231"
}, {
    "name": "全家中興店",
    "addr": "台北市中山區龍江路201號1F",
    "pkey": "017058",
    "tel": "02-25012043"
}, {
    "name": "全家鑫豐店",
    "addr": "台北市中山區龍江路356巷72號",
    "pkey": "015663",
    "tel": "02-25157030"
}, {
    "name": "全家新南京店",
    "addr": "台北市中山區龍江路95號1樓",
    "pkey": "014112",
    "tel": "02-87725827"
}, {
    "name": "全家榮星店",
    "addr": "台北市中山區龍江路352號",
    "pkey": "014280",
    "tel": "02-25169569"
}, {
    "name": "全家雙林店",
    "addr": "台北市中山區雙城街2之2號",
    "pkey": "016078",
    "tel": "02-25992453"
}, {
    "name": "全家金磚店",
    "addr": "台北市中山區雙城街19巷2號",
    "pkey": "013731",
    "tel": "02-25994347"
}, {
    "name": "全家雙城店",
    "addr": "台北市中山區雙城街12之1號",
    "pkey": "016173",
    "tel": "02-25996056"
}, ], [{
    "name": "全家鑫德店",
    "addr": "臺北市松山區八德路二段400號",
    "pkey": "013938",
    "tel": "02-87717609"
}, {
    "name": "全家中崙店",
    "addr": "台北市松山區八德路三段74巷43號",
    "pkey": "015638",
    "tel": "02-25776466"
}, {
    "name": "全家寶清店",
    "addr": "台北市松山區八德路四段598號1樓",
    "pkey": "016953",
    "tel": "02-27532857"
}, {
    "name": "全家復盛店",
    "addr": "台北市松山區八德路四段40號．42號",
    "pkey": "016137",
    "tel": "02-27619127"
}, {
    "name": "全家京民店",
    "addr": "台北市松山區三民路6號＋B1",
    "pkey": "013794",
    "tel": "02-27422080"
}, {
    "name": "全家三富店",
    "addr": "台北市松山區三民路148號",
    "pkey": "017205",
    "tel": "02-27677510"
}, {
    "name": "全家常興店",
    "addr": "台北市松山區五常街364號1樓",
    "pkey": "016801",
    "tel": "02-25464600"
}, {
    "name": "全家微風店",
    "addr": "台北市松山區市民大道四段51號1樓",
    "pkey": "015587",
    "tel": "02-87719880"
}, {
    "name": "全家豐禾店",
    "addr": "台北市松山區民生東路三段130巷5弄2號",
    "pkey": "012220",
    "tel": "02-27126702"
}, {
    "name": "全家豐興店",
    "addr": "台北市松山區民生東路三段130巷5弄22號",
    "pkey": "013309",
    "tel": "02-25471001"
}, {
    "name": "全家豐華店",
    "addr": "台北市松山區民生東路三段113巷6弄1號一樓",
    "pkey": "013024",
    "tel": "02-27123226"
}, {
    "name": "全家敦德店",
    "addr": "台北市松山區民生東路三段127巷6號1樓",
    "pkey": "017087",
    "tel": "02-27130655"
}, {
    "name": "全家東豐店",
    "addr": "台北市松山區民生東路五段37號",
    "pkey": "014959",
    "tel": "02-27612771"
}, {
    "name": "全家松民店",
    "addr": "台北市松山區民生東路五段159號",
    "pkey": "016542",
    "tel": "02-37652608"
}, {
    "name": "全家昇東店",
    "addr": "台北市松山區民生東路五段197號",
    "pkey": "016472",
    "tel": "02-27491649"
}, {
    "name": "全家民復店",
    "addr": "台北市松山區民生東路四段80巷3號1F",
    "pkey": "016172",
    "tel": "02-25473532"
}, {
    "name": "全家中央店",
    "addr": "台北市松山區民生東路四段95號",
    "pkey": "016262",
    "tel": "02-25460351"
}, {
    "name": "全家興北店",
    "addr": "台北市松山區民權東路三段103巷15—1號",
    "pkey": "015862",
    "tel": "02-27150977"
}, {
    "name": "全家新民有店",
    "addr": "台北市松山區民權東路三段160巷11號",
    "pkey": "017122",
    "tel": "02-87129937"
}, {
    "name": "全家北權店",
    "addr": "台北市松山區民權東路三段106巷11號",
    "pkey": "014789",
    "tel": "02-25469055"
}, {
    "name": "全家松指部店",
    "addr": "臺北市松山區民權東路四段121號（松指部）",
    "pkey": "011881",
    "tel": "02-25475302"
}, {
    "name": "全家大理店",
    "addr": "台北市松山區光復北路11巷50號1樓",
    "pkey": "015906",
    "tel": "02-27473064"
}, {
    "name": "全家新德光店",
    "addr": "台北市松山區光復南路32巷46-4號",
    "pkey": "013740",
    "tel": "02-25780506"
}, {
    "name": "全家新大吉店",
    "addr": "台北市松山區吉祥路19號",
    "pkey": "014091",
    "tel": "02-27489223"
}, {
    "name": "全家松壽店",
    "addr": "台北市松山區延壽街330巷7弄22號一樓",
    "pkey": "016058",
    "tel": "02-27474015"
}, {
    "name": "全家塔悠店",
    "addr": "臺北市松山區延壽街2號一樓",
    "pkey": "016890",
    "tel": "02-27420973"
}, {
    "name": "全家長復店",
    "addr": "台北市松山區長安東路二段219號",
    "pkey": "014887",
    "tel": "02-27500001"
}, {
    "name": "全家力晶店",
    "addr": "台北市松山區南京東路三段258號",
    "pkey": "017487",
    "tel": "02-27213487"
}, {
    "name": "全家京暉店",
    "addr": "台北市松山區南京東路三段285號壹樓",
    "pkey": "017500",
    "tel": "02-25472310"
}, {
    "name": "全家新東寶店",
    "addr": "台北市松山區南京東路五段291巷14號",
    "pkey": "013920",
    "tel": "02-27605928"
}, {
    "name": "全家新東光店",
    "addr": "台北市松山區南京東路五段123巷1號1樓",
    "pkey": "014918",
    "tel": "02-37652819"
}, {
    "name": "全家京吉店",
    "addr": "台北市松山區南京東路五段180號",
    "pkey": "015823",
    "tel": "02-27478279"
}, {
    "name": "全家大盛店",
    "addr": "台北市松山區南京東路五段66巷2弄1之1號1樓",
    "pkey": "011716",
    "tel": "02-27650089"
}, {
    "name": "全家新健康店",
    "addr": "台北市松山區南京東路四段133巷9弄2號",
    "pkey": "017826",
    "tel": "02-25462607"
}, {
    "name": "全家京盛店",
    "addr": "台北市松山區南京東路四段56-1號1樓",
    "pkey": "015030",
    "tel": "02-25795737"
}, {
    "name": "全家巨星超市店",
    "addr": "台北市松山區南京東路四段2號（16、17號店舖）",
    "pkey": "017138",
    "tel": "02-25770670"
}, {
    "name": "全家京鑽店",
    "addr": "台北市松山區南京東路四段47號壹樓",
    "pkey": "017769",
    "tel": "02-25460775"
}, {
    "name": "全家民康店",
    "addr": "台北市松山區健康路285號1樓",
    "pkey": "017248",
    "tel": "02-27457090"
}, {
    "name": "全家康柏店",
    "addr": "台北市松山區健康路220號",
    "pkey": "013286",
    "tel": "02-27604612"
}, {
    "name": "全家松醫店",
    "addr": "台北市松山區健康路158號",
    "pkey": "011273",
    "tel": "02-27600199"
}, {
    "name": "全家富錦店",
    "addr": "台北市松山區富錦街529號一樓",
    "pkey": "017017",
    "tel": "02-27455196"
}, {
    "name": "全家敦中店",
    "addr": "台北市松山區敦化北路4巷1號",
    "pkey": "015863",
    "tel": "02-87716763"
}, {
    "name": "全家長城店",
    "addr": "台北市松山區敦化北路120巷80號",
    "pkey": "012657",
    "tel": "02-27176687"
}, {
    "name": "全家宏大店",
    "addr": "台北市松山區敦化北路155巷3號1樓",
    "pkey": "012127",
    "tel": "02-27183704"
}, {
    "name": "全家長塑店",
    "addr": "台北市松山區敦化北路199巷2弄5號1樓",
    "pkey": "016406",
    "tel": "02-27198993"
}, {
    "name": "全家松旺店",
    "addr": "台北市松山區塔悠路19號",
    "pkey": "016710",
    "tel": "02-37652775"
}, {
    "name": "全家新東店",
    "addr": "台北市松山區新東街14號",
    "pkey": "014542",
    "tel": "02-27653580"
}, {
    "name": "全家慶城店",
    "addr": "台北市松山區慶城街8號",
    "pkey": "014261",
    "tel": "02-25464461"
}, ], [{
    "name": "全家大安店",
    "addr": "台北市大安區大安路一段20號",
    "pkey": "013409",
    "tel": "02-27117896"
}, {
    "name": "全家仁慈店",
    "addr": "台北市大安區仁愛路四段48巷6號",
    "pkey": "011616",
    "tel": "02-27089002"
}, {
    "name": "全家明曜店",
    "addr": "台北市大安區仁愛路四段151巷34號．36號",
    "pkey": "014770",
    "tel": "02-27780326"
}, {
    "name": "全家國泰店",
    "addr": "台北市大安區仁愛路四段266巷15弄10號1樓",
    "pkey": "016473",
    "tel": "02-27542056"
}, {
    "name": "全家忠愛店",
    "addr": "台北市大安區仁愛路四段27巷43號",
    "pkey": "013596",
    "tel": "02-27314580"
}, {
    "name": "全家敦新店",
    "addr": "台北市大安區仁愛路四段112巷5號一樓",
    "pkey": "017725",
    "tel": "02-27057671"
}, {
    "name": "全家吉泰店",
    "addr": "台北市大安區仁愛路四段300巷11之1號",
    "pkey": "013899",
    "tel": "02-27001566"
}, {
    "name": "全家通昌店",
    "addr": "台北市大安區文昌街142號壹樓全部",
    "pkey": "014482",
    "tel": "02-23256420"
}, {
    "name": "全家安賢店",
    "addr": "臺北市大安區四維路170巷4號",
    "pkey": "017768",
    "tel": "02-27074252"
}, {
    "name": "全家華視店",
    "addr": "台北市大安區光復南路116巷26號",
    "pkey": "014368",
    "tel": "02-27310238"
}, {
    "name": "全家光新店",
    "addr": "台北市大安區光復南路418號",
    "pkey": "012911",
    "tel": "02-27849586"
}, {
    "name": "全家敦安店",
    "addr": "台北市大安區安和路一段112巷27號",
    "pkey": "016746",
    "tel": "02-27019097"
}, {
    "name": "全家和信店",
    "addr": "台北市大安區安和路一段104號",
    "pkey": "016909",
    "tel": "02-27556391"
}, {
    "name": "全家樂和店",
    "addr": "台北市大安區安和路二段169號",
    "pkey": "016351",
    "tel": "02-27329745"
}, {
    "name": "全家東方店",
    "addr": "台北市大安區安和路二段10巷10號壹樓及地下室",
    "pkey": "011102",
    "tel": "02-27039578"
}, {
    "name": "全家安居店",
    "addr": "台北市大安區安居街76號",
    "pkey": "016322",
    "tel": "02-27375452"
}, {
    "name": "全家辛亥店",
    "addr": "台北市大安區辛亥路二段171巷3號",
    "pkey": "013549",
    "tel": "02-23778503"
}, {
    "name": "全家二繽店",
    "addr": "台北市大安區辛亥路三段330號",
    "pkey": "015895",
    "tel": "02-27372960"
}, {
    "name": "全家台師店",
    "addr": "台北市大安區和平東路一段162號",
    "pkey": "016569",
    "tel": "02-23682773"
}, {
    "name": "全家成功店",
    "addr": "台北市大安區和平東路二段311巷32號",
    "pkey": "012910",
    "tel": "02-27550428"
}, {
    "name": "全家和東店",
    "addr": "台北市大安區和平東路二段102之3號1樓",
    "pkey": "011013",
    "tel": "02-27371371"
}, {
    "name": "全家和新店",
    "addr": "台北市大安區和平東路二段22號",
    "pkey": "001205",
    "tel": "02-83691009"
}, {
    "name": "全家和復店",
    "addr": "台北市大安區和平東路二段261號，263號",
    "pkey": "014395",
    "tel": "02-27540370"
}, {
    "name": "全家和茂店",
    "addr": "台北市大安區和平東路三段58號1樓",
    "pkey": "014448",
    "tel": "02-27371408"
}, {
    "name": "全家延安二店",
    "addr": "台北市大安區延吉街130號",
    "pkey": "013927",
    "tel": "02-87717379"
}, {
    "name": "全家延安店",
    "addr": "台北市大安區延吉街158號",
    "pkey": "017556",
    "tel": "02-87716553"
}, {
    "name": "全家延孝店",
    "addr": "台北市大安區延吉街135號之三，一樓",
    "pkey": "013082",
    "tel": "02-27405319"
}, {
    "name": "全家昌隆店",
    "addr": "台北市大安區忠孝東路三段217巷2弄1號1樓",
    "pkey": "011032",
    "tel": "02-87733114"
}, {
    "name": "全家延東店",
    "addr": "台北市大安區忠孝東路四段223巷41號",
    "pkey": "016517",
    "tel": "02-87724842"
}, {
    "name": "全家延吉店",
    "addr": "台北市大安區忠孝東路四段216巷31號",
    "pkey": "017206",
    "tel": "02-27412630"
}, {
    "name": "全家龍普店",
    "addr": "台北市大安區忠孝東路四段170巷6弄2號",
    "pkey": "015461",
    "tel": "02-87733622"
}, {
    "name": "全家台興店",
    "addr": "台北市大安區長興街50號",
    "pkey": "015746",
    "tel": "02-27324804"
}, {
    "name": "全家金信店",
    "addr": "台北市大安區信義路二段104號1樓",
    "pkey": "017363",
    "tel": "02-23587145"
}, {
    "name": "全家信美店",
    "addr": "臺北市大安區信義路三段134巷2號壹樓＋地下室",
    "pkey": "014695",
    "tel": "02-27544328"
}, {
    "name": "全家義安店",
    "addr": "台北市大安區信義路四段88號（部分）",
    "pkey": "014159",
    "tel": "02-27015844"
}, {
    "name": "全家義和店",
    "addr": "台北市大安區信義路四段265巷8號",
    "pkey": "014960",
    "tel": "02-27047661"
}, {
    "name": "全家義興店",
    "addr": "台北市大安區信義路四段1之10．1之11號",
    "pkey": "015666",
    "tel": "02-27048404"
}, {
    "name": "全家建南店",
    "addr": "台北市大安區建國南路一段156，158號",
    "pkey": "013898",
    "tel": "02-27318185"
}, {
    "name": "全家北科店",
    "addr": "台北市大安區建國南路一段81號",
    "pkey": "016573",
    "tel": "02-27762695"
}, {
    "name": "全家建國店",
    "addr": "台北市大安區建國南路二段151巷38號1樓",
    "pkey": "014393",
    "tel": "02-27540801"
}, {
    "name": "全家師大店",
    "addr": "台北市大安區師大路79號",
    "pkey": "017121",
    "tel": "02-23918196"
}, {
    "name": "全家通和店",
    "addr": "台北市大安區通安街77號",
    "pkey": "014206",
    "tel": "02-27331503"
}, {
    "name": "全家興忠店",
    "addr": "台北市大安區復興南路一段200號",
    "pkey": "016321",
    "tel": "02-27419504"
}, {
    "name": "全家興仁店",
    "addr": "台北市大安區復興南路一段217號",
    "pkey": "010475",
    "tel": "02-87732350"
}, {
    "name": "全家懷生店",
    "addr": "台北市大安區復興南路一段70號",
    "pkey": "015263",
    "tel": "02-27763718"
}, {
    "name": "全家興和店",
    "addr": "台北市大安區復興南路二段153號",
    "pkey": "015818",
    "tel": "02-27845780"
}, {
    "name": "全家興南店",
    "addr": "台北市大安區復興南路二段8，10號",
    "pkey": "012603",
    "tel": "02-27552227"
}, {
    "name": "全家新敦民店",
    "addr": "臺北市大安區敦化南路一段161巷7號",
    "pkey": "014052",
    "tel": "02-27111320"
}, {
    "name": "全家忠孝店",
    "addr": "台北市大安區敦化南路一段190巷7號",
    "pkey": "017287",
    "tel": "02-27780668"
}, {
    "name": "全家新遠企店",
    "addr": "台北市大安區敦化南路二段261號",
    "pkey": "011894",
    "tel": "02-27323623"
}, {
    "name": "全家新生南路店",
    "addr": "台北市大安區新生南路一段163號",
    "pkey": "012805",
    "tel": "02-27035220"
}, {
    "name": "全家大森店",
    "addr": "台北市大安區新生南路一段165巷35號",
    "pkey": "016790",
    "tel": "02-27005349"
}, {
    "name": "全家台新店",
    "addr": "台北市大安區新生南路三段84之8號",
    "pkey": "016709",
    "tel": "02-23626210"
}, {
    "name": "全家瑞和店",
    "addr": "台北市大安區瑞安街135巷28號1樓",
    "pkey": "012658",
    "tel": "02-27049888"
}, {
    "name": "全家濟南二店",
    "addr": "台北市大安區濟南路三段7號",
    "pkey": "013823",
    "tel": "02-87734589"
}, {
    "name": "全家臨江店",
    "addr": "台北市大安區臨江街2巷2號",
    "pkey": "017497",
    "tel": "02-27322438"
}, {
    "name": "全家古亭店",
    "addr": "台北市大安區羅斯福路二段103號",
    "pkey": "011105",
    "tel": "02-23673372"
}, {
    "name": "全家羅中店",
    "addr": "台北市大安區羅斯福路二段17號1F",
    "pkey": "013639",
    "tel": "02-23924175"
}, {
    "name": "全家羅騰店",
    "addr": "台北市大安區羅斯福路三段269巷2號",
    "pkey": "014346",
    "tel": "02-23651801"
}, {
    "name": "全家新台大店",
    "addr": "臺北市大安區羅斯福路四段1號第一學生活動中心",
    "pkey": "011741",
    "tel": "02-23688949"
}, {
    "name": "全家台福店",
    "addr": "台北市大安區羅斯福路四段1號腳踏車部部份空間",
    "pkey": "013518",
    "tel": "02-83691892"
}, {
    "name": "全家台大楓林店",
    "addr": "台北市大安區羅斯福路四段1號（女九餐廳）",
    "pkey": "017548",
    "tel": "02-23675017"
}, {
    "name": "全家台大二活店",
    "addr": "台北市大安區羅斯福路四段85號（第二學生活動中心）",
    "pkey": "017186",
    "tel": "02-23661941"
}, ], [{
    "name": "全家民和店",
    "addr": "台北市萬華區民和街9號1樓",
    "pkey": "016199",
    "tel": "02-23039216"
}, {
    "name": "全家萬園店",
    "addr": "台北市萬華區西園路一段159號壹樓",
    "pkey": "015429",
    "tel": "02-23040410"
}, {
    "name": "全家金園店",
    "addr": "臺北市萬華區西園路二段140巷42號",
    "pkey": "015892",
    "tel": "02-23083402"
}, {
    "name": "全家萬年店",
    "addr": "台北市萬華區西寧南路155號1樓",
    "pkey": "013811",
    "tel": "02-23883343"
}, {
    "name": "全家和西店",
    "addr": "台北市萬華區和平西路三段290之5號、290",
    "pkey": "017367",
    "tel": "02-23080749"
}, {
    "name": "全家昆明店",
    "addr": "台北市萬華區昆明街186號1樓",
    "pkey": "014885",
    "tel": "02-23705910"
}, {
    "name": "全家成都店",
    "addr": "台北市萬華區昆明街134號；成都路86號",
    "pkey": "013285",
    "tel": "02-23758507"
}, {
    "name": "全家萬昌店",
    "addr": "台北市萬華區昆明街92-1號1樓",
    "pkey": "015859",
    "tel": "02-23822578"
}, {
    "name": "全家萬東店",
    "addr": "台北市萬華區東園街174號1樓",
    "pkey": "014839",
    "tel": "02-23077891"
}, {
    "name": "全家鑫吉利店",
    "addr": "台北市萬華區東園街28巷34號",
    "pkey": "016130",
    "tel": "02-23378557"
}, {
    "name": "全家東園店",
    "addr": "台北市萬華區東園街69號",
    "pkey": "017723",
    "tel": "02-23327420"
}, {
    "name": "全家長泰店",
    "addr": "台北市萬華區長泰街2號2之1號一樓",
    "pkey": "015543",
    "tel": "02-23034841"
}, {
    "name": "全家公園店",
    "addr": "台北市萬華區青年路48號",
    "pkey": "015730",
    "tel": "02-23051904"
}, {
    "name": "全家日祥店",
    "addr": "台北市萬華區青年路154號、168巷2弄14號1樓",
    "pkey": "017099",
    "tel": "02-23331039"
}, {
    "name": "全家新青年店",
    "addr": "臺北市萬華區青年路6號",
    "pkey": "017866",
    "tel": "02-23331983"
}, {
    "name": "全家新峨嵋店",
    "addr": "台北市萬華區峨眉街82號1樓",
    "pkey": "017651",
    "tel": "02-23711411"
}, {
    "name": "全家萬國店",
    "addr": "台北市萬華區峨眉街21號1樓",
    "pkey": "013812",
    "tel": "02-23894642"
}, {
    "name": "全家桂林店",
    "addr": "台北市萬華區桂林路23號1樓",
    "pkey": "016202",
    "tel": "02-23318161"
}, {
    "name": "全家康定店",
    "addr": "台北市萬華區康定路73號",
    "pkey": "014905",
    "tel": "02-23899260"
}, {
    "name": "全家康陽店",
    "addr": "台北市萬華區康定路99號",
    "pkey": "015851",
    "tel": "02-23812716"
}, {
    "name": "全家康勝店",
    "addr": "台北市萬華區康定路60號1樓",
    "pkey": "016682",
    "tel": "02-23821077"
}, {
    "name": "全家新富民店",
    "addr": "台北市萬華區富民路91巷8號1樓",
    "pkey": "015943",
    "tel": "02-23070071"
}, {
    "name": "全家貴陽店",
    "addr": "台北市萬華區貴陽街二段182號，184號",
    "pkey": "017698",
    "tel": "02-23891854"
}, {
    "name": "全家新武成店",
    "addr": "台北市萬華區萬大路486巷59弄1號1樓",
    "pkey": "017153",
    "tel": "02-23326103"
}, {
    "name": "全家萬中店",
    "addr": "台北市萬華區漢口街二段22號",
    "pkey": "015246",
    "tel": "02-23887636"
}, {
    "name": "全家萬明店",
    "addr": "台北市萬華區漢口街二段67之2號1樓",
    "pkey": "017790",
    "tel": "02-23119635"
}, {
    "name": "全家漢中店",
    "addr": "台北市萬華區漢中街139號1樓",
    "pkey": "017430",
    "tel": "02-23141275"
}, {
    "name": "全家龍廣店",
    "addr": "台北市萬華區廣州街203號1．2樓",
    "pkey": "017328",
    "tel": "02-23026434"
}, {
    "name": "全家新廣州店",
    "addr": "台北市萬華區廣州街235-1號",
    "pkey": "016407",
    "tel": "02-23027354"
}, {
    "name": "全家新興義店",
    "addr": "台北市萬華區興義街41號1樓",
    "pkey": "016734",
    "tel": "02-23034328"
}, {
    "name": "全家綠堤店",
    "addr": "台北市萬華區環河南路二段173號",
    "pkey": "013690",
    "tel": "02-23041210"
}, {
    "name": "全家環南店",
    "addr": "台北市萬華區環河南路二段298號",
    "pkey": "017103",
    "tel": "02-23026891"
}, {
    "name": "全家寶元店",
    "addr": "台北市萬華區寶興街40號",
    "pkey": "014743",
    "tel": "02-23099925"
}, {
    "name": "全家寶興店",
    "addr": "台北市萬華區寶興街78號",
    "pkey": "016832",
    "tel": "02-23013308"
}, ], [{
    "name": "全家大道店",
    "addr": "台北市信義區大道路79號1樓",
    "pkey": "015953",
    "tel": "02-27276692"
}, {
    "name": "全家五分埔店",
    "addr": "台北市信義區中坡北路23號1樓",
    "pkey": "014917",
    "tel": "02-27653612"
}, {
    "name": "全家新中坡店",
    "addr": "台北市信義區中坡南路229號",
    "pkey": "016421",
    "tel": "02-27270460"
}, {
    "name": "全家協和店",
    "addr": "台北市信義區中坡南路38號1F",
    "pkey": "015064",
    "tel": "02-27590819"
}, {
    "name": "全家永吉二店",
    "addr": "台北市信義區永吉路223號",
    "pkey": "012953",
    "tel": "02-27491648"
}, {
    "name": "全家厚雅店",
    "addr": "台北市信義區永吉路30巷118號1樓",
    "pkey": "017731",
    "tel": "02-27659814"
}, {
    "name": "全家光復南路店",
    "addr": "台北市信義區光復南路447之2號",
    "pkey": "016838",
    "tel": "02-27294291"
}, {
    "name": "全家復昌店",
    "addr": "台北市信義區光復南路505號、507號及文昌街32",
    "pkey": "017767",
    "tel": "02-23459489"
}, {
    "name": "全家盛興店",
    "addr": "台北市信義區吳興街334號",
    "pkey": "015433",
    "tel": "02-27201400"
}, {
    "name": "全家北醫店",
    "addr": "台北市信義區吳興街263號",
    "pkey": "016260",
    "tel": "02-27229824"
}, {
    "name": "全家三興店",
    "addr": "台北市信義區吳興街7號",
    "pkey": "017120",
    "tel": "02-27232796"
}, {
    "name": "全家六張黎店",
    "addr": "台北市信義區和平東路三段387號",
    "pkey": "016604",
    "tel": "02-27338739"
}, {
    "name": "全家忠信店",
    "addr": "台北市信義區忠孝東路五段425號1樓及地下室",
    "pkey": "016839",
    "tel": "02-27422963"
}, {
    "name": "全家新忠隆店",
    "addr": "台北市信義區忠孝東路五段71巷8號壹樓",
    "pkey": "012808",
    "tel": "02-27493532"
}, {
    "name": "全家永信店",
    "addr": "台北市信義區忠孝東路五段472號",
    "pkey": "017031",
    "tel": "02-87807876"
}, {
    "name": "全家聯合店",
    "addr": "台北市信義區忠孝東路四段553巷6弄17號1樓",
    "pkey": "014769",
    "tel": "02-27685432"
}, {
    "name": "全家松興店",
    "addr": "台北市信義區松山路107號",
    "pkey": "012602",
    "tel": "02-27603790"
}, {
    "name": "全家松盛店",
    "addr": "台北市信義區松山路153號",
    "pkey": "013949",
    "tel": "02-27606140"
}, {
    "name": "全家崧捷店",
    "addr": "台北市信義區松山路11號",
    "pkey": "016138",
    "tel": "02-27656379"
}, {
    "name": "全家欣松春店",
    "addr": "台北市信義區松山路281號1樓",
    "pkey": "013312",
    "tel": "02-27493963"
}, {
    "name": "全家新安興店",
    "addr": "台北市信義區松仁路240巷2號",
    "pkey": "016145",
    "tel": "02-27204938"
}, {
    "name": "全家永孝店",
    "addr": "台北市信義區松信路145號",
    "pkey": "017679",
    "tel": "02-27678185"
}, {
    "name": "全家松站店",
    "addr": "台北市信義區松隆路329巷8號壹樓",
    "pkey": "016261",
    "tel": "02-27678206"
}, {
    "name": "全家建鑫店",
    "addr": "台北市信義區松壽路24號",
    "pkey": "017309",
    "tel": "02-27233205"
}, {
    "name": "全家松永店",
    "addr": "台北市信義區松德路157號",
    "pkey": "016465",
    "tel": "02-23465356"
}, {
    "name": "全家新信德店",
    "addr": "台北市信義區松德路283號",
    "pkey": "013167",
    "tel": "02-23465799"
}, {
    "name": "全家信安店",
    "addr": "台北市信義區松德路200巷13號1樓",
    "pkey": "015265",
    "tel": "02-87895039"
}, {
    "name": "全家新松林店",
    "addr": "台北市信義區虎林街61-4號",
    "pkey": "012985",
    "tel": "02-27493109"
}, {
    "name": "全家欣富台店",
    "addr": "台北市信義區虎林街120巷165號",
    "pkey": "015896",
    "tel": "02-27491525"
}, {
    "name": "全家忠林店",
    "addr": "台北市信義區虎林街166號1樓及地下室",
    "pkey": "016495",
    "tel": "02-87891305"
}, {
    "name": "全家永林店",
    "addr": "台北市信義區虎林街82巷23號",
    "pkey": "014999",
    "tel": "02-27470209"
}, {
    "name": "全家海華店",
    "addr": "台北市信義區虎林街132巷81號1樓",
    "pkey": "015819",
    "tel": "02-87890667"
}, {
    "name": "全家祥和店",
    "addr": "台北市信義區信義路五段150巷401弄31號",
    "pkey": "017662",
    "tel": "02-27291793"
}, {
    "name": "全家外貿店",
    "addr": "台北市信義區信義路五段5號2樓",
    "pkey": "015758",
    "tel": "02-27209160"
}, {
    "name": "全家松仁店",
    "addr": "台北市信義區信義路五段150巷221號",
    "pkey": "015083",
    "tel": "02-27237309"
}, {
    "name": "全家松友店",
    "addr": "台北市信義區信義路六段78號",
    "pkey": "017689",
    "tel": "02-23460402"
}, {
    "name": "全家新貿店",
    "addr": "臺北市信義區信義路四段407號壹樓",
    "pkey": "012171",
    "tel": "02-87802293"
}, {
    "name": "全家永隆店",
    "addr": "台北市信義區基隆路一段147巷7號",
    "pkey": "012588",
    "tel": "02-27678120"
}, {
    "name": "全家崇德店",
    "addr": "台北市信義區崇德街29號",
    "pkey": "015668",
    "tel": "02-27333493"
}, {
    "name": "全家莊新店",
    "addr": "台北市信義區莊敬路307號",
    "pkey": "014889",
    "tel": "02-27581883"
}, {
    "name": "全家莊敬店",
    "addr": "台北市信義區莊敬路374號",
    "pkey": "016678",
    "tel": "02-27201156"
}, ], [{
    "name": "全家芝玉店",
    "addr": "台北市士林區士東路266巷5弄16號",
    "pkey": "016375",
    "tel": "02-28343943"
}, {
    "name": "全家新士誠店",
    "addr": "台北市士林區士東路86號壹樓",
    "pkey": "017575",
    "tel": "02-28314357"
}, {
    "name": "全家大南店",
    "addr": "台北市士林區大南路52號",
    "pkey": "015059",
    "tel": "02-28833976"
}, {
    "name": "全家華港店",
    "addr": "台北市士林區大南路231號",
    "pkey": "015792",
    "tel": "02-28810722"
}, {
    "name": "全家士林店",
    "addr": "台北市士林區中山北路五段697號",
    "pkey": "013370",
    "tel": "02-28348066"
}, {
    "name": "全家榮富店",
    "addr": "台北市士林區中山北路六段726號北側",
    "pkey": "012924",
    "tel": "02-28768631"
}, {
    "name": "全家天強店",
    "addr": "台北市士林區中山北路六段238號壹樓",
    "pkey": "014985",
    "tel": "02-28317990"
}, {
    "name": "全家士商店",
    "addr": "台北市士林區中正路503號",
    "pkey": "017340",
    "tel": "02-28838435"
}, {
    "name": "全家新陽明店",
    "addr": "臺北市士林區中正路329號",
    "pkey": "016684",
    "tel": "02-28818262"
}, {
    "name": "全家福林店",
    "addr": "台北市士林區中正路233號，233之1號",
    "pkey": "016707",
    "tel": "02-88611682"
}, {
    "name": "全家新磺溪店",
    "addr": "台北市士林區天母西路40-2號1樓",
    "pkey": "015200",
    "tel": "02-28767673"
}, {
    "name": "全家天山店",
    "addr": "台北市士林區天母東路69巷11之9號1樓",
    "pkey": "014438",
    "tel": "02-28769215"
}, {
    "name": "全家天成店",
    "addr": "台北市士林區天母東路36號之5，之6",
    "pkey": "014541",
    "tel": "02-28747141"
}, {
    "name": "全家大北店",
    "addr": "臺北市士林區文林路320號",
    "pkey": "013548",
    "tel": "02-28819255"
}, {
    "name": "全家華崗店",
    "addr": "台北市士林區光華路26巷3號-2",
    "pkey": "013571",
    "tel": "02-28629007"
}, {
    "name": "全家中影店",
    "addr": "台北市士林區至善路二段34號",
    "pkey": "017406",
    "tel": "02-28839581"
}, {
    "name": "全家至善店",
    "addr": "台北市士林區至善路二段268號一樓",
    "pkey": "011021",
    "tel": "02-28414153"
}, {
    "name": "全家和豐店",
    "addr": "台北市士林區和豐街2號一樓",
    "pkey": "013958",
    "tel": "02-28813084"
}, {
    "name": "全家葫蘆店",
    "addr": "台北市士林區延平北路五段283之1號",
    "pkey": "016798",
    "tel": "02-88114965"
}, {
    "name": "全家新蘭雅店",
    "addr": "台北市士林區忠誠路二段52號壹樓及地下室部份",
    "pkey": "014987",
    "tel": "02-28314977"
}, {
    "name": "全家新天和店",
    "addr": "台北市士林區忠誠路二段168號1樓",
    "pkey": "014186",
    "tel": "02-28723753"
}, {
    "name": "全家誠德店",
    "addr": "台北市士林區忠誠路二段5號1樓",
    "pkey": "016412",
    "tel": "02-28344780"
}, {
    "name": "全家永新店",
    "addr": "台北市士林區社子街27號",
    "pkey": "010706",
    "tel": "02-28113436"
}, {
    "name": "全家社中店",
    "addr": "台北市士林區社中街386號",
    "pkey": "014540",
    "tel": "02-28132673"
}, {
    "name": "全家致昇店",
    "addr": "台北市士林區雨聲街36號1樓",
    "pkey": "017718",
    "tel": "02-28385392"
}, {
    "name": "全家大港店",
    "addr": "台北市士林區前港街39號",
    "pkey": "011515",
    "tel": "02-28832065"
}, {
    "name": "全家福港店",
    "addr": "台北市士林區前港街126號",
    "pkey": "014902",
    "tel": "02-28804266"
}, {
    "name": "全家天文店",
    "addr": "台北市士林區美崙街118號",
    "pkey": "014389",
    "tel": "02-28319102"
}, {
    "name": "全家新葫東店",
    "addr": "台北市士林區重慶北路四段184號1樓",
    "pkey": "014686",
    "tel": "02-28162923"
}, {
    "name": "全家新格致店",
    "addr": "台北市士林區格致路53號1樓",
    "pkey": "016306",
    "tel": "02-28623855"
}, {
    "name": "全家通河店",
    "addr": "台北市士林區通河街145號",
    "pkey": "016516",
    "tel": "02-28858507"
}, {
    "name": "全家新文大店",
    "addr": "台北市士林區華岡路55號",
    "pkey": "014455",
    "tel": "02-28620079"
}, {
    "name": "全家美崙店",
    "addr": "台北市士林區華榮街97號",
    "pkey": "017408",
    "tel": "02-28346427"
}, {
    "name": "全家百齡店",
    "addr": "台北市士林區福港街158-1號",
    "pkey": "016305",
    "tel": "02-28834606"
}, {
    "name": "全家芝蘭店",
    "addr": "台北市士林區德行東路330號",
    "pkey": "016784",
    "tel": "02-28314783"
}, {
    "name": "全家德忠店",
    "addr": "台北市士林區德行東路109巷75號壹樓",
    "pkey": "013150",
    "tel": "02-28318420"
}, {
    "name": "全家德行店",
    "addr": "台北市士林區德行東路109巷3號",
    "pkey": "014141",
    "tel": "02-28314191"
}, {
    "name": "全家東大店",
    "addr": "台北市士林區臨溪路70號",
    "pkey": "012149",
    "tel": "02-28835919"
}, ], [{
    "name": "全家崇合店",
    "addr": "台北市北投區三合街二段487號1樓",
    "pkey": "014838",
    "tel": "02-28972076"
}, {
    "name": "全家大同店",
    "addr": "台北市北投區大業路452巷31號",
    "pkey": "013332",
    "tel": "02-28919974"
}, {
    "name": "全家大業店",
    "addr": "台北市北投區大興街22號",
    "pkey": "014373",
    "tel": "02-28964457"
}, {
    "name": "全家甲桂林店",
    "addr": "台北市北投區中山北路七段219巷3弄171號壹樓",
    "pkey": "015397",
    "tel": "02-28725427"
}, {
    "name": "全家文化店",
    "addr": "台北市北投區中央北路二段97號1樓",
    "pkey": "016219",
    "tel": "02-28976316"
}, {
    "name": "全家新復興崗店",
    "addr": "台北市北投區中央北路三段4號1樓",
    "pkey": "015782",
    "tel": "02-28910617"
}, {
    "name": "全家中央南路店",
    "addr": "台北市北投區中央南路二段15號1樓",
    "pkey": "017247",
    "tel": "02-28911712"
}, {
    "name": "全家新和店",
    "addr": "台北市北投區中和街489號",
    "pkey": "012067",
    "tel": "02-28912821"
}, {
    "name": "全家復中店",
    "addr": "台北市北投區中和街328號1樓",
    "pkey": "016498",
    "tel": "02-28924021"
}, {
    "name": "全家中永店",
    "addr": "台北市北投區中和街252號一樓",
    "pkey": "015082",
    "tel": "02-28949813"
}, {
    "name": "全家新奇岩店",
    "addr": "台北市北投區公館路230號",
    "pkey": "017098",
    "tel": "02-28947281"
}, {
    "name": "全家永興店",
    "addr": "台北市北投區永興路一段1號、3號一樓",
    "pkey": "013283",
    "tel": "02-28947414"
}, {
    "name": "全家榮光店",
    "addr": "台北市北投區石牌路一段166巷93號",
    "pkey": "016515",
    "tel": "02-28217765"
}, {
    "name": "全家北榮店",
    "addr": "台北市北投區石牌路二段201號",
    "pkey": "014647",
    "tel": "02-28766755"
}, {
    "name": "全家華勝店",
    "addr": "台北市北投區石牌路二段88之1號1樓",
    "pkey": "016961",
    "tel": "02-28217248"
}, {
    "name": "全家陽大店",
    "addr": "台北市北投區立農街二段155號1樓",
    "pkey": "015891",
    "tel": "02-28272232"
}, {
    "name": "全家光明店",
    "addr": "台北市北投區光明路23號，25號",
    "pkey": "011823",
    "tel": "02-28966631"
}, {
    "name": "全家北投店",
    "addr": "台北市北投區光明路218之1號",
    "pkey": "013491",
    "tel": "02-28941595"
}, {
    "name": "全家新自強店",
    "addr": "台北市北投區自強街116號1樓",
    "pkey": "016560",
    "tel": "02-28212852"
}, {
    "name": "全家東陽店",
    "addr": "台北市北投區西安街一段283號",
    "pkey": "015347",
    "tel": "02-28212319"
}, {
    "name": "全家唭哩店",
    "addr": "臺北市北投區西安街二段283號",
    "pkey": "016748",
    "tel": "02-28219568"
}, {
    "name": "全家立賢店",
    "addr": "台北市北投區承德路七段290號",
    "pkey": "013569",
    "tel": "02-28202721"
}, {
    "name": "全家明德店",
    "addr": "台北市北投區明德路93號",
    "pkey": "017081",
    "tel": "02-28239507"
}, {
    "name": "全家東華店",
    "addr": "台北市北投區東華街二段88號",
    "pkey": "014539",
    "tel": "02-28232256"
}, {
    "name": "全家新知行店",
    "addr": "臺北市北投區知行路237號",
    "pkey": "013901",
    "tel": "02-28586738"
}, {
    "name": "全家行勝店",
    "addr": "台北市北投區知行路298號1樓",
    "pkey": "016300",
    "tel": "02-28586707"
}, {
    "name": "全家振華店",
    "addr": "台北市北投區振華街2號",
    "pkey": "014771",
    "tel": "02-28232410"
}, {
    "name": "全家清江店",
    "addr": "台北市北投區清江路1號，中央南路一段63號",
    "pkey": "015119",
    "tel": "02-28970433"
}, {
    "name": "全家尊賢店",
    "addr": "台北市北投區尊賢街260號1F",
    "pkey": "017007",
    "tel": "02-28271417"
}, {
    "name": "全家新實店",
    "addr": "臺北市北投區實踐街51號1樓",
    "pkey": "009489",
    "tel": "02-28236547"
}, ], [{
    "name": "全家麗山店",
    "addr": "台北市內湖區內湖路一段737巷49號",
    "pkey": "017163",
    "tel": "02-26279495"
}, {
    "name": "全家湖安店",
    "addr": "台北市內湖區內湖路一段285巷19號1樓",
    "pkey": "013996",
    "tel": "02-26591427"
}, {
    "name": "全家碧湖店",
    "addr": "台北市內湖區內湖路一段593號一樓及地下室",
    "pkey": "011528",
    "tel": "02-26277149"
}, {
    "name": "全家麗水店",
    "addr": "台北市內湖區內湖路一段733號1樓",
    "pkey": "016568",
    "tel": "02-26272956"
}, {
    "name": "全家湖濱店",
    "addr": "臺北市內湖區內湖路二段103巷104號",
    "pkey": "012857",
    "tel": "02-26593051"
}, {
    "name": "全家文湖店",
    "addr": "台北市內湖區文湖街59號",
    "pkey": "017393",
    "tel": "02-27973433"
}, {
    "name": "全家紫陽店",
    "addr": "台北市內湖區文德路212號",
    "pkey": "016630",
    "tel": "02-87519703"
}, {
    "name": "全家瑞陽店",
    "addr": "台北市內湖區文德路90巷49號",
    "pkey": "016951",
    "tel": "02-26597471"
}, {
    "name": "全家德陽店",
    "addr": "臺北市內湖區文德路22巷25號",
    "pkey": "016895",
    "tel": "02-27987160"
}, {
    "name": "全家民善店",
    "addr": "台北市內湖區民善街1號1樓",
    "pkey": "017999",
    "tel": "02-87922468"
}, {
    "name": "全家三民店",
    "addr": "台北市內湖區民權東路六段90巷1號",
    "pkey": "016265",
    "tel": "02-27942827"
}, {
    "name": "全家內華店",
    "addr": "台北市內湖區民權東路六段162號",
    "pkey": "014391",
    "tel": "02-27911354"
}, {
    "name": "全家金莊店",
    "addr": "台北市內湖區石潭路67號1樓",
    "pkey": "014027",
    "tel": "02-27941829"
}, {
    "name": "全家東安店",
    "addr": "台北市內湖區安康路480號",
    "pkey": "013902",
    "tel": "02-26345521"
}, {
    "name": "全家新三總店",
    "addr": "台北市內湖區成功路二段325號B1F",
    "pkey": "016534",
    "tel": "02-87917684"
}, {
    "name": "全家新內湖店",
    "addr": "臺北市內湖區成功路二段420號",
    "pkey": "015371",
    "tel": "02-27948239"
}, {
    "name": "全家德湖店",
    "addr": "台北市內湖區成功路四段62號1樓及B1",
    "pkey": "017622",
    "tel": "02-87923344"
}, {
    "name": "全家湖盛店",
    "addr": "台北市內湖區成功路四段143號",
    "pkey": "015508",
    "tel": "02-87921285"
}, {
    "name": "全家行善店",
    "addr": "臺北市內湖區行善路289號",
    "pkey": "013637",
    "tel": "02-27967192"
}, {
    "name": "全家新東湖店",
    "addr": "臺北市內湖區東湖路43巷4號",
    "pkey": "017030",
    "tel": "02-26317679"
}, {
    "name": "全家金瑞店",
    "addr": "臺北市內湖區金龍路224號",
    "pkey": "017786",
    "tel": "02-27934276"
}, {
    "name": "全家星湖店",
    "addr": "台北市內湖區星雲街161巷1號",
    "pkey": "016673",
    "tel": "02-27906271"
}, {
    "name": "全家內科店",
    "addr": "台北市內湖區洲子街61號1樓（部份）",
    "pkey": "017501",
    "tel": "02-87511523"
}, {
    "name": "全家康雲店",
    "addr": "台北市內湖區康寧路一段116號及地下室",
    "pkey": "015810",
    "tel": "02-27940805"
}, {
    "name": "全家紫新店",
    "addr": "台北市內湖區康寧路ㄧ段37號ㄧ樓",
    "pkey": "016456",
    "tel": "02-27940091"
}, {
    "name": "全家護校店",
    "addr": "台北市內湖區康寧路三段75巷137號",
    "pkey": "013798",
    "tel": "02-26342271"
}, {
    "name": "全家康福店",
    "addr": "台北市內湖區康樂街87號",
    "pkey": "014160",
    "tel": "02-26339860"
}, {
    "name": "全家精英店",
    "addr": "台北市內湖區堤頂大道二段241號壹樓",
    "pkey": "014042",
    "tel": "02-26579148"
}, {
    "name": "全家新瑞店",
    "addr": "台北市內湖區堤頂大道二段407巷26號一樓",
    "pkey": "014663",
    "tel": "02-26592842"
}, {
    "name": "全家興盛店",
    "addr": "台北市內湖區新明路182號",
    "pkey": "012756",
    "tel": "02-27903667"
}, {
    "name": "全家新湖店",
    "addr": "台北市內湖區新湖二路250巷8號1樓",
    "pkey": "014943",
    "tel": "02-27937065"
}, {
    "name": "全家瑞湖店",
    "addr": "台北市內湖區瑞光路513巷39號1樓",
    "pkey": "013730",
    "tel": "02-87524016"
}, {
    "name": "全家瑞光店",
    "addr": "台北市內湖區瑞光路510號1樓",
    "pkey": "008784",
    "tel": "02-87514993"
}, {
    "name": "全家瑞興店",
    "addr": "台北市內湖區瑞光路303號",
    "pkey": "015849",
    "tel": "02-26591468"
}, {
    "name": "全家瑞盛店",
    "addr": "台北市內湖區瑞光路66巷40號",
    "pkey": "015393",
    "tel": "02-87926581"
}, {
    "name": "全家新德明店",
    "addr": "臺北市內湖區環山路一段110號",
    "pkey": "013284",
    "tel": "02-27996853"
}, {
    "name": "全家環山店",
    "addr": "台北市內湖區環山路一段5號",
    "pkey": "014772",
    "tel": "02-26271008"
}, {
    "name": "全家湖山店",
    "addr": "台北市內湖區麗山街348巷10弄2號",
    "pkey": "015432",
    "tel": "02-26572616"
}, ], [{
    "name": "全家工業三店",
    "addr": "台北市南港區三重路66之2號1樓",
    "pkey": "017680",
    "tel": "02-27833949"
}, {
    "name": "全家工業一店",
    "addr": "台北市南港區三重路19-7號內之一部份",
    "pkey": "013755",
    "tel": "02-26550313"
}, {
    "name": "全家北鑫店",
    "addr": "台北市南港區中坡南路15號",
    "pkey": "010980",
    "tel": "02-27866062"
}, {
    "name": "全家新成鑫店",
    "addr": "台北市南港區玉成街176巷1號",
    "pkey": "015639",
    "tel": "02-27853529"
}, {
    "name": "全家南港車站店",
    "addr": "台北市南港區忠孝東路七段371號B2",
    "pkey": "017777",
    "tel": "02-27837703"
}, {
    "name": "全家新昆陽店",
    "addr": "台北市南港區昆陽街145號",
    "pkey": "014774",
    "tel": "02-27883495"
}, {
    "name": "全家港成店",
    "addr": "台北市南港區南港路三段2號",
    "pkey": "014576",
    "tel": "02-26548729"
}, {
    "name": "全家研究院店",
    "addr": "台北市南港區研究院路二段70巷1號",
    "pkey": "016464",
    "tel": "02-26515140"
}, {
    "name": "全家華科大店",
    "addr": "台北市南港區研究院路三段245號",
    "pkey": "014456",
    "tel": "02-26548039"
}, {
    "name": "全家重陽店",
    "addr": "台北市南港區重陽路183、185號1樓",
    "pkey": "013890",
    "tel": "02-27893918"
}, {
    "name": "全家向陽店",
    "addr": "台北市南港區重陽路16號一樓",
    "pkey": "016840",
    "tel": "02-27887390"
}, {
    "name": "全家富康店",
    "addr": "台北市南港區富康街86號1F",
    "pkey": "010985",
    "tel": "02-27821423"
}, {
    "name": "全家工業二店",
    "addr": "台北市南港區園區街3號2樓之7",
    "pkey": "012973",
    "tel": "02-26558763"
}, {
    "name": "全家港福店",
    "addr": "台北市南港區福德街373巷63號1樓",
    "pkey": "013158",
    "tel": "02-26543532"
}, {
    "name": "全家中視店",
    "addr": "台北市南港區興南街39號1樓",
    "pkey": "012943",
    "tel": "02-27864176"
}, {
    "name": "全家興華店",
    "addr": "台北市南港區興華路86號",
    "pkey": "017488",
    "tel": "02-27834076"
}, {
    "name": "全家國興店",
    "addr": "台北市南港區舊莊街一段3巷3弄2號",
    "pkey": "015973",
    "tel": "02-27832665"
}, {
    "name": "全家胡適店",
    "addr": "台北市南港區舊莊街一段3巷16號",
    "pkey": "010358",
    "tel": "02-27888455"
}, {
    "name": "全家新莊研店",
    "addr": "台北市南港區舊莊街一段169號",
    "pkey": "014856",
    "tel": "02-27853487"
}, ], [{
    "name": "全家試院店",
    "addr": "台北市文山區木柵路一段91號93號一樓",
    "pkey": "016093",
    "tel": "02-22369520"
}, {
    "name": "全家木興店",
    "addr": "台北市文山區木柵路二段52號",
    "pkey": "013748",
    "tel": "02-22348419"
}, {
    "name": "全家明興店",
    "addr": "台北市文山區木柵路二段109巷25弄2號．2-1號",
    "pkey": "016837",
    "tel": "02-86618412"
}, {
    "name": "全家木柵路店",
    "addr": "台北市文山區木柵路三段148號150號",
    "pkey": "013343",
    "tel": "02-29362952"
}, {
    "name": "全家木新店",
    "addr": "台北市文山區木新路三段333．335號",
    "pkey": "015542",
    "tel": "02-29388551"
}, {
    "name": "全家欣榮店",
    "addr": "台北市文山區木新路三段93號",
    "pkey": "015897",
    "tel": "02-22343591"
}, {
    "name": "全家仙岩店",
    "addr": "台北市文山區仙岩路2號",
    "pkey": "015040",
    "tel": "02-86631305"
}, {
    "name": "全家師美店",
    "addr": "台北市文山區汀州路四段77號",
    "pkey": "014208",
    "tel": "02-29322856"
}, {
    "name": "全家順輝店",
    "addr": "台北市文山區光輝路7號",
    "pkey": "015729",
    "tel": "02-29388216"
}, {
    "name": "全家興昌店",
    "addr": "台北市文山區辛亥路四段101巷1號",
    "pkey": "015086",
    "tel": "02-29357810"
}, {
    "name": "全家名門店",
    "addr": "臺北市文山區和平東路四段95、97號1樓",
    "pkey": "017175",
    "tel": "02-22301700"
}, {
    "name": "全家大順店",
    "addr": "台北市文山區忠順街一段131號",
    "pkey": "017245",
    "tel": "02-22344799"
}, {
    "name": "全家鑫順店",
    "addr": "台北市文山區忠順街二段16號",
    "pkey": "016580",
    "tel": "02-29370174"
}, {
    "name": "全家興政店",
    "addr": "台北市文山區指南路二段83號壹＋貳樓",
    "pkey": "016836",
    "tel": "02-86619335"
}, {
    "name": "全家政富店",
    "addr": "台北市文山區指南路二段145號1樓",
    "pkey": "017249",
    "tel": "02-86613075"
}, {
    "name": "全家景中店",
    "addr": "台北市文山區景中街5號，七號一樓",
    "pkey": "017661",
    "tel": "02-29334768"
}, {
    "name": "全家景文店",
    "addr": "台北市文山區景文街83號",
    "pkey": "017308",
    "tel": "02-29303305"
}, {
    "name": "全家景後店",
    "addr": "台北市文山區景後街95號",
    "pkey": "016952",
    "tel": "02-29342042"
}, {
    "name": "全家新文華店",
    "addr": "台北市文山區景華街3巷2號1樓及B1",
    "pkey": "013719",
    "tel": "02-86633877"
}, {
    "name": "全家華德店",
    "addr": "台北市文山區景華街75號",
    "pkey": "015865",
    "tel": "02-29356335"
}, {
    "name": "全家景富店",
    "addr": "台北市文山區景福街25號",
    "pkey": "016800",
    "tel": "02-89313890"
}, {
    "name": "全家新福興店",
    "addr": "臺北市文山區福興路65號",
    "pkey": "015158",
    "tel": "02-29301491"
}, {
    "name": "全家萬興店",
    "addr": "臺北市文山區興隆路一段55巷27弄1-4號",
    "pkey": "016925",
    "tel": "02-29304220"
}, {
    "name": "全家景興店",
    "addr": "台北市文山區興隆路一段249號1樓",
    "pkey": "016263",
    "tel": "02-29304049"
}, {
    "name": "全家興園店",
    "addr": "台北市文山區興隆路二段220巷33號",
    "pkey": "015728",
    "tel": "02-29334696"
}, {
    "name": "全家興業店",
    "addr": "台北市文山區興隆路二段279號",
    "pkey": "015667",
    "tel": "02-86635963"
}, {
    "name": "全家靜興店",
    "addr": "台北市文山區興隆路二段75號壹樓",
    "pkey": "014857",
    "tel": "02-29356712"
}, {
    "name": "全家中科大店",
    "addr": "台北市文山區興隆路三段36巷9弄10號",
    "pkey": "016916",
    "tel": "02-29333950"
}, {
    "name": "全家再興店",
    "addr": "台北市文山區興隆路三段207巷11弄2號",
    "pkey": "014696",
    "tel": "02-22302780"
}, {
    "name": "全家興崙店",
    "addr": "台北市文山區興隆路四段50之1號",
    "pkey": "017365",
    "tel": "02-29397480"
}, {
    "name": "全家萬和店",
    "addr": "台北市文山區羅斯福路五段218巷38弄2號1樓",
    "pkey": "014182",
    "tel": "02-86636168"
}, {
    "name": "全家萬福店",
    "addr": "台北市文山區羅斯福路五段269巷11號",
    "pkey": "017119",
    "tel": "02-29315696"
}, {
    "name": "全家羅和店",
    "addr": "台北市文山區羅斯福路六段146-1號",
    "pkey": "016570",
    "tel": "02-29352655"
}, {
    "name": "全家景和店",
    "addr": "台北市文山區羅斯福路六段274號",
    "pkey": "015197",
    "tel": "02-89319847"
}, ], ], [[{
    "name": "全家萬里頂社店",
    "addr": "新北市萬里區大鵬里頂社1號",
    "pkey": "017753",
    "tel": "02-24081473"
}, {
    "name": "全家野柳新港口店",
    "addr": "新北市萬里區港東路68號",
    "pkey": "012773",
    "tel": "02-24927310"
}, ], [{
    "name": "全家金山中山店",
    "addr": "新北市金山區中山路205號",
    "pkey": "011377",
    "tel": "02-24081325"
}, {
    "name": "全家金山金美店",
    "addr": "新北市金山區中山路252號",
    "pkey": "015029",
    "tel": "02-24081821"
}, {
    "name": "全家金山金中店",
    "addr": "新北市金山區中山路101號",
    "pkey": "015505",
    "tel": "02-24081427"
}, ], [{
    "name": "全家板橋振興店",
    "addr": "新北市板橋區三民路一段31巷89弄3號",
    "pkey": "011950",
    "tel": "02-89612085"
}, {
    "name": "全家板橋富山店",
    "addr": "新北市板橋區三民路一段94號，96號",
    "pkey": "013226",
    "tel": "02-89641541"
}, {
    "name": "全家板橋三民店",
    "addr": "新北市板橋區三民路二段203之9號",
    "pkey": "013905",
    "tel": "02-29629497"
}, {
    "name": "全家板橋長壽店",
    "addr": "新北市板橋區三民路二段83號",
    "pkey": "015688",
    "tel": "02-29572584"
}, {
    "name": "全家板橋樂福店",
    "addr": "新北市板橋區三民路二段21巷6號1樓",
    "pkey": "013653",
    "tel": "02-29636100"
}, {
    "name": "全家板橋長民店",
    "addr": "新北市板橋區三民路二段153巷1-3號1樓＆B1",
    "pkey": "017062",
    "tel": "02-29558365"
}, {
    "name": "全家板橋天和店",
    "addr": "新北市板橋區三民路二段140號1樓",
    "pkey": "016086",
    "tel": "02-29556108"
}, {
    "name": "全家板橋正隆店",
    "addr": "新北市板橋區三民路二段正隆巷34號一樓",
    "pkey": "017313",
    "tel": "02-29578305"
}, {
    "name": "全家板橋大仁店",
    "addr": "新北市板橋區大仁街108之1號",
    "pkey": "013601",
    "tel": "02-29670947"
}, {
    "name": "全家板橋興安店",
    "addr": "新北市板橋區大觀路二段37巷38號1樓",
    "pkey": "013555",
    "tel": "02-29672852"
}, {
    "name": "全家板橋新站店",
    "addr": "新北市板橋區中山路一段160號",
    "pkey": "013383",
    "tel": "02-29638358"
}, {
    "name": "全家板橋新光店",
    "addr": "新北市板橋區中山路一段141-2號1樓",
    "pkey": "016230",
    "tel": "02-29550932"
}, {
    "name": "全家板橋市府店",
    "addr": "新北市板橋區中山路一段161號B1",
    "pkey": "013827",
    "tel": "02-29646019"
}, {
    "name": "全家板橋新光仁店",
    "addr": "新北市板橋區中山路二段25號1-5樓",
    "pkey": "014633",
    "tel": "02-89539335"
}, {
    "name": "全家板橋光復店",
    "addr": "新北市板橋區中山路二段503號1樓",
    "pkey": "015738",
    "tel": "02-29643847"
}, {
    "name": "全家板橋大庭店",
    "addr": "新北市板橋區中正路191號",
    "pkey": "017125",
    "tel": "02-29670325"
}, {
    "name": "全家板橋瑞安店",
    "addr": "新北市板橋區中正路395號1樓",
    "pkey": "017177",
    "tel": "02-29677282"
}, {
    "name": "全家板橋美庭店",
    "addr": "新北市板橋區中正路216巷21號、23號1樓",
    "pkey": "015275",
    "tel": "02-29607413"
}, {
    "name": "全家板橋花園店",
    "addr": "新北市板橋區中正路一巷14號1樓",
    "pkey": "016042",
    "tel": "02-29679720"
}, {
    "name": "全家板橋勝文店",
    "addr": "新北市板橋區仁化街46號及46之1號1樓",
    "pkey": "016053",
    "tel": "02-82528693"
}, {
    "name": "全家板橋新壽店",
    "addr": "新北市板橋區介壽街17號1樓",
    "pkey": "016326",
    "tel": "02-22554220"
}, {
    "name": "全家板橋文化店",
    "addr": "新北市板橋區文化路一段280號",
    "pkey": "014167",
    "tel": "02-22544632"
}, {
    "name": "全家板橋新民店",
    "addr": "新北市板橋區文化路一段188巷42號1樓",
    "pkey": "017604",
    "tel": "02-22570742"
}, {
    "name": "全家板橋致科店",
    "addr": "新北市板橋區文化路一段313號1樓",
    "pkey": "015455",
    "tel": "02-22569453"
}, {
    "name": "全家板橋立都店",
    "addr": "新北市板橋區文化路二段259號1樓",
    "pkey": "017459",
    "tel": "02-22559171"
}, {
    "name": "全家板橋龍江店",
    "addr": "新北市板橋區文化路二段182巷3弄91，93號1樓",
    "pkey": "016502",
    "tel": "02-82535436"
}, {
    "name": "全家板橋興盛店",
    "addr": "新北市板橋區文聖街161號1樓",
    "pkey": "017022",
    "tel": "02-82589625"
}, {
    "name": "全家板橋新遠店",
    "addr": "新北市板橋區四川路一段371號1樓",
    "pkey": "015272",
    "tel": "02-89539873"
}, {
    "name": "全家板橋板川店",
    "addr": "新北市板橋區四川路二段245巷7號1樓",
    "pkey": "015962",
    "tel": "02-89674495"
}, {
    "name": "全家板橋華德店",
    "addr": "新北市板橋區四川路二段47巷3弄4號1樓",
    "pkey": "014123",
    "tel": "02-89676847"
}, {
    "name": "全家板橋宏翠店",
    "addr": "新北市板橋區四維路100號1樓",
    "pkey": "014578",
    "tel": "02-82572973"
}, {
    "name": "全家板橋互維店",
    "addr": "新北市板橋區四維路293號1樓",
    "pkey": "016945",
    "tel": "02-22586320"
}, {
    "name": "全家板橋勝維店",
    "addr": "新北市板橋區四維路318號1樓",
    "pkey": "017236",
    "tel": "02-82570329"
}, {
    "name": "全家板橋四維店",
    "addr": "新北市板橋區四維路180號",
    "pkey": "014502",
    "tel": "02-22542469"
}, {
    "name": "全家板橋廣隆店",
    "addr": "新北市板橋區民生路一段33號1樓",
    "pkey": "016032",
    "tel": "02-29577130"
}, {
    "name": "全家板橋金巨蛋店",
    "addr": "新北市板橋區民生路二段250號1樓及b1",
    "pkey": "010379",
    "tel": "02-22573505"
}, {
    "name": "全家板橋文興店",
    "addr": "新北市板橋區民生路二段230號1樓",
    "pkey": "012688",
    "tel": "02-22579434"
}, {
    "name": "全家板橋金典店",
    "addr": "新北市板橋區民生路二段16之1號1樓＆夾層",
    "pkey": "015869",
    "tel": "02-29642035"
}, {
    "name": "全家板橋金富店",
    "addr": "新北市板橋區民生路三段27號1樓",
    "pkey": "015700",
    "tel": "02-22541621"
}, {
    "name": "全家板橋民族店",
    "addr": "新北市板橋區民族路61號",
    "pkey": "015605",
    "tel": "02-89510850"
}, {
    "name": "全家板橋民安店",
    "addr": "新北市板橋區民權路202巷7弄2-4號1樓",
    "pkey": "016928",
    "tel": "02-29667664"
}, {
    "name": "全家板橋聯翠店",
    "addr": "新北市板橋區光武街22號壹樓",
    "pkey": "016221",
    "tel": "02-22559113"
}, {
    "name": "全家板橋宜宅店",
    "addr": "新北市板橋區合宜路129號1樓",
    "pkey": "017479",
    "tel": "02-29600030"
}, {
    "name": "全家板橋祝山店",
    "addr": "新北市板橋區吳鳳路21巷2號1樓",
    "pkey": "010407",
    "tel": "02-22554105"
}, {
    "name": "全家板橋和平店",
    "addr": "新北市板橋區和平路100號",
    "pkey": "016441",
    "tel": "02-29535609"
}, {
    "name": "全家板橋大東店",
    "addr": "新北市板橋區府中路127號1樓",
    "pkey": "014811",
    "tel": "02-89698004"
}, {
    "name": "全家板橋板農店",
    "addr": "新北市板橋區府中路29—1號1樓",
    "pkey": "002816",
    "tel": "02-22723346"
}, {
    "name": "全家板橋大隆店",
    "addr": "新北市板橋區忠孝路50號一樓",
    "pkey": "014053",
    "tel": "02-29533231"
}, {
    "name": "全家板橋中勝店",
    "addr": "新北市板橋區林園街2號",
    "pkey": "015125",
    "tel": "02-22724924"
}, {
    "name": "全家板橋板長店",
    "addr": "新北市板橋區板新路97＆99號1樓",
    "pkey": "016440",
    "tel": "02-29545602"
}, {
    "name": "全家板橋松柏店",
    "addr": "新北市板橋區松柏街13號",
    "pkey": "015142",
    "tel": "02-82520901"
}, {
    "name": "全家板橋金鑽店",
    "addr": "新北市板橋區金門街29號",
    "pkey": "011788",
    "tel": "02-26750923"
}, {
    "name": "全家板橋金鑫店",
    "addr": "新北市板橋區金門街376號1樓",
    "pkey": "017817",
    "tel": "02-86872745"
}, {
    "name": "全家板橋公園店",
    "addr": "新北市板橋區金門街206＆208號1樓",
    "pkey": "014085",
    "tel": "02-26753572"
}, {
    "name": "全家板橋金成店",
    "addr": "新北市板橋區金門街313號1樓",
    "pkey": "015351",
    "tel": "02-26855676"
}, {
    "name": "全家板橋美華店",
    "addr": "新北市板橋區金華街10巷48弄78號1樓",
    "pkey": "017385",
    "tel": "02-29657713"
}, {
    "name": "全家板橋永安店",
    "addr": "新北市板橋區長安街331巷94號1樓",
    "pkey": "016536",
    "tel": "02-29645603"
}, {
    "name": "全家板橋安東店",
    "addr": "新北市板橋區長安街138巷1弄50號1樓",
    "pkey": "016505",
    "tel": "02-29514997"
}, {
    "name": "全家板橋西安店",
    "addr": "新北市板橋區長安街295號1樓",
    "pkey": "014045",
    "tel": "02-29513527"
}, {
    "name": "全家板橋富安店",
    "addr": "新北市板橋區長江路一段100號1樓",
    "pkey": "013294",
    "tel": "02-82571724"
}, {
    "name": "全家板橋漢江店",
    "addr": "新北市板橋區長江路二段120號1樓",
    "pkey": "016640",
    "tel": "02-22593499"
}, {
    "name": "全家板橋干城店",
    "addr": "新北市板橋區信義路243號1樓",
    "pkey": "016543",
    "tel": "02-29644958"
}, {
    "name": "全家板橋信陽店",
    "addr": "新北市板橋區信義路72號一樓",
    "pkey": "012606",
    "tel": "02-29506920"
}, {
    "name": "全家板橋新雅店",
    "addr": "新北市板橋區南雅東路8號（代表號）1樓",
    "pkey": "015046",
    "tel": "02-29655750"
}, {
    "name": "全家板橋大雅店",
    "addr": "新北市板橋區南雅南路二段5號1樓",
    "pkey": "017478",
    "tel": "02-29649724"
}, {
    "name": "全家板橋英仕店",
    "addr": "新北市板橋區英士路54號1樓",
    "pkey": "015909",
    "tel": "02-22599823"
}, {
    "name": "全家板橋慶豐店",
    "addr": "新北市板橋區重慶路278號1樓",
    "pkey": "014925",
    "tel": "02-89535147"
}, {
    "name": "全家板橋新慶店",
    "addr": "新北市板橋區重慶路60-1號1樓＆地下室",
    "pkey": "014306",
    "tel": "02-29511914"
}, {
    "name": "全家板橋板慶店",
    "addr": "新北市板橋區重慶路290巷3號1樓",
    "pkey": "017433",
    "tel": "02-89539805"
}, {
    "name": "全家板橋運山店",
    "addr": "新北市板橋區海山路33號",
    "pkey": "015143",
    "tel": "02-89647745"
}, {
    "name": "全家板橋國泰店",
    "addr": "新北市板橋區國泰街37號1樓",
    "pkey": "016122",
    "tel": "02-29596571"
}, {
    "name": "全家板橋莒安店",
    "addr": "新北市板橋區莒光路131號",
    "pkey": "012836",
    "tel": "02-82536711"
}, {
    "name": "全家板橋莒光店",
    "addr": "新北市板橋區莒光路225，227號",
    "pkey": "013712",
    "tel": "02-22593060"
}, {
    "name": "全家板橋益豐店",
    "addr": "新北市板橋區莒光路36號1樓",
    "pkey": "017225",
    "tel": "02-22577224"
}, {
    "name": "全家板橋萬板店",
    "addr": "新北市板橋區莊敬路220巷1號1樓",
    "pkey": "015192",
    "tel": "02-22546290"
}, {
    "name": "全家板橋富陽店",
    "addr": "新北市板橋區復興街130號一樓",
    "pkey": "012976",
    "tel": "02-29689648"
}, {
    "name": "全家板橋華興店",
    "addr": "新北市板橋區華興街41．43號",
    "pkey": "017432",
    "tel": "02-29524563"
}, {
    "name": "全家板橋華雅店",
    "addr": "新北市板橋區華興街90號",
    "pkey": "016537",
    "tel": "02-29551279"
}, {
    "name": "全家板橋華陽店",
    "addr": "新北市板橋區陽明街88、90號一樓",
    "pkey": "015273",
    "tel": "02-22585156"
}, {
    "name": "全家板橋板民店",
    "addr": "新北市板橋區新民街39號1樓",
    "pkey": "015440",
    "tel": "02-29545946"
}, {
    "name": "全家板橋甫華店",
    "addr": "新北市板橋區新生街27號1樓",
    "pkey": "015612",
    "tel": "02-89659345"
}, {
    "name": "全家板橋富貴店",
    "addr": "新北市板橋區新海路462，464，466號1樓",
    "pkey": "014783",
    "tel": "02-22599157"
}, {
    "name": "全家板橋新農店",
    "addr": "新北市板橋區新海路328，330號1樓",
    "pkey": "013382",
    "tel": "02-22538884"
}, {
    "name": "全家板橋欣興店",
    "addr": "新北市板橋區新興路1號1樓",
    "pkey": "015546",
    "tel": "02-29654269"
}, {
    "name": "全家板橋溪崑店",
    "addr": "新北市板橋區溪崑二街134、136、138號1樓",
    "pkey": "014890",
    "tel": "02-26876563"
}, {
    "name": "全家板橋千甲店",
    "addr": "新北市板橋區溪崑二街26號一樓",
    "pkey": "014425",
    "tel": "02-26758509"
}, {
    "name": "全家板橋裕民店",
    "addr": "新北市板橋區裕民街44號1樓",
    "pkey": "013433",
    "tel": "02-22586434"
}, {
    "name": "全家板橋裕盛店",
    "addr": "新北市板橋區裕民街95號",
    "pkey": "013673",
    "tel": "02-22567681"
}, {
    "name": "全家板橋僑一店",
    "addr": "新北市板橋區僑中一街124巷9弄1號",
    "pkey": "017023",
    "tel": "02-29679685"
}, {
    "name": "全家板橋興僑店",
    "addr": "新北市板橋區僑中一街90號1樓",
    "pkey": "016422",
    "tel": "02-89697997"
}, {
    "name": "全家板橋僑二店",
    "addr": "新北市板橋區僑中二街116巷1號1樓",
    "pkey": "013816",
    "tel": "02-89699174"
}, {
    "name": "全家板橋國民店",
    "addr": "新北市板橋區實踐路132號1樓",
    "pkey": "014543",
    "tel": "02-29572609"
}, {
    "name": "全家板橋新都店",
    "addr": "新北市板橋區漢生東路159號1樓",
    "pkey": "015357",
    "tel": "02-29649535"
}, {
    "name": "全家板橋廣和店",
    "addr": "新北市板橋區廣和街79號1樓",
    "pkey": "012898",
    "tel": "02-89518657"
}, {
    "name": "全家板橋堂春店",
    "addr": "新北市板橋區篤行路三段1號1樓",
    "pkey": "013691",
    "tel": "02-26835266"
}, {
    "name": "全家板橋雙城店",
    "addr": "新北市板橋區縣民大道二段106號1樓",
    "pkey": "017384",
    "tel": "02-29544584"
}, {
    "name": "全家板橋雙子店",
    "addr": "新北市板橋區縣民大道二段66號1樓",
    "pkey": "017113",
    "tel": "02-29649816"
}, {
    "name": "全家板橋聚星店",
    "addr": "新北市板橋區館前西路4號、4-1號1樓",
    "pkey": "013063",
    "tel": "02-29539549"
}, {
    "name": "全家板橋館西店",
    "addr": "新北市板橋區館前西路128號",
    "pkey": "013552",
    "tel": "02-29655570"
}, {
    "name": "全家板橋新泉店",
    "addr": "新北市板橋區龍泉街126號",
    "pkey": "015271",
    "tel": "02-82573744"
}, {
    "name": "全家板橋美堤店",
    "addr": "新北市板橋區龍興街71巷1號1樓",
    "pkey": "017227",
    "tel": "02-29682151"
}, {
    "name": "全家板橋雙十店",
    "addr": "新北市板橋區雙十路二段6—8號，6—9號，6—10",
    "pkey": "013385",
    "tel": "02-22546231"
}, {
    "name": "全家板橋華江店",
    "addr": "新北市板橋區雙十路三段54號",
    "pkey": "012072",
    "tel": "02-22554256"
}, {
    "name": "全家板橋江翠店",
    "addr": "新北市板橋區懷德街127巷1，3號1F",
    "pkey": "017065",
    "tel": "02-22525104"
}, {
    "name": "全家板橋懷聖店",
    "addr": "新北市板橋區懷德街201巷2號",
    "pkey": "016423",
    "tel": "02-22505214"
}, {
    "name": "全家板橋新翠店",
    "addr": "新北市板橋區懷德街127巷23弄7號1樓",
    "pkey": "015008",
    "tel": "02-22544470"
}, ], [{
    "name": "全家汐止力行店",
    "addr": "新北市汐止區力行街1號",
    "pkey": "012879",
    "tel": "02-26401386"
}, {
    "name": "全家汐止茂盛店",
    "addr": "新北市汐止區大同路一段225號壹樓",
    "pkey": "017139",
    "tel": "02-26413633"
}, {
    "name": "全家汐止智興店",
    "addr": "新北市汐止區大同路二段200號",
    "pkey": "016460",
    "tel": "02-26490742"
}, {
    "name": "全家汐止龍安店",
    "addr": "新北市汐止區大同路二段184巷11號",
    "pkey": "016735",
    "tel": "02-26490723"
}, {
    "name": "全家汐止宏國店",
    "addr": "新北市汐止區大同路二段283號",
    "pkey": "015955",
    "tel": "02-86923110"
}, {
    "name": "全家汐止大同店",
    "addr": "新北市汐止區大同路三段269，271號",
    "pkey": "014301",
    "tel": "02-86486545"
}, {
    "name": "全家汐止經貿店",
    "addr": "新北市汐止區大同路三段190號壹樓部份",
    "pkey": "014997",
    "tel": "02-86473139"
}, {
    "name": "全家汐止摩天店",
    "addr": "新北市汐止區大同路三段611之3號壹樓",
    "pkey": "017124",
    "tel": "02-26905548"
}, {
    "name": "全家汐止農會店",
    "addr": "新北市汐止區中正路106號1樓",
    "pkey": "017700",
    "tel": "02-86916715"
}, {
    "name": "全家汐止興中店",
    "addr": "新北市汐止區中興路158號",
    "pkey": "013935",
    "tel": "02-86933681"
}, {
    "name": "全家汐止福全店",
    "addr": "新北市汐止區仁愛路149號",
    "pkey": "014806",
    "tel": "02-26479466"
}, {
    "name": "全家汐止桂冠店",
    "addr": "新北市汐止區水源路二段34號",
    "pkey": "012878",
    "tel": "02-26474855"
}, {
    "name": "全家汐止汐旺店",
    "addr": "新北市汐止區汐萬路一段343巷33號",
    "pkey": "013510",
    "tel": "02-26464086"
}, {
    "name": "全家汐止伯爵店",
    "addr": "新北市汐止區伯爵街52巷1號壹樓部份",
    "pkey": "016528",
    "tel": "02-26474757"
}, {
    "name": "全家汐止和平店",
    "addr": "新北市汐止區和平街48號",
    "pkey": "017392",
    "tel": "02-26439807"
}, {
    "name": "全家汐止宜興店",
    "addr": "新北市汐止區宜興街12號",
    "pkey": "015000",
    "tel": "02-26606803"
}, {
    "name": "全家汐止秀峰店",
    "addr": "新北市汐止區忠孝東路228號",
    "pkey": "014996",
    "tel": "02-26919425"
}, {
    "name": "全家汐止新忠孝店",
    "addr": "新北市汐止區忠孝東路258號",
    "pkey": "016496",
    "tel": "02-26919701"
}, {
    "name": "全家汐止橋東店",
    "addr": "新北市汐止區忠孝東路402號",
    "pkey": "016049",
    "tel": "02-86475279"
}, {
    "name": "全家汐止鑫峰店",
    "addr": "新北市汐止區明峰街162號",
    "pkey": "014371",
    "tel": "02-26953467"
}, {
    "name": "全家汐止保興店",
    "addr": "新北市汐止區保一街39號",
    "pkey": "016132",
    "tel": "02-86489793"
}, {
    "name": "全家汐止站前店",
    "addr": "新北市汐止區南昌街16號",
    "pkey": "014205",
    "tel": "02-86923096"
}, {
    "name": "全家汐止建安店",
    "addr": "新北市汐止區建成路59巷9號．15號",
    "pkey": "015041",
    "tel": "02-26418761"
}, {
    "name": "全家汐止建泰店",
    "addr": "新北市汐止區建成路59巷2號（國泰醫院汐止院區）",
    "pkey": "009012",
    "tel": "02-26902115"
}, {
    "name": "全家汐止欣康湖店",
    "addr": "新北市汐止區康寧街137號1樓",
    "pkey": "015349",
    "tel": "02-26927849"
}, {
    "name": "全家汐止康寧店",
    "addr": "新北市汐止區康寧街169巷23號1樓",
    "pkey": "010629",
    "tel": "02-26959946"
}, {
    "name": "全家汐止日月光店",
    "addr": "新北市汐止區康寧街747號．749號",
    "pkey": "013046",
    "tel": "02-26486322"
}, {
    "name": "全家汐止祥雲店",
    "addr": "新北市汐止區祥雲街1號壹樓部份",
    "pkey": "014105",
    "tel": "02-26462022"
}, {
    "name": "全家汐止莊敬店",
    "addr": "新北市汐止區莊敬街139號",
    "pkey": "012895",
    "tel": "02-26435764"
}, {
    "name": "全家汐止興莊店",
    "addr": "新北市汐止區莊敬街32號壹樓全部",
    "pkey": "015249",
    "tel": "02-86424336"
}, {
    "name": "全家汐止新水蓮店",
    "addr": "新北市汐止區湖前街110巷97弄24號B1之1之2",
    "pkey": "016217",
    "tel": "02-26909465"
}, {
    "name": "全家汐止鄉長店",
    "addr": "新北市汐止區鄉長路一段27號壹樓及貳樓",
    "pkey": "016026",
    "tel": "02-26919409"
}, {
    "name": "全家汐止連新店",
    "addr": "新北市汐止區新台五路一段151號壹樓及地下室",
    "pkey": "015504",
    "tel": "02-26919772"
}, {
    "name": "全家汐止青山店",
    "addr": "新北市汐止區新台五路一段212號；212之1號",
    "pkey": "012666",
    "tel": "02-26489817"
}, {
    "name": "全家汐止亞太店",
    "addr": "新北市汐止區新台五路一段96號Ｃ棟",
    "pkey": "012998",
    "tel": "02-26969769"
}, {
    "name": "全家汐止亞太二店",
    "addr": "新北市汐止區新台五路一段82至116號、Ｄ8—2號",
    "pkey": "012413",
    "tel": "02-26960486"
}, {
    "name": "全家汐止遠雄店",
    "addr": "新北市汐止區新台五路一段93號B1樓B11300號",
    "pkey": "013826",
    "tel": "02-26971106"
}, {
    "name": "全家汐止新興店",
    "addr": "新北市汐止區新興路21及23號",
    "pkey": "014220",
    "tel": "02-26919264"
}, {
    "name": "全家汐止福旺店",
    "addr": "新北市汐止區福德一路109號",
    "pkey": "017788",
    "tel": "02-86933934"
}, {
    "name": "全家汐止長虹店",
    "addr": "新北市汐止區福德二路81-1號",
    "pkey": "016025",
    "tel": "02-26948906"
}, {
    "name": "全家汐止興福店",
    "addr": "新北市汐止區福德二路134號",
    "pkey": "016148",
    "tel": "02-86932048"
}, {
    "name": "全家汐止樟興店",
    "addr": "新北市汐止區樟樹一路16號，18號",
    "pkey": "014625",
    "tel": "02-26904033"
}, {
    "name": "全家汐止樟中店",
    "addr": "新北市汐止區樟樹一路127號1樓",
    "pkey": "013502",
    "tel": "02-86425058"
}, {
    "name": "全家汐止樟福店",
    "addr": "新北市汐止區樟樹一路220號",
    "pkey": "017305",
    "tel": "02-86923181"
}, {
    "name": "全家汐止新樹店",
    "addr": "新北市汐止區樟樹二路273號",
    "pkey": "015754",
    "tel": "02-26487704"
}, ], [{
    "name": "全家深坑金典店",
    "addr": "新北市深坑區北深路二段77號",
    "pkey": "014699",
    "tel": "02-26624307"
}, {
    "name": "全家深坑北福店",
    "addr": "新北市深坑區北深路三段239號",
    "pkey": "015531",
    "tel": "02-26629753"
}, {
    "name": "全家深坑北深店",
    "addr": "新北市深坑區北深路三段179號",
    "pkey": "014888",
    "tel": "02-26644845"
}, {
    "name": "全家深坑埔新店",
    "addr": "新北市深坑區埔新街93號1樓",
    "pkey": "016992",
    "tel": "02-26641876"
}, ], [{
    "name": "全家石碇國道店",
    "addr": "新北市石碇區文山路一段6號",
    "pkey": "016572",
    "tel": "02-26633428"
}, {
    "name": "全家石碇雙溪店",
    "addr": "新北市石碇區隆盛里雙溪58號",
    "pkey": "017288",
    "tel": "02-26633324"
}, ], [{
    "name": "全家瑞芳龍川店",
    "addr": "新北市瑞芳區一坑路11之1號",
    "pkey": "014515",
    "tel": "02-24061884"
}, {
    "name": "全家瑞芳傑魚坑店",
    "addr": "新北市瑞芳區傑魚坑路62號",
    "pkey": "017772",
    "tel": "02-24969517"
}, {
    "name": "全家九份觀景店",
    "addr": "新北市瑞芳區輕便路43號4樓",
    "pkey": "013604",
    "tel": "02-24969045"
}, ], [{
    "name": "全家平溪平安店",
    "addr": "新北市平溪區石底街53號",
    "pkey": "016320",
    "tel": "02-24951706"
}, ], [{
    "name": "全家貢寮澳底一店",
    "addr": "新北市貢寮區大澳街1之1、3號1樓",
    "pkey": "015334",
    "tel": "02-24903521"
}, ], [{
    "name": "全家新店慶民店",
    "addr": "新北市新店區二十張路3號",
    "pkey": "015483",
    "tel": "02-89193666"
}, {
    "name": "全家新店三福店",
    "addr": "新北市新店區三民路77號",
    "pkey": "013815",
    "tel": "02-29188975"
}, {
    "name": "全家新店福民店",
    "addr": "新北市新店區中央路145號",
    "pkey": "013020",
    "tel": "02-22194351"
}, {
    "name": "全家新店新中央店",
    "addr": "新北市新店區中央路63號",
    "pkey": "017773",
    "tel": "02-22197580"
}, {
    "name": "全家新店大鵬店",
    "addr": "新北市新店區中正路698號",
    "pkey": "012877",
    "tel": "02-22184729"
}, {
    "name": "全家新店中欣店",
    "addr": "新北市新店區中正路3號",
    "pkey": "013251",
    "tel": "02-29156887"
}, {
    "name": "全家新店莊敬店",
    "addr": "新北市新店區中正路523號",
    "pkey": "014690",
    "tel": "02-82193280"
}, {
    "name": "全家新店新百合店",
    "addr": "新北市新店區中正路404號",
    "pkey": "015406",
    "tel": "02-22199017"
}, {
    "name": "全家新店正中店",
    "addr": "新北市新店區中正路366號",
    "pkey": "017464",
    "tel": "02-22195702"
}, {
    "name": "全家新店正民店",
    "addr": "新北市新店區中正路224號",
    "pkey": "015747",
    "tel": "02-29137185"
}, {
    "name": "全家新店五豐店",
    "addr": "新北市新店區中正路59號",
    "pkey": "016352",
    "tel": "02-89145746"
}, {
    "name": "全家新店中盛店",
    "addr": "新北市新店區中正路493-2號1樓",
    "pkey": "017303",
    "tel": "02-86673532"
}, {
    "name": "全家新店中華店",
    "addr": "新北市新店區中華路50號",
    "pkey": "015122",
    "tel": "02-86658913"
}, {
    "name": "全家新店新寶安店",
    "addr": "新北市新店區中興路三段209號",
    "pkey": "010583",
    "tel": "02-29157211"
}, {
    "name": "全家新店富強店",
    "addr": "新北市新店區中興路三段156號",
    "pkey": "013061",
    "tel": "02-89145943"
}, {
    "name": "全家新店新文強店",
    "addr": "新北市新店區文化路17號",
    "pkey": "016113",
    "tel": "02-29107458"
}, {
    "name": "全家新店站前店",
    "addr": "新北市新店區北宜路一段6號",
    "pkey": "015727",
    "tel": "02-29147259"
}, {
    "name": "全家新店美譚店",
    "addr": "新北市新店區北宜路二段419號",
    "pkey": "011255",
    "tel": "02-22171398"
}, {
    "name": "全家新店長春店",
    "addr": "新北市新店區北宜路二段149號1樓",
    "pkey": "015893",
    "tel": "02-82171585"
}, {
    "name": "全家新店忠誠店",
    "addr": "新北市新店區北新路二段119號1樓",
    "pkey": "014840",
    "tel": "02-29158815"
}, {
    "name": "全家新店七張站店",
    "addr": "新北市新店區北新路二段150-1號",
    "pkey": "017307",
    "tel": "02-86657572"
}, {
    "name": "全家新店金采店",
    "addr": "新北市新店區北新路三段213號旁壹樓部份（如附圖）",
    "pkey": "011778",
    "tel": "02-89146548"
}, {
    "name": "全家新店民德店",
    "addr": "新北市新店區民族路6號",
    "pkey": "010926",
    "tel": "02-89113923"
}, {
    "name": "全家新店新民族店",
    "addr": "新北市新店區民族路97號1樓＋地下室",
    "pkey": "016232",
    "tel": "02-29137896"
}, {
    "name": "全家新店寶元店",
    "addr": "新北市新店區民權路19號",
    "pkey": "013200",
    "tel": "02-29156106"
}, {
    "name": "全家新店民權店",
    "addr": "新北市新店區民權路105號1樓",
    "pkey": "015042",
    "tel": "02-86673437"
}, {
    "name": "全家新店民佳店",
    "addr": "新北市新店區民權路72號",
    "pkey": "015726",
    "tel": "02-86658005"
}, {
    "name": "全家新店皇家店",
    "addr": "新北市新店區永平街27號一樓",
    "pkey": "015890",
    "tel": "02-29499704"
}, {
    "name": "全家新店安和店",
    "addr": "新北市新店區永平街89號1樓",
    "pkey": "015562",
    "tel": "02-29475039"
}, {
    "name": "全家新店新和店",
    "addr": "新北市新店區永安街81號1樓",
    "pkey": "012128",
    "tel": "02-29413706"
}, {
    "name": "全家新店永業店",
    "addr": "新北市新店區永業路81巷1弄1號",
    "pkey": "017701",
    "tel": "02-29131378"
}, {
    "name": "全家新店光明店",
    "addr": "新北市新店區7鄰光明街136號1樓",
    "pkey": "015565",
    "tel": "02-86654542"
}, {
    "name": "全家新店如意店",
    "addr": "新北市新店區如意街29號1樓",
    "pkey": "014071",
    "tel": "02-22101261"
}, {
    "name": "全家新店安民店",
    "addr": "新北市新店區安民街1號1樓",
    "pkey": "016629",
    "tel": "02-86662484"
}, {
    "name": "全家新店安順店",
    "addr": "新北市新店區安民街192號1樓",
    "pkey": "016968",
    "tel": "02-22121274"
}, {
    "name": "全家新店景大店",
    "addr": "新北市新店區安忠路99號B2",
    "pkey": "017650",
    "tel": "02-22123186"
}, {
    "name": "全家新店陽光店",
    "addr": "新北市新店區安忠路57巷10號1樓",
    "pkey": "016527",
    "tel": "02-86665549"
}, {
    "name": "全家新店永安店",
    "addr": "新北市新店區安康路二段157號",
    "pkey": "017741",
    "tel": "02-86661942"
}, {
    "name": "全家新店德安店",
    "addr": "新北市新店區安康路二段303號",
    "pkey": "017097",
    "tel": "02-86663307"
}, {
    "name": "全家新店城泰店",
    "addr": "新北市新店區安康路三段311號1樓",
    "pkey": "016027",
    "tel": "02-22143601"
}, {
    "name": "全家新店康橋店",
    "addr": "新北市新店區安康路三段738號、740號1樓",
    "pkey": "017396",
    "tel": "02-22140466"
}, {
    "name": "全家新店襄陽店",
    "addr": "新北市新店區安祥路104-10號",
    "pkey": "016835",
    "tel": "02-82151522"
}, {
    "name": "全家新店香坡店",
    "addr": "新北市新店區安祥路113號，115號",
    "pkey": "011110",
    "tel": "02-22005350"
}, {
    "name": "全家新店康德店",
    "addr": "新北市新店區安德街71巷2號、4號1樓",
    "pkey": "017527",
    "tel": "02-22121574"
}, {
    "name": "全家新店德順店",
    "addr": "新北市新店區安德街120巷6號",
    "pkey": "017349",
    "tel": "02-22121692"
}, {
    "name": "全家新店健民店",
    "addr": "新北市新店區明德路69巷28號",
    "pkey": "014698",
    "tel": "02-29162699"
}, {
    "name": "全家新店玫瑰店",
    "addr": "新北市新店區玫瑰路58巷1號1樓",
    "pkey": "013159",
    "tel": "02-22103956"
}, {
    "name": "全家新店新陽店",
    "addr": "新北市新店區花園一路一段2號一樓",
    "pkey": "012473",
    "tel": "02-26669640"
}, {
    "name": "全家新店慈濟店",
    "addr": "新北市新店區建國路289號B1慈濟醫院大愛美食坊",
    "pkey": "012505",
    "tel": "02-82192878"
}, {
    "name": "全家新店江陵店",
    "addr": "新北市新店區建國路219號",
    "pkey": "016583",
    "tel": "02-22190529"
}, {
    "name": "全家新店龜山店",
    "addr": "新北市新店區新烏路三段144號1樓",
    "pkey": "012835",
    "tel": "02-26666253"
}, {
    "name": "全家新店溪園店",
    "addr": "新北市新店區溪園路389號一樓",
    "pkey": "014692",
    "tel": "02-82189189"
}, {
    "name": "全家新店鑫泉店",
    "addr": "新北市新店區溪園路401號",
    "pkey": "015316",
    "tel": "02-86677615"
}, {
    "name": "全家新店僑信店",
    "addr": "新北市新店區僑信路20號1樓",
    "pkey": "017740",
    "tel": "02-22143950"
}, {
    "name": "全家新店德正店",
    "addr": "新北市新店區德正街27巷1號",
    "pkey": "013151",
    "tel": "02-29126411"
}, {
    "name": "全家新店寶中店",
    "addr": "新北市新店區寶中路77號",
    "pkey": "017775",
    "tel": "02-29117614"
}, {
    "name": "全家新店橋興店",
    "addr": "新北市新店區寶橋路235巷129號",
    "pkey": "015043",
    "tel": "02-89192388"
}, {
    "name": "全家新店寶興店",
    "addr": "新北市新店區寶橋路80號一樓",
    "pkey": "015085",
    "tel": "02-86654892"
}, {
    "name": "全家新店新寶工店",
    "addr": "新北市新店區寶橋路235巷8號",
    "pkey": "015825",
    "tel": "02-89145941"
}, {
    "name": "全家新店新寶橋店",
    "addr": "新北市新店區寶橋路51號1，2樓",
    "pkey": "016969",
    "tel": "02-29122431"
}, {
    "name": "全家新店統寶店",
    "addr": "新北市新店區寶興路47號",
    "pkey": "015188",
    "tel": "02-89147339"
}, {
    "name": "全家新店福興店",
    "addr": "新北市新店區寶興路43號",
    "pkey": "017173",
    "tel": "02-29184961"
}, ], [{
    "name": "全家坪林順益店",
    "addr": "新北市坪林區水柳腳路133號",
    "pkey": "016050",
    "tel": "02-26657521"
}, ], [{
    "name": "全家烏來溫泉店",
    "addr": "新北市烏來區烏來街79號1樓",
    "pkey": "015637",
    "tel": "02-26618084"
}, {
    "name": "全家烏來烏萊店",
    "addr": "新北市烏來區環山路62號1樓",
    "pkey": "014579",
    "tel": "02-26617682"
}, ], [{
    "name": "全家永和新樂新店",
    "addr": "新北市永和區大新街3號1樓",
    "pkey": "016198",
    "tel": "02-86607125"
}, {
    "name": "全家永和正得店",
    "addr": "新北市永和區中正路342號一樓",
    "pkey": "016282",
    "tel": "02-29200317"
}, {
    "name": "全家永和大福店",
    "addr": "新北市永和區中正路608．610．610之1號",
    "pkey": "014886",
    "tel": "02-29254322"
}, {
    "name": "全家永和正新店",
    "addr": "新北市永和區中正路278號1樓",
    "pkey": "016358",
    "tel": "02-29464214"
}, {
    "name": "全家永和鼎豐店",
    "addr": "新北市永和區中興街7號1樓",
    "pkey": "014877",
    "tel": "02-29200709"
}, {
    "name": "全家永和耕莘店",
    "addr": "新北市永和區中興街95號1樓",
    "pkey": "011651",
    "tel": "02-29240539"
}, {
    "name": "全家永和仁和店",
    "addr": "新北市永和區仁愛路33號",
    "pkey": "016796",
    "tel": "02-32330262"
}, {
    "name": "全家永和新仁愛店",
    "addr": "新北市永和區仁愛路103號1樓",
    "pkey": "015290",
    "tel": "02-86609734"
}, {
    "name": "全家永和新仁店",
    "addr": "新北市永和區仁愛路352巷94號、96號",
    "pkey": "017056",
    "tel": "02-86602630"
}, {
    "name": "全家永和文化店",
    "addr": "新北市永和區文化路18，20，22號1樓",
    "pkey": "013671",
    "tel": "02-86604492"
}, {
    "name": "全家永和維源店",
    "addr": "新北市永和區水源街39巷2號",
    "pkey": "013832",
    "tel": "02-89230231"
}, {
    "name": "全家永和教室店",
    "addr": "新北市永和區民生路65號1樓及地下室",
    "pkey": "015942",
    "tel": "02-89418262"
}, {
    "name": "全家永和民有店",
    "addr": "新北市永和區民有街73號1樓",
    "pkey": "017795",
    "tel": "02-89434344"
}, {
    "name": "全家永和國艷店",
    "addr": "新北市永和區民樂街39巷2號1樓",
    "pkey": "014992",
    "tel": "02-29232783"
}, {
    "name": "全家永和騎士店",
    "addr": "新北市永和區民權路53號1樓",
    "pkey": "011177",
    "tel": "02-89433594"
}, {
    "name": "全家永和永平店",
    "addr": "新北市永和區永平路232號",
    "pkey": "015633",
    "tel": "02-86603548"
}, {
    "name": "全家永和永亨店",
    "addr": "新北市永和區永亨路62號、64號、66號1樓",
    "pkey": "013201",
    "tel": "02-29208853"
}, {
    "name": "全家永和永福店",
    "addr": "新北市永和區永和路一段93號",
    "pkey": "017534",
    "tel": "02-29234354"
}, {
    "name": "全家永和永復店",
    "addr": "新北市永和區永和路二段316號1樓",
    "pkey": "013650",
    "tel": "02-29286095"
}, {
    "name": "全家永和保安店",
    "addr": "新北市永和區永貞路387號",
    "pkey": "010855",
    "tel": "02-29207792"
}, {
    "name": "全家永和保平店",
    "addr": "新北市永和區永貞路354號，356號",
    "pkey": "014237",
    "tel": "02-89231532"
}, {
    "name": "全家永和秀成店",
    "addr": "新北市永和區成功路一段137，139號",
    "pkey": "012475",
    "tel": "02-29215822"
}, {
    "name": "全家永和田單店",
    "addr": "新北市永和區成功路二段157號1樓",
    "pkey": "015822",
    "tel": "02-29432844"
}, {
    "name": "全家永和御林店",
    "addr": "新北市永和區竹林路213巷44號1樓",
    "pkey": "017405",
    "tel": "02-89250327"
}, {
    "name": "全家永和永林店",
    "addr": "新北市永和區竹林路37號",
    "pkey": "016658",
    "tel": "02-89274417"
}, {
    "name": "全家永和復興店",
    "addr": "新北市永和區秀朗路一段186號1F",
    "pkey": "013716",
    "tel": "02-29254364"
}, {
    "name": "全家永和秀和店",
    "addr": "新北市永和區秀朗路一段76、78號",
    "pkey": "017102",
    "tel": "02-29280903"
}, {
    "name": "全家永和樂華店",
    "addr": "新北市永和區保平路18巷12號1樓",
    "pkey": "016051",
    "tel": "02-29264823"
}, {
    "name": "全家永和羅鄰店",
    "addr": "新北市永和區保平路268巷25號1樓",
    "pkey": "013578",
    "tel": "02-29293596"
}, {
    "name": "全家永和仁保店",
    "addr": "新北市永和區保福路二段103號1樓",
    "pkey": "017697",
    "tel": "02-29285824"
}, {
    "name": "全家永和國和店",
    "addr": "新北市永和區國中路86巷2號",
    "pkey": "016708",
    "tel": "02-29281175"
}, {
    "name": "全家永和得元店",
    "addr": "新北市永和區得和路373巷29號",
    "pkey": "017152",
    "tel": "02-29265391"
}, {
    "name": "全家永和得和店",
    "addr": "新北市永和區得和路372號",
    "pkey": "014466",
    "tel": "02-29416037"
}, {
    "name": "全家永和頂溪店",
    "addr": "新北市永和區復興街3號",
    "pkey": "015790",
    "tel": "02-29262511"
}, {
    "name": "全家永和新廷店",
    "addr": "新北市永和區福和路320號1樓",
    "pkey": "014012",
    "tel": "02-29203971"
}, {
    "name": "全家永和新富店",
    "addr": "新北市永和區福和路57巷14弄2號1樓",
    "pkey": "015631",
    "tel": "02-89215154"
}, {
    "name": "全家永和福和店",
    "addr": "新北市永和區福和路173．175號",
    "pkey": "010856",
    "tel": "02-29213528"
}, {
    "name": "全家永和水悅店",
    "addr": "新北市永和區環河西路一段83號1．2樓",
    "pkey": "017055",
    "tel": "02-29267011"
}, {
    "name": "全家永和環河店",
    "addr": "新北市永和區環河西路二段219號，221號",
    "pkey": "013435",
    "tel": "02-32339160"
}, {
    "name": "全家永和環東店",
    "addr": "新北市永和區環河東路一段122號，124號",
    "pkey": "015635",
    "tel": "02-89278437"
}, ], [{
    "name": "全家中和仁勇店",
    "addr": "新北市中和區大勇街20號1樓",
    "pkey": "017751",
    "tel": "02-29400962"
}, {
    "name": "全家中和勝鴻店",
    "addr": "新北市中和區中山路二段2巷45弄1號1樓",
    "pkey": "012373",
    "tel": "02-82451477"
}, {
    "name": "全家中和佳和店",
    "addr": "新北市中和區中山路二段132號、134號1樓",
    "pkey": "013708",
    "tel": "02-22450773"
}, {
    "name": "全家中和中業店",
    "addr": "新北市中和區中山路二段383＆385號1樓",
    "pkey": "017744",
    "tel": "02-32343384"
}, {
    "name": "全家中和中環店",
    "addr": "新北市中和區中山路三段111號1樓",
    "pkey": "014683",
    "tel": "02-22267465"
}, {
    "name": "全家中和漢陽店",
    "addr": "新北市中和區中山路三段172號1樓",
    "pkey": "017341",
    "tel": "02-22230343"
}, {
    "name": "全家中和中漢店",
    "addr": "新北市中和區中山路三段146-2號",
    "pkey": "016420",
    "tel": "02-22239355"
}, {
    "name": "全家中和環球店",
    "addr": "新北市中和區中山路三段120之11號",
    "pkey": "016030",
    "tel": "02-32349461"
}, {
    "name": "全家中和元氣店",
    "addr": "新北市中和區中山路三段39號2樓",
    "pkey": "016076",
    "tel": "02-22256901"
}, {
    "name": "全家中和環中店",
    "addr": "新北市中和區中山路三段122號地下二樓",
    "pkey": "013862",
    "tel": "02-22214528"
}, {
    "name": "全家中和德民店",
    "addr": "新北市中和區中正路1186號1樓",
    "pkey": "015975",
    "tel": "02-22214027"
}, {
    "name": "全家中和鎮順店",
    "addr": "新北市中和區中正路167巷16號1樓",
    "pkey": "015821",
    "tel": "02-22427811"
}, {
    "name": "全家中和福朋店",
    "addr": "新北市中和區中正路633號",
    "pkey": "014505",
    "tel": "02-22286315"
}, {
    "name": "全家中和和興店",
    "addr": "新北市中和區中正路11號，13號",
    "pkey": "017188",
    "tel": "02-22446249"
}, {
    "name": "全家中和國華店",
    "addr": "新北市中和區中正路868-1號",
    "pkey": "009408",
    "tel": "02-32343009"
}, {
    "name": "全家中和力行店",
    "addr": "新北市中和區中正路242號",
    "pkey": "017455",
    "tel": "02-22435392"
}, {
    "name": "全家中和廣場店",
    "addr": "新北市中和區中正路712號一樓",
    "pkey": "015062",
    "tel": "02-82278301"
}, {
    "name": "全家中和中鼎店",
    "addr": "新北市中和區中安街80號一樓",
    "pkey": "015370",
    "tel": "02-29294187"
}, {
    "name": "全家中和中安店",
    "addr": "新北市中和區中安街192號",
    "pkey": "016316",
    "tel": "02-29256006"
}, {
    "name": "全家中和中和店",
    "addr": "新北市中和區中和路480號1F",
    "pkey": "015820",
    "tel": "02-32338551"
}, {
    "name": "全家中和新漳和店",
    "addr": "新北市中和區中和路24號1樓",
    "pkey": "015342",
    "tel": "02-22463806"
}, {
    "name": "全家中和名揚店",
    "addr": "新北市中和區中和路300號1樓",
    "pkey": "017597",
    "tel": "02-29266847"
}, {
    "name": "全家中和金原店",
    "addr": "新北市中和區中原街126號1樓",
    "pkey": "017210",
    "tel": "02-82211769"
}, {
    "name": "全家中和中興店",
    "addr": "新北市中和區中興街111號，113號",
    "pkey": "013338",
    "tel": "02-82423542"
}, {
    "name": "全家中和巴黎店",
    "addr": "新北市中和區中興街235巷1號",
    "pkey": "014516",
    "tel": "02-22407145"
}, {
    "name": "全家中和仁義店",
    "addr": "新北市中和區仁愛街36號",
    "pkey": "017250",
    "tel": "02-29484666"
}, {
    "name": "全家中和新愛店",
    "addr": "新北市中和區仁愛街9號1樓",
    "pkey": "014687",
    "tel": "02-89411538"
}, {
    "name": "全家中和新維店",
    "addr": "新北市中和區四維街37巷2號1樓",
    "pkey": "014598",
    "tel": "02-89411871"
}, {
    "name": "全家中和光明店",
    "addr": "新北市中和區民生街85巷2弄1號1樓",
    "pkey": "015921",
    "tel": "02-89535241"
}, {
    "name": "全家中和國院店",
    "addr": "新北市中和區民安街51號1樓",
    "pkey": "016872",
    "tel": "02-22213432"
}, {
    "name": "全家中和嘉穗店",
    "addr": "新北市中和區民利街91號1樓",
    "pkey": "013129",
    "tel": "02-22221242"
}, {
    "name": "全家中和福美店",
    "addr": "新北市中和區永和路74號1樓",
    "pkey": "011460",
    "tel": "02-22435180"
}, {
    "name": "全家中和永貞店",
    "addr": "新北市中和區永貞路244號",
    "pkey": "016605",
    "tel": "02-29288350"
}, {
    "name": "全家中和秀山店",
    "addr": "新北市中和區立人街65號，67號",
    "pkey": "017577",
    "tel": "02-89421005"
}, {
    "name": "全家中和建業店",
    "addr": "新北市中和區立德街189號1樓",
    "pkey": "017603",
    "tel": "02-22224223"
}, {
    "name": "全家中和萊陽店",
    "addr": "新北市中和區光華街1號3號一樓",
    "pkey": "013001",
    "tel": "02-82456393"
}, {
    "name": "全家中和安樂店",
    "addr": "新北市中和區安樂路81號",
    "pkey": "016201",
    "tel": "02-29400326"
}, {
    "name": "全家中和智山店",
    "addr": "新北市中和區自立路38、38-1號1樓",
    "pkey": "014803",
    "tel": "02-89422563"
}, {
    "name": "全家中和新秀店",
    "addr": "新北市中和區秀朗路三段44號1樓",
    "pkey": "012255",
    "tel": "02-29426524"
}, {
    "name": "全家中和平興店",
    "addr": "新北市中和區和平街20號",
    "pkey": "014308",
    "tel": "02-29431824"
}, {
    "name": "全家中和和平店",
    "addr": "新北市中和區和平街56號1樓；54巷1弄1號1樓",
    "pkey": "015860",
    "tel": "02-29444304"
}, {
    "name": "全家中和新忠店",
    "addr": "新北市中和區忠孝街27號1樓",
    "pkey": "013906",
    "tel": "02-29425376"
}, {
    "name": "全家中和水源店",
    "addr": "新北市中和區保平路320號、322號",
    "pkey": "013672",
    "tel": "02-82459519"
}, {
    "name": "全家中和保健店",
    "addr": "新北市中和區保健路17號",
    "pkey": "016747",
    "tel": "02-29444222"
}, {
    "name": "全家中和南勢角店",
    "addr": "新北市中和區南山路399巷10號1樓",
    "pkey": "011531",
    "tel": "02-89412772"
}, {
    "name": "全家中和勝華店",
    "addr": "新北市中和區南華路67號壹樓",
    "pkey": "016490",
    "tel": "02-22425933"
}, {
    "name": "全家中和圓順店",
    "addr": "新北市中和區建一路141號",
    "pkey": "011256",
    "tel": "02-22289923"
}, {
    "name": "全家中和遠建店",
    "addr": "新北市中和區建一路176號1樓",
    "pkey": "012607",
    "tel": "02-82272991"
}, {
    "name": "全家中和建新店",
    "addr": "新北市中和區建八路28號1樓",
    "pkey": "014773",
    "tel": "02-82263686"
}, {
    "name": "全家中和員慶店",
    "addr": "新北市中和區員山路73號一樓",
    "pkey": "016681",
    "tel": "02-22236924"
}, {
    "name": "全家中和員山店",
    "addr": "新北市中和區員山路325之5號1F＆地下室",
    "pkey": "015632",
    "tel": "02-22267296"
}, {
    "name": "全家中和新慶店",
    "addr": "新北市中和區員山路137號1樓",
    "pkey": "016753",
    "tel": "02-82217342"
}, {
    "name": "全家中和興國店",
    "addr": "新北市中和區國光街104號1樓",
    "pkey": "015266",
    "tel": "02-29635114"
}, {
    "name": "全家中和莒城店",
    "addr": "新北市中和區莒光路181號",
    "pkey": "012956",
    "tel": "02-22230924"
}, {
    "name": "全家中和自強店",
    "addr": "新北市中和區莒光路131號",
    "pkey": "013225",
    "tel": "02-32346883"
}, {
    "name": "全家中和連勝店",
    "addr": "新北市中和區連城路231號1樓及2樓",
    "pkey": "017808",
    "tel": "02-22490286"
}, {
    "name": "全家中和世紀店",
    "addr": "新北市中和區連城路268之1號1樓",
    "pkey": "016359",
    "tel": "02-82278716"
}, {
    "name": "全家中和連福店",
    "addr": "新北市中和區連城路391號，393號",
    "pkey": "015919",
    "tel": "02-32347896"
}, {
    "name": "全家中和和連店",
    "addr": "新北市中和區連城路265巷1號一樓",
    "pkey": "014995",
    "tel": "02-82457861"
}, {
    "name": "全家中和新后店",
    "addr": "新北市中和區連城路469巷23號1樓",
    "pkey": "014166",
    "tel": "02-22216706"
}, {
    "name": "全家中和連新店",
    "addr": "新北市中和區連城路521之1號1樓",
    "pkey": "015225",
    "tel": "02-32346707"
}, {
    "name": "全家中和安勝店",
    "addr": "新北市中和區連勝街59號",
    "pkey": "016841",
    "tel": "02-22430244"
}, {
    "name": "全家中和景會店",
    "addr": "新北市中和區景平路433號1樓",
    "pkey": "011919",
    "tel": "02-22424705"
}, {
    "name": "全家中和福順店",
    "addr": "新北市中和區景平路708號",
    "pkey": "012395",
    "tel": "02-82454113"
}, {
    "name": "全家中和福真店",
    "addr": "新北市中和區景平路701、701之1號2樓",
    "pkey": "012957",
    "tel": "02-22469262"
}, {
    "name": "全家中和勝平店",
    "addr": "新北市中和區景平路517、519號1樓",
    "pkey": "014993",
    "tel": "02-22474417"
}, {
    "name": "全家中和摩天店",
    "addr": "新北市中和區景平路182號1樓",
    "pkey": "014013",
    "tel": "02-89423447"
}, {
    "name": "全家中和景平店",
    "addr": "新北市中和區景平路478號",
    "pkey": "016267",
    "tel": "02-89422184"
}, {
    "name": "全家中和景秀店",
    "addr": "新北市中和區景平路71—2號",
    "pkey": "011938",
    "tel": "02-86680018"
}, {
    "name": "全家中和新平店",
    "addr": "新北市中和區景新街265、267號",
    "pkey": "017894",
    "tel": "02-89411655"
}, {
    "name": "全家中和景欣店",
    "addr": "新北市中和區景新街385號，385號之1",
    "pkey": "016077",
    "tel": "02-29439032"
}, {
    "name": "全家中和景明店",
    "addr": "新北市中和區景新街212號1樓",
    "pkey": "015781",
    "tel": "02-29466803"
}, {
    "name": "全家中和朕新店",
    "addr": "新北市中和區景德街124號1樓",
    "pkey": "013652",
    "tel": "02-29426294"
}, {
    "name": "全家中和華順店",
    "addr": "新北市中和區華順街59號1樓",
    "pkey": "017825",
    "tel": "02-29542123"
}, {
    "name": "全家中和華福店",
    "addr": "新北市中和區華順街117號，119號",
    "pkey": "017156",
    "tel": "02-29506983"
}, {
    "name": "全家中和華夏店",
    "addr": "新北市中和區華新街202號，204號",
    "pkey": "017057",
    "tel": "02-29479070"
}, {
    "name": "全家中和華隆店",
    "addr": "新北市中和區華新街109巷1-3號",
    "pkey": "016749",
    "tel": "02-29414221"
}, {
    "name": "全家中和華樹店",
    "addr": "新北市中和區華新街55號1樓",
    "pkey": "017394",
    "tel": "02-29493985"
}, {
    "name": "全家中和錦順店",
    "addr": "新北市中和區圓通路395號1樓",
    "pkey": "014503",
    "tel": "02-22426992"
}, {
    "name": "全家中和圓峰店",
    "addr": "新北市中和區圓通路226號1樓",
    "pkey": "016458",
    "tel": "02-22433191"
}, {
    "name": "全家中和凌雲店",
    "addr": "新北市中和區圓通路367巷2號",
    "pkey": "017209",
    "tel": "02-22427725"
}, {
    "name": "全家中和安邦店",
    "addr": "新北市中和區圓通路169號",
    "pkey": "013339",
    "tel": "02-22460866"
}, {
    "name": "全家中和圓通店",
    "addr": "新北市中和區圓通路307之5號",
    "pkey": "017486",
    "tel": "02-22454902"
}, {
    "name": "全家中和新生店",
    "addr": "新北市中和區新生街132號",
    "pkey": "017310",
    "tel": "02-32342883"
}, {
    "name": "全家中和新正店",
    "addr": "新北市中和區新生街190號1樓",
    "pkey": "017716",
    "tel": "02-22263432"
}, {
    "name": "全家中和新中穗店",
    "addr": "新北市中和區新生街8號1樓",
    "pkey": "017101",
    "tel": "02-22253237"
}, {
    "name": "全家中和民德店",
    "addr": "新北市中和區壽德街26號1樓",
    "pkey": "016873",
    "tel": "02-29640401"
}, {
    "name": "全家中和福祥店",
    "addr": "新北市中和區福祥路30號1．2樓",
    "pkey": "016231",
    "tel": "02-22428093"
}, {
    "name": "全家中和南中店",
    "addr": "新北市中和區廣福路62號1樓",
    "pkey": "012472",
    "tel": "02-22464585"
}, {
    "name": "全家中和德穗店",
    "addr": "新北市中和區德光路24．26號1樓",
    "pkey": "017271",
    "tel": "02-89526580"
}, {
    "name": "全家中和橋安店",
    "addr": "新北市中和區橋和路120號",
    "pkey": "009159",
    "tel": "02-22424182"
}, {
    "name": "全家中和橋和店",
    "addr": "新北市中和區橋和路152號，156號",
    "pkey": "016530",
    "tel": "02-22445415"
}, {
    "name": "全家中和新興店",
    "addr": "新北市中和區興南路二段36號",
    "pkey": "016548",
    "tel": "02-29427198"
}, {
    "name": "全家中和南興店",
    "addr": "新北市中和區興南路二段5號",
    "pkey": "017174",
    "tel": "02-29420466"
}, {
    "name": "全家中和烘爐店",
    "addr": "新北市中和區興南路二段120號1樓",
    "pkey": "017717",
    "tel": "02-29468782"
}, {
    "name": "全家中和錦福店",
    "addr": "新北市中和區錦和路95號1樓",
    "pkey": "014485",
    "tel": "02-82453548"
}, {
    "name": "全家中和錦中店",
    "addr": "新北市中和區錦和路356號1樓",
    "pkey": "016750",
    "tel": "02-22458753"
}, ], [{
    "name": "全家土城工業店",
    "addr": "新北市土城區中山路61號1樓",
    "pkey": "017045",
    "tel": "02-22678853"
}, {
    "name": "全家土城新德店",
    "addr": "新北市土城區中央路一段248之2號",
    "pkey": "017226",
    "tel": "02-22644631"
}, {
    "name": "全家土城員仁店",
    "addr": "新北市土城區中央路二段308號",
    "pkey": "014627",
    "tel": "02-82623135"
}, {
    "name": "全家土城中源店",
    "addr": "新北市土城區中央路二段260號1樓",
    "pkey": "016035",
    "tel": "02-82623623"
}, {
    "name": "全家土城中央店",
    "addr": "新北市土城區中央路二段89號",
    "pkey": "017431",
    "tel": "02-22741563"
}, {
    "name": "全家土城順風店",
    "addr": "新北市土城區中央路二段154號",
    "pkey": "013000",
    "tel": "02-82612108"
}, {
    "name": "全家土城欣隆店",
    "addr": "新北市土城區中央路三段283號1樓",
    "pkey": "014891",
    "tel": "02-22683967"
}, {
    "name": "全家土城永寧店",
    "addr": "新北市土城區中央路三段74-1號＆74號1樓",
    "pkey": "015205",
    "tel": "02-22694365"
}, {
    "name": "全家土城大安店",
    "addr": "新北市土城區中央路三段187號",
    "pkey": "016643",
    "tel": "02-22690923"
}, {
    "name": "全家土城頂埔店",
    "addr": "新北市土城區中央路四段262號1樓",
    "pkey": "010501",
    "tel": "02-22674416"
}, {
    "name": "全家土城恆山店",
    "addr": "新北市土城區中央路四段281號1樓",
    "pkey": "011902",
    "tel": "02-22684232"
}, {
    "name": "全家土城鴻海附店",
    "addr": "新北市土城區中央路四段53-1號1樓",
    "pkey": "011502",
    "tel": "02-22689435"
}, {
    "name": "全家土城頂運店",
    "addr": "新北市土城區中央路四段70號1樓",
    "pkey": "014307",
    "tel": "02-22671054"
}, {
    "name": "全家土城鴻海店",
    "addr": "新北市土城區自由街2號5樓",
    "pkey": "011501",
    "tel": "02-22695054"
}, {
    "name": "全家土城新亞店",
    "addr": "新北市土城區亞洲路57號",
    "pkey": "013871",
    "tel": "02-22697840"
}, {
    "name": "全家土城峰吉店",
    "addr": "新北市土城區延吉街159號1樓",
    "pkey": "012914",
    "tel": "02-22628864"
}, {
    "name": "全家土城延豐店",
    "addr": "新北市土城區延吉街270號1樓",
    "pkey": "010679",
    "tel": "02-22746691"
}, {
    "name": "全家土城吉美店",
    "addr": "新北市土城區延吉街239號1樓",
    "pkey": "017621",
    "tel": "02-22602720"
}, {
    "name": "全家土城冠延店",
    "addr": "新北市土城區延和路111號",
    "pkey": "012590",
    "tel": "02-22622680"
}, {
    "name": "全家土城新延店",
    "addr": "新北市土城區延和路207號1樓",
    "pkey": "014347",
    "tel": "02-22628742"
}, {
    "name": "全家土城延安店",
    "addr": "新北市土城區延壽路21號1樓",
    "pkey": "012824",
    "tel": "02-22669835"
}, {
    "name": "全家土城義鴻店",
    "addr": "新北市土城區明德路一段311號1樓",
    "pkey": "015765",
    "tel": "02-22733196"
}, {
    "name": "全家土城德清店",
    "addr": "新北市土城區明德路一段103號1樓",
    "pkey": "014611",
    "tel": "02-22628154"
}, {
    "name": "全家土城立雲店",
    "addr": "新北市土城區金城路二段258之5號",
    "pkey": "017025",
    "tel": "02-22643909"
}, {
    "name": "全家土城香榭店",
    "addr": "新北市土城區金城路三段10號1樓",
    "pkey": "015116",
    "tel": "02-22645031"
}, {
    "name": "全家土城大城店",
    "addr": "新北市土城區金城路三段141號1樓＆地下一樓",
    "pkey": "016301",
    "tel": "02-82620927"
}, {
    "name": "全家土城青水店",
    "addr": "新北市土城區青仁路32號1樓",
    "pkey": "017002",
    "tel": "02-22707634"
}, {
    "name": "全家土城雲陽店",
    "addr": "新北市土城區青雲路185號1樓",
    "pkey": "015868",
    "tel": "02-22740328"
}, {
    "name": "全家土城寬樺店",
    "addr": "新北市土城區青雲路382號、384號",
    "pkey": "013062",
    "tel": "02-22662881"
}, {
    "name": "全家土城青雲店",
    "addr": "新北市土城區青雲路42號，44號",
    "pkey": "016646",
    "tel": "02-22743769"
}, {
    "name": "全家土城仁愛店",
    "addr": "新北市土城區清水路166號",
    "pkey": "015069",
    "tel": "02-22611306"
}, {
    "name": "全家土城海裕店",
    "addr": "新北市土城區裕民路92巷22弄3號1樓",
    "pkey": "013713",
    "tel": "02-22622604"
}, {
    "name": "全家土城學富店",
    "addr": "新北市土城區裕民路69號1樓",
    "pkey": "015735",
    "tel": "02-22641614"
}, {
    "name": "全家土城裕勝店",
    "addr": "新北市土城區裕生路57號1．2樓",
    "pkey": "011035",
    "tel": "02-22623307"
}, {
    "name": "全家土城御昇店",
    "addr": "新北市土城區裕生路12號1樓",
    "pkey": "016000",
    "tel": "02-22629626"
}, {
    "name": "全家土城城堡店",
    "addr": "新北市土城區福仁街50巷1號",
    "pkey": "010739",
    "tel": "02-22743213"
}, {
    "name": "全家土城金福店",
    "addr": "新北市土城區福安街1號1-3樓全棟",
    "pkey": "014336",
    "tel": "02-22695639"
}, {
    "name": "全家土城福祥店",
    "addr": "新北市土城區福祥街46號一樓",
    "pkey": "014748",
    "tel": "02-82615458"
}, {
    "name": "全家土城廣明店",
    "addr": "新北市土城區廣明街45號？47號",
    "pkey": "017179",
    "tel": "02-89674909"
}, {
    "name": "全家土城學林店",
    "addr": "新北市土城區學成路36號1樓",
    "pkey": "016846",
    "tel": "02-82620694"
}, {
    "name": "全家土城新學店",
    "addr": "新北市土城區學府路一段187號1樓",
    "pkey": "011462",
    "tel": "02-82624507"
}, {
    "name": "全家土城海山店",
    "addr": "新北市土城區學府路一段294號",
    "pkey": "015127",
    "tel": "02-22647851"
}, {
    "name": "全家土城廣福店",
    "addr": "新北市土城區學府路一段162號",
    "pkey": "015545",
    "tel": "02-22738441"
}, {
    "name": "全家土城廣興店",
    "addr": "新北市土城區學府路一段100號",
    "pkey": "016503",
    "tel": "02-22647450"
}, {
    "name": "全家土城美仁店",
    "addr": "新北市土城區學府路二段21號1樓",
    "pkey": "016755",
    "tel": "02-82614954"
}, ], [{
    "name": "全家三峽新莉雅店",
    "addr": "新北市三峽區二鬮路59之1號1樓",
    "pkey": "016930",
    "tel": "02-26741580"
}, {
    "name": "全家三峽三樹店",
    "addr": "新北市三峽區三樹路257號259號一樓",
    "pkey": "016501",
    "tel": "02-26739736"
}, {
    "name": "全家三峽同發店",
    "addr": "新北市三峽區大同路3-1號1樓及地下層全部",
    "pkey": "016206",
    "tel": "02-86714604"
}, {
    "name": "全家三峽金同店",
    "addr": "新北市三峽區大同路196之1號1樓",
    "pkey": "016389",
    "tel": "02-86721784"
}, {
    "name": "全家三峽大德店",
    "addr": "新北市三峽區大德路483號1樓",
    "pkey": "015439",
    "tel": "02-35012620"
}, {
    "name": "全家三峽福容店",
    "addr": "新北市三峽區大學路81號1樓",
    "pkey": "017026",
    "tel": "02-26728452"
}, {
    "name": "全家三峽北苑店",
    "addr": "新北市三峽區大學路151號1樓（商學院）",
    "pkey": "016069",
    "tel": "02-86714877"
}, {
    "name": "全家三峽觀成店",
    "addr": "新北市三峽區大觀路80號1樓",
    "pkey": "017063",
    "tel": "02-86723040"
}, {
    "name": "全家三峽峇里店",
    "addr": "新北市三峽區中山路303號一樓",
    "pkey": "016002",
    "tel": "02-26736076"
}, {
    "name": "全家三峽金寶店",
    "addr": "新北市三峽區中山路240號",
    "pkey": "017460",
    "tel": "02-86714922"
}, {
    "name": "全家三峽新介壽店",
    "addr": "新北市三峽區介壽路三段176號1樓",
    "pkey": "013562",
    "tel": "02-86766209"
}, {
    "name": "全家三峽文化店",
    "addr": "新北市三峽區文化路117號1樓",
    "pkey": "015998",
    "tel": "02-26728908"
}, {
    "name": "全家三峽大勇店",
    "addr": "新北市三峽區文化路254號1樓",
    "pkey": "016661",
    "tel": "02-26734590"
}, {
    "name": "全家三峽民權店",
    "addr": "新北市三峽區民權街231號1樓",
    "pkey": "016818",
    "tel": "02-86711532"
}, {
    "name": "全家三峽光明店",
    "addr": "新北市三峽區光明路6號，8號1樓",
    "pkey": "016152",
    "tel": "02-26749014"
}, {
    "name": "全家三峽大同店",
    "addr": "新北市三峽區光明路100之6號",
    "pkey": "015009",
    "tel": "02-86742229"
}, {
    "name": "全家三峽錦隆店",
    "addr": "新北市三峽區國光街1號1樓",
    "pkey": "015145",
    "tel": "02-86717821"
}, {
    "name": "全家三峽國寧店",
    "addr": "新北市三峽區國學街31．33號",
    "pkey": "014195",
    "tel": "02-86721143"
}, {
    "name": "全家三峽和平店",
    "addr": "新北市三峽區復興路157號1樓",
    "pkey": "016033",
    "tel": "02-26735218"
}, {
    "name": "全家三峽恩主店",
    "addr": "新北市三峽區復興路373、375號1樓",
    "pkey": "016929",
    "tel": "02-26714305"
}, {
    "name": "全家三峽復興店",
    "addr": "新北市三峽區復興路56號1樓",
    "pkey": "013675",
    "tel": "02-26714174"
}, {
    "name": "全家三峽學勝店",
    "addr": "新北市三峽區學勤路162號1樓",
    "pkey": "014192",
    "tel": "02-86716146"
}, ], [{
    "name": "全家樹林德園店",
    "addr": "新北市樹林區八德街600及602號",
    "pkey": "017830",
    "tel": "02-26807279"
}, {
    "name": "全家樹林俊興店",
    "addr": "新北市樹林區三俊街127號1F",
    "pkey": "014329",
    "tel": "02-26887701"
}, {
    "name": "全家樹林大安店",
    "addr": "新北市樹林區大安路501號1樓",
    "pkey": "013444",
    "tel": "02-26877960"
}, {
    "name": "全家樹林金安店",
    "addr": "新北市樹林區大安路585號1樓",
    "pkey": "017798",
    "tel": "02-26875845"
}, {
    "name": "全家樹林凱旋店",
    "addr": "新北市樹林區大成路10號1樓（光纖）三峽鎮",
    "pkey": "015870",
    "tel": "02-89700748"
}, {
    "name": "全家樹林藝術店",
    "addr": "新北市樹林區大雅路287號1樓",
    "pkey": "016070",
    "tel": "02-26687483"
}, {
    "name": "全家樹林學誠店",
    "addr": "新北市樹林區大義路196＆198號",
    "pkey": "016095",
    "tel": "02-35017864"
}, {
    "name": "全家樹林新中店",
    "addr": "新北市樹林區中山路三段107號及107-1號",
    "pkey": "011655",
    "tel": "02-26685755"
}, {
    "name": "全家樹林三德店",
    "addr": "新北市樹林區中正路482號1樓",
    "pkey": "017289",
    "tel": "02-26763033"
}, {
    "name": "全家樹林新全球店",
    "addr": "新北市樹林區中華路291號",
    "pkey": "016645",
    "tel": "02-86862215"
}, {
    "name": "全家樹林中華店",
    "addr": "新北市樹林區中華路183．185號1樓",
    "pkey": "013987",
    "tel": "02-86867009"
}, {
    "name": "全家樹林太平店",
    "addr": "新北市樹林區太元街58號",
    "pkey": "012659",
    "tel": "02-86845773"
}, {
    "name": "全家樹林仁醫店",
    "addr": "新北市樹林區文化街14號1樓",
    "pkey": "017547",
    "tel": "02-26842900"
}, {
    "name": "全家樹林日新店",
    "addr": "新北市樹林區日新街50號1樓",
    "pkey": "015126",
    "tel": "02-26876139"
}, {
    "name": "全家樹林新育店",
    "addr": "新北市樹林區育英街53號1樓",
    "pkey": "017301",
    "tel": "02-26860566"
}, {
    "name": "全家樹林育園店",
    "addr": "新北市樹林區佳園路一段43號",
    "pkey": "014701",
    "tel": "02-26684376"
}, {
    "name": "全家樹林五圓店",
    "addr": "新北市樹林區忠孝街99號1樓",
    "pkey": "013692",
    "tel": "02-86850375"
}, {
    "name": "全家樹林欣榮店",
    "addr": "新北市樹林區東榮街107號1樓",
    "pkey": "016153",
    "tel": "02-86857876"
}, {
    "name": "全家樹林新保安店",
    "addr": "新北市樹林區保安街二段215號1樓",
    "pkey": "015350",
    "tel": "02-26886257"
}, {
    "name": "全家樹林俊信店",
    "addr": "新北市樹林區俊英街118號1樓",
    "pkey": "013700",
    "tel": "02-26758782"
}, {
    "name": "全家樹林俊霖店",
    "addr": "新北市樹林區俊英街155巷1號1樓",
    "pkey": "013556",
    "tel": "02-26765503"
}, {
    "name": "全家樹林俊英店",
    "addr": "新北市樹林區俊英街113號",
    "pkey": "017506",
    "tel": "02-26899787"
}, {
    "name": "全家樹林車站店",
    "addr": "新北市樹林區後站街8號",
    "pkey": "013950",
    "tel": "02-26813492"
}, {
    "name": "全家樹林新柑園店",
    "addr": "新北市樹林區柑園街一段302號1樓",
    "pkey": "015191",
    "tel": "02-26684823"
}, {
    "name": "全家樹林國凱店",
    "addr": "新北市樹林區國凱街82號",
    "pkey": "015999",
    "tel": "02-86860727"
}, {
    "name": "全家樹林博愛店",
    "addr": "新北市樹林區博愛街158號1樓",
    "pkey": "012979",
    "tel": "02-86755840"
}, {
    "name": "全家樹林佳瑪店",
    "addr": "新北市樹林區博愛街89號1樓",
    "pkey": "016205",
    "tel": "02-26878166"
}, {
    "name": "全家樹林復興店",
    "addr": "新北市樹林區復興路272號，274號",
    "pkey": "013007",
    "tel": "02-26873547"
}, {
    "name": "全家樹林潭興店",
    "addr": "新北市樹林區潭興街22號1樓、地下室",
    "pkey": "015007",
    "tel": "02-26829851"
}, {
    "name": "全家樹林學園店",
    "addr": "新北市樹林區學成路601號1樓",
    "pkey": "015005",
    "tel": "02-35019721"
}, {
    "name": "全家樹林學勤店",
    "addr": "新北市樹林區學勤路550．552號1樓",
    "pkey": "016052",
    "tel": "02-89705219"
}, {
    "name": "全家樹林龍興店",
    "addr": "新北市樹林區龍興街15號",
    "pkey": "013985",
    "tel": "02-26889613"
}, ], [{
    "name": "全家鶯歌行政店",
    "addr": "新北市鶯歌區中正一路154號",
    "pkey": "015010",
    "tel": "02-26781963"
}, {
    "name": "全家鶯歌正鶯店",
    "addr": "新北市鶯歌區中正一路371號",
    "pkey": "013002",
    "tel": "02-86782074"
}, {
    "name": "全家鶯歌永明店",
    "addr": "新北市鶯歌區永明街78號1樓",
    "pkey": "017458",
    "tel": "02-26703617"
}, {
    "name": "全家鶯歌尖峰店",
    "addr": "新北市鶯歌區尖山路126號1樓",
    "pkey": "017792",
    "tel": "02-86774110"
}, {
    "name": "全家鶯歌新南雅店",
    "addr": "新北市鶯歌區南雅路442號",
    "pkey": "017829",
    "tel": "02-26704972"
}, {
    "name": "全家鶯歌國慶店",
    "addr": "新北市鶯歌區建國路122號1樓",
    "pkey": "014002",
    "tel": "02-26776756"
}, {
    "name": "全家鶯歌站前店",
    "addr": "新北市鶯歌區建國路53之5號、、53之6號1樓",
    "pkey": "013655",
    "tel": "02-86774875"
}, {
    "name": "全家鶯歌鶯桃店",
    "addr": "新北市鶯歌區鶯桃路45號1樓",
    "pkey": "016155",
    "tel": "02-26706210"
}, ], [{
    "name": "全家三重力行店",
    "addr": "新北市三重區力行路一段40號",
    "pkey": "013389",
    "tel": "02-29808615"
}, {
    "name": "全家三重大勇店",
    "addr": "新北市三重區力行路二段2號一樓",
    "pkey": "011856",
    "tel": "02-29829253"
}, {
    "name": "全家三重三民店",
    "addr": "新北市三重區三民街112號",
    "pkey": "016031",
    "tel": "02-29843629"
}, {
    "name": "全家三重新福田店",
    "addr": "新北市三重區三民街270號1樓",
    "pkey": "014700",
    "tel": "02-29823712"
}, {
    "name": "全家三重三安店",
    "addr": "新北市三重區三和路三段40號",
    "pkey": "013288",
    "tel": "02-29819584"
}, {
    "name": "全家三重厚德店",
    "addr": "新北市三重區三和路三段186號1樓",
    "pkey": "015592",
    "tel": "02-29815241"
}, {
    "name": "全家三重龍和店",
    "addr": "新北市三重區三和路三段59號",
    "pkey": "014907",
    "tel": "02-29762428"
}, {
    "name": "全家三重福運店",
    "addr": "新北市三重區三和路四段250號1樓",
    "pkey": "016177",
    "tel": "02-22863881"
}, {
    "name": "全家三重銀和店",
    "addr": "新北市三重區三和路四段394號1樓",
    "pkey": "015268",
    "tel": "02-22870339"
}, {
    "name": "全家三重新三陽店",
    "addr": "新北市三重區三陽路13巷2號1樓",
    "pkey": "016269",
    "tel": "02-29718178"
}, {
    "name": "全家三重富貴店",
    "addr": "新北市三重區三賢街201號",
    "pkey": "014746",
    "tel": "02-82876954"
}, {
    "name": "全家三重大同店",
    "addr": "新北市三重區大同北路6號1樓",
    "pkey": "015671",
    "tel": "02-29841445"
}, {
    "name": "全家三重車勇店",
    "addr": "新北市三重區大勇街1號1樓",
    "pkey": "016941",
    "tel": "02-29868439"
}, {
    "name": "全家三重大智店",
    "addr": "新北市三重區大智街94號",
    "pkey": "015269",
    "tel": "02-29807923"
}, {
    "name": "全家三重致學店",
    "addr": "新北市三重區大智街197號1樓",
    "pkey": "015591",
    "tel": "02-29869646"
}, {
    "name": "全家三重三佾店",
    "addr": "新北市三重區中央北路58號1樓",
    "pkey": "013411",
    "tel": "02-29784888"
}, {
    "name": "全家三重中央店",
    "addr": "新北市三重區中央南路51號1樓",
    "pkey": "016577",
    "tel": "02-29744057"
}, {
    "name": "全家三重興南店",
    "addr": "新北市三重區中央南路8號1樓",
    "pkey": "017732",
    "tel": "02-29742923"
}, {
    "name": "全家三重金勇店",
    "addr": "新北市三重區中正北路378號1樓",
    "pkey": "015555",
    "tel": "02-29850689"
}, {
    "name": "全家三重新正店",
    "addr": "新北市三重區中正南路184號1樓",
    "pkey": "015946",
    "tel": "02-29720095"
}, {
    "name": "全家三重華山店",
    "addr": "新北市三重區中華路28號",
    "pkey": "017456",
    "tel": "02-29879931"
}, {
    "name": "全家三重華泰店",
    "addr": "新北市三重區中華路53號1樓",
    "pkey": "017371",
    "tel": "02-29874587"
}, {
    "name": "全家三重新三信店",
    "addr": "新北市三重區五華街255號1樓",
    "pkey": "015089",
    "tel": "02-28559623"
}, {
    "name": "全家三重五華店",
    "addr": "新北市三重區五華街89號",
    "pkey": "017059",
    "tel": "02-89822418"
}, {
    "name": "全家三重華興店",
    "addr": "新北市三重區五華街45號．47號1樓",
    "pkey": "015088",
    "tel": "02-29876468"
}, {
    "name": "全家三重仁美店",
    "addr": "新北市三重區仁美街104號",
    "pkey": "013640",
    "tel": "02-82879284"
}, {
    "name": "全家三重新仁義店",
    "addr": "新北市三重區仁義街164號1樓",
    "pkey": "011369",
    "tel": "02-89859488"
}, {
    "name": "全家三重通華店",
    "addr": "新北市三重區仁義街317號",
    "pkey": "017123",
    "tel": "02-82875919"
}, {
    "name": "全家三重華義店",
    "addr": "新北市三重區仁義街244號、富華街193號1樓",
    "pkey": "013289",
    "tel": "02-89859180"
}, {
    "name": "全家三重文興店",
    "addr": "新北市三重區文化南路16號1樓",
    "pkey": "016624",
    "tel": "02-29761512"
}, {
    "name": "全家三重民生店",
    "addr": "新北市三重區民生東街2號",
    "pkey": "012686",
    "tel": "02-29809320"
}, {
    "name": "全家三重永安店",
    "addr": "新北市三重區永安北路二段11號1樓",
    "pkey": "015519",
    "tel": "02-28579121"
}, {
    "name": "全家三重福旺店",
    "addr": "新北市三重區永福街123號1樓",
    "pkey": "015923",
    "tel": "02-22863796"
}, {
    "name": "全家三重永福店",
    "addr": "新北市三重區永福街124號",
    "pkey": "010607",
    "tel": "02-22801075"
}, {
    "name": "全家三重興富店",
    "addr": "新北市三重區光復路一段70號1樓",
    "pkey": "016773",
    "tel": "02-85124587"
}, {
    "name": "全家三重群光店",
    "addr": "新北市三重區光復路二段69號1樓",
    "pkey": "015533",
    "tel": "02-29999287"
}, {
    "name": "全家三重環南店",
    "addr": "新北市三重區成功路52號，54號，56號1樓",
    "pkey": "014810",
    "tel": "02-29743620"
}, {
    "name": "全家三重成功店",
    "addr": "新北市三重區成功路145巷45號47號一樓",
    "pkey": "012550",
    "tel": "02-29742342"
}, {
    "name": "全家三重欣田店",
    "addr": "新北市三重區自強路二段24號",
    "pkey": "013850",
    "tel": "02-89837451"
}, {
    "name": "全家三重自強店",
    "addr": "新北市三重區自強路三段16號",
    "pkey": "017572",
    "tel": "02-89832068"
}, {
    "name": "全家三重車路頭店",
    "addr": "新北市三重區車路頭街140號1樓及地下室",
    "pkey": "014376",
    "tel": "02-82839334"
}, {
    "name": "全家三重公園店",
    "addr": "新北市三重區忠孝路二段34號",
    "pkey": "017457",
    "tel": "02-29836585"
}, {
    "name": "全家三重田心店",
    "addr": "新北市三重區忠孝路三段50巷82號一樓",
    "pkey": "016894",
    "tel": "02-29844120"
}, {
    "name": "全家三重長壽店",
    "addr": "新北市三重區長壽西街1號",
    "pkey": "017724",
    "tel": "02-89827026"
}, {
    "name": "全家三重新光榮店",
    "addr": "新北市三重區長興街57號1樓",
    "pkey": "016115",
    "tel": "02-29767953"
}, {
    "name": "全家三重重陽店",
    "addr": "新北市三重區重陽路一段109，111號",
    "pkey": "015140",
    "tel": "02-89810631"
}, {
    "name": "全家三重重仁店",
    "addr": "新北市三重區重陽路三段5巷30號",
    "pkey": "016550",
    "tel": "02-89883651"
}, {
    "name": "全家三重信安店",
    "addr": "新北市三重區重陽路四段55號1樓",
    "pkey": "017797",
    "tel": "02-29878001"
}, {
    "name": "全家三重天台店",
    "addr": "新北市三重區重新路二段78號",
    "pkey": "017212",
    "tel": "02-29744755"
}, {
    "name": "全家三重菜寮店",
    "addr": "新北市三重區重新路三段126號1樓",
    "pkey": "012257",
    "tel": "02-29749493"
}, {
    "name": "全家三重重光店",
    "addr": "新北市三重區重新路三段176號1樓",
    "pkey": "014776",
    "tel": "02-29746074"
}, {
    "name": "全家三重湯城店",
    "addr": "新北市三重區重新路五段609巷14號之7＆之8",
    "pkey": "013907",
    "tel": "02-29992495"
}, {
    "name": "全家三重中興店",
    "addr": "新北市三重區重新路五段595，597號",
    "pkey": "013353",
    "tel": "02-29992889"
}, {
    "name": "全家三重新運店",
    "addr": "新北市三重區捷運路19巷6弄20號1樓",
    "pkey": "017255",
    "tel": "02-29879457"
}, {
    "name": "全家三重街口店",
    "addr": "新北市三重區頂崁街210巷2號1樓",
    "pkey": "016766",
    "tel": "02-29875620"
}, {
    "name": "全家三重頂崁店",
    "addr": "新北市三重區22鄰頂崁街210巷31號1樓",
    "pkey": "017619",
    "tel": "02-29809001"
}, {
    "name": "全家三重集勇店",
    "addr": "新北市三重區集勇街19號",
    "pkey": "017543",
    "tel": "02-28570741"
}, {
    "name": "全家三重集美店",
    "addr": "新北市三重區集美街149號1樓",
    "pkey": "013022",
    "tel": "02-29742761"
}, {
    "name": "全家三重集明店",
    "addr": "新北市三重區集美街116號1樓",
    "pkey": "013493",
    "tel": "02-29738074"
}, {
    "name": "全家三重溪尾店",
    "addr": "新北市三重區溪尾街160號1樓",
    "pkey": "015959",
    "tel": "02-22867450"
}, {
    "name": "全家三重福溪店",
    "addr": "新北市三重區溪尾街56號",
    "pkey": "015958",
    "tel": "02-82873066"
}, {
    "name": "全家三重過圳店",
    "addr": "新北市三重區過圳街3號1樓",
    "pkey": "015003",
    "tel": "02-29868554"
}, {
    "name": "全家三重興德店",
    "addr": "新北市三重區興德路123號",
    "pkey": "011589",
    "tel": "02-85124015"
}, {
    "name": "全家三重龍門店",
    "addr": "新北市三重區龍門路276號",
    "pkey": "013598",
    "tel": "02-29723089"
}, {
    "name": "全家三重龍美店",
    "addr": "新北市三重區龍濱路120號1樓",
    "pkey": "015733",
    "tel": "02-29785611"
}, {
    "name": "全家三重龍明店",
    "addr": "新北市三重區龍濱路168號1樓",
    "pkey": "016875",
    "tel": "02-29781104"
}, {
    "name": "全家三重環北店",
    "addr": "新北市三重區環河南路253號一樓",
    "pkey": "015551",
    "tel": "02-29736779"
}, {
    "name": "全家三重集成店",
    "addr": "新北市三重區環河南路254巷43號之1、2號",
    "pkey": "011558",
    "tel": "02-29757564"
}, ], [{
    "name": "全家新莊八德店",
    "addr": "新北市新莊區八德街15巷2號，17號",
    "pkey": "017256",
    "tel": "02-22014759"
}, {
    "name": "全家新莊新德勝店",
    "addr": "新北市新莊區八德街135號",
    "pkey": "017019",
    "tel": "02-22014708"
}, {
    "name": "全家新莊新幸福店",
    "addr": "新北市新莊區中平路184巷10弄7號1樓",
    "pkey": "016711",
    "tel": "02-29969520"
}, {
    "name": "全家新莊狀元店",
    "addr": "新北市新莊區中平路268號",
    "pkey": "017314",
    "tel": "02-29984996"
}, {
    "name": "全家新莊中平店",
    "addr": "新北市新莊區中平路294號",
    "pkey": "015167",
    "tel": "02-29976597"
}, {
    "name": "全家新莊中永店",
    "addr": "新北市新莊區中平路66號",
    "pkey": "012580",
    "tel": "02-89920165"
}, {
    "name": "全家新莊安和店",
    "addr": "新北市新莊區中正路829巷22弄1號",
    "pkey": "015095",
    "tel": "02-29036055"
}, {
    "name": "全家新莊輔園店",
    "addr": "新北市新莊區中正路510號",
    "pkey": "017778",
    "tel": "02-29040262"
}, {
    "name": "全家新莊迴龍店",
    "addr": "新北市新莊區中正路895-26號1樓",
    "pkey": "015762",
    "tel": "02-29011240"
}, {
    "name": "全家新莊公所店",
    "addr": "新北市新莊區中正路255號1樓＋2樓",
    "pkey": "016362",
    "tel": "02-29924230"
}, {
    "name": "全家新莊福海店",
    "addr": "新北市新莊區中正路401號",
    "pkey": "011300",
    "tel": "02-22038885"
}, {
    "name": "全家新莊龍鳳店",
    "addr": "新北市新莊區中正路729號",
    "pkey": "012190",
    "tel": "02-29017635"
}, {
    "name": "全家新莊新建店",
    "addr": "新北市新莊區中正路新建巷40號1樓",
    "pkey": "016519",
    "tel": "02-29013769"
}, {
    "name": "全家新莊中環店",
    "addr": "新北市新莊區中和街155巷2號1樓＋2樓部分",
    "pkey": "016268",
    "tel": "02-29906924"
}, {
    "name": "全家新莊和運店",
    "addr": "新北市新莊區中和街17號1樓",
    "pkey": "017219",
    "tel": "02-29907549"
}, {
    "name": "全家新莊新中信店",
    "addr": "新北市新莊區中信街41號1樓",
    "pkey": "011872",
    "tel": "02-89927949"
}, {
    "name": "全家新莊中原店",
    "addr": "新北市新莊區中原路297號",
    "pkey": "012008",
    "tel": "02-89920047"
}, {
    "name": "全家新莊福壽店",
    "addr": "新北市新莊區中原路45號",
    "pkey": "010599",
    "tel": "02-29908643"
}, {
    "name": "全家新莊新和港店",
    "addr": "新北市新莊區中港一街143號",
    "pkey": "015169",
    "tel": "02-29938945"
}, {
    "name": "全家新莊中港店",
    "addr": "新北市新莊區中港路126號",
    "pkey": "016775",
    "tel": "02-29944832"
}, {
    "name": "全家新莊中美店",
    "addr": "新北市新莊區中港路413＆415號1樓",
    "pkey": "011855",
    "tel": "02-22796927"
}, {
    "name": "全家新莊華寧店",
    "addr": "新北市新莊區中華路一段8號1樓",
    "pkey": "013363",
    "tel": "02-29946014"
}, {
    "name": "全家新莊首富店",
    "addr": "新北市新莊區中華路二段5號",
    "pkey": "016500",
    "tel": "02-29902685"
}, {
    "name": "全家新莊中榮店",
    "addr": "新北市新莊區中榮街84號",
    "pkey": "012508",
    "tel": "02-29983442"
}, {
    "name": "全家新莊新工店",
    "addr": "新北市新莊區五工二路81號一樓",
    "pkey": "017061",
    "tel": "02-22989786"
}, {
    "name": "全家新莊樹成店",
    "addr": "新北市新莊區化成路738號",
    "pkey": "017370",
    "tel": "02-85214163"
}, {
    "name": "全家新莊福成店",
    "addr": "新北市新莊區化成路552號1樓及地下室",
    "pkey": "014648",
    "tel": "02-29948672"
}, {
    "name": "全家新莊福基店",
    "addr": "新北市新莊區化成路812號",
    "pkey": "012152",
    "tel": "02-85211601"
}, {
    "name": "全家新莊新市店",
    "addr": "新北市新莊區化成路431巷76號",
    "pkey": "014920",
    "tel": "02-85212417"
}, {
    "name": "全家新莊天美店",
    "addr": "新北市新莊區天祥街42號1樓",
    "pkey": "013499",
    "tel": "02-29030732"
}, {
    "name": "全家新莊新雙鳳店",
    "addr": "新北市新莊區天祥街2號",
    "pkey": "014082",
    "tel": "02-29011246"
}, {
    "name": "全家新莊維新店",
    "addr": "新北市新莊區四維路147號1樓",
    "pkey": "017683",
    "tel": "02-22041652"
}, {
    "name": "全家新莊德祐店",
    "addr": "新北市新莊區四維路150巷9號1樓",
    "pkey": "010510",
    "tel": "02-22083680"
}, {
    "name": "全家新莊民本店",
    "addr": "新北市新莊區民本街23巷2號1樓",
    "pkey": "012111",
    "tel": "02-22032338"
}, {
    "name": "全家新莊民和店",
    "addr": "新北市新莊區民安西路247號1樓",
    "pkey": "015763",
    "tel": "02-22049299"
}, {
    "name": "全家新莊富安店",
    "addr": "新北市新莊區民安路285之1號",
    "pkey": "012721",
    "tel": "02-22046753"
}, {
    "name": "全家新莊立信店",
    "addr": "新北市新莊區立信一街12號",
    "pkey": "017020",
    "tel": "02-29982115"
}, {
    "name": "全家新莊自成店",
    "addr": "新北市新莊區自信街2號1樓",
    "pkey": "013388",
    "tel": "02-29949824"
}, {
    "name": "全家新莊自強店",
    "addr": "新北市新莊區自強街2號",
    "pkey": "011946",
    "tel": "02-89916578"
}, {
    "name": "全家新莊盛寧店",
    "addr": "新北市新莊區西盛街151號1樓",
    "pkey": "013693",
    "tel": "02-22030264"
}, {
    "name": "全家新莊興盛店",
    "addr": "新北市新莊區西盛街230號1樓",
    "pkey": "012798",
    "tel": "02-22047033"
}, {
    "name": "全家新莊盛華店",
    "addr": "新北市新莊區西盛街390號1樓",
    "pkey": "015641",
    "tel": "02-22046755"
}, {
    "name": "全家新莊昌平店",
    "addr": "新北市新莊區昌平街50號",
    "pkey": "016436",
    "tel": "02-29906374"
}, {
    "name": "全家新莊昌盛店",
    "addr": "新北市新莊區昌盛街67號一樓",
    "pkey": "016226",
    "tel": "02-22764464"
}, {
    "name": "全家新莊明中店",
    "addr": "新北市新莊區明中街45號之2一樓",
    "pkey": "011756",
    "tel": "02-29937198"
}, {
    "name": "全家新莊建中店",
    "addr": "新北市新莊區建中街118號，120號",
    "pkey": "014580",
    "tel": "02-22779137"
}, {
    "name": "全家新莊建興店",
    "addr": "新北市新莊區建安街18號1樓",
    "pkey": "016179",
    "tel": "02-22015482"
}, {
    "name": "全家新莊建安店",
    "addr": "新北市新莊區建安街42號",
    "pkey": "011562",
    "tel": "02-22044299"
}, {
    "name": "全家新莊建國店",
    "addr": "新北市新莊區建國一路49號1樓右半",
    "pkey": "015298",
    "tel": "02-29081905"
}, {
    "name": "全家新莊學輔店",
    "addr": "新北市新莊區建國一路2號",
    "pkey": "014145",
    "tel": "02-29018239"
}, {
    "name": "全家新莊新園寧店",
    "addr": "新北市新莊區建興街101號",
    "pkey": "012608",
    "tel": "02-29949325"
}, {
    "name": "全家新莊新建明店",
    "addr": "新北市新莊區後港一路48號1樓",
    "pkey": "014642",
    "tel": "02-22048981"
}, {
    "name": "全家新莊北醫店",
    "addr": "新北市新莊區思源路127號",
    "pkey": "012848",
    "tel": "02-29944981"
}, {
    "name": "全家新莊頭前店",
    "addr": "新北市新莊區思源路595號一樓",
    "pkey": "016776",
    "tel": "02-85217886"
}, {
    "name": "全家新莊超級店",
    "addr": "新北市新莊區莊崑路25號1樓",
    "pkey": "017372",
    "tel": "02-22045567"
}, {
    "name": "全家新莊金富店",
    "addr": "新北市新莊區富國路176巷7號1樓",
    "pkey": "015623",
    "tel": "02-22023655"
}, {
    "name": "全家新莊景德店",
    "addr": "新北市新莊區景德路382號",
    "pkey": "014156",
    "tel": "02-22064530"
}, {
    "name": "全家新莊天成店",
    "addr": "新北市新莊區新北大道七段219號",
    "pkey": "013365",
    "tel": "02-29018545"
}, {
    "name": "全家新莊城邦店",
    "addr": "新北市新莊區新北大道三段7號1樓",
    "pkey": "017645",
    "tel": "02-85216513"
}, {
    "name": "全家新莊新立店",
    "addr": "新北市新莊區新泰路225巷1號1樓",
    "pkey": "013951",
    "tel": "02-29922460"
}, {
    "name": "全家新莊新泰店",
    "addr": "新北市新莊區新泰路146號",
    "pkey": "011029",
    "tel": "02-29972384"
}, {
    "name": "全家新莊泰豐店",
    "addr": "新北市新莊區新泰路3巷1號",
    "pkey": "017043",
    "tel": "02-22026118"
}, {
    "name": "全家新莊金泰店",
    "addr": "新北市新莊區新泰路305巷1號1樓",
    "pkey": "014948",
    "tel": "02-29902069"
}, {
    "name": "全家新莊武廟店",
    "addr": "新北市新莊區新莊路435號，435號之1",
    "pkey": "016704",
    "tel": "02-29975613"
}, {
    "name": "全家新莊海山店",
    "addr": "新北市新莊區新莊路741號1樓",
    "pkey": "016586",
    "tel": "02-22042064"
}, {
    "name": "全家新莊新樹店",
    "addr": "新北市新莊區新樹路613號1樓",
    "pkey": "013771",
    "tel": "02-22075970"
}, {
    "name": "全家新莊萬安店",
    "addr": "新北市新莊區萬安街80號",
    "pkey": "013410",
    "tel": "02-22037583"
}, {
    "name": "全家新莊裕民店",
    "addr": "新北市新莊區裕民街97號1樓",
    "pkey": "014809",
    "tel": "02-29017969"
}, {
    "name": "全家新莊仁義店",
    "addr": "新北市新莊區福壽街38號1F",
    "pkey": "015961",
    "tel": "02-29962848"
}, {
    "name": "全家新莊福祿店",
    "addr": "新北市新莊區福壽街81號1樓",
    "pkey": "014556",
    "tel": "02-89938193"
}, {
    "name": "全家新莊新福義店",
    "addr": "新北市新莊區福壽街132號1樓",
    "pkey": "014457",
    "tel": "02-29964281"
}, {
    "name": "全家新莊福樂店",
    "addr": "新北市新莊區福樂街30號1樓",
    "pkey": "015827",
    "tel": "02-89923468"
}, {
    "name": "全家新莊金豐店",
    "addr": "新北市新莊區豐年街66號1樓",
    "pkey": "015960",
    "tel": "02-22069828"
}, {
    "name": "全家新莊祥鳳店",
    "addr": "新北市新莊區雙鳳路106-1號",
    "pkey": "016518",
    "tel": "02-29022674"
}, {
    "name": "全家新莊三鳳店",
    "addr": "新北市新莊區雙鳳路130號",
    "pkey": "016802",
    "tel": "02-29080840"
}, ], [{
    "name": "全家泰山白金店",
    "addr": "新北市泰山區仁愛路108號1樓",
    "pkey": "015463",
    "tel": "02-22979409"
}, {
    "name": "全家泰山同興店",
    "addr": "新北市泰山區仁義路220巷8號1樓",
    "pkey": "016581",
    "tel": "02-29007443"
}, {
    "name": "全家泰山民權店",
    "addr": "新北市泰山區民權路29號1樓",
    "pkey": "015408",
    "tel": "02-22968230"
}, {
    "name": "全家泰山全興店",
    "addr": "新北市泰山區全興路165號一樓",
    "pkey": "016686",
    "tel": "02-22975119"
}, {
    "name": "全家泰山辭修店",
    "addr": "新北市泰山區明志路一段374號1樓",
    "pkey": "016363",
    "tel": "02-22971269"
}, {
    "name": "全家泰山義學店",
    "addr": "新北市泰山區明志路二段47號",
    "pkey": "011137",
    "tel": "02-29001245"
}, {
    "name": "全家泰山明豐店",
    "addr": "新北市泰山區明志路二段383號1樓",
    "pkey": "015991",
    "tel": "02-29048829"
}, {
    "name": "全家泰山工專店",
    "addr": "新北市泰山區明志路三段170號",
    "pkey": "017682",
    "tel": "02-29046856"
}, {
    "name": "全家泰山南科店",
    "addr": "新北市泰山區南林路98號支援二棟6樓販賣部",
    "pkey": "015812",
    "tel": "02-29045893"
}, {
    "name": "全家泰山南亞店",
    "addr": "新北市泰山區大科村南林路98號8樓販賣部",
    "pkey": "017660",
    "tel": "02-29045869"
}, {
    "name": "全家泰山新泰林店",
    "addr": "新北市泰山區泰林路二段107號1樓",
    "pkey": "014432",
    "tel": "02-29000777"
}, {
    "name": "全家泰山麗池店",
    "addr": "新北市泰山區泰林路二段518號",
    "pkey": "012416",
    "tel": "02-29007046"
}, {
    "name": "全家泰山黎明店",
    "addr": "新北市泰山區泰林路二段575號、577號1樓",
    "pkey": "014458",
    "tel": "02-22979445"
}, {
    "name": "全家泰山憲訓店",
    "addr": "新北市泰山區泰林路二段364號1樓",
    "pkey": "015626",
    "tel": "02-29005487"
}, {
    "name": "全家泰山新貴子店",
    "addr": "新北市泰山區貴子路38號1樓",
    "pkey": "013058",
    "tel": "02-29036660"
}, {
    "name": "全家泰山輔醫店",
    "addr": "新北市泰山區貴子路69號B1",
    "pkey": "016639",
    "tel": "02-29014162"
}, {
    "name": "全家泰山福興店",
    "addr": "新北市泰山區福興一街60號一樓",
    "pkey": "017494",
    "tel": "02-85311767"
}, ], [{
    "name": "全家林口洪福店",
    "addr": "新北市林口區下福里11鄰147號之1",
    "pkey": "011082",
    "tel": "02-26061202"
}, {
    "name": "全家林口工六店",
    "addr": "新北市林口區工六路78號",
    "pkey": "015709",
    "tel": "02-26016951"
}, {
    "name": "全家林口麗林店",
    "addr": "新北市林口區中山路522號1樓",
    "pkey": "015407",
    "tel": "02-26024790"
}, {
    "name": "全家林口南林店",
    "addr": "新北市林口區中山路555號",
    "pkey": "015867",
    "tel": "02-26010881"
}, {
    "name": "全家林口新中林店",
    "addr": "新北市林口區中正路168號1樓",
    "pkey": "014754",
    "tel": "02-86014581"
}, {
    "name": "全家林口新僑大店",
    "addr": "新北市林口區中正路55號1樓",
    "pkey": "015550",
    "tel": "02-26014016"
}, {
    "name": "全家林口中正店",
    "addr": "新北市林口區中正路266號",
    "pkey": "016361",
    "tel": "02-26015562"
}, {
    "name": "全家林口菁埔店",
    "addr": "新北市林口區仁愛路一段292號",
    "pkey": "016401",
    "tel": "02-26017544"
}, {
    "name": "全家林口新高中店",
    "addr": "新北市林口區仁愛路二段156號1樓",
    "pkey": "015436",
    "tel": "02-86012624"
}, {
    "name": "全家林口文園店",
    "addr": "新北市林口區公園路178號1樓",
    "pkey": "014946",
    "tel": "02-26090261"
}, {
    "name": "全家林口樂活店",
    "addr": "新北市林口區文化二路一段269號1樓",
    "pkey": "016942",
    "tel": "02-26089613"
}, {
    "name": "全家林口隆林店",
    "addr": "新北市林口區文化二路二段90．92號",
    "pkey": "013770",
    "tel": "02-26022405"
}, {
    "name": "全家林口新都店",
    "addr": "新北市林口區文化三路一段557號．559號1樓",
    "pkey": "014068",
    "tel": "02-26009183"
}, {
    "name": "全家林口影城店",
    "addr": "新北市林口區文化三路一段406號1樓",
    "pkey": "014003",
    "tel": "02-26090534"
}, {
    "name": "全家林口廣場店",
    "addr": "新北市林口區文化三路一段223號一樓",
    "pkey": "015437",
    "tel": "02-26069860"
}, {
    "name": "全家林口環球店",
    "addr": "新北市林口區文化三路一段2號1樓",
    "pkey": "016876",
    "tel": "02-26083394"
}, {
    "name": "全家林口菁英店",
    "addr": "新北市林口區文化三路一段121號1樓",
    "pkey": "017041",
    "tel": "02-26089574"
}, {
    "name": "全家林口幸福店",
    "addr": "新北市林口區文化三路一段35號1樓",
    "pkey": "016842",
    "tel": "02-26098325"
}, {
    "name": "全家林口新林店",
    "addr": "新北市林口區忠孝路128＆130號1樓",
    "pkey": "016120",
    "tel": "02-26009570"
}, {
    "name": "全家林口忠孝店",
    "addr": "新北市林口區忠孝路601號",
    "pkey": "012028",
    "tel": "02-26085421"
}, {
    "name": "全家林口竹林店",
    "addr": "新北市林口區林口路126號1F",
    "pkey": "012288",
    "tel": "02-26024731"
}, {
    "name": "全家林口文義店",
    "addr": "新北市林口區信義路289號",
    "pkey": "015091",
    "tel": "02-26090866"
}, {
    "name": "全家林口南勢店",
    "addr": "新北市林口區南勢街228號1樓",
    "pkey": "016617",
    "tel": "02-26007216"
}, {
    "name": "全家林口醒吾店",
    "addr": "新北市林口區東林村粉寮路一段66號1樓",
    "pkey": "013227",
    "tel": "02-26031858"
}, {
    "name": "全家林口國宅店",
    "addr": "新北市林口區麗園一街4巷1號1之4",
    "pkey": "011619",
    "tel": "02-26081140"
}, ], [{
    "name": "全家蘆洲九蘆店",
    "addr": "新北市蘆洲區九芎街66號1樓",
    "pkey": "016437",
    "tel": "02-28482350"
}, {
    "name": "全家蘆洲希望店",
    "addr": "新北市蘆洲區三民路378之3號1樓",
    "pkey": "017042",
    "tel": "02-82866754"
}, {
    "name": "全家蘆洲恆德店",
    "addr": "新北市蘆洲區三民路26巷22號，24號",
    "pkey": "015465",
    "tel": "02-82814638"
}, {
    "name": "全家蘆洲中央店",
    "addr": "新北市蘆洲區5鄰中央路56號",
    "pkey": "016044",
    "tel": "02-82850698"
}, {
    "name": "全家蘆洲正原店",
    "addr": "新北市蘆洲區中正路185巷19號",
    "pkey": "016475",
    "tel": "02-22892773"
}, {
    "name": "全家蘆洲新福原店",
    "addr": "新北市蘆洲區中原路70號",
    "pkey": "013983",
    "tel": "02-22892264"
}, {
    "name": "全家蘆洲華安店",
    "addr": "新北市蘆洲區中華街6巷52號1樓",
    "pkey": "016176",
    "tel": "02-28488839"
}, {
    "name": "全家蘆洲興賢店",
    "addr": "新北市蘆洲區中興街60號1樓",
    "pkey": "015640",
    "tel": "02-82866445"
}, {
    "name": "全家蘆洲新民愛店",
    "addr": "新北市蘆洲區仁愛街81號1樓",
    "pkey": "015267",
    "tel": "02-28470046"
}, {
    "name": "全家蘆洲新民生店",
    "addr": "新北市蘆洲區民生街123號1樓",
    "pkey": "012335",
    "tel": "02-22852487"
}, {
    "name": "全家蘆洲保佑店",
    "addr": "新北市蘆洲區民族路423號",
    "pkey": "016499",
    "tel": "02-82855113"
}, {
    "name": "全家蘆洲保新店",
    "addr": "新北市蘆洲區民族路387號",
    "pkey": "016151",
    "tel": "02-82860534"
}, {
    "name": "全家蘆洲仁德店",
    "addr": "新北市蘆洲區民族路74號1樓",
    "pkey": "017021",
    "tel": "02-82812279"
}, {
    "name": "全家蘆洲民星店",
    "addr": "新北市蘆洲區民族路424，424之1號1樓",
    "pkey": "013541",
    "tel": "02-28472257"
}, {
    "name": "全家蘆洲玉清店",
    "addr": "新北市蘆洲區民族路178號，180號一樓",
    "pkey": "013986",
    "tel": "02-82822002"
}, {
    "name": "全家蘆洲民華店",
    "addr": "新北市蘆洲區民族路422巷82弄14，16號",
    "pkey": "013473",
    "tel": "02-82831441"
}, {
    "name": "全家蘆洲民仁店",
    "addr": "新北市蘆洲區民族路448號",
    "pkey": "017018",
    "tel": "02-82835024"
}, {
    "name": "全家蘆洲名族店",
    "addr": "新北市蘆洲區民族路251號1樓",
    "pkey": "016020",
    "tel": "02-82852406"
}, {
    "name": "全家蘆洲義興店",
    "addr": "新北市蘆洲區民義街68巷2、6號1樓",
    "pkey": "014807",
    "tel": "02-28484834"
}, {
    "name": "全家蘆洲新虹展店",
    "addr": "新北市蘆洲區民義街22巷18號",
    "pkey": "017557",
    "tel": "02-82862521"
}, {
    "name": "全家蘆洲新鷺江店",
    "addr": "新北市蘆洲區民權路35號1樓",
    "pkey": "017594",
    "tel": "02-82851197"
}, {
    "name": "全家蘆洲福安店",
    "addr": "新北市蘆洲區民權路66號1樓",
    "pkey": "017369",
    "tel": "02-82854511"
}, {
    "name": "全家蘆洲永成店",
    "addr": "新北市蘆洲區永樂街83號一樓",
    "pkey": "015090",
    "tel": "02-28487328"
}, {
    "name": "全家蘆洲永樂店",
    "addr": "新北市蘆洲區永樂街38巷57弄1號1F",
    "pkey": "012039",
    "tel": "02-28470014"
}, {
    "name": "全家蘆洲光華店",
    "addr": "新北市蘆洲區光華路132巷1號，134號1樓",
    "pkey": "017060",
    "tel": "02-82823555"
}, {
    "name": "全家蘆洲金華店",
    "addr": "新北市蘆洲區光華路150巷38號1樓",
    "pkey": "011139",
    "tel": "02-22827493"
}, {
    "name": "全家蘆洲中華店",
    "addr": "新北市蘆洲區和平路122，124號",
    "pkey": "016400",
    "tel": "02-82814768"
}, {
    "name": "全家蘆洲成功店",
    "addr": "新北市蘆洲區長安街248號",
    "pkey": "016551",
    "tel": "02-82831373"
}, {
    "name": "全家蘆洲長興店",
    "addr": "新北市蘆洲區長安街168號1樓",
    "pkey": "017112",
    "tel": "02-28481192"
}, {
    "name": "全家蘆洲長發店",
    "addr": "新北市蘆洲區長安街11號1樓＆B1",
    "pkey": "016987",
    "tel": "02-82860503"
}, {
    "name": "全家蘆洲新安店",
    "addr": "新北市蘆洲區長安街301號1樓",
    "pkey": "015866",
    "tel": "02-82868249"
}, {
    "name": "全家蘆洲安宅店",
    "addr": "新北市蘆洲區長安街71號1樓",
    "pkey": "017770",
    "tel": "02-28481650"
}, {
    "name": "全家蘆洲信義店",
    "addr": "新北市蘆洲區信義路220號1樓",
    "pkey": "015622",
    "tel": "02-82854161"
}, {
    "name": "全家蘆洲復江店",
    "addr": "新北市蘆洲區復興路150˙152號一樓",
    "pkey": "013083",
    "tel": "02-22881963"
}, {
    "name": "全家蘆洲復興店",
    "addr": "新北市蘆洲區復興路11號1樓",
    "pkey": "016986",
    "tel": "02-82852663"
}, {
    "name": "全家蘆洲花園店",
    "addr": "新北市蘆洲區集賢路269巷10號1樓",
    "pkey": "017425",
    "tel": "02-82863423"
}, {
    "name": "全家蘆洲集賢店",
    "addr": "新北市蘆洲區集賢路237號",
    "pkey": "011037",
    "tel": "02-22897841"
}, ], [{
    "name": "全家五股工商店",
    "addr": "新北市五股區工商路81號及83號",
    "pkey": "012562",
    "tel": "02-22933482"
}, {
    "name": "全家五股高亞店",
    "addr": "新北市五股區中興路一段142號142之1號一",
    "pkey": "016985",
    "tel": "02-29844397"
}, {
    "name": "全家五股五權店",
    "addr": "新北市五股區五工五路34號",
    "pkey": "016477",
    "tel": "02-22984246"
}, {
    "name": "全家五股六福店",
    "addr": "新北市五股區五福路70號1樓",
    "pkey": "017211",
    "tel": "02-22931649"
}, {
    "name": "全家五股五福店",
    "addr": "新北市五股區五福路24號",
    "pkey": "013819",
    "tel": "02-82957618"
}, {
    "name": "全家五股維興店",
    "addr": "新北市五股區四維路78號．80號1樓",
    "pkey": "015625",
    "tel": "02-89813796"
}, {
    "name": "全家五股新五義店",
    "addr": "新北市五股區民義路一段109號1樓",
    "pkey": "012113",
    "tel": "02-22939726"
}, {
    "name": "全家五股民義店",
    "addr": "新北市五股區民義路二段16號1樓",
    "pkey": "014640",
    "tel": "02-22942736"
}, {
    "name": "全家五股水碓店",
    "addr": "新北市五股區成泰路一段7巷21號、23號1樓",
    "pkey": "013597",
    "tel": "02-22977124"
}, {
    "name": "全家五股蓬萊店",
    "addr": "新北市五股區成泰路一段235-11號1樓及B1",
    "pkey": "014557",
    "tel": "02-82921512"
}, {
    "name": "全家五股成泰店",
    "addr": "新北市五股區成泰路三段577巷138號1樓",
    "pkey": "016476",
    "tel": "02-22931703"
}, {
    "name": "全家五股青水店",
    "addr": "新北市五股區成泰路四段16號1樓",
    "pkey": "016466",
    "tel": "02-82923238"
}, {
    "name": "全家五股自強店",
    "addr": "新北市五股區自強路74號1樓",
    "pkey": "013386",
    "tel": "02-82921942"
}, {
    "name": "全家五股貿商店",
    "addr": "新北市五股區自強路154號1樓",
    "pkey": "015001",
    "tel": "02-22936597"
}, {
    "name": "全家五股御雲店",
    "addr": "新北市五股區西雲路2號1樓",
    "pkey": "016438",
    "tel": "02-22931757"
}, {
    "name": "全家五股金雲店",
    "addr": "新北市五股區西雲路208號1樓",
    "pkey": "016943",
    "tel": "02-22952906"
}, {
    "name": "全家五股芳洲店",
    "addr": "新北市五股區芳洲一路38號1樓＆2樓",
    "pkey": "017243",
    "tel": "02-22953094"
}, {
    "name": "全家五股凌雲店",
    "addr": "新北市五股區凌雲路一段81號",
    "pkey": "013066",
    "tel": "02-22941821"
}, {
    "name": "全家五股登科店",
    "addr": "新北市五股區登林路76之9號1樓",
    "pkey": "015853",
    "tel": "02-22931643"
}, {
    "name": "全家五股洲子洋店",
    "addr": "新北市五股區新城八路72號1樓",
    "pkey": "016882",
    "tel": "02-22953856"
}, ], [{
    "name": "全家八里龍王店",
    "addr": "新北市八里區中山路一段131號1樓",
    "pkey": "017646",
    "tel": "02-26101008"
}, {
    "name": "全家八里中華店",
    "addr": "新北市八里區中華路二段468號1樓",
    "pkey": "016467",
    "tel": "02-86303476"
}, {
    "name": "全家八里華城店",
    "addr": "新北市八里區中華路二段306號1樓",
    "pkey": "017734",
    "tel": "02-86304933"
}, {
    "name": "全家八里廖添丁店",
    "addr": "新北市八里區中華路三段17號1樓",
    "pkey": "017641",
    "tel": "02-26101005"
}, {
    "name": "全家八里富塘店",
    "addr": "新北市八里區訊塘路62號1樓",
    "pkey": "015166",
    "tel": "02-86303914"
}, {
    "name": "全家八里船頭店",
    "addr": "新北市八里區渡船頭街1號",
    "pkey": "013618",
    "tel": "02-86304308"
}, {
    "name": "全家八里龍米店",
    "addr": "新北市八里區龍米路一段222號1樓",
    "pkey": "014921",
    "tel": "02-26187522"
}, ], [{
    "name": "全家淡水興忠店",
    "addr": "新北市淡水區11鄰大忠街43號1樓",
    "pkey": "017189",
    "tel": "02-26263386"
}, {
    "name": "全家淡水新生店",
    "addr": "新北市淡水區大義街11號",
    "pkey": "015480",
    "tel": "02-26224332"
}, {
    "name": "全家淡水新江店",
    "addr": "新北市淡水區中山北路二段188巷16號1樓",
    "pkey": "012464",
    "tel": "02-26227391"
}, {
    "name": "全家淡水市鎮店",
    "addr": "新北市淡水區中山北路二段185號1樓",
    "pkey": "017796",
    "tel": "02-26236102"
}, {
    "name": "全家淡水正中店",
    "addr": "新北市淡水區中正東路一段77號79號",
    "pkey": "015699",
    "tel": "02-26282285"
}, {
    "name": "全家淡水紅林店",
    "addr": "新北市淡水區中正東路二段69號1樓",
    "pkey": "017105",
    "tel": "02-28092016"
}, {
    "name": "全家淡水新天闊店",
    "addr": "新北市淡水區中正東路二段33號",
    "pkey": "014800",
    "tel": "02-28084041"
}, {
    "name": "全家淡水登峰店",
    "addr": "新北市淡水區中正東路二段27號2樓",
    "pkey": "002353",
    "tel": "02-28085461"
}, {
    "name": "全家淡水捷運站店",
    "addr": "新北市淡水區中正路1號（淡水站5號販賣店部分）",
    "pkey": "017272",
    "tel": "02-26269599"
}, {
    "name": "全家淡水淡海店",
    "addr": "新北市淡水區中正路一段62巷2號",
    "pkey": "012856",
    "tel": "02-28050241"
}, {
    "name": "全家淡水水源店",
    "addr": "新北市淡水區水源街一段124號1樓",
    "pkey": "014623",
    "tel": "02-26291496"
}, {
    "name": "全家淡水源德店",
    "addr": "新北市淡水區水源街一段1號",
    "pkey": "013011",
    "tel": "02-26264758"
}, {
    "name": "全家淡水富山店",
    "addr": "新北市淡水區水源街二段177巷67號",
    "pkey": "012237",
    "tel": "02-26239971"
}, {
    "name": "全家淡水新旭店",
    "addr": "新北市淡水區北新路169巷35號1樓",
    "pkey": "017606",
    "tel": "02-26253827"
}, {
    "name": "全家淡水學城店",
    "addr": "新北市淡水區北新路182巷21弄1-1號",
    "pkey": "014259",
    "tel": "02-26299127"
}, {
    "name": "全家淡水竹圍店",
    "addr": "新北市淡水區民生路58號",
    "pkey": "012735",
    "tel": "02-28099936"
}, {
    "name": "全家淡水竹勝店",
    "addr": "新北市淡水區民族路56號1樓",
    "pkey": "016892",
    "tel": "02-28082083"
}, {
    "name": "全家淡水加州店",
    "addr": "新北市淡水區民權路19號",
    "pkey": "016344",
    "tel": "02-88093432"
}, {
    "name": "全家淡水自強店",
    "addr": "新北市淡水區自強路82號、84號",
    "pkey": "015250",
    "tel": "02-28080360"
}, {
    "name": "全家淡水沙崙店",
    "addr": "新北市淡水區沙崙路149號",
    "pkey": "014991",
    "tel": "02-28050829"
}, {
    "name": "全家淡水校園店",
    "addr": "新北市淡水區英專路151號〈淡大美食廣場B1部分〉",
    "pkey": "016529",
    "tel": "02-26209881"
}, {
    "name": "全家淡水大學店",
    "addr": "新北市淡水區英專路151號",
    "pkey": "015160",
    "tel": "02-26226380"
}, {
    "name": "全家淡水摩洛哥店",
    "addr": "新北市淡水區淡金路38巷70號",
    "pkey": "016029",
    "tel": "02-86268106"
}, {
    "name": "全家淡水新莊店",
    "addr": "新北市淡水區淡金路一段166號",
    "pkey": "014945",
    "tel": "02-26227867"
}, {
    "name": "全家淡水聖大店",
    "addr": "新北市淡水區淡金路四段499號1樓",
    "pkey": "015662",
    "tel": "02-28013756"
}, {
    "name": "全家淡水新崙店",
    "addr": "新北市淡水區淡海路76號1樓",
    "pkey": "015518",
    "tel": "02-28053641"
}, {
    "name": "全家淡水青水店",
    "addr": "新北市淡水區清水街9-5號一樓",
    "pkey": "017729",
    "tel": "02-26209862"
}, {
    "name": "全家淡水淡水店",
    "addr": "新北市淡水區博愛街14號",
    "pkey": "015199",
    "tel": "02-26237472"
}, {
    "name": "全家淡水義山店",
    "addr": "新北市淡水區新市一路一段103號1樓",
    "pkey": "015058",
    "tel": "02-26258537"
}, {
    "name": "全家淡水新園店",
    "addr": "新北市淡水區新民街78號",
    "pkey": "017690",
    "tel": "02-26218918"
}, {
    "name": "全家淡水新民店",
    "addr": "新北市淡水區新民街180之6號",
    "pkey": "017429",
    "tel": "02-26223099"
}, {
    "name": "全家淡水旭陞店",
    "addr": "新北市淡水區新生街53號1樓",
    "pkey": "012355",
    "tel": "02-26217371"
}, {
    "name": "全家淡水新摩天店",
    "addr": "新北市淡水區新春街184號",
    "pkey": "015976",
    "tel": "02-26255587"
}, {
    "name": "全家淡水福春店",
    "addr": "新北市淡水區新春街2號一樓",
    "pkey": "014190",
    "tel": "02-26281994"
}, {
    "name": "全家淡水新興店",
    "addr": "新北市淡水區新興街64號",
    "pkey": "017100",
    "tel": "02-26230631"
}, {
    "name": "全家淡水鄧公店",
    "addr": "新北市淡水區鄧公路32巷1號",
    "pkey": "016387",
    "tel": "02-26282840"
}, {
    "name": "全家淡水麗景店",
    "addr": "新北市淡水區學府路30號1樓",
    "pkey": "012586",
    "tel": "02-26252260"
}, {
    "name": "全家淡水財庫店",
    "addr": "新北市淡水區學府路136巷46號一樓",
    "pkey": "016825",
    "tel": "02-86319663"
}, {
    "name": "全家淡水濱海店",
    "addr": "新北市淡水區濱海路一段308號",
    "pkey": "013190",
    "tel": "02-26228293"
}, ], [{
    "name": "全家三芝吉祥店",
    "addr": "新北市三芝區淡金路一段73，75，77號",
    "pkey": "015037",
    "tel": "02-26361917"
}, ], [{
    "name": "全家石門粽香店",
    "addr": "新北市石門區中央路24號",
    "pkey": "015742",
    "tel": "02-26382011"
}, ], ], [[{
    "name": "全家中壢青埔店",
    "addr": "桃園市中壢區7鄰領航北路二段66號1樓",
    "pkey": "017522",
    "tel": "03-2873133"
}, {
    "name": "全家中壢原大店",
    "addr": "桃園市中壢區大仁二街17號1樓",
    "pkey": "015070",
    "tel": "03-4379511"
}, {
    "name": "全家中壢新仁店",
    "addr": "桃園市中壢區大仁四街16號1樓",
    "pkey": "017802",
    "tel": "03-4659758"
}, {
    "name": "全家中壢中央一店",
    "addr": "桃園市中壢區中大路300號（女十四舍B1）",
    "pkey": "013520",
    "tel": "03-4206551"
}, {
    "name": "全家中壢中央二店",
    "addr": "桃園市中壢區中大路300號（男九舍）",
    "pkey": "013833",
    "tel": "03-4265685"
}, {
    "name": "全家中壢中央三店",
    "addr": "桃園市中壢區中大路300號松苑餐廳1樓",
    "pkey": "017558",
    "tel": "03-4205531"
}, {
    "name": "全家中壢新仁美店",
    "addr": "桃園市中壢區中山東路三段211之1號",
    "pkey": "017202",
    "tel": "03-4565503"
}, {
    "name": "全家中壢太子店",
    "addr": "桃園市中壢區中山東路三段51號",
    "pkey": "014471",
    "tel": "03-4665494"
}, {
    "name": "全家中壢農會店",
    "addr": "桃園市中壢區中山路97號1樓",
    "pkey": "013676",
    "tel": "03-4222900"
}, {
    "name": "全家中壢金央店",
    "addr": "桃園市中壢區中山路100號1F",
    "pkey": "014340",
    "tel": "03-4254651"
}, {
    "name": "全家中壢中北店",
    "addr": "桃園市中壢區中北路31號",
    "pkey": "014093",
    "tel": "03-4364237"
}, {
    "name": "全家中壢龍凱店",
    "addr": "桃園市中壢區中央路218號1樓",
    "pkey": "011006",
    "tel": "03-4207322"
}, {
    "name": "全家中壢源興店",
    "addr": "桃園市中壢區中平路86-1號（興中移）",
    "pkey": "015926",
    "tel": "03-2807380"
}, {
    "name": "全家中壢站前店",
    "addr": "桃園市中壢區5鄰中平路1、3號1樓",
    "pkey": "017317",
    "tel": "03-4265615"
}, {
    "name": "全家中壢龍正店",
    "addr": "桃園市中壢區中正路35號1樓",
    "pkey": "015050",
    "tel": "03-4268507"
}, {
    "name": "全家中壢車站店",
    "addr": "桃園市中壢區中和路139號1樓部分空間",
    "pkey": "017445",
    "tel": "03-4225316"
}, {
    "name": "全家中壢環華店",
    "addr": "桃園市中壢區中華路一段227號1樓",
    "pkey": "017564",
    "tel": "03-4516327"
}, {
    "name": "全家中壢明光店",
    "addr": "桃園市中壢區中華路一段550號8樓",
    "pkey": "012987",
    "tel": "03-4536307"
}, {
    "name": "全家中壢龍園店",
    "addr": "桃園市中壢區中園路15號",
    "pkey": "016287",
    "tel": "03-4629416"
}, {
    "name": "全家中壢宏大店",
    "addr": "桃園市中壢區中園路192-2號",
    "pkey": "014262",
    "tel": "03-4535014"
}, {
    "name": "全家中壢萬能店",
    "addr": "桃園市中壢區中園路二段91號",
    "pkey": "014537",
    "tel": "03-4620757"
}, {
    "name": "全家中壢海華店",
    "addr": "桃園市中壢區元化路282．286號一樓",
    "pkey": "016442",
    "tel": "03-2807841"
}, {
    "name": "全家中壢六合店",
    "addr": "桃園市中壢區六和路48號",
    "pkey": "013495",
    "tel": "03-4255260"
}, {
    "name": "全家中壢文忠店",
    "addr": "桃園市中壢區文中路二段51-9號",
    "pkey": "016383",
    "tel": "03-4332555"
}, {
    "name": "全家中壢元生店",
    "addr": "桃園市中壢區文化二路252號256號",
    "pkey": "015207",
    "tel": "03-4341827"
}, {
    "name": "全家中壢三和店",
    "addr": "桃園市中壢區日新路80號",
    "pkey": "014717",
    "tel": "03-4654605"
}, {
    "name": "全家中壢日新店",
    "addr": "桃園市中壢區日新路24號",
    "pkey": "016850",
    "tel": "03-4361235"
}, {
    "name": "全家中壢弘志店",
    "addr": "桃園市中壢區弘揚路29號",
    "pkey": "015509",
    "tel": "03-4658967"
}, {
    "name": "全家中壢弘福店",
    "addr": "桃園市中壢區弘揚路90號1F＋B1",
    "pkey": "012582",
    "tel": "03-4384005"
}, {
    "name": "全家中壢高嶺店",
    "addr": "桃園市中壢區民族路五段326之2號",
    "pkey": "016883",
    "tel": "03-4207529"
}, {
    "name": "全家中壢元權店",
    "addr": "桃園市中壢區民權路340號1樓。2樓",
    "pkey": "014491",
    "tel": "03-4951945"
}, {
    "name": "全家中壢富裕店",
    "addr": "桃園市中壢區永強街103號1樓",
    "pkey": "016972",
    "tel": "03-4523403"
}, {
    "name": "全家中壢中美店",
    "addr": "桃園市中壢區光復街13號",
    "pkey": "015672",
    "tel": "03-4269866"
}, {
    "name": "全家中壢吉林店",
    "addr": "桃園市中壢區吉林二路79巷2號",
    "pkey": "016565",
    "tel": "03-4514926"
}, {
    "name": "全家中壢吉園店",
    "addr": "桃園市中壢區吉林路68之1號",
    "pkey": "014612",
    "tel": "03-4610309"
}, {
    "name": "全家中壢城章店",
    "addr": "桃園市中壢區成章一街156號",
    "pkey": "016377",
    "tel": "03-4625435"
}, {
    "name": "全家中壢復華店",
    "addr": "桃園市中壢區自強四路88號一樓",
    "pkey": "017676",
    "tel": "03-4341338"
}, {
    "name": "全家中壢工業店",
    "addr": "桃園市中壢區西園路116號1樓",
    "pkey": "015372",
    "tel": "03-4612181"
}, {
    "name": "全家中壢天晟店",
    "addr": "桃園市中壢區延平路149號1樓",
    "pkey": "012512",
    "tel": "03-4343442"
}, {
    "name": "全家中壢忠孝店",
    "addr": "桃園市中壢區信義路76號",
    "pkey": "014161",
    "tel": "03-4519387"
}, {
    "name": "全家中壢西園店",
    "addr": "桃園市中壢區南園二路12號14號一樓",
    "pkey": "012980",
    "tel": "03-4552182"
}, {
    "name": "全家中壢金園店",
    "addr": "桃園市中壢區南園二路323號1樓",
    "pkey": "013733",
    "tel": "03-4536048"
}, {
    "name": "全家中壢清英店",
    "addr": "桃園市中壢區健行路229號",
    "pkey": "011200",
    "tel": "03-4280454"
}, {
    "name": "全家中壢後站店",
    "addr": "桃園市中壢區健行路2號1樓",
    "pkey": "012435",
    "tel": "03-4593622"
}, {
    "name": "全家中壢自立店",
    "addr": "桃園市中壢區莊敬路823號",
    "pkey": "016302",
    "tel": "03-4612172"
}, {
    "name": "全家中壢復興店",
    "addr": "桃園市中壢區復興路1號1樓",
    "pkey": "017258",
    "tel": "03-4259562"
}, {
    "name": "全家中壢十里店",
    "addr": "桃園市中壢區復興路161號",
    "pkey": "014892",
    "tel": "03-4272590"
}, {
    "name": "全家中壢市代店",
    "addr": "桃園市中壢區慈惠三街155號",
    "pkey": "015642",
    "tel": "03-4228332"
}, {
    "name": "全家中壢禾凱店",
    "addr": "桃園市中壢區新中北路380號",
    "pkey": "010479",
    "tel": "03-4355908"
}, {
    "name": "全家中壢新中原店",
    "addr": "桃園市中壢區新中北路243號1樓",
    "pkey": "014239",
    "tel": "03-4657833"
}, {
    "name": "全家中壢興廣店",
    "addr": "桃園市中壢區新中北路二段489號",
    "pkey": "013557",
    "tel": "03-4536026"
}, {
    "name": "全家中壢新美店",
    "addr": "桃園市中壢區新生路80號1樓",
    "pkey": "015491",
    "tel": "03-2806386"
}, {
    "name": "全家中壢環北店",
    "addr": "桃園市中壢區新生路402號；環北路303號305號",
    "pkey": "016443",
    "tel": "03-4345363"
}, {
    "name": "全家中壢柏德店",
    "addr": "桃園市中壢區實踐路221號",
    "pkey": "012079",
    "tel": "03-4382027"
}, {
    "name": "全家中壢榮安店",
    "addr": "桃園市中壢區榮安十三街205號",
    "pkey": "016896",
    "tel": "03-2850697"
}, {
    "name": "全家中壢榮光店",
    "addr": "桃園市中壢區榮安十三街262號",
    "pkey": "014359",
    "tel": "03-4610427"
}, {
    "name": "全家中壢福爵店",
    "addr": "桃園市中壢區福州二街526號1樓",
    "pkey": "012881",
    "tel": "03-4616552"
}, {
    "name": "全家中壢大福店",
    "addr": "桃園市中壢區福州二街457號",
    "pkey": "016539",
    "tel": "03-4535514"
}, {
    "name": "全家中壢元大一店",
    "addr": "桃園市中壢區遠東路135號（元智大學宿舍區）",
    "pkey": "014600",
    "tel": "03-4358022"
}, {
    "name": "全家中壢元大二店",
    "addr": "桃園市中壢區遠東路135號（元智大學圖書館）",
    "pkey": "013736",
    "tel": "03-4357993"
}, {
    "name": "全家中壢元智店",
    "addr": "桃園市中壢區興仁路二段63號",
    "pkey": "014841",
    "tel": "03-4358772"
}, {
    "name": "全家中壢興榮店",
    "addr": "桃園市中壢區興仁路二段288號1樓",
    "pkey": "016288",
    "tel": "03-2854760"
}, {
    "name": "全家中壢龍川店",
    "addr": "桃園市中壢區龍川街3號1樓．2樓約5坪",
    "pkey": "013579",
    "tel": "03-4371941"
}, {
    "name": "全家中壢龍航店",
    "addr": "桃園市中壢區龍岡路一段204號",
    "pkey": "014221",
    "tel": "03-4670906"
}, {
    "name": "全家中壢龍興店",
    "addr": "桃園市中壢區龍岡路二段317．319號1樓",
    "pkey": "011178",
    "tel": "03-2841406"
}, {
    "name": "全家中壢龍岡店",
    "addr": "桃園市中壢區龍岡路二段115號",
    "pkey": "016180",
    "tel": "03-4578429"
}, {
    "name": "全家中壢龍門店",
    "addr": "桃園市中壢區龍岡路三段616號",
    "pkey": "015111",
    "tel": "03-4507940"
}, {
    "name": "全家中壢龍慈店",
    "addr": "桃園市中壢區龍岡路三段275號1F",
    "pkey": "017228",
    "tel": "03-4687862"
}, {
    "name": "全家中壢龍樹店",
    "addr": "桃園市中壢區龍東路205號1樓、2樓",
    "pkey": "016493",
    "tel": "03-4381941"
}, {
    "name": "全家中壢米干店",
    "addr": "桃園市中壢區龍東路260號",
    "pkey": "016097",
    "tel": "03-4384109"
}, {
    "name": "全家中壢龍東店",
    "addr": "桃園市中壢區龍東路124號1樓",
    "pkey": "015299",
    "tel": "03-4668249"
}, {
    "name": "全家中壢環東店",
    "addr": "桃園市中壢區環中東路235-1號",
    "pkey": "017257",
    "tel": "03-4518150"
}, {
    "name": "全家中壢環中店",
    "addr": "桃園市中壢區環中東路208號、208之1號1樓",
    "pkey": "012940",
    "tel": "03-2853547"
}, {
    "name": "全家中壢環西店",
    "addr": "桃園市中壢區環西路二段302號1樓、2樓",
    "pkey": "017346",
    "tel": "03-4944757"
}, ], [{
    "name": "全家平鎮中庸店",
    "addr": "桃園市平鎮區中庸路126號128號一樓",
    "pkey": "011359",
    "tel": "03-4397398"
}, {
    "name": "全家平鎮日星店",
    "addr": "桃園市平鎮區中豐路山頂段3號1、2樓",
    "pkey": "016899",
    "tel": "03-4693600"
}, {
    "name": "全家平鎮南東店",
    "addr": "桃園市平鎮區中豐路南勢二段1號",
    "pkey": "016562",
    "tel": "03-4397532"
}, {
    "name": "全家平鎮南勢店",
    "addr": "桃園市平鎮區中豐路南勢二段206號1樓",
    "pkey": "013908",
    "tel": "03-4396949"
}, {
    "name": "全家平鎮富民店",
    "addr": "桃園市平鎮區文化街116號1樓",
    "pkey": "015880",
    "tel": "03-4952304"
}, {
    "name": "全家平鎮平東店",
    "addr": "桃園市平鎮區平東路571號1F",
    "pkey": "017531",
    "tel": "03-4501388"
}, {
    "name": "全家平鎮新明店",
    "addr": "桃園市平鎮區民族路135號壹樓（如附圖所示）",
    "pkey": "017721",
    "tel": "03-4952141"
}, {
    "name": "全家平鎮民族店",
    "addr": "桃園市平鎮區民族路二段189，191號1樓",
    "pkey": "016897",
    "tel": "03-4024798"
}, {
    "name": "全家平鎮義興店",
    "addr": "桃園市平鎮區育達路75號1F",
    "pkey": "017461",
    "tel": "03-4931646"
}, {
    "name": "全家平鎮振興店",
    "addr": "桃園市平鎮區和平路216號",
    "pkey": "016281",
    "tel": "03-4576430"
}, {
    "name": "全家平鎮極光店",
    "addr": "桃園市平鎮區延平路二段15號",
    "pkey": "011201",
    "tel": "03-4013607"
}, {
    "name": "全家平鎮彩虹店",
    "addr": "桃園市平鎮區延平路二段341號一樓（前段約18坪）",
    "pkey": "016156",
    "tel": "03-4028491"
}, {
    "name": "全家平鎮新義店",
    "addr": "桃園市平鎮區延平路二段400巷8號",
    "pkey": "013960",
    "tel": "03-4023615"
}, {
    "name": "全家平鎮大仁店",
    "addr": "桃園市平鎮區金陵路三段68號",
    "pkey": "013390",
    "tel": "03-4575027"
}, {
    "name": "全家平鎮金豐店",
    "addr": "桃園市平鎮區南平路119號",
    "pkey": "015988",
    "tel": "03-4396499"
}, {
    "name": "全家平鎮新德店",
    "addr": "桃園市平鎮區振興西路138號1樓",
    "pkey": "013415",
    "tel": "03-4936884"
}, {
    "name": "全家平鎮義廣店",
    "addr": "桃園市平鎮區廣明路59號",
    "pkey": "017260",
    "tel": "03-4931243"
}, {
    "name": "全家平鎮廣泰店",
    "addr": "桃園市平鎮區廣泰路112號1樓",
    "pkey": "016849",
    "tel": "03-4931983"
}, {
    "name": "全家平鎮廣南店",
    "addr": "桃園市平鎮區環南路二段37號1樓",
    "pkey": "012916",
    "tel": "03-4024499"
}, {
    "name": "全家平鎮德育店",
    "addr": "桃園市平鎮區環南路三段93號",
    "pkey": "015441",
    "tel": "03-4589131"
}, ], [{
    "name": "全家龍潭龍昌店",
    "addr": "桃園市龍潭區大昌路二段80號",
    "pkey": "010722",
    "tel": "03-4797183"
}, {
    "name": "全家龍潭五福店",
    "addr": "桃園市龍潭區中正路187之9號",
    "pkey": "015096",
    "tel": "03-4807507"
}, {
    "name": "全家龍潭興龍店",
    "addr": "桃園市龍潭區中正路148號",
    "pkey": "016098",
    "tel": "03-4809934"
}, {
    "name": "全家龍潭陸軍店",
    "addr": "桃園市龍潭區中正路三林段81號崑崙樓一樓",
    "pkey": "015011",
    "tel": "03-4705634"
}, {
    "name": "全家龍潭陸醫店",
    "addr": "桃園市龍潭區中興路168號1樓",
    "pkey": "017181",
    "tel": "03-4096642"
}, {
    "name": "全家龍潭武漢店",
    "addr": "桃園市龍潭區中興路334號1樓",
    "pkey": "012989",
    "tel": "03-4798052"
}, {
    "name": "全家龍潭中興店",
    "addr": "桃園市龍潭區中興村中興路65號1樓",
    "pkey": "012693",
    "tel": "03-4990684"
}, {
    "name": "全家龍潭兄弟店",
    "addr": "桃園市龍潭區民生路10號",
    "pkey": "012193",
    "tel": "03-4092818"
}, {
    "name": "全家龍潭百年店",
    "addr": "桃園市龍潭區百年路19號",
    "pkey": "017675",
    "tel": "03-4097375"
}, {
    "name": "全家龍潭龍聖店",
    "addr": "桃園市龍潭區梅龍路189號1樓",
    "pkey": "012510",
    "tel": "03-4096182"
}, {
    "name": "全家龍潭華映店",
    "addr": "桃園市龍潭區三和村華映路1號1樓",
    "pkey": "004931",
    "tel": "03-4893171"
}, {
    "name": "全家龍潭華映二店",
    "addr": "桃園市龍潭區華映路1號（Ｌ2棟8樓）",
    "pkey": "012695",
    "tel": "03-4091583"
}, ], [{
    "name": "全家楊梅三民店",
    "addr": "桃園市楊梅區三民路二段96巷2號一樓",
    "pkey": "014582",
    "tel": "03-4314516"
}, {
    "name": "全家楊梅楊光店",
    "addr": "桃園市楊梅區中山北路二段48之1號1樓",
    "pkey": "014343",
    "tel": "03-4827453"
}, {
    "name": "全家楊梅富岡店",
    "addr": "桃園市楊梅區中正路95、97號1樓",
    "pkey": "016713",
    "tel": "03-2821711"
}, {
    "name": "全家新屋清華店",
    "addr": "桃園市新屋區中華路614號",
    "pkey": "016827",
    "tel": "03-4970524"
}, {
    "name": "全家楊梅晟熙店",
    "addr": "桃園市楊梅區中興路42號1樓",
    "pkey": "015231",
    "tel": "03-4311570"
}, {
    "name": "全家楊梅四維店",
    "addr": "桃園市楊梅區文化街263號1樓",
    "pkey": "017749",
    "tel": "03-4828986"
}, {
    "name": "全家楊梅埔心店",
    "addr": "桃園市楊梅區永美路210號",
    "pkey": "014777",
    "tel": "03-4315180"
}, {
    "name": "全家楊梅永美店",
    "addr": "桃園市楊梅區永美路393-1號1F",
    "pkey": "016096",
    "tel": "03-4825087"
}, {
    "name": "全家楊梅華映店",
    "addr": "桃園市楊梅區行善路80號",
    "pkey": "010860",
    "tel": "03-4881704"
}, {
    "name": "全家楊梅青城店",
    "addr": "桃園市楊梅區青山五街26號1樓與地下1樓",
    "pkey": "016079",
    "tel": "03-4963453"
}, {
    "name": "全家楊梅瑞梅店",
    "addr": "桃園市楊梅區梅獅路二段69之1號",
    "pkey": "010315",
    "tel": "03-4312535"
}, {
    "name": "全家楊梅瑞平店",
    "addr": "桃園市楊梅區梅獅路二段168號1樓",
    "pkey": "012628",
    "tel": "03-4317536"
}, {
    "name": "全家楊梅新成店",
    "addr": "桃園市楊梅區新成路171號",
    "pkey": "014650",
    "tel": "03-4855816"
}, {
    "name": "全家楊梅金山店",
    "addr": "桃園市楊梅區新農街606號1樓",
    "pkey": "016197",
    "tel": "03-4750721"
}, {
    "name": "全家楊梅車站店",
    "addr": "桃園市楊梅區楊新路65號壹樓",
    "pkey": "015987",
    "tel": "03-4757495"
}, {
    "name": "全家楊梅幼獅店",
    "addr": "桃園市楊梅區獅一路1之6號",
    "pkey": "011621",
    "tel": "03-4965695"
}, {
    "name": "全家楊梅瑞溪店",
    "addr": "桃園市楊梅區瑞溪路一段129號",
    "pkey": "015571",
    "tel": "03-4313895"
}, {
    "name": "全家楊梅北都店",
    "addr": "桃園市楊梅區裕成南路332號一樓",
    "pkey": "011759",
    "tel": "03-4314050"
}, {
    "name": "全家楊梅民族店",
    "addr": "桃園市楊梅區電研路250巷1號1樓",
    "pkey": "011883",
    "tel": "03-4207805"
}, ], [{
    "name": "全家新屋車站店",
    "addr": "桃園市新屋區中山路361號1樓",
    "pkey": "014342",
    "tel": "03-4770006"
}, {
    "name": "全家新屋富榮店",
    "addr": "桃園市新屋區新榮路206號",
    "pkey": "013354",
    "tel": "03-4904523"
}, ], [{
    "name": "全家觀音大觀店",
    "addr": "桃園市觀音區保障村大觀路一段345號",
    "pkey": "016971",
    "tel": "03-4761360"
}, {
    "name": "全家觀音草漯店",
    "addr": "桃園市觀音區大觀路二段190-7號",
    "pkey": "017348",
    "tel": "03-4830671"
}, {
    "name": "全家觀音新坡店",
    "addr": "桃園市觀音區中山路二段673號1＆2樓",
    "pkey": "015813",
    "tel": "03-2825391"
}, {
    "name": "全家觀音敬業店",
    "addr": "桃園市觀音區成功路一段551，553，555號1樓",
    "pkey": "015490",
    "tel": "03-4160058"
}, {
    "name": "全家觀音成功店",
    "addr": "桃園市觀音區成功路二段829號",
    "pkey": "015049",
    "tel": "03-4831031"
}, {
    "name": "全家觀音忠愛店",
    "addr": "桃園市觀音區忠愛路1號",
    "pkey": "016286",
    "tel": "03-4989002"
}, {
    "name": "全家觀音商城店",
    "addr": "桃園市觀音區建國路172號",
    "pkey": "016021",
    "tel": "03-4834435"
}, ], [{
    "name": "全家桃園力行店",
    "addr": "桃園市桃園區力行路194號1樓",
    "pkey": "016946",
    "tel": "03-3321461"
}, {
    "name": "全家桃園宏海店",
    "addr": "桃園市桃園區上海路100號",
    "pkey": "012345",
    "tel": "03-2173319"
}, {
    "name": "全家桃園車站店",
    "addr": "桃園市桃園區大同路28號1樓",
    "pkey": "012382",
    "tel": "03-3317405"
}, {
    "name": "全家桃園冠倫店",
    "addr": "桃園市桃園區大有路554號",
    "pkey": "017411",
    "tel": "03-3562892"
}, {
    "name": "全家桃園後站店",
    "addr": "桃園市桃園區大林路71號1F",
    "pkey": "017375",
    "tel": "03-3642526"
}, {
    "name": "全家桃園大業店",
    "addr": "桃園市桃園區大業路一段137、139號",
    "pkey": "015927",
    "tel": "03-3170925"
}, {
    "name": "全家桃園元富店",
    "addr": "桃園市桃園區大業路一段46號、48號1樓",
    "pkey": "013051",
    "tel": "03-3355731"
}, {
    "name": "全家桃園御賞店",
    "addr": "桃園市桃園區大興西路二段128號1樓",
    "pkey": "017747",
    "tel": "03-2161611"
}, {
    "name": "全家桃園鶴岡店",
    "addr": "桃園市桃園區大興西路二段139巷77號",
    "pkey": "016848",
    "tel": "03-2160572"
}, {
    "name": "全家桃園大豐店",
    "addr": "桃園市桃園區大豐路102號1樓",
    "pkey": "011772",
    "tel": "03-3642026"
}, {
    "name": "全家桃園國陽店",
    "addr": "桃園市桃園區中山東路32之21號1樓．B1",
    "pkey": "014546",
    "tel": "03-3377356"
}, {
    "name": "全家桃園朝陽店",
    "addr": "桃園市桃園區中山東路17號",
    "pkey": "013799",
    "tel": "03-3381667"
}, {
    "name": "全家桃園中山店",
    "addr": "桃園市桃園區中山路505號1F",
    "pkey": "012707",
    "tel": "03-3334800"
}, {
    "name": "全家桃園中聖店",
    "addr": "桃園市桃園區中山路849號1樓",
    "pkey": "017259",
    "tel": "03-3708946"
}, {
    "name": "全家桃園吉昌店",
    "addr": "桃園市桃園區中平路32號",
    "pkey": "017579",
    "tel": "03-2207751"
}, {
    "name": "全家桃園中璦店",
    "addr": "桃園市桃園區中正三街411號",
    "pkey": "015593",
    "tel": "03-3264880"
}, {
    "name": "全家桃園統領店",
    "addr": "桃園市桃園區中正路61號",
    "pkey": "017625",
    "tel": "03-3327673"
}, {
    "name": "全家桃園大正店",
    "addr": "桃園市桃園區中正路302號1樓",
    "pkey": "013535",
    "tel": "03-3344775"
}, {
    "name": "全家桃園北埔店",
    "addr": "桃園市桃園區中正路511號",
    "pkey": "015828",
    "tel": "03-3315307"
}, {
    "name": "全家桃園東埔店",
    "addr": "桃園市桃園區中正路378號",
    "pkey": "015871",
    "tel": "03-3357105"
}, {
    "name": "全家桃園同德店",
    "addr": "桃園市桃園區中正路1316號，1318號1樓",
    "pkey": "016425",
    "tel": "03-3588136"
}, {
    "name": "全家桃園站前店",
    "addr": "桃園市桃園區中正路13，15，17號",
    "pkey": "013929",
    "tel": "03-3367478"
}, {
    "name": "全家桃園中寧店",
    "addr": "桃園市桃園區中正路1167號1樓",
    "pkey": "012837",
    "tel": "03-3589158"
}, {
    "name": "全家桃園和信店",
    "addr": "桃園市桃園區中正路48巷16號",
    "pkey": "013496",
    "tel": "03-3366772"
}, {
    "name": "全家桃園世貿店",
    "addr": "桃園市桃園區中正路1069號",
    "pkey": "015048",
    "tel": "03-3577571"
}, {
    "name": "全家桃園中州店",
    "addr": "桃園市桃園區中州街57號",
    "pkey": "012546",
    "tel": "03-2288471"
}, {
    "name": "全家桃園南中店",
    "addr": "桃園市桃園區中埔六街54號1樓",
    "pkey": "016819",
    "tel": "03-3466658"
}, {
    "name": "全家桃園明德店",
    "addr": "桃園市桃園區中華路三號一樓之九，三號一樓之十",
    "pkey": "015715",
    "tel": "03-3362313"
}, {
    "name": "全家桃園壽星店",
    "addr": "桃園市桃園區仁愛路60號1樓。2樓",
    "pkey": "013961",
    "tel": "03-3795374"
}, {
    "name": "全家桃園龍昇店",
    "addr": "桃園市桃園區介壽路17號一樓",
    "pkey": "016563",
    "tel": "03-2184602"
}, {
    "name": "全家桃園德壽店",
    "addr": "桃園市桃園區介壽路412號",
    "pkey": "012629",
    "tel": "03-3768427"
}, {
    "name": "全家桃園早稻田店",
    "addr": "桃園市桃園區正康三街181號1樓",
    "pkey": "015033",
    "tel": "03-3465031"
}, {
    "name": "全家桃園民安店",
    "addr": "桃園市桃園區民生路74號1樓",
    "pkey": "014162",
    "tel": "03-3397059"
}, {
    "name": "全家桃園民光店",
    "addr": "桃園市桃園區民光東路120號",
    "pkey": "016478",
    "tel": "03-3588972"
}, {
    "name": "全家桃園縣安店",
    "addr": "桃園市桃園區民安路99號1樓",
    "pkey": "014309",
    "tel": "03-3335813"
}, {
    "name": "全家桃園民樂店",
    "addr": "桃園市桃園區民族路187號",
    "pkey": "015881",
    "tel": "03-3368935"
}, {
    "name": "全家桃園龍彩店",
    "addr": "桃園市桃園區永安北路424號1樓之1",
    "pkey": "017316",
    "tel": "03-3171967"
}, {
    "name": "全家桃園永安店",
    "addr": "桃園市桃園區永安路219號",
    "pkey": "016365",
    "tel": "03-3395404"
}, {
    "name": "全家桃園中埔店",
    "addr": "桃園市桃園區同德十街35號、37號1樓",
    "pkey": "015128",
    "tel": "03-3414897"
}, {
    "name": "全家桃園東陽店",
    "addr": "桃園市桃園區成功路二段69號1樓",
    "pkey": "014517",
    "tel": "03-3395478"
}, {
    "name": "全家桃園建國店",
    "addr": "桃園市桃園區延平路135之1號1樓",
    "pkey": "015711",
    "tel": "03-3766328"
}, {
    "name": "全家桃園長沙店",
    "addr": "桃園市桃園區長沙街72號",
    "pkey": "014955",
    "tel": "03-3634586"
}, {
    "name": "全家桃園同安店",
    "addr": "桃園市桃園區南平路211號",
    "pkey": "014949",
    "tel": "03-3586804"
}, {
    "name": "全家桃園南平店",
    "addr": "桃園市桃園區南平路194．196號",
    "pkey": "016594",
    "tel": "03-3463509"
}, {
    "name": "全家桃園愛國店",
    "addr": "桃園市桃園區建國路40號",
    "pkey": "015206",
    "tel": "03-3767528"
}, {
    "name": "全家桃園建新店",
    "addr": "桃園市桃園區建新街88號",
    "pkey": "016182",
    "tel": "03-3751735"
}, {
    "name": "全家桃園桃都店",
    "addr": "桃園市桃園區桃鶯路388號1樓",
    "pkey": "016289",
    "tel": "03-3716791"
}, {
    "name": "全家桃園國強店",
    "addr": "桃園市桃園區國強一街218號1樓",
    "pkey": "014058",
    "tel": "03-3708336"
}, {
    "name": "全家桃園鼎聖店",
    "addr": "桃園市桃園區國鼎一街28號",
    "pkey": "012630",
    "tel": "03-3922199"
}, {
    "name": "全家桃園莊敬店",
    "addr": "桃園市桃園區莊敬路一段376號，中正路1416號",
    "pkey": "017532",
    "tel": "03-3585850"
}, {
    "name": "全家桃園莊園店",
    "addr": "桃園市桃園區莊敬路二段243之1號",
    "pkey": "015146",
    "tel": "03-2160387"
}, {
    "name": "全家桃園客運店",
    "addr": "桃園市桃園區復興路159號1樓",
    "pkey": "017376",
    "tel": "03-3336196"
}, {
    "name": "全家桃園玉山店",
    "addr": "桃園市桃園區復興路387號",
    "pkey": "015047",
    "tel": "03-3331571"
}, {
    "name": "全家桃園慈愛店",
    "addr": "桃園市桃園區慈光街114號",
    "pkey": "015570",
    "tel": "03-3576920"
}, {
    "name": "全家桃園榮運店",
    "addr": "桃園市桃園區經國路899號一樓房屋",
    "pkey": "015911",
    "tel": "03-3586466"
}, {
    "name": "全家桃園麗品店",
    "addr": "桃園市桃園區經國路223號1F",
    "pkey": "014961",
    "tel": "03-3469068"
}, {
    "name": "全家桃園天祥店",
    "addr": "桃園市桃園區經國路451號一樓",
    "pkey": "012381",
    "tel": "03-3562389"
}, {
    "name": "全家桃園大盛店",
    "addr": "桃園市桃園區經國路142號",
    "pkey": "017166",
    "tel": "03-3586001"
}, {
    "name": "全家桃園市府店",
    "addr": "桃園市桃園區縣府路1號",
    "pkey": "016538",
    "tel": "03-3946139"
}, {
    "name": "全家桃園縣政店",
    "addr": "桃園市桃園區縣府路88之1號1樓．2樓",
    "pkey": "014129",
    "tel": "03-3384179"
}, {
    "name": "全家桃園龍安店",
    "addr": "桃園市桃園區龍安街169之3號，國強十一街71號",
    "pkey": "012939",
    "tel": "03-2172781"
}, {
    "name": "全家桃園寶山店",
    "addr": "桃園市桃園區寶山街375．377號1樓",
    "pkey": "014702",
    "tel": "03-3579430"
}, {
    "name": "全家桃園金寶店",
    "addr": "桃園市桃園區寶山街265號1樓",
    "pkey": "015230",
    "tel": "03-3268325"
}, ], [{
    "name": "全家龜山大傳店",
    "addr": "桃園市龜山區大同路232號1樓＋2樓",
    "pkey": "016847",
    "tel": "03-3492278"
}, {
    "name": "全家龜山山鶯店",
    "addr": "桃園市龜山區山鶯路41號",
    "pkey": "017190",
    "tel": "03-3595062"
}, {
    "name": "全家龜山新明德店",
    "addr": "桃園市龜山區中興路一段6號1樓和2樓",
    "pkey": "014375",
    "tel": "03-3490469"
}, {
    "name": "全家龜山庚勤店",
    "addr": "桃園市龜山區文化一路261號庚勤樓Ｌ棟5樓",
    "pkey": "014215",
    "tel": "03-2118033"
}, {
    "name": "全家龜山長明店",
    "addr": "桃園市龜山區文化一路259號",
    "pkey": "014193",
    "tel": "03-2118463"
}, {
    "name": "全家龜山文銓店",
    "addr": "桃園市龜山區文化七路186號1樓",
    "pkey": "016323",
    "tel": "03-3284576"
}, {
    "name": "全家龜山樂高店",
    "addr": "桃園市龜山區文化七路97號1樓",
    "pkey": "016360",
    "tel": "03-3186127"
}, {
    "name": "全家龜山文學店",
    "addr": "桃園市龜山區文化二路34巷14弄12號1樓",
    "pkey": "015826",
    "tel": "03-3186557"
}, {
    "name": "全家龜山新城店",
    "addr": "桃園市龜山區文青路217號1樓",
    "pkey": "016068",
    "tel": "03-3183264"
}, {
    "name": "全家龜山新都店",
    "addr": "桃園市龜山區文青路357號1＆2樓",
    "pkey": "017360",
    "tel": "03-3974704"
}, {
    "name": "全家龜山自強店",
    "addr": "桃園市龜山區新興村38鄰自強南路71號73號1樓",
    "pkey": "017530",
    "tel": "03-3207774"
}, {
    "name": "全家龜山幸美店",
    "addr": "桃園市龜山區幸美九街27號1樓",
    "pkey": "014069",
    "tel": "03-3197009"
}, {
    "name": "全家龜山幸福店",
    "addr": "桃園市龜山區幸福一街24號1樓",
    "pkey": "015228",
    "tel": "03-3196352"
}, {
    "name": "全家龜山忠義店",
    "addr": "桃園市龜山區楓樹村忠義路一段56號一樓",
    "pkey": "011858",
    "tel": "03-3494488"
}, {
    "name": "全家龜山大湖店",
    "addr": "桃園市龜山區忠義路二段626號1樓",
    "pkey": "016413",
    "tel": "03-3272353"
}, {
    "name": "全家蘆竹南祥店",
    "addr": "桃園市龜山區南上路435號",
    "pkey": "017801",
    "tel": "03-3216145"
}, {
    "name": "全家龜山興龍店",
    "addr": "桃園市龜山區振興路50號一樓",
    "pkey": "014286",
    "tel": "03-3597922"
}, {
    "name": "全家龜山陸光店",
    "addr": "桃園市龜山區陸光路98號1樓",
    "pkey": "016327",
    "tel": "03-2132197"
}, {
    "name": "全家龜山頂興店",
    "addr": "桃園市龜山區山福村頂興路39之6號一樓",
    "pkey": "011725",
    "tel": "03-3590358"
}, {
    "name": "全家龜山文欣店",
    "addr": "桃園市龜山區復興一路74號1樓",
    "pkey": "015297",
    "tel": "03-3279270"
}, {
    "name": "全家龜山環球店",
    "addr": "桃園市龜山區復興一路8號2樓",
    "pkey": "016576",
    "tel": "03-3275621"
}, {
    "name": "全家龜山金石店",
    "addr": "桃園市龜山區復興一路144號1樓",
    "pkey": "015811",
    "tel": "03-3979040"
}, {
    "name": "全家龜山雲蓮店",
    "addr": "桃園市龜山區復興街302號",
    "pkey": "015691",
    "tel": "03-3183365"
}, {
    "name": "全家龜山導航店",
    "addr": "桃園市龜山區華亞二路270號B1樓",
    "pkey": "017546",
    "tel": "03-3273147"
}, {
    "name": "全家龜山龍壽店",
    "addr": "桃園市龜山區龍壽村萬壽路一段93號",
    "pkey": "014287",
    "tel": "02-82001091"
}, {
    "name": "全家龜山光啟店",
    "addr": "桃園市龜山區萬壽路一段268之3號",
    "pkey": "015163",
    "tel": "02-82001363"
}, {
    "name": "全家龜山龍華店",
    "addr": "桃園市龜山區萬壽路一段116號",
    "pkey": "015462",
    "tel": "02-82092667"
}, {
    "name": "全家龜山萬壽店",
    "addr": "桃園市龜山區龜山村萬壽路二段662號662之1號一",
    "pkey": "011093",
    "tel": "03-3501272"
}, {
    "name": "全家龜山德明店",
    "addr": "桃園市龜山區德明路105號，107號1樓",
    "pkey": "017529",
    "tel": "03-3509883"
}, {
    "name": "全家龜山銘園店",
    "addr": "桃園市龜山區德明路5號．第二餐廳旁",
    "pkey": "013107",
    "tel": "03-3297518"
}, {
    "name": "全家龜山銘美店",
    "addr": "桃園市龜山區德明路5號1樓",
    "pkey": "011056",
    "tel": "03-3197261"
}, ], [{
    "name": "全家八德大和店",
    "addr": "桃園市八德區大和路103號1樓。2樓",
    "pkey": "013962",
    "tel": "03-3749852"
}, {
    "name": "全家八德桃華店",
    "addr": "桃園市八德區中華路268．270號",
    "pkey": "016803",
    "tel": "03-2172762"
}, {
    "name": "全家八德介壽店",
    "addr": "桃園市八德區介壽路一段643號",
    "pkey": "016898",
    "tel": "03-3645872"
}, {
    "name": "全家八德大義店",
    "addr": "桃園市八德區介壽路一段785號1樓",
    "pkey": "014953",
    "tel": "03-3712776"
}, {
    "name": "全家八德福壽店",
    "addr": "桃園市八德區介壽路一段392號1樓",
    "pkey": "017523",
    "tel": "03-3619253"
}, {
    "name": "全家八德貴族店",
    "addr": "桃園市八德區介壽路二段309號",
    "pkey": "012744",
    "tel": "03-3661473"
}, {
    "name": "全家八德新富順店",
    "addr": "桃園市八德區介壽路二段1016號",
    "pkey": "013720",
    "tel": "03-3684036"
}, {
    "name": "全家八德瑞德店",
    "addr": "桃園市八德區13鄰介壽路二段1382號1樓",
    "pkey": "014931",
    "tel": "03-3658715"
}, {
    "name": "全家八德瑞祥店",
    "addr": "桃園市八德區介壽路二段1231號1樓",
    "pkey": "013519",
    "tel": "03-3731140"
}, {
    "name": "全家八德永福店",
    "addr": "桃園市八德區永福西街32巷1號",
    "pkey": "017409",
    "tel": "03-3761401"
}, {
    "name": "全家八德和平店",
    "addr": "桃園市八德區和平路818號",
    "pkey": "014908",
    "tel": "03-3710180"
}, {
    "name": "全家八德大愛店",
    "addr": "桃園市八德區和平路196號",
    "pkey": "015129",
    "tel": "03-3642251"
}, {
    "name": "全家八德忠誠店",
    "addr": "桃園市八德區忠孝街12號",
    "pkey": "017234",
    "tel": "03-3660842"
}, {
    "name": "全家八德櫻花店",
    "addr": "桃園市八德區長安街375號1樓",
    "pkey": "014530",
    "tel": "03-3754001"
}, {
    "name": "全家八德仁興店",
    "addr": "桃園市八德區建國路241號",
    "pkey": "015331",
    "tel": "03-3731041"
}, {
    "name": "全家八德建國店",
    "addr": "桃園市八德區建國路657號一樓部分",
    "pkey": "014950",
    "tel": "03-3713364"
}, {
    "name": "全家八德建興店",
    "addr": "桃園市八德區建國路59號1樓及2樓",
    "pkey": "016723",
    "tel": "03-3732907"
}, {
    "name": "全家八德茄苳店",
    "addr": "桃園市八德區茄苳路846號1樓",
    "pkey": "013457",
    "tel": "03-3715371"
}, {
    "name": "全家八德桃鶯店",
    "addr": "桃園市八德區桃鶯路34號",
    "pkey": "014128",
    "tel": "03-3621084"
}, {
    "name": "全家八德新興店",
    "addr": "桃園市八德區新興路301號",
    "pkey": "015097",
    "tel": "03-3775940"
}, {
    "name": "全家八德忠勇店",
    "addr": "桃園市八德區義勇街105號（八德東勇移店）",
    "pkey": "016181",
    "tel": "03-3677792"
}, {
    "name": "全家八德銀和店",
    "addr": "桃園市八德區銀和街29＆31號",
    "pkey": "017702",
    "tel": "03-3746651"
}, {
    "name": "全家八德金和店",
    "addr": "桃園市八德區銀和街63號加地下室",
    "pkey": "017343",
    "tel": "03-3744118"
}, {
    "name": "全家八德大湳店",
    "addr": "桃園市八德區廣福路42號一樓",
    "pkey": "017373",
    "tel": "03-3629260"
}, {
    "name": "全家八德德富店",
    "addr": "桃園市八德區廣福路805號",
    "pkey": "013872",
    "tel": "03-3756696"
}, {
    "name": "全家八德新市店",
    "addr": "桃園市八德區興豐路485號",
    "pkey": "016169",
    "tel": "03-3680546"
}, {
    "name": "全家八德豐吉店",
    "addr": "桃園市八德區豐田一路2號",
    "pkey": "015702",
    "tel": "03-3683640"
}, ], [{
    "name": "全家大溪仁東店",
    "addr": "桃園市大溪區仁和七街52號",
    "pkey": "010493",
    "tel": "03-3802401"
}, {
    "name": "全家大溪仁和店",
    "addr": "桃園市大溪區仁和路二段219號",
    "pkey": "013735",
    "tel": "03-3900112"
}, {
    "name": "全家大溪崎頂店",
    "addr": "桃園市大溪區介壽路886號1樓",
    "pkey": "014439",
    "tel": "03-3808479"
}, {
    "name": "全家大溪永昌店",
    "addr": "桃園市大溪區永昌路355號",
    "pkey": "016744",
    "tel": "03-3804394"
}, {
    "name": "全家大溪松樹店",
    "addr": "桃園市大溪區仁善里松樹21之1號",
    "pkey": "015358",
    "tel": "03-3805861"
}, {
    "name": "全家大溪交流店",
    "addr": "桃園市大溪區員林路一段451號",
    "pkey": "015511",
    "tel": "03-3804491"
}, {
    "name": "全家大溪員林店",
    "addr": "桃園市大溪區員林路一段11號",
    "pkey": "017180",
    "tel": "03-3900461"
}, {
    "name": "全家大溪員明店",
    "addr": "桃園市大溪區員林路二段275號1-3樓",
    "pkey": "014643",
    "tel": "03-3807960"
}, {
    "name": "全家大溪埔頂店",
    "addr": "桃園市大溪區埔頂路二段158號",
    "pkey": "012511",
    "tel": "03-3907337"
}, {
    "name": "全家大溪慈湖店",
    "addr": "桃園市大溪區復興路2號1樓",
    "pkey": "015071",
    "tel": "03-3885439"
}, ], [{
    "name": "全家大園蓮園店",
    "addr": "桃園市大園區大觀路602號",
    "pkey": "012398",
    "tel": "03-3858411"
}, {
    "name": "全家大園都心店",
    "addr": "桃園市大園區中山北路31號1樓。2樓",
    "pkey": "014795",
    "tel": "03-3842104"
}, {
    "name": "全家大園航園店",
    "addr": "桃園市大園區中正東路338號",
    "pkey": "013969",
    "tel": "03-3865480"
}, {
    "name": "全家大園華園店",
    "addr": "桃園市大園區中華路61號",
    "pkey": "013023",
    "tel": "03-3854615"
}, {
    "name": "全家大園果林店",
    "addr": "桃園市大園區？林村拔子林23之83號",
    "pkey": "017434",
    "tel": "03-3936443"
}, {
    "name": "全家大園新華航店",
    "addr": "桃園市大園區航站南路1號2樓",
    "pkey": "014339",
    "tel": "03-3931900"
}, {
    "name": "全家大園華儲店",
    "addr": "桃園市大園區航勤北路10之1號1樓",
    "pkey": "014016",
    "tel": "03-3834223"
}, {
    "name": "全家大園田心店",
    "addr": "桃園市大園區新興路85號",
    "pkey": "017044",
    "tel": "03-3867231"
}, {
    "name": "全家大園領航店",
    "addr": "桃園市大園區領航北路四段352號1樓",
    "pkey": "016059",
    "tel": "03-3819197"
}, ], [{
    "name": "全家蘆竹上興店",
    "addr": "桃園市蘆竹區上興路267號1樓",
    "pkey": "014330",
    "tel": "03-3134806"
}, {
    "name": "全家蘆竹興仁店",
    "addr": "桃園市蘆竹區上興路190號",
    "pkey": "015366",
    "tel": "03-3234007"
}, {
    "name": "全家蘆竹大竹店",
    "addr": "桃園市蘆竹區大竹路492號",
    "pkey": "015233",
    "tel": "03-3237280"
}, {
    "name": "全家蘆竹興福店",
    "addr": "桃園市蘆竹區大竹路533號",
    "pkey": "017703",
    "tel": "03-3132705"
}, {
    "name": "全家蘆竹中愛店",
    "addr": "桃園市蘆竹區中山路18-1號1樓",
    "pkey": "010579",
    "tel": "03-3114647"
}, {
    "name": "全家蘆竹中福店",
    "addr": "桃園市蘆竹區中山路126號",
    "pkey": "016208",
    "tel": "03-3129091"
}, {
    "name": "全家蘆竹五福店",
    "addr": "桃園市蘆竹區五福村五福一路34號1樓",
    "pkey": "017276",
    "tel": "03-2223953"
}, {
    "name": "全家蘆竹六福店",
    "addr": "桃園市蘆竹區五福六路48號",
    "pkey": "016553",
    "tel": "03-2124152"
}, {
    "name": "全家蘆竹仁愛店",
    "addr": "桃園市蘆竹區仁愛路三段38號1樓",
    "pkey": "014396",
    "tel": "03-3216480"
}, {
    "name": "全家蘆竹鼎福店",
    "addr": "桃園市蘆竹區六福路163號1樓",
    "pkey": "011691",
    "tel": "03-3216360"
}, {
    "name": "全家蘆竹洛陽店",
    "addr": "桃園市蘆竹區南榮村光明路一段119號121號一樓",
    "pkey": "012307",
    "tel": "03-3112515"
}, {
    "name": "全家蘆竹吉川店",
    "addr": "桃園市蘆竹區吉林路99號",
    "pkey": "017666",
    "tel": "03-3126604"
}, {
    "name": "全家蘆竹吉林店",
    "addr": "桃園市蘆竹區吉林路2號",
    "pkey": "017598",
    "tel": "03-3127253"
}, {
    "name": "全家蘆竹奉順店",
    "addr": "桃園市蘆竹區奉化路106號",
    "pkey": "016285",
    "tel": "03-2121391"
}, {
    "name": "全家蘆竹奉化店",
    "addr": "桃園市蘆竹區奉化路36號、38號、南順一街63號",
    "pkey": "014017",
    "tel": "03-3211379"
}, {
    "name": "全家蘆竹南興店",
    "addr": "桃園市蘆竹區南興村奉化路189號一樓",
    "pkey": "012631",
    "tel": "03-3216536"
}, {
    "name": "全家蘆竹星馳店",
    "addr": "桃園市蘆竹區忠孝西路169巷2號",
    "pkey": "017435",
    "tel": "03-3529579"
}, {
    "name": "全家蘆竹長壽店",
    "addr": "桃園市蘆竹區長春路67號1樓",
    "pkey": "015925",
    "tel": "03-3214825"
}, {
    "name": "全家蘆竹坑口店",
    "addr": "桃園市蘆竹區南山北路二段398之1號",
    "pkey": "017722",
    "tel": "03-3543954"
}, {
    "name": "全家蘆竹南山店",
    "addr": "桃園市蘆竹區南山路一段75號、77號",
    "pkey": "012776",
    "tel": "03-2121487"
}, {
    "name": "全家蘆竹山腳店",
    "addr": "桃園市蘆竹區南山路三段278號1樓（前段）",
    "pkey": "013108",
    "tel": "03-3244499"
}, {
    "name": "全家蘆竹南竹店",
    "addr": "桃園市蘆竹區南竹路一段68號1樓",
    "pkey": "017404",
    "tel": "03-2124691"
}, {
    "name": "全家蘆竹明竹店",
    "addr": "桃園市蘆竹區南竹路一段134號",
    "pkey": "017410",
    "tel": "03-3126044"
}, {
    "name": "全家蘆竹南崁店",
    "addr": "桃園市蘆竹區南崁路228號",
    "pkey": "016712",
    "tel": "03-3528210"
}, {
    "name": "全家蘆竹南亞店",
    "addr": "桃園市蘆竹區南崁路一段322號",
    "pkey": "016552",
    "tel": "03-3215704"
}, {
    "name": "全家蘆竹南工店",
    "addr": "桃園市蘆竹區南崁路二段81號1樓",
    "pkey": "017345",
    "tel": "03-3229538"
}, {
    "name": "全家蘆竹星光店",
    "addr": "桃園市蘆竹區南順六街72號",
    "pkey": "016222",
    "tel": "03-2124840"
}, {
    "name": "全家蘆竹海湖店",
    "addr": "桃園市蘆竹區海山路二段7、9號、11號1樓",
    "pkey": "017578",
    "tel": "03-3542342"
}, {
    "name": "全家蘆竹至誠店",
    "addr": "桃園市蘆竹區開南路1號",
    "pkey": "012195",
    "tel": "03-3029733"
}, {
    "name": "全家蘆竹開南店",
    "addr": "桃園市蘆竹區新興街120號",
    "pkey": "014716",
    "tel": "03-2161494"
}, ], ], [[{
    "name": "全家新竹廟口店",
    "addr": "新竹市北區中山路90號",
    "pkey": "015072",
    "tel": "03-5244817"
}, {
    "name": "全家新竹水田店",
    "addr": "新竹市北區中正路240號1樓",
    "pkey": "015778",
    "tel": "03-5222149"
}, {
    "name": "全家新竹光田店",
    "addr": "新竹市北區水田街146號1樓",
    "pkey": "010506",
    "tel": "03-5312245"
}, {
    "name": "全家新竹新民店",
    "addr": "新竹市北區北大路252號",
    "pkey": "015209",
    "tel": "03-5241565"
}, {
    "name": "全家新竹中山店",
    "addr": "新竹市北區四維路91號",
    "pkey": "015051",
    "tel": "03-5268570"
}, {
    "name": "全家新竹新美店",
    "addr": "新竹市北區田美三街47號",
    "pkey": "015171",
    "tel": "03-5421870"
}, {
    "name": "全家新竹光華店",
    "addr": "新竹市北區光華北街63號",
    "pkey": "017230",
    "tel": "03-5427691"
}, {
    "name": "全家新竹西大店",
    "addr": "新竹市北區西大路402．404號1樓",
    "pkey": "015130",
    "tel": "03-5258280"
}, {
    "name": "全家新竹大竹店",
    "addr": "新竹市北區西大路848號",
    "pkey": "015598",
    "tel": "03-5326698"
}, {
    "name": "全家新竹大富店",
    "addr": "新竹市北區西大路527號",
    "pkey": "016329",
    "tel": "03-5240080"
}, {
    "name": "全家新竹遠百店",
    "addr": "新竹市北區西門街101號1、2樓",
    "pkey": "013421",
    "tel": "03-5213733"
}, {
    "name": "全家新竹師專店",
    "addr": "新竹市北區西門街203號1樓",
    "pkey": "011070",
    "tel": "03-5245011"
}, {
    "name": "全家新竹金鵬店",
    "addr": "新竹市北區延平路一段388號1樓",
    "pkey": "014108",
    "tel": "03-5229126"
}, {
    "name": "全家新竹漁港店",
    "addr": "新竹市北區東大路四段269號1樓",
    "pkey": "017437",
    "tel": "03-5364060"
}, {
    "name": "全家新竹荷蘭村店",
    "addr": "新竹市北區武陵路175巷2號1樓",
    "pkey": "016447",
    "tel": "03-5451966"
}, {
    "name": "全家新竹新武陵店",
    "addr": "新竹市北區武陵路267號1樓",
    "pkey": "017010",
    "tel": "03-5426961"
}, {
    "name": "全家新竹武東店",
    "addr": "新竹市北區武陵路71號1樓",
    "pkey": "015928",
    "tel": "03-5409154"
}, {
    "name": "全家新竹鐵道店",
    "addr": "新竹市北區武陵路268號1樓",
    "pkey": "017068",
    "tel": "03-5339257"
}, {
    "name": "全家新竹天群店",
    "addr": "新竹市北區武陵路36-1號1、2樓",
    "pkey": "014589",
    "tel": "03-5322090"
}, {
    "name": "全家新竹金竹店",
    "addr": "新竹市北區金竹路115號1樓",
    "pkey": "013053",
    "tel": "03-5327930"
}, {
    "name": "全家新竹大魯閣店",
    "addr": "新竹市北區湳雅街91之2號B1樓",
    "pkey": "017198",
    "tel": "03-5339500"
}, {
    "name": "全家新竹經城店",
    "addr": "新竹市北區經國路一段339號1樓",
    "pkey": "017785",
    "tel": "03-5344679"
}, {
    "name": "全家新竹國光店",
    "addr": "新竹市北區經國路二段190號1樓",
    "pkey": "017193",
    "tel": "03-5334587"
}, {
    "name": "全家新竹客進店",
    "addr": "新竹市北區經國路二段549號",
    "pkey": "015829",
    "tel": "03-5250228"
}, ], [{
    "name": "全家新竹元太店",
    "addr": "新竹市東區力行一路3號B1員工餐廳",
    "pkey": "014827",
    "tel": "03-5779271"
}, {
    "name": "全家新竹新日光店",
    "addr": "新竹市東區力行三路7號1樓（科學園區）",
    "pkey": "016531",
    "tel": "03-5794586"
}, {
    "name": "全家新竹頎邦二店",
    "addr": "新竹市東區力行五路3號2樓（新竹科學園區）",
    "pkey": "016756",
    "tel": "03-5678788"
}, {
    "name": "全家新竹旺宏三店",
    "addr": "新竹市東區力行路19號1樓（新竹科學園區）",
    "pkey": "013391",
    "tel": "03-5771386"
}, {
    "name": "全家新竹旺宏店",
    "addr": "新竹市東區科學園區力行路16號",
    "pkey": "012254",
    "tel": "03-5631811"
}, {
    "name": "全家新竹大同店",
    "addr": "新竹市東區大同路16號18號一樓",
    "pkey": "013835",
    "tel": "03-5277520"
}, {
    "name": "全家新竹交大店",
    "addr": "新竹市東區大學路1001之2號一樓",
    "pkey": "017757",
    "tel": "03-5739817"
}, {
    "name": "全家新竹交通店",
    "addr": "新竹市東區大學路1001-2號之學生13舍1樓",
    "pkey": "014136",
    "tel": "03-5750018"
}, {
    "name": "全家交大研三店",
    "addr": "新竹市東區大學路1001號研三舍",
    "pkey": "017628",
    "tel": "03-5160155"
}, {
    "name": "全家新竹科館店",
    "addr": "新竹市東區工業東二路1號1樓",
    "pkey": "013052",
    "tel": "03-5678869"
}, {
    "name": "全家新竹巨城店",
    "addr": "新竹市東區中央路229號B1",
    "pkey": "015680",
    "tel": "03-5319068"
}, {
    "name": "全家新竹金站店",
    "addr": "新竹市東區中正路100號地下室、1-2樓",
    "pkey": "017278",
    "tel": "03-5281022"
}, {
    "name": "全家新竹經華店",
    "addr": "新竹市東區中華路一段101號",
    "pkey": "016036",
    "tel": "03-5341261"
}, {
    "name": "全家新竹新四維店",
    "addr": "新竹市東區中華路三段8號1、2樓",
    "pkey": "014721",
    "tel": "03-5247191"
}, {
    "name": "全家新竹德安店",
    "addr": "新竹市東區公道五路二段89號1樓",
    "pkey": "017439",
    "tel": "03-5711545"
}, {
    "name": "全家新竹建美店",
    "addr": "新竹市東區公道五路二段271號1樓",
    "pkey": "016448",
    "tel": "03-5165610"
}, {
    "name": "全家新竹民樂店",
    "addr": "新竹市東區民生路252號1樓",
    "pkey": "017191",
    "tel": "03-5359133"
}, {
    "name": "全家新竹民族店",
    "addr": "新竹市東區民族路139號一樓",
    "pkey": "016807",
    "tel": "03-5330300"
}, {
    "name": "全家新竹百貨店",
    "addr": "新竹市東區民族路2號地下1樓",
    "pkey": "016963",
    "tel": "03-5284080"
}, {
    "name": "全家新竹慈雲店",
    "addr": "新竹市東區立鵬路101號",
    "pkey": "016099",
    "tel": "03-5771028"
}, {
    "name": "全家新竹新龍安店",
    "addr": "新竹市東區光復路一段525巷13號1樓",
    "pkey": "017677",
    "tel": "03-6687149"
}, {
    "name": "全家新竹科學店",
    "addr": "新竹市東區光復路一段603號1樓",
    "pkey": "016235",
    "tel": "03-5794048"
}, {
    "name": "全家新竹水木店",
    "addr": "新竹市東區光復路二段101號水木餐廳1樓",
    "pkey": "017242",
    "tel": "03-5735178"
}, {
    "name": "全家新竹竹蓮店",
    "addr": "新竹市東區竹蓮街104號1樓",
    "pkey": "016037",
    "tel": "03-5620023"
}, {
    "name": "全家新竹向陽店",
    "addr": "新竹市東區明湖路646號",
    "pkey": "016806",
    "tel": "03-5208093"
}, {
    "name": "全家新竹五福店",
    "addr": "新竹市東區明湖路1255號1樓",
    "pkey": "014935",
    "tel": "03-5292709"
}, {
    "name": "全家新竹轉運店",
    "addr": "新竹市東區東南街1巷6號1樓",
    "pkey": "013963",
    "tel": "03-5616002"
}, {
    "name": "全家新竹金元寶店",
    "addr": "新竹市東區金山九街68號1樓",
    "pkey": "015596",
    "tel": "03-5794484"
}, {
    "name": "全家新竹金科店",
    "addr": "新竹市東區金山街162號1樓",
    "pkey": "017261",
    "tel": "03-5770176"
}, {
    "name": "全家新竹十一街店",
    "addr": "新竹市東區金山街63號1樓部份",
    "pkey": "013089",
    "tel": "03-5799553"
}, {
    "name": "全家新竹東大店",
    "addr": "新竹市東區南大路83號1樓",
    "pkey": "014018",
    "tel": "03-5619916"
}, {
    "name": "全家新竹師苑店",
    "addr": "新竹市東區南大路636號，638號一樓",
    "pkey": "015930",
    "tel": "03-5618432"
}, {
    "name": "全家新竹新興店",
    "addr": "新竹市東區南大路577號一樓",
    "pkey": "015971",
    "tel": "03-5629557"
}, {
    "name": "全家新竹建源店",
    "addr": "新竹市東區建中一路60號1樓",
    "pkey": "015251",
    "tel": "03-5748788"
}, {
    "name": "全家新竹公學店",
    "addr": "新竹市東區建功一路99號1樓",
    "pkey": "016330",
    "tel": "03-5748909"
}, {
    "name": "全家新竹竹科店",
    "addr": "新竹市東區科學工業園區竹村七路7號1樓",
    "pkey": "013181",
    "tel": "03-5770320"
}, {
    "name": "全家新竹新民治店",
    "addr": "新竹市東區8鄰科學園路88號1樓",
    "pkey": "015155",
    "tel": "03-6687741"
}, {
    "name": "全家新竹食品店",
    "addr": "新竹市東區食品路47號1樓",
    "pkey": "016055",
    "tel": "03-5753302"
}, {
    "name": "全家新竹品明店",
    "addr": "新竹市東區食品路406號1樓",
    "pkey": "017192",
    "tel": "03-5625101"
}, {
    "name": "全家新竹頎邦店",
    "addr": "新竹市東區展業一路10號9樓﹝新竹科學園區﹞",
    "pkey": "016597",
    "tel": "03-6687601"
}, {
    "name": "全家新竹翠峰店",
    "addr": "新竹市東區高翠路375號",
    "pkey": "015210",
    "tel": "03-6667396"
}, {
    "name": "全家新竹瑞昱二店",
    "addr": "新竹市東區園區二路9號1樓",
    "pkey": "014791",
    "tel": "03-5679706"
}, {
    "name": "全家新竹新莊店",
    "addr": "新竹市東區新莊街52號1樓",
    "pkey": "015963",
    "tel": "03-5794795"
}, {
    "name": "全家新竹綠光店",
    "addr": "新竹市東區綠水路63號1樓及地下室",
    "pkey": "016367",
    "tel": "03-5717181"
}, {
    "name": "全家新竹龍山店",
    "addr": "新竹市東區龍山東路228號1樓",
    "pkey": "015830",
    "tel": "03-6687058"
}, {
    "name": "全家新竹關新店",
    "addr": "新竹市東區關新東路350號1樓",
    "pkey": "015831",
    "tel": "03-5679359"
}, {
    "name": "全家新竹寶山店",
    "addr": "新竹市東區寶山路448號1樓",
    "pkey": "014310",
    "tel": "03-5779007"
}, {
    "name": "全家新竹鐵支店",
    "addr": "新竹市東區鐵道路一段28巷79號1樓",
    "pkey": "012583",
    "tel": "03-5347461"
}, ], [{
    "name": "全家新竹庄頭店",
    "addr": "新竹市香山區大庄路17號",
    "pkey": "014005",
    "tel": "03-5400020"
}, {
    "name": "全家新竹頂福店",
    "addr": "新竹市香山區中山路540號1樓",
    "pkey": "012242",
    "tel": "03-5398942"
}, {
    "name": "全家新竹金福店",
    "addr": "新竹市香山區中山路640巷170號1樓",
    "pkey": "016492",
    "tel": "03-5303020"
}, {
    "name": "全家新竹香山店",
    "addr": "新竹市香山區中華路五段678號1樓",
    "pkey": "016328",
    "tel": "03-5378583"
}, {
    "name": "全家新竹中隘店",
    "addr": "新竹市香山區中華路六段667號、669號1樓",
    "pkey": "016139",
    "tel": "03-5181480"
}, {
    "name": "全家新竹台玻店",
    "addr": "新竹市香山區中華路四段470號",
    "pkey": "016828",
    "tel": "03-5384820"
}, {
    "name": "全家新竹中華店",
    "addr": "新竹市香山區五福路二段776、778號",
    "pkey": "016596",
    "tel": "03-5183072"
}, {
    "name": "全家新竹元村店",
    "addr": "新竹市香山區元培街197＆199號1樓",
    "pkey": "011845",
    "tel": "03-5303904"
}, {
    "name": "全家新竹學園店",
    "addr": "新竹市香山區元培街365-1號1樓",
    "pkey": "014720",
    "tel": "03-5397422"
}, {
    "name": "全家新竹內湖店",
    "addr": "新竹市香山區內湖路39號",
    "pkey": "014131",
    "tel": "03-5377351"
}, {
    "name": "全家新竹東埔店",
    "addr": "新竹市香山區牛埔東路196號1樓",
    "pkey": "016366",
    "tel": "03-5401779"
}, {
    "name": "全家新竹玄奘店",
    "addr": "新竹市香山區玄奘路48號1樓",
    "pkey": "016480",
    "tel": "03-5403055"
}, {
    "name": "全家新竹濱海店",
    "addr": "新竹市香山區西濱路二段601號",
    "pkey": "013355",
    "tel": "03-5400409"
}, {
    "name": "全家新竹延平店",
    "addr": "新竹市香山區延平路二段727巷1號",
    "pkey": "014813",
    "tel": "03-5380450"
}, {
    "name": "全家新竹大庄店",
    "addr": "新竹市香山區香北路86號1樓",
    "pkey": "016851",
    "tel": "03-5402252"
}, {
    "name": "全家新竹華夏店",
    "addr": "新竹市香山區埔前路49號",
    "pkey": "014507",
    "tel": "03-5398160"
}, ], ], [[{
    "name": "全家竹北新竹義店",
    "addr": "新竹縣竹北市三民路88號1樓",
    "pkey": "015052",
    "tel": "03-5528422"
}, {
    "name": "全家竹北環竹店",
    "addr": "新竹縣竹北市9鄰中山路178號",
    "pkey": "014652",
    "tel": "03-5534117"
}, {
    "name": "全家竹北中正西店",
    "addr": "新竹縣竹北市中正西路149號1樓",
    "pkey": "017158",
    "tel": "03-5528316"
}, {
    "name": "全家竹北宏豐店",
    "addr": "新竹縣竹北市中正西路999號1樓",
    "pkey": "016209",
    "tel": "03-5564742"
}, {
    "name": "全家竹北大河店",
    "addr": "新竹縣竹北市中華路2-51號",
    "pkey": "014718",
    "tel": "03-5531113"
}, {
    "name": "全家竹北六家店",
    "addr": "新竹縣竹北市文興路二段529號全部",
    "pkey": "012247",
    "tel": "03-6681742"
}, {
    "name": "全家竹北立錡店",
    "addr": "新竹縣竹北市台元一街8號13樓",
    "pkey": "017220",
    "tel": "03-5601125"
}, {
    "name": "全家竹北宏福店",
    "addr": "新竹縣竹北市光明一路236號1樓",
    "pkey": "013774",
    "tel": "03-6571083"
}, {
    "name": "全家竹北竹采店",
    "addr": "新竹縣竹北市成功一街82號1樓後段",
    "pkey": "015375",
    "tel": "03-5505119"
}, {
    "name": "全家竹北成功店",
    "addr": "新竹縣竹北市成功八路160號一樓",
    "pkey": "014963",
    "tel": "03-6682618"
}, {
    "name": "全家竹北自強店",
    "addr": "新竹縣竹北市自強南路52號",
    "pkey": "017693",
    "tel": "03-5505530"
}, {
    "name": "全家竹北科大店",
    "addr": "新竹縣竹北市科大一路93號",
    "pkey": "011228",
    "tel": "03-6571794"
}, {
    "name": "全家竹北泰和店",
    "addr": "新竹縣竹北市泰和路169號",
    "pkey": "017229",
    "tel": "03-5518451"
}, {
    "name": "全家竹北高鐵店",
    "addr": "新竹縣竹北市高鐵七路6號",
    "pkey": "013785",
    "tel": "03-6120886"
}, {
    "name": "全家竹北高鐵二店",
    "addr": "新竹縣竹北市高鐵七路6號2樓",
    "pkey": "013786",
    "tel": "03-6120887"
}, {
    "name": "全家竹北俠隱店",
    "addr": "新竹縣竹北市莊敬六街7號",
    "pkey": "017691",
    "tel": "03-6579422"
}, {
    "name": "全家竹北嘉興店",
    "addr": "新竹縣竹北市勝利七街二段66號1樓",
    "pkey": "013210",
    "tel": "03-6580147"
}, {
    "name": "全家竹北大悅店",
    "addr": "新竹縣竹北市勝利八街一段225號",
    "pkey": "016131",
    "tel": "03-6589350"
}, {
    "name": "全家竹北大漾店",
    "addr": "新竹縣竹北市博愛南路9號1樓",
    "pkey": "016043",
    "tel": "03-5550065"
}, {
    "name": "全家竹北台燿店",
    "addr": "新竹縣竹北市博愛街803號",
    "pkey": "016356",
    "tel": "03-5555018"
}, {
    "name": "全家竹北湧億店",
    "addr": "新竹縣竹北市博愛街273號",
    "pkey": "017745",
    "tel": "03-5552800"
}, {
    "name": "全家竹北台元店",
    "addr": "新竹縣竹北市博愛街523號1樓",
    "pkey": "015673",
    "tel": "03-5552394"
}, {
    "name": "全家竹北新竹愛店",
    "addr": "新竹縣竹北市博愛街422號一樓",
    "pkey": "016233",
    "tel": "03-5527543"
}, {
    "name": "全家竹北新華興店",
    "addr": "新竹縣竹北市華興街287號1樓",
    "pkey": "013393",
    "tel": "03-5517240"
}, {
    "name": "全家竹北雙城店",
    "addr": "新竹縣竹北市新瀧一街1號",
    "pkey": "017072",
    "tel": "03-6688362"
}, {
    "name": "全家竹北時尚店",
    "addr": "新竹縣竹北市嘉豐十一路一段31號1樓",
    "pkey": "017642",
    "tel": "03-6588915"
}, {
    "name": "全家竹北嘉豐店",
    "addr": "新竹縣竹北市嘉豐五路二段79號1樓",
    "pkey": "013162",
    "tel": "03-6578910"
}, {
    "name": "全家竹北唯美店",
    "addr": "新竹縣竹北市嘉豐六路二段19號",
    "pkey": "011689",
    "tel": "03-6683172"
}, {
    "name": "全家竹北新東元店",
    "addr": "新竹縣竹北市縣政二路67號1樓",
    "pkey": "013084",
    "tel": "03-6573571"
}, {
    "name": "全家竹北縣政店",
    "addr": "新竹縣竹北市縣政二路396號",
    "pkey": "016158",
    "tel": "03-5589342"
}, {
    "name": "全家竹北竹風店",
    "addr": "新竹縣竹北市環北路一段113號",
    "pkey": "016355",
    "tel": "03-5530293"
}, ], [{
    "name": "全家湖口千禧店",
    "addr": "新竹縣湖口鄉千禧路1號1樓",
    "pkey": "013820",
    "tel": "03-5696076"
}, {
    "name": "全家湖口新工業店",
    "addr": "新竹縣湖口鄉工業一路36號1樓",
    "pkey": "010573",
    "tel": "03-5977127"
}, {
    "name": "全家湖口中大店",
    "addr": "新竹縣湖口鄉中山路三段530號",
    "pkey": "015236",
    "tel": "03-6991002"
}, {
    "name": "全家湖口文和店",
    "addr": "新竹縣湖口鄉仁和路178號180號",
    "pkey": "015172",
    "tel": "03-5976181"
}, {
    "name": "全家湖口仁和店",
    "addr": "新竹縣湖口鄉鳳凰村仁和路45號",
    "pkey": "015170",
    "tel": "03-5971288"
}, {
    "name": "全家湖口達仁店",
    "addr": "新竹縣湖口鄉仁樂路118號",
    "pkey": "017159",
    "tel": "03-5977610"
}, {
    "name": "全家湖口文化店",
    "addr": "新竹縣湖口鄉文化路32號",
    "pkey": "016715",
    "tel": "03-5978323"
}, {
    "name": "全家湖口新安宅店",
    "addr": "新竹縣湖口鄉光復東路133號",
    "pkey": "012487",
    "tel": "03-5972923"
}, {
    "name": "全家湖口頎邦店",
    "addr": "新竹縣湖口鄉光復路12號5樓",
    "pkey": "016415",
    "tel": "03-6960342"
}, {
    "name": "全家湖口大功店",
    "addr": "新竹縣湖口鄉成功路76-1號",
    "pkey": "017756",
    "tel": "03-5901520"
}, {
    "name": "全家湖口成功店",
    "addr": "新竹縣湖口鄉成功路128號",
    "pkey": "017262",
    "tel": "03-5900098"
}, {
    "name": "全家湖口吉勝店",
    "addr": "新竹縣湖口鄉勝利村勝利路二段1號1樓",
    "pkey": "012610",
    "tel": "03-5977531"
}, {
    "name": "全家湖口裝甲店",
    "addr": "新竹縣湖口鄉勝利路二段350號",
    "pkey": "015293",
    "tel": "03-5982079"
}, ], [{
    "name": "全家新豐欣興店",
    "addr": "新竹縣新豐鄉中崙村中崙290號1樓",
    "pkey": "016545",
    "tel": "03-6992808"
}, {
    "name": "全家新豐尚仁店",
    "addr": "新竹縣新豐鄉尚仁街131號1樓",
    "pkey": "014932",
    "tel": "03-5579285"
}, {
    "name": "全家新豐松柏店",
    "addr": "新竹縣新豐鄉松柏街152號1樓",
    "pkey": "017640",
    "tel": "03-5577802"
}, {
    "name": "全家新豐建興店",
    "addr": "新竹縣新豐鄉建興路一段36號",
    "pkey": "016507",
    "tel": "03-5574185"
}, {
    "name": "全家新豐大興店",
    "addr": "新竹縣新豐鄉建興路二段496號1樓",
    "pkey": "015492",
    "tel": "03-5574059"
}, {
    "name": "全家新豐泰安店",
    "addr": "新竹縣新豐鄉泰安街75號1樓",
    "pkey": "017758",
    "tel": "03-5575691"
}, {
    "name": "全家新豐新庄店",
    "addr": "新竹縣新豐鄉新庄路133號",
    "pkey": "013087",
    "tel": "03-5575060"
}, {
    "name": "全家新豐松林店",
    "addr": "新竹縣新豐鄉新興路111號",
    "pkey": "016479",
    "tel": "03-5575748"
}, {
    "name": "全家新豐宏達店",
    "addr": "新竹縣新豐鄉新興路80號1樓",
    "pkey": "015373",
    "tel": "03-5578834"
}, {
    "name": "全家新豐福比店",
    "addr": "新竹縣新豐鄉新興路763號",
    "pkey": "017187",
    "tel": "03-5595316"
}, ], [{
    "name": "全家新埔埔德店",
    "addr": "新竹縣新埔鎮中正路629號1樓",
    "pkey": "017436",
    "tel": "03-5880669"
}, {
    "name": "全家新埔長茂店",
    "addr": "新竹縣新埔鎮中正路378號1樓",
    "pkey": "017648",
    "tel": "03-5885547"
}, {
    "name": "全家新埔新文山店",
    "addr": "新竹縣新埔鎮文山路犁頭山段865號1樓",
    "pkey": "015098",
    "tel": "03-5880071"
}, ], [{
    "name": "全家關西正義店",
    "addr": "新竹縣關西鎮正義路254號，256號",
    "pkey": "015235",
    "tel": "03-5870347"
}, {
    "name": "全家關西宏義店",
    "addr": "新竹縣關西鎮正義路27號1樓",
    "pkey": "015992",
    "tel": "03-5170455"
}, ], [{
    "name": "全家芎林五龍店",
    "addr": "新竹縣芎林鄉五和街126號",
    "pkey": "014933",
    "tel": "03-5931858"
}, {
    "name": "全家芎林富林店",
    "addr": "新竹縣芎林鄉富林路三段94號1樓",
    "pkey": "017067",
    "tel": "03-6671033"
}, ], [{
    "name": "全家竹東鎮金店",
    "addr": "新竹縣竹東鎮中山路67號1樓",
    "pkey": "013947",
    "tel": "03-5111020"
}, {
    "name": "全家竹東新市店",
    "addr": "新竹縣竹東鎮中央路92號",
    "pkey": "014870",
    "tel": "03-5821272"
}, {
    "name": "全家竹東致東店",
    "addr": "新竹縣竹東鎮中正路1號",
    "pkey": "014601",
    "tel": "03-5101897"
}, {
    "name": "全家竹東新中興店",
    "addr": "新竹縣竹東鎮中興路二段162號",
    "pkey": "015099",
    "tel": "03-5836522"
}, {
    "name": "全家竹東工研店",
    "addr": "新竹縣竹東鎮中興路四段195號52館1樓",
    "pkey": "014081",
    "tel": "03-5834633"
}, {
    "name": "全家竹東大林店",
    "addr": "新竹縣竹東鎮中豐路三段6號1樓",
    "pkey": "013330",
    "tel": "03-5950012"
}, {
    "name": "全家竹東大鄉店",
    "addr": "新竹縣竹東鎮中豐路三段97．99號1樓",
    "pkey": "016662",
    "tel": "03-5104813"
}, {
    "name": "全家竹東興仁店",
    "addr": "新竹縣竹東鎮仁愛路446號1樓",
    "pkey": "013522",
    "tel": "03-5947181"
}, {
    "name": "全家竹東北興店",
    "addr": "新竹縣竹東鎮北興路三段503號1樓",
    "pkey": "015595",
    "tel": "03-5967896"
}, {
    "name": "全家竹東上舜店",
    "addr": "新竹縣竹東鎮光明路261號．263號1樓",
    "pkey": "016183",
    "tel": "03-5832801"
}, {
    "name": "全家竹東東峰店",
    "addr": "新竹縣竹東鎮東峰路162號1樓",
    "pkey": "016331",
    "tel": "03-5103509"
}, {
    "name": "全家竹東東寧店",
    "addr": "新竹縣竹東鎮東寧路三段151號",
    "pkey": "010890",
    "tel": "03-5940109"
}, {
    "name": "全家竹東新商華店",
    "addr": "新竹縣竹東鎮東寧路三段43號全部一樓至四樓",
    "pkey": "012364",
    "tel": "03-5100715"
}, {
    "name": "全家竹東長春店",
    "addr": "新竹縣竹東鎮長春路三段165號一、二樓",
    "pkey": "013504",
    "tel": "03-5103321"
}, ], [{
    "name": "全家新竹橫山店",
    "addr": "新竹縣橫山鄉橫山村4鄰中豐路一段262號",
    "pkey": "017779",
    "tel": "03-5933001"
}, {
    "name": "全家橫山致豐店",
    "addr": "新竹縣橫山鄉大肚村12鄰中豐路二段112-2號",
    "pkey": "016494",
    "tel": "03-5931649"
}, ], ], [[{
    "name": "全家竹南火車頭店",
    "addr": "苗栗縣竹南鎮中山路166號2樓",
    "pkey": "015855",
    "tel": "037462484"
}, {
    "name": "全家竹南京華店",
    "addr": "苗栗縣竹南鎮中華路123號1樓",
    "pkey": "013607",
    "tel": "037668774"
}, {
    "name": "全家竹南中華店",
    "addr": "苗栗縣竹南鎮中華路189號1樓、2樓",
    "pkey": "015100",
    "tel": "037595730"
}, {
    "name": "全家竹南京元店",
    "addr": "苗栗縣竹南鎮中華路118號",
    "pkey": "012918",
    "tel": "037670239"
}, {
    "name": "全家竹南廣源店",
    "addr": "苗栗縣竹南鎮公義路1636-1號1樓",
    "pkey": "013160",
    "tel": "037586466"
}, {
    "name": "全家竹南中義店",
    "addr": "苗栗縣竹南鎮公義路1354號1樓",
    "pkey": "010696",
    "tel": "037586083"
}, {
    "name": "全家竹南新豐店",
    "addr": "苗栗縣竹南鎮公義路136號6樓",
    "pkey": "012388",
    "tel": "037635603"
}, {
    "name": "全家竹南天文店",
    "addr": "苗栗縣竹南鎮天文路51號",
    "pkey": "017643",
    "tel": "037611158"
}, {
    "name": "全家竹南崁頂店",
    "addr": "苗栗縣竹南鎮永貞路二段149號",
    "pkey": "013525",
    "tel": "037614709"
}, {
    "name": "全家竹南光華店",
    "addr": "苗栗縣竹南鎮光復路241號1樓",
    "pkey": "014750",
    "tel": "037484619"
}, {
    "name": "全家竹南龍佳店",
    "addr": "苗栗縣竹南鎮佳北二街1號",
    "pkey": "015378",
    "tel": "037615681"
}, {
    "name": "全家竹南博愛店",
    "addr": "苗栗縣竹南鎮博愛街53號1樓及地下室",
    "pkey": "014651",
    "tel": "037480834"
}, {
    "name": "全家竹南新七囍店",
    "addr": "苗栗縣竹南鎮博愛街799號",
    "pkey": "015352",
    "tel": "037550642"
}, {
    "name": "全家竹南群聯店",
    "addr": "苗栗縣竹南鎮群義路1號7樓",
    "pkey": "017422",
    "tel": "037583247"
}, {
    "name": "全家竹南龍鳳店",
    "addr": "苗栗縣竹南鎮20鄰龍山路一段167號",
    "pkey": "017350",
    "tel": "037479480"
}, {
    "name": "全家竹南龍好店",
    "addr": "苗栗縣竹南鎮龍山路二段2號一樓",
    "pkey": "015535",
    "tel": "037462495"
}, {
    "name": "全家竹南龍天店",
    "addr": "苗栗縣竹南鎮龍天路57號1樓",
    "pkey": "016687",
    "tel": "037474675"
}, {
    "name": "全家竹南環營店",
    "addr": "苗栗縣竹南鎮環市路一段162號",
    "pkey": "017667",
    "tel": "037480422"
}, {
    "name": "全家竹南環市店",
    "addr": "苗栗縣竹南鎮環市路二段75號1樓2樓",
    "pkey": "016805",
    "tel": "037478611"
}, ], [{
    "name": "全家頭份大同店",
    "addr": "苗栗縣頭份市大同路1號一樓",
    "pkey": "017066",
    "tel": "037598262"
}, {
    "name": "全家頭份斗煥店",
    "addr": "苗栗縣頭份市大營路1號",
    "pkey": "014196",
    "tel": "037691198"
}, {
    "name": "全家頭份信義店",
    "addr": "苗栗縣頭份市中山路53號1樓及地下室",
    "pkey": "017813",
    "tel": "037691745"
}, {
    "name": "全家頭份新市鎮店",
    "addr": "苗栗縣頭份市中央路753號1樓",
    "pkey": "017423",
    "tel": "037630276"
}, {
    "name": "全家頭份中央店",
    "addr": "苗栗縣頭份市中央路76號1樓",
    "pkey": "015692",
    "tel": "037676449"
}, {
    "name": "全家頭份上公園店",
    "addr": "苗栗縣頭份市中正路356號",
    "pkey": "016598",
    "tel": "037592732"
}, {
    "name": "全家頭份信東店",
    "addr": "苗栗縣頭份市中華路1135號1樓",
    "pkey": "017692",
    "tel": "037662980"
}, {
    "name": "全家頭份立華店",
    "addr": "苗栗縣頭份市中華路600之8號1樓",
    "pkey": "016955",
    "tel": "037695982"
}, {
    "name": "全家頭份武昌店",
    "addr": "苗栗縣頭份市中華路1322號1樓",
    "pkey": "017011",
    "tel": "037662470"
}, {
    "name": "全家頭份公園店",
    "addr": "苗栗縣頭份市公園路2號",
    "pkey": "014130",
    "tel": "037637836"
}, {
    "name": "全家頭份文化店",
    "addr": "苗栗縣頭份市文化街209號一樓",
    "pkey": "016931",
    "tel": "037687195"
}, {
    "name": "全家頭份雙民店",
    "addr": "苗栗縣頭份市民族路196號1樓",
    "pkey": "011989",
    "tel": "037594283"
}, {
    "name": "全家頭份田寮店",
    "addr": "苗栗縣頭份市10鄰自強路二段628號",
    "pkey": "012633",
    "tel": "037637825"
}, {
    "name": "全家頭份和平店",
    "addr": "苗栗縣頭份市和平路83號1樓",
    "pkey": "013878",
    "tel": "037595069"
}, {
    "name": "全家頭份尚順二店",
    "addr": "苗栗縣頭份市尚順路50號1樓",
    "pkey": "017627",
    "tel": "037696023"
}, {
    "name": "全家頭份尚順店",
    "addr": "苗栗縣頭份市東民三街1號1樓",
    "pkey": "013792",
    "tel": "037596441"
}, {
    "name": "全家頭份八寶店",
    "addr": "苗栗縣頭份市信義路533號1樓",
    "pkey": "014459",
    "tel": "037625806"
}, {
    "name": "全家頭份為恭店",
    "addr": "苗栗縣頭份市信義路128號1樓（如附圖所示）",
    "pkey": "011425",
    "tel": "037597731"
}, ], [{
    "name": "全家南庄桂花園店",
    "addr": "苗栗縣南庄鄉南江村5鄰東江89號1樓",
    "pkey": "012430",
    "tel": "037823692"
}, ], [{
    "name": "全家苗栗獅潭店",
    "addr": "苗栗縣獅潭鄉新店村新店150之6號一樓",
    "pkey": "015873",
    "tel": "037932482"
}, ], [{
    "name": "全家後龍大龍店",
    "addr": "苗栗縣後龍鎮中北街67-3號67-4號67-5號",
    "pkey": "016901",
    "tel": "037729069"
}, {
    "name": "全家苗栗高鐵店",
    "addr": "苗栗縣後龍鎮高鐵三路268號",
    "pkey": "016390",
    "tel": "037248133"
}, {
    "name": "全家後龍新東店",
    "addr": "苗栗縣後龍鎮造豐路126號",
    "pkey": "014722",
    "tel": "037731679"
}, ], [{
    "name": "全家通霄中正店",
    "addr": "苗栗縣通霄鎮中正路80號",
    "pkey": "013275",
    "tel": "037759228"
}, {
    "name": "全家通霄河堤店",
    "addr": "苗栗縣通霄鎮忠孝路8-1號",
    "pkey": "015978",
    "tel": "037757074"
}, ], [{
    "name": "全家苑裡社苓店",
    "addr": "苗栗縣苑裡鎮110-5號",
    "pkey": "015237",
    "tel": "037745382"
}, {
    "name": "全家苑裡新興店",
    "addr": "苗栗縣苑裡鎮大同路3號",
    "pkey": "015523",
    "tel": "037860826"
}, {
    "name": "全家苑裡甜心店",
    "addr": "苗栗縣苑裡鎮9鄰山柑93號",
    "pkey": "010497",
    "tel": "037741579"
}, {
    "name": "全家苑裡金世界店",
    "addr": "苗栗縣苑裡鎮世界路二段268號",
    "pkey": "016626",
    "tel": "037857210"
}, {
    "name": "全家苑裡新信義店",
    "addr": "苗栗縣苑裡鎮建國路56-2號",
    "pkey": "014969",
    "tel": "037856811"
}, ], [{
    "name": "全家聯合大學店",
    "addr": "苗栗縣苗栗市聯大1號",
    "pkey": "017541",
    "tel": "037350968"
}, {
    "name": "全家苗栗新農會店",
    "addr": "苗栗縣苗栗市14鄰中山路524號1樓",
    "pkey": "012450",
    "tel": "037359757"
}, {
    "name": "全家苗栗中山店",
    "addr": "苗栗縣苗栗市中山路986之4號一樓",
    "pkey": "015252",
    "tel": "037336919"
}, {
    "name": "全家苗栗富樂店",
    "addr": "苗栗縣苗栗市中正路399號一樓",
    "pkey": "017377",
    "tel": "037358638"
}, {
    "name": "全家苗栗大利店",
    "addr": "苗栗縣苗栗市中正路1132號",
    "pkey": "016210",
    "tel": "037369349"
}, {
    "name": "全家苗栗新大發店",
    "addr": "苗栗縣苗栗市22鄰中華路673號",
    "pkey": "016587",
    "tel": "037261796"
}, {
    "name": "全家苗栗福麗店",
    "addr": "苗栗縣苗栗市民族路132號1樓",
    "pkey": "016988",
    "tel": "037378597"
}, {
    "name": "全家苗栗玉清店",
    "addr": "苗栗縣苗栗市玉清路38號1樓",
    "pkey": "017708",
    "tel": "037373733"
}, {
    "name": "全家苗栗自治店",
    "addr": "苗栗縣苗栗市自治路162號",
    "pkey": "017608",
    "tel": "037368221"
}, {
    "name": "全家苗栗真興店",
    "addr": "苗栗縣苗栗市為公路540號",
    "pkey": "016061",
    "tel": "037265972"
}, {
    "name": "全家苗栗台鐵店",
    "addr": "苗栗縣苗栗市為公路1-1號3樓",
    "pkey": "017006",
    "tel": "037275374"
}, {
    "name": "全家苗栗英才店",
    "addr": "苗栗縣苗栗市英才路127號",
    "pkey": "014059",
    "tel": "037372848"
}, {
    "name": "全家苗栗嘉新店",
    "addr": "苗栗縣苗栗市國華路126號",
    "pkey": "013955",
    "tel": "037267843"
}, {
    "name": "全家苗栗大勝店",
    "addr": "苗栗縣苗栗市新東街142號",
    "pkey": "015300",
    "tel": "037325993"
}, {
    "name": "全家苗栗聯大店",
    "addr": "苗栗縣苗栗市聯大二號",
    "pkey": "013321",
    "tel": "037381430"
}, ], [{
    "name": "全家造橋朝陽店",
    "addr": "苗栗縣造橋鄉朝陽村朝陽路127號",
    "pkey": "013183",
    "tel": "037562446"
}, ], [{
    "name": "全家頭屋雙龍店",
    "addr": "苗栗縣頭屋鄉尖豐路135-2號",
    "pkey": "016186",
    "tel": "037252310"
}, ], [{
    "name": "全家公館金交流店",
    "addr": "苗栗縣公館鄉玉谷村14鄰向陽31號1樓",
    "pkey": "017128",
    "tel": "037233561"
}, {
    "name": "全家公館農會店",
    "addr": "苗栗縣公館鄉忠孝路227號",
    "pkey": "015291",
    "tel": "037237517"
}, {
    "name": "全家公館新鶴岡店",
    "addr": "苗栗縣公館鄉鶴山村7鄰鶴山235之1號1樓",
    "pkey": "014548",
    "tel": "037237605"
}, ], [{
    "name": "全家大湖新南昌店",
    "addr": "苗栗縣大湖鄉南昌路20號",
    "pkey": "012478",
    "tel": "037995457"
}, ], [{
    "name": "全家銅鑼工業店",
    "addr": "苗栗縣銅鑼鄉中平村中興路3之1號1樓",
    "pkey": "016238",
    "tel": "037232502"
}, {
    "name": "全家銅鑼新福興店",
    "addr": "苗栗縣銅鑼鄉福興村13鄰平陽路40-6號1樓",
    "pkey": "012424",
    "tel": "037981203"
}, {
    "name": "全家銅鑼京元店",
    "addr": "苗栗縣銅鑼鄉銅科北路8號4樓",
    "pkey": "013741",
    "tel": "037987616"
}, ], [{
    "name": "全家卓蘭上新店",
    "addr": "苗栗縣卓蘭鎮19鄰上新12號",
    "pkey": "017807",
    "tel": "04-25898473"
}, {
    "name": "全家卓蘭水梨店",
    "addr": "苗栗縣卓蘭鎮中正路48號",
    "pkey": "016313",
    "tel": "04-25897758"
}, ], ], [[{
    "name": "全家斗南新陽光店",
    "addr": "雲林縣斗南鎮大成路62號",
    "pkey": "015476",
    "tel": "05-5968582"
}, {
    "name": "全家斗南大業店",
    "addr": "雲林縣斗南鎮5鄰大業路243號1樓",
    "pkey": "014443",
    "tel": "05-5974872"
}, {
    "name": "全家斗南西岐店",
    "addr": "雲林縣斗南鎮中山路151-16號",
    "pkey": "010462",
    "tel": "05-5953351"
}, {
    "name": "全家斗南光華店",
    "addr": "雲林縣斗南鎮光華路96號",
    "pkey": "014670",
    "tel": "05-5953576"
}, {
    "name": "全家斗南利台店",
    "addr": "雲林縣斗南鎮忠孝路228-2號",
    "pkey": "013515",
    "tel": "05-5972136"
}, {
    "name": "全家斗南林子店",
    "addr": "雲林縣斗南鎮林子201號",
    "pkey": "016759",
    "tel": "05-5974262"
}, ], [{
    "name": "全家大埤南和店",
    "addr": "雲林縣大埤鄉中正路19號",
    "pkey": "013014",
    "tel": "05-5918608"
}, ], [{
    "name": "全家虎尾虎威店",
    "addr": "雲林縣虎尾鎮八德街88號",
    "pkey": "015283",
    "tel": "05-6329484"
}, {
    "name": "全家虎尾霹靂店",
    "addr": "雲林縣虎尾鎮中興路83號1樓",
    "pkey": "015773",
    "tel": "05-6223248"
}, {
    "name": "全家虎尾文科店",
    "addr": "雲林縣虎尾鎮文科路1151號",
    "pkey": "017750",
    "tel": "05-6331799"
}, {
    "name": "全家虎尾新興店",
    "addr": "雲林縣虎尾鎮民權路13號",
    "pkey": "014792",
    "tel": "05-6323822"
}, {
    "name": "全家虎尾工專店",
    "addr": "雲林縣虎尾鎮立德路2號",
    "pkey": "014820",
    "tel": "05-6364272"
}, {
    "name": "全家虎尾新光店",
    "addr": "雲林縣虎尾鎮光明路75號",
    "pkey": "015477",
    "tel": "05-6326703"
}, {
    "name": "全家虎尾平和店",
    "addr": "雲林縣虎尾鎮光復路126號",
    "pkey": "016780",
    "tel": "05-6324174"
}, {
    "name": "全家虎尾新忠孝店",
    "addr": "雲林縣虎尾鎮忠孝路44號",
    "pkey": "016462",
    "tel": "05-6320832"
}, {
    "name": "全家虎尾立人店",
    "addr": "雲林縣虎尾鎮復興路177號1＆2樓",
    "pkey": "017653",
    "tel": "05-6325725"
}, {
    "name": "全家虎尾興南店",
    "addr": "雲林縣虎尾鎮興南158之12號",
    "pkey": "015965",
    "tel": "05-6328374"
}, ], [{
    "name": "全家土庫建國店",
    "addr": "雲林縣土庫鎮建國路137號",
    "pkey": "012981",
    "tel": "05-6628899"
}, ], [{
    "name": "全家褒忠聚寶店",
    "addr": "雲林縣褒忠鄉中正路131號1樓",
    "pkey": "012685",
    "tel": "05-6975735"
}, ], [{
    "name": "全家東勢安康店",
    "addr": "雲林縣東勢鄉東南村康安路6號",
    "pkey": "014522",
    "tel": "05-6993185"
}, ], [{
    "name": "全家雲林崙豐店",
    "addr": "雲林縣台西鄉永豐村崙豐路108號1樓",
    "pkey": "017561",
    "tel": "05-6902447"
}, ], [{
    "name": "全家崙背永昌店",
    "addr": "雲林縣崙背鄉南光路1之10號",
    "pkey": "010802",
    "tel": "05-6967662"
}, ], [{
    "name": "全家麥寮長庚店",
    "addr": "雲林縣麥寮鄉中興村工業路1500號",
    "pkey": "017504",
    "tel": "05-6910710"
}, {
    "name": "全家麥寮新泰順店",
    "addr": "雲林縣麥寮鄉中興路76-3號",
    "pkey": "013030",
    "tel": "05-6936160"
}, {
    "name": "全家麥寮新工店",
    "addr": "雲林縣麥寮鄉仁德西路二段543號",
    "pkey": "012303",
    "tel": "05-6916675"
}, {
    "name": "全家麥寮六輕店",
    "addr": "雲林縣麥寮鄉中興村台塑工業園區1號",
    "pkey": "013776",
    "tel": "05-6812640"
}, {
    "name": "全家麥寮新和順店",
    "addr": "雲林縣麥寮鄉光復路34號",
    "pkey": "016162",
    "tel": "05-6939370"
}, {
    "name": "全家麥寮德順店",
    "addr": "雲林縣麥寮鄉施厝村施厝230號1樓",
    "pkey": "010681",
    "tel": "05-6914811"
}, {
    "name": "全家麥寮橋頭店",
    "addr": "雲林縣麥寮鄉橋頭村橋頭路327號一樓",
    "pkey": "013924",
    "tel": "05-6911471"
}, ], [{
    "name": "全家斗六上海店",
    "addr": "雲林縣斗六市上海路176號1樓",
    "pkey": "012458",
    "tel": "05-5373410"
}, {
    "name": "全家斗六榮大店",
    "addr": "雲林縣斗六市大學路一段402號1樓",
    "pkey": "016809",
    "tel": "05-5360113"
}, {
    "name": "全家斗六雲大店",
    "addr": "雲林縣斗六市中山路573號",
    "pkey": "013359",
    "tel": "05-5360798"
}, {
    "name": "全家斗六社口店",
    "addr": "雲林縣斗六市中山路321號1樓2樓全部",
    "pkey": "016621",
    "tel": "05-5360684"
}, {
    "name": "全家斗六環中店",
    "addr": "雲林縣斗六市中華路275號",
    "pkey": "016372",
    "tel": "05-5374847"
}, {
    "name": "全家斗六新中興店",
    "addr": "雲林縣斗六市中興路30號",
    "pkey": "017467",
    "tel": "05-5570421"
}, {
    "name": "全家斗六工業店",
    "addr": "雲林縣斗六市斗工十路108號1樓",
    "pkey": "017655",
    "tel": "05-5575825"
}, {
    "name": "全家斗六四維店",
    "addr": "雲林縣斗六市四維路132號1樓",
    "pkey": "017562",
    "tel": "05-5350953"
}, {
    "name": "全家斗六車頭店",
    "addr": "雲林縣斗六市民生路187號2樓",
    "pkey": "016858",
    "tel": "05-5334074"
}, {
    "name": "全家斗六莊敬店",
    "addr": "雲林縣斗六市成功路280號一樓",
    "pkey": "016463",
    "tel": "05-5338296"
}, {
    "name": "全家斗六竹圍店",
    "addr": "雲林縣斗六市竹圍路51號一樓",
    "pkey": "015256",
    "tel": "05-5515203"
}, {
    "name": "全家斗六西平店",
    "addr": "雲林縣斗六市西平路677號",
    "pkey": "016470",
    "tel": "05-5516477"
}, {
    "name": "全家斗六明德店",
    "addr": "雲林縣斗六市明德路103號1樓",
    "pkey": "015017",
    "tel": "05-5339978"
}, {
    "name": "全家斗六保明店",
    "addr": "雲林縣斗六市保長路51-1號",
    "pkey": "010618",
    "tel": "05-5370414"
}, {
    "name": "全家斗六重光店",
    "addr": "雲林縣斗六市南聖路78巷47號1樓",
    "pkey": "016619",
    "tel": "05-5338946"
}, {
    "name": "全家斗六永昌店",
    "addr": "雲林縣斗六市雲林路二段135號1樓",
    "pkey": "017038",
    "tel": "05-5376148"
}, {
    "name": "全家斗六久安店",
    "addr": "雲林縣斗六市雲林路三段473號",
    "pkey": "017335",
    "tel": "05-5222671"
}, {
    "name": "全家斗六龍潭店",
    "addr": "雲林縣斗六市龍潭北路2號1樓",
    "pkey": "015257",
    "tel": "05-5336820"
}, {
    "name": "全家斗六鎮北店",
    "addr": "雲林縣斗六市鎮北路152號1樓．2樓",
    "pkey": "015073",
    "tel": "05-5331047"
}, {
    "name": "全家斗六牛桃灣店",
    "addr": "雲林縣斗六市鎮北路349-2號",
    "pkey": "016540",
    "tel": "05-5512040"
}, ], [{
    "name": "全家林內采虹店",
    "addr": "雲林縣林內鄉中正路30號．32號",
    "pkey": "011055",
    "tel": "05-5898442"
}, ], [{
    "name": "全家古坑永光店",
    "addr": "雲林縣古坑鄉永光村光昌路15巷5號",
    "pkey": "017379",
    "tel": "05-5821723"
}, ], [{
    "name": "全家莿桐饒平店",
    "addr": "雲林縣莿桐鄉四合村后埔128號",
    "pkey": "017739",
    "tel": "05-5712906"
}, ], [{
    "name": "全家西螺平和店",
    "addr": "雲林縣西螺鎮平和南路399號1-3樓",
    "pkey": "015858",
    "tel": "05-5875059"
}, {
    "name": "全家西螺廣福店",
    "addr": "雲林縣西螺鎮光復西路2號",
    "pkey": "012175",
    "tel": "05-5875923"
}, {
    "name": "全家西螺七崁店",
    "addr": "雲林縣西螺鎮吳厝70-1號",
    "pkey": "016859",
    "tel": "05-5878263"
}, {
    "name": "全家西螺延平店",
    "addr": "雲林縣西螺鎮延平路191號",
    "pkey": "010805",
    "tel": "05-5873047"
}, {
    "name": "全家西螺青果店",
    "addr": "雲林縣西螺鎮新興路500號",
    "pkey": "017766",
    "tel": "05-5879480"
}, ], [{
    "name": "全家二崙新崙店",
    "addr": "雲林縣二崙鄉中山路115號",
    "pkey": "017762",
    "tel": "05-5989801"
}, {
    "name": "全家二崙永定店",
    "addr": "雲林縣二崙鄉永定村永定路407號",
    "pkey": "016566",
    "tel": "05-5981816"
}, ], [{
    "name": "全家北港文仁店",
    "addr": "雲林縣北港鎮大同路554之1號",
    "pkey": "014333",
    "tel": "05-7820974"
}, {
    "name": "全家北港天后店",
    "addr": "雲林縣北港鎮中山路90號",
    "pkey": "017612",
    "tel": "05-7837465"
}, {
    "name": "全家北港順風店",
    "addr": "雲林縣北港鎮中正路95號一樓、二樓",
    "pkey": "017050",
    "tel": "05-7836010"
}, {
    "name": "全家北港豐順店",
    "addr": "雲林縣北港鎮公園路73號1．2樓",
    "pkey": "016397",
    "tel": "05-7839941"
}, {
    "name": "全家北港財神店",
    "addr": "雲林縣北港鎮文仁路143號一樓",
    "pkey": "015799",
    "tel": "05-7821172"
}, {
    "name": "全家北港華勝店",
    "addr": "雲林縣北港鎮華勝路416號1樓",
    "pkey": "016276",
    "tel": "05-7825091"
}, ], [{
    "name": "全家雲林水林店",
    "addr": "雲林縣水林鄉新興南路4號，6號",
    "pkey": "013876",
    "tel": "05-7850306"
}, ], [{
    "name": "全家雲林元長店",
    "addr": "雲林縣元長鄉長南村13鄰中山路115號1樓",
    "pkey": "016056",
    "tel": "05-7888693"
}, ], ], [[{
    "name": "全家嘉義八德店",
    "addr": "嘉義市西區八德路240號",
    "pkey": "013070",
    "tel": "05-2911792"
}, {
    "name": "全家嘉義上新店",
    "addr": "嘉義市西區上海路322號全部",
    "pkey": "015634",
    "tel": "05-2840713"
}, {
    "name": "全家嘉義德慶店",
    "addr": "嘉義市西區中興路319之3號1樓",
    "pkey": "016450",
    "tel": "05-2319477"
}, {
    "name": "全家嘉義鑫愛店",
    "addr": "嘉義市西區仁愛路508號",
    "pkey": "016398",
    "tel": "05-2277893"
}, {
    "name": "全家嘉義新億高店",
    "addr": "嘉義市西區仁愛路212號",
    "pkey": "017134",
    "tel": "05-2236429"
}, {
    "name": "全家嘉義仁安店",
    "addr": "嘉義市西區仁愛路175號1樓",
    "pkey": "017596",
    "tel": "05-2843206"
}, {
    "name": "全家嘉義玉山店",
    "addr": "嘉義市西區世賢路二段468號",
    "pkey": "014498",
    "tel": "05-2842603"
}, {
    "name": "全家嘉義北園店",
    "addr": "嘉義市西區北社尾路31號1樓",
    "pkey": "013265",
    "tel": "05-2382806"
}, {
    "name": "全家嘉義北港店",
    "addr": "嘉義市西區北港路1465號",
    "pkey": "017656",
    "tel": "05-2387313"
}, {
    "name": "全家嘉義湖瑞店",
    "addr": "嘉義市西區民生南路589號",
    "pkey": "016127",
    "tel": "05-2841584"
}, {
    "name": "全家嘉義光路店",
    "addr": "嘉義市西區民生南路528號1樓",
    "pkey": "012459",
    "tel": "05-2843075"
}, {
    "name": "全家嘉義憶富店",
    "addr": "嘉義市西區民權路396號1樓",
    "pkey": "012699",
    "tel": "05-2229931"
}, {
    "name": "全家嘉義自強店",
    "addr": "嘉義市西區自強街86號、88號、90號、92號1樓",
    "pkey": "015179",
    "tel": "05-2863047"
}, {
    "name": "全家嘉義中榮店",
    "addr": "嘉義市西區嘉義市西區世賢路二段600號",
    "pkey": "016620",
    "tel": "05-2844853"
}, {
    "name": "全家嘉義保安店",
    "addr": "嘉義市西區保安二路159號",
    "pkey": "016461",
    "tel": "05-2911249"
}, {
    "name": "全家嘉義漢口店",
    "addr": "嘉義市西區南京路392號",
    "pkey": "012425",
    "tel": "05-2844070"
}, {
    "name": "全家嘉義南京店",
    "addr": "嘉義市西區南京路423號427號",
    "pkey": "013228",
    "tel": "05-2838475"
}, {
    "name": "全家嘉義國楊店",
    "addr": "嘉義市西區垂楊路434號",
    "pkey": "016757",
    "tel": "05-2165585"
}, {
    "name": "全家嘉義向榮店",
    "addr": "嘉義市西區國華街519號1樓",
    "pkey": "013500",
    "tel": "05-2319535"
}, {
    "name": "全家嘉義新榮店",
    "addr": "嘉義市西區新榮路337號之2　1樓",
    "pkey": "016758",
    "tel": "05-2278676"
}, {
    "name": "全家嘉義興雅店",
    "addr": "嘉義市西區興雅路72號",
    "pkey": "017415",
    "tel": "05-2910040"
}, {
    "name": "全家嘉義興達店",
    "addr": "嘉義市西區興達路318號1樓",
    "pkey": "015180",
    "tel": "05-2319795"
}, ], [{
    "name": "全家嘉義聖馬店",
    "addr": "嘉義市東區大雅路二段565號二樓商店街",
    "pkey": "016160",
    "tel": "05-2777467"
}, {
    "name": "全家嘉義東雅店",
    "addr": "嘉義市東區文雅街41號",
    "pkey": "015500",
    "tel": "05-2763383"
}, {
    "name": "全家嘉義台林店",
    "addr": "嘉義市東區台林街260號",
    "pkey": "015798",
    "tel": "05-2756775"
}, {
    "name": "全家嘉義仁義店",
    "addr": "嘉義市東區台林街99號",
    "pkey": "017292",
    "tel": "05-2766504"
}, {
    "name": "全家嘉義芳草店",
    "addr": "嘉義市東區15鄰立仁路8號一樓",
    "pkey": "016430",
    "tel": "05-2235698"
}, {
    "name": "全家嘉義祥鳳店",
    "addr": "嘉義市東區吳鳳北路112號1F",
    "pkey": "013375",
    "tel": "05-2229819"
}, {
    "name": "全家嘉義新東義店",
    "addr": "嘉義市東區林森東路319巷61號",
    "pkey": "016431",
    "tel": "05-2789206"
}, {
    "name": "全家嘉義保健店",
    "addr": "嘉義市東區保健街149號",
    "pkey": "015255",
    "tel": "05-2778270"
}, {
    "name": "全家嘉義朝陽店",
    "addr": "嘉義市東區垂楊路132號壹樓",
    "pkey": "015800",
    "tel": "05-2764353"
}, {
    "name": "全家嘉義宣信店",
    "addr": "嘉義市東區宣信街248號",
    "pkey": "017161",
    "tel": "05-2292039"
}, {
    "name": "全家嘉義博東店",
    "addr": "嘉義市東區博東路183號",
    "pkey": "014939",
    "tel": "05-2788717"
}, {
    "name": "全家嘉義興安店",
    "addr": "嘉義市東區興安街199號",
    "pkey": "011333",
    "tel": "05-2226570"
}, {
    "name": "全家嘉義日新店",
    "addr": "嘉義市東區彌陀路238巷69號",
    "pkey": "017380",
    "tel": "05-2788326"
}, ], ], [[{
    "name": "全家番路觸口店",
    "addr": "嘉義縣番路鄉觸口村1-10號",
    "pkey": "017810",
    "tel": "05-2592923"
}, ], [{
    "name": "全家梅山公園店",
    "addr": "嘉義縣梅山鄉公園路338號1樓",
    "pkey": "017475",
    "tel": "05-2621278"
}, ], [{
    "name": "全家竹崎灣橋店",
    "addr": "嘉義縣竹崎鄉灣橋村五間厝3之6號",
    "pkey": "012700",
    "tel": "05-2793585"
}, {
    "name": "全家竹崎中山店",
    "addr": "嘉義縣竹崎鄉中山路282號",
    "pkey": "016396",
    "tel": "05-2616307"
}, ], [{
    "name": "全家中埔和興店",
    "addr": "嘉義縣中埔鄉和興村中山路五段943號",
    "pkey": "012595",
    "tel": "05-2394800"
}, {
    "name": "全家中埔中華店",
    "addr": "嘉義縣中埔鄉和睦村中華路678號",
    "pkey": "011680",
    "tel": "05-2390438"
}, {
    "name": "全家中埔興化店",
    "addr": "嘉義縣中埔鄉富裕路413號",
    "pkey": "012673",
    "tel": "05-2399132"
}, {
    "name": "全家中埔明珠店",
    "addr": "嘉義縣中埔鄉社口村19鄰檨仔林23-7號",
    "pkey": "011787",
    "tel": "05-2538162"
}, ], [{
    "name": "全家水上柳子林店",
    "addr": "嘉義縣水上鄉柳林村1500號",
    "pkey": "016275",
    "tel": "05-2688937"
}, {
    "name": "全家水上福德店",
    "addr": "嘉義縣水上鄉中正路161號、163號1樓",
    "pkey": "016081",
    "tel": "05-2681562"
}, {
    "name": "全家水上鎮安店",
    "addr": "嘉義縣水上鄉寬士村崎仔頭31之2號",
    "pkey": "016161",
    "tel": "05-2352125"
}, ], [{
    "name": "全家鹿草福祿店",
    "addr": "嘉義縣鹿草鄉西井村鹿草路290號、290號附1",
    "pkey": "017714",
    "tel": "05-3753947"
}, ], [{
    "name": "全家太保嘉新店",
    "addr": "嘉義縣太保市中山路一段806號1樓、2樓",
    "pkey": "017710",
    "tel": "05-2386407"
}, {
    "name": "全家太保麻魚店",
    "addr": "嘉義縣太保市中山路二段185號",
    "pkey": "017195",
    "tel": "05-2385049"
}, {
    "name": "全家嘉義高鐵店",
    "addr": "嘉義縣太保市高鐵西路168號",
    "pkey": "013782",
    "tel": "05-3109508"
}, {
    "name": "全家嘉義高鐵二店",
    "addr": "嘉義縣太保市高鐵西路168號2樓",
    "pkey": "013783",
    "tel": "05-3109508"
}, {
    "name": "全家太保縣府店",
    "addr": "嘉義縣太保市祥和三路東段212號一樓",
    "pkey": "016128",
    "tel": "05-3627137"
}, ], [{
    "name": "全家朴子南通店",
    "addr": "嘉義縣朴子市南通路三段767號、769號1樓",
    "pkey": "014063",
    "tel": "05-3707834"
}, {
    "name": "全家朴子嘉庚店",
    "addr": "嘉義縣朴子市嘉朴路西段6號",
    "pkey": "017051",
    "tel": "05-3625445"
}, {
    "name": "全家朴子鴨母寮店",
    "addr": "嘉義縣朴子市鴨母寮1之18號",
    "pkey": "016126",
    "tel": "05-3692982"
}, {
    "name": "全家朴子四海店",
    "addr": "嘉義縣朴子市應菜埔29-6號",
    "pkey": "017452",
    "tel": "05-3707141"
}, ], [{
    "name": "全家東石蚵庄店",
    "addr": "嘉義縣東石鄉東石村東石5號附6",
    "pkey": "012921",
    "tel": "05-3734531"
}, ], [{
    "name": "全家六腳蒜頭店",
    "addr": "嘉義縣六腳鄉蒜頭村125號",
    "pkey": "015900",
    "tel": "05-3805752"
}, ], [{
    "name": "全家新港中洋店",
    "addr": "嘉義縣新港鄉三間厝179號",
    "pkey": "012845",
    "tel": "05-3774310"
}, {
    "name": "全家新港天后店",
    "addr": "嘉義縣新港鄉中山路35號",
    "pkey": "016860",
    "tel": "05-3742300"
}, ], [{
    "name": "全家中正大學店",
    "addr": "嘉義縣民雄鄉三興村160號",
    "pkey": "013855",
    "tel": "05-2723991"
}, {
    "name": "全家中正大學附店",
    "addr": "嘉義縣民雄鄉三興村168號（學人宿舍）",
    "pkey": "017473",
    "tel": "05-2722372"
}, {
    "name": "全家中正新創店",
    "addr": "嘉義縣民雄鄉大學路168號（共同科教室）",
    "pkey": "013856",
    "tel": "05-2722824"
}, {
    "name": "全家民雄神農店",
    "addr": "嘉義縣民雄鄉三興村公園路370號壹樓",
    "pkey": "016781",
    "tel": "05-2723206"
}, {
    "name": "全家民雄正大店",
    "addr": "嘉義縣民雄鄉正大路一段919號1樓",
    "pkey": "013883",
    "tel": "05-2208968"
}, {
    "name": "全家民雄新金興店",
    "addr": "嘉義縣民雄鄉金興村21鄰忠義街83號全棟",
    "pkey": "017132",
    "tel": "05-2203668"
}, {
    "name": "全家民雄興平店",
    "addr": "嘉義縣民雄鄉昇平路42號",
    "pkey": "014549",
    "tel": "05-2265398"
}, {
    "name": "全家民雄雙福店",
    "addr": "嘉義縣民雄鄉雙福村建國路二段80號、82號一樓",
    "pkey": "017130",
    "tel": "05-2205479"
}, {
    "name": "全家民雄埤角店",
    "addr": "嘉義縣民雄鄉福樂村埤角106號",
    "pkey": "016810",
    "tel": "05-2206503"
}, {
    "name": "全家民雄福樂店",
    "addr": "嘉義縣民雄鄉埤角路2之92號，2之93號",
    "pkey": "017131",
    "tel": "05-2219351"
}, ], [{
    "name": "全家大林佳能店",
    "addr": "嘉義縣大林鎮大埔美園區一路46號二樓",
    "pkey": "017222",
    "tel": "05-2955238"
}, {
    "name": "全家大林站前店",
    "addr": "嘉義縣大林鎮中山路26號1樓",
    "pkey": "015458",
    "tel": "05-2649515"
}, {
    "name": "全家大林大發店",
    "addr": "嘉義縣大林鎮中正路485號",
    "pkey": "016861",
    "tel": "05-2641039"
}, {
    "name": "全家大林民生店",
    "addr": "嘉義縣大林鎮中興路二段82號及空地約190坪",
    "pkey": "017742",
    "tel": "05-2641797"
}, {
    "name": "全家大林大埔美店",
    "addr": "嘉義縣大林鎮互助社區15號",
    "pkey": "011402",
    "tel": "05-2955892"
}, {
    "name": "全家大林明華店",
    "addr": "嘉義縣大林鎮民生北路61號",
    "pkey": "017771",
    "tel": "05-2642683"
}, {
    "name": "全家大林慈院店",
    "addr": "嘉義縣大林鎮民生路2號B1樓",
    "pkey": "013263",
    "tel": "05-2641294"
}, ], [{
    "name": "全家布袋金滿店",
    "addr": "嘉義縣布袋鎮207號1樓",
    "pkey": "016395",
    "tel": "05-3477739"
}, {
    "name": "全家布袋上海店",
    "addr": "嘉義縣布袋鎮上海路211號",
    "pkey": "017763",
    "tel": "05-3478805"
}, ], ], [[{
    "name": "全家台南中山店",
    "addr": "台南市中西區中山路139號",
    "pkey": "013461",
    "tel": "06-2262010"
}, {
    "name": "全家台南大學店",
    "addr": "台南市中西區五妃街190號全棟",
    "pkey": "016434",
    "tel": "06-2142350"
}, {
    "name": "全家台南五妃店",
    "addr": "台南市中西區五妃街270號1樓",
    "pkey": "015195",
    "tel": "06-2142397"
}, {
    "name": "全家台南赤崁店",
    "addr": "台南市中西區民族路二段257號一樓",
    "pkey": "012778",
    "tel": "06-2216207"
}, {
    "name": "全家台南和善店",
    "addr": "台南市中西區和善街69號1F",
    "pkey": "017086",
    "tel": "06-2802166"
}, {
    "name": "全家台南美環店",
    "addr": "台南市中西區府前路二段277號",
    "pkey": "017588",
    "tel": "06-2989962"
}, {
    "name": "全家台南康樂三店",
    "addr": "台南市中西區府前路二段178號1樓",
    "pkey": "016761",
    "tel": "06-2224451"
}, {
    "name": "全家台南忠義店",
    "addr": "台南市中西區忠義路一段56號1樓",
    "pkey": "015019",
    "tel": "06-2143579"
}, {
    "name": "全家台南勝興店",
    "addr": "台南市中西區武聖路153號1樓",
    "pkey": "013966",
    "tel": "06-3582106"
}, {
    "name": "全家台南康樂二店",
    "addr": "台南市中西區康樂街150號一樓",
    "pkey": "011605",
    "tel": "06-2213463"
}, {
    "name": "全家台南康樂一店",
    "addr": "台南市中西區康樂街135號1樓",
    "pkey": "015381",
    "tel": "06-2255075"
}, ], [{
    "name": "全家台南成大店",
    "addr": "台南市東區大學路1號　光復校區學生餐廳",
    "pkey": "017599",
    "tel": "06-2004692"
}, {
    "name": "全家台南南紡店",
    "addr": "台南市東區中華東路一段366號",
    "pkey": "016022",
    "tel": "06-2090782"
}, {
    "name": "全家台南新義統店",
    "addr": "臺南市東區仁和路101-1號",
    "pkey": "015601",
    "tel": "06-2897432"
}, {
    "name": "全家台南仁東店",
    "addr": "臺南市東區仁東街32號1樓",
    "pkey": "017016",
    "tel": "06-2605708"
}, {
    "name": "全家台南一中店",
    "addr": "台南市東區民族路一段1號",
    "pkey": "015966",
    "tel": "06-2087710"
}, {
    "name": "全家台南東平店",
    "addr": "台南市東區光明街217號，219號",
    "pkey": "010589",
    "tel": "06-2002921"
}, {
    "name": "全家台南東成店",
    "addr": "台南市東區自由路三段223號",
    "pkey": "012923",
    "tel": "06-2897438"
}, {
    "name": "全家台南新博店",
    "addr": "台南市東區育樂街170號1樓",
    "pkey": "016533",
    "tel": "06-2094958"
}, {
    "name": "全家台南鴻興店",
    "addr": "台南市東區東和路30號1樓",
    "pkey": "013793",
    "tel": "06-2086173"
}, {
    "name": "全家台南新樓店",
    "addr": "台南市東區東門路一段57號1樓",
    "pkey": "013885",
    "tel": "06-2085046"
}, {
    "name": "全家台南東文店",
    "addr": "臺南市東區東門路三段168號",
    "pkey": "014478",
    "tel": "06-2603556"
}, {
    "name": "全家台南林森店",
    "addr": "台南市東區林森路二段188號",
    "pkey": "015302",
    "tel": "06-2376800"
}, {
    "name": "全家台南榮寶店",
    "addr": "台南市東區長榮路一段236號1樓",
    "pkey": "016905",
    "tel": "06-2363772"
}, {
    "name": "全家台南崇善店",
    "addr": "臺南市東區崇善路688號",
    "pkey": "017196",
    "tel": "06-2600746"
}, {
    "name": "全家台南東德店",
    "addr": "臺南市東區崇德路128號",
    "pkey": "014977",
    "tel": "06-2908347"
}, {
    "name": "全家台南崇德店",
    "addr": "台南市東區崇德路737號",
    "pkey": "012651",
    "tel": "06-2673558"
}, {
    "name": "全家台南新崇義店",
    "addr": "台南市東區崇德路471-3號",
    "pkey": "014872",
    "tel": "06-2908348"
}, {
    "name": "全家台南富農一店",
    "addr": "臺南市東區富農街二段3號1樓",
    "pkey": "015801",
    "tel": "06-3359083"
}, {
    "name": "全家台南裕聖店",
    "addr": "台南市東區裕信路383號",
    "pkey": "017803",
    "tel": "06-3314522"
}, {
    "name": "全家台南德東店",
    "addr": "台南市東區德東街83號全棟",
    "pkey": "012852",
    "tel": "06-2900863"
}, ], [{
    "name": "全家台南新大林店",
    "addr": "台南市南區大同路二段136巷2號",
    "pkey": "016082",
    "tel": "06-2141759"
}, {
    "name": "全家台南華興店",
    "addr": "台南市南區中華南路二段110號",
    "pkey": "016109",
    "tel": "06-2921082"
}, {
    "name": "全家台南水萍塭店",
    "addr": "台南市南區金華路二段384號",
    "pkey": "016717",
    "tel": "06-2211952"
}, {
    "name": "全家台南三喜店",
    "addr": "台南市南區喜樹路220號",
    "pkey": "017095",
    "tel": "06-2628253"
}, {
    "name": "全家台南金華店",
    "addr": "臺南市南區新孝路72號1樓",
    "pkey": "012731",
    "tel": "06-2638459"
}, {
    "name": "全家台南新和店",
    "addr": "台南市南區新建路47號1樓",
    "pkey": "012461",
    "tel": "06-2630575"
}, {
    "name": "全家台南新夏店",
    "addr": "台南市南區新興路151號",
    "pkey": "016468",
    "tel": "06-2615535"
}, {
    "name": "全家台南神鷹店",
    "addr": "台南市南區機場路905號",
    "pkey": "016721",
    "tel": "06-2907130"
}, {
    "name": "全家台南灣裡店",
    "addr": "台南市南區興南街63號左邊",
    "pkey": "017544",
    "tel": "06-2960741"
}, {
    "name": "全家台南永寧店",
    "addr": "台南市南區灣裡路278號",
    "pkey": "017687",
    "tel": "06-2627520"
}, ], [{
    "name": "全家台南大興店",
    "addr": "台南市北區大興街398號",
    "pkey": "017521",
    "tel": "06-2506975"
}, {
    "name": "全家台南大豐店",
    "addr": "台南市北區中華北路一段80號1樓全部",
    "pkey": "017583",
    "tel": "06-2507706"
}, {
    "name": "全家台南公園店",
    "addr": "台南市北區公園北路131號1樓",
    "pkey": "016590",
    "tel": "06-2246780"
}, {
    "name": "全家台南和順店",
    "addr": "台南市北區公園南路360號1樓",
    "pkey": "017453",
    "tel": "06-2254767"
}, {
    "name": "全家台南北成店",
    "addr": "台南市北區北成路39號",
    "pkey": "015215",
    "tel": "06-2826541"
}, {
    "name": "全家台南國宅店",
    "addr": "台南市北區北門路二段545號一樓",
    "pkey": "017576",
    "tel": "06-2521509"
}, {
    "name": "全家台南新北門店",
    "addr": "台南市北區北門路二段71號1樓",
    "pkey": "014706",
    "tel": "06-2222025"
}, {
    "name": "全家台南北園店",
    "addr": "台南市北區北園街20號1樓及夾層",
    "pkey": "017085",
    "tel": "06-2344469"
}, {
    "name": "全家台南長成店",
    "addr": "台南市北區成功路212號",
    "pkey": "016556",
    "tel": "06-2255085"
}, {
    "name": "全家台南忠成店",
    "addr": "台南市北區成功路118，120號",
    "pkey": "016336",
    "tel": "06-2211656"
}, {
    "name": "全家台南臨安店",
    "addr": "台南市北區成功路586號一樓",
    "pkey": "014781",
    "tel": "06-2508275"
}, {
    "name": "全家台南育德店",
    "addr": "台南市北區育德路433號1樓",
    "pkey": "017520",
    "tel": "06-2512062"
}, {
    "name": "全家台南和緯店",
    "addr": "台南市北區和緯路三段333號1樓",
    "pkey": "013368",
    "tel": "06-2507078"
}, {
    "name": "全家台南長順店",
    "addr": "台南市北區長北街112號",
    "pkey": "016862",
    "tel": "06-2210179"
}, {
    "name": "全家台南南園店",
    "addr": "台南市北區南園街102號1＋2樓",
    "pkey": "017417",
    "tel": "06-2389353"
}, {
    "name": "全家台南海安三店",
    "addr": "台南市北區海安路三段219巷5號",
    "pkey": "011018",
    "tel": "06-2587936"
}, ], [{
    "name": "全家台南文平店",
    "addr": "台南市安平區文平路405．407號",
    "pkey": "015980",
    "tel": "06-2989408"
}, {
    "name": "全家台南新安平店",
    "addr": "臺南市安平區安平路177號1樓",
    "pkey": "012199",
    "tel": "06-2234228"
}, {
    "name": "全家台南河美店",
    "addr": "台南市安平區安平路428號",
    "pkey": "014275",
    "tel": "06-2230712"
}, {
    "name": "全家台南康裕店",
    "addr": "台南市安平區健康三街209號1樓",
    "pkey": "015135",
    "tel": "06-2931235"
}, {
    "name": "全家台南新康華店",
    "addr": "台南市安平區健康三街235號",
    "pkey": "017672",
    "tel": "06-2954396"
}, {
    "name": "全家台南建平店",
    "addr": "台南市安平區健康路三段10號一樓",
    "pkey": "017416",
    "tel": "06-2992938"
}, {
    "name": "全家台南國平店",
    "addr": "台南市安平區國平路599之1號1樓",
    "pkey": "017015",
    "tel": "06-2939137"
}, {
    "name": "全家台南慶平店",
    "addr": "台南市安平區5鄰慶平路80號1樓",
    "pkey": "013931",
    "tel": "06-2930685"
}, {
    "name": "全家台南承天店",
    "addr": "台南市安平區慶平路573號1樓",
    "pkey": "014913",
    "tel": "06-2983705"
}, ], [{
    "name": "全家台南大安店",
    "addr": "台南市安南區大安街140號1樓",
    "pkey": "016337",
    "tel": "06-2474809"
}, {
    "name": "全家台南安慶店",
    "addr": "台南市安南區大安街728號一樓",
    "pkey": "016760",
    "tel": "06-2474770"
}, {
    "name": "全家台南台江店",
    "addr": "台南市安南區台江大道二段481號",
    "pkey": "014098",
    "tel": "06-2470289"
}, {
    "name": "全家台南新本原店",
    "addr": "臺南市安南區本原街三段247號1樓",
    "pkey": "016223",
    "tel": "06-2453180"
}, {
    "name": "全家台南安中店",
    "addr": "台南市安南區安中路一段699巷1號",
    "pkey": "017162",
    "tel": "06-2478562"
}, {
    "name": "全家台南興德店",
    "addr": "台南市安南區安中路四段238號1樓",
    "pkey": "015181",
    "tel": "06-2457612"
}, {
    "name": "全家台南文安店",
    "addr": "台南市安南區安和路一段73＆75號1樓",
    "pkey": "017580",
    "tel": "06-2827508"
}, {
    "name": "全家台南安順店",
    "addr": "台南市安南區安和路二段166號",
    "pkey": "016012",
    "tel": "06-3564715"
}, {
    "name": "全家台南長安店",
    "addr": "台南市安南區長和路二段12巷275號",
    "pkey": "013361",
    "tel": "06-3571280"
}, {
    "name": "全家台南長溪店",
    "addr": "台南市安南區長溪路三段376號",
    "pkey": "014849",
    "tel": "06-2475035"
}, {
    "name": "全家台南土城店",
    "addr": "台南市安南區城西街一段64號、66號1樓",
    "pkey": "010627",
    "tel": "06-2570385"
}, {
    "name": "全家台南安南店",
    "addr": "台南市安南區海佃路一段160號",
    "pkey": "017029",
    "tel": "06-3584103"
}, {
    "name": "全家台南新安田店",
    "addr": "台南市安南區海佃路一段347號",
    "pkey": "016718",
    "tel": "06-3586576"
}, {
    "name": "全家台南頂安店",
    "addr": "台南市安南區培安路151號",
    "pkey": "017096",
    "tel": "06-3560771"
}, ], [{
    "name": "全家永康永仁店",
    "addr": "台南市永康區大仁街39號1樓",
    "pkey": "015443",
    "tel": "06-2056842"
}, {
    "name": "全家永康大武店",
    "addr": "台南市永康區大武街8號",
    "pkey": "014437",
    "tel": "06-2521479"
}, {
    "name": "全家永康大橋店",
    "addr": "台南市永康區大橋二街68號1樓",
    "pkey": "011449",
    "tel": "06-3039275"
}, {
    "name": "全家永康華橋店",
    "addr": "台南市永康區大橋三街86號",
    "pkey": "012922",
    "tel": "06-2317322"
}, {
    "name": "全家永康大展店",
    "addr": "台南市永康區大灣東路38號",
    "pkey": "014188",
    "tel": "06-2054274"
}, {
    "name": "全家永康大華店",
    "addr": "台南市永康區大灣路319號1樓",
    "pkey": "017280",
    "tel": "06-2715086"
}, {
    "name": "全家永康新大灣店",
    "addr": "台南市永康區大灣路197號",
    "pkey": "017295",
    "tel": "06-2057565"
}, {
    "name": "全家永康五王店",
    "addr": "台南市永康區中山東路220號",
    "pkey": "016738",
    "tel": "06-3020810"
}, {
    "name": "全家永康新科店",
    "addr": "台南市永康區中正七街27號、29號一樓",
    "pkey": "015802",
    "tel": "06-2436091"
}, {
    "name": "全家永康世界店",
    "addr": "台南市永康區中正路242號",
    "pkey": "014194",
    "tel": "06-2019873"
}, {
    "name": "全家永康學府店",
    "addr": "台南市永康區中正路581號",
    "pkey": "017585",
    "tel": "06-2435262"
}, {
    "name": "全家永康兵仔市店",
    "addr": "台南市永康區中華一路61號",
    "pkey": "017743",
    "tel": "06-3123115"
}, {
    "name": "全家永康福樂店",
    "addr": "台南市永康區中華二路270號一樓",
    "pkey": "017518",
    "tel": "06-2039583"
}, {
    "name": "全家永康新長億店",
    "addr": "台南市永康區中華西街159號",
    "pkey": "017545",
    "tel": "06-3020941"
}, {
    "name": "全家永康五福店",
    "addr": "台南市永康區中華路508號",
    "pkey": "014587",
    "tel": "06-3026970"
}, {
    "name": "全家永康文化店",
    "addr": "台南市永康區文化路118號",
    "pkey": "017381",
    "tel": "06-2339352"
}, {
    "name": "全家永康永華店",
    "addr": "台南市永康區永大路二段1266號",
    "pkey": "012481",
    "tel": "06-3013225"
}, {
    "name": "全家永康永安店",
    "addr": "台南市永康區永安路113之7號一樓",
    "pkey": "015901",
    "tel": "06-2434833"
}, {
    "name": "全家永康永明店",
    "addr": "台南市永康區永明街262號",
    "pkey": "013402",
    "tel": "06-2017873"
}, {
    "name": "全家永康龍橋店",
    "addr": "台南市永康區自強路830號",
    "pkey": "014900",
    "tel": "06-2029670"
}, {
    "name": "全家永康自強店",
    "addr": "台南市永康區自強路728號1樓",
    "pkey": "015133",
    "tel": "06-2023702"
}, {
    "name": "全家永康廣興店",
    "addr": "台南市永康區西勢路205號",
    "pkey": "016105",
    "tel": "06-2073215"
}, {
    "name": "全家永康忠孝店",
    "addr": "台南市永康區忠孝路78，80號",
    "pkey": "015967",
    "tel": "06-3134320"
}, {
    "name": "全家永康東強店",
    "addr": "台南市永康區東橋一路246號一樓",
    "pkey": "016315",
    "tel": "06-3026813"
}, {
    "name": "全家永康新南台店",
    "addr": "台南市永康區南台街36號1樓",
    "pkey": "017566",
    "tel": "06-2434018"
}, {
    "name": "全家永康勝學店",
    "addr": "台南市永康區勝學路240號1樓",
    "pkey": "017491",
    "tel": "06-3139334"
}, {
    "name": "全家永康永慶店",
    "addr": "台南市永康區復國一路344號．346號",
    "pkey": "016295",
    "tel": "06-2029417"
}, {
    "name": "全家永康復華店",
    "addr": "台南市永康區復國一路477號1樓",
    "pkey": "012613",
    "tel": "06-2036243"
}, {
    "name": "全家永康永勝店",
    "addr": "台南市永康區復華七街119號1樓",
    "pkey": "016108",
    "tel": "06-2017269"
}, {
    "name": "全家永康華興店",
    "addr": "台南市永康區華興街148號1樓",
    "pkey": "014705",
    "tel": "06-3126297"
}, {
    "name": "全家永康新民店",
    "addr": "台南市永康區新民街73號",
    "pkey": "016829",
    "tel": "06-2438287"
}, {
    "name": "全家永康鹽洲店",
    "addr": "台南市永康區鹽忠街127號",
    "pkey": "016889",
    "tel": "06-2434458"
}, ], [{
    "name": "全家歸仁大順店",
    "addr": "台南市歸仁區大順街170號一樓",
    "pkey": "011889",
    "tel": "06-2397162"
}, {
    "name": "全家歸仁文仁店",
    "addr": "台南市歸仁區民族北街85號一樓",
    "pkey": "016513",
    "tel": "06-3307920"
}, {
    "name": "全家歸仁新文化店",
    "addr": "台南市歸仁區民權北路147號",
    "pkey": "015446",
    "tel": "06-2303581"
}, {
    "name": "全家歸仁長榮店",
    "addr": "台南市歸仁區長大路1號第一宿舍一樓",
    "pkey": "015402",
    "tel": "06-2785265"
}, ], [{
    "name": "全家新化新北店",
    "addr": "台南市新化區中正路697號全部",
    "pkey": "017268",
    "tel": "06-5987546"
}, {
    "name": "全家新化那拔店",
    "addr": "台南市新化區那拔林23號之16",
    "pkey": "017581",
    "tel": "06-5912967"
}, {
    "name": "全家新化鑫義店",
    "addr": "台南市新化區信義路371號",
    "pkey": "016163",
    "tel": "06-5901941"
}, ], [{
    "name": "全家玉井民生店",
    "addr": "台南市玉井區民族路89號",
    "pkey": "013516",
    "tel": "06-5745873"
}, ], [{
    "name": "全家仁德中二店",
    "addr": "台南市仁德區文華ㄧ街89號（教學區）",
    "pkey": "017587",
    "tel": "06-2672656"
}, {
    "name": "全家仁德仁義店",
    "addr": "台南市仁德區中山路426號",
    "pkey": "015981",
    "tel": "06-2492442"
}, {
    "name": "全家仁德二仁店",
    "addr": "台南市仁德區中正西路21號",
    "pkey": "012619",
    "tel": "06-2663473"
}, {
    "name": "全家仁德仁紡店",
    "addr": "台南市仁德區中正路二段805號",
    "pkey": "013540",
    "tel": "06-2491472"
}, {
    "name": "全家仁德中一店",
    "addr": "台南市仁德區文華一街89號（活動中心）",
    "pkey": "017586",
    "tel": "06-2672649"
}, {
    "name": "全家仁德鼎安店",
    "addr": "台南市仁德區德安路1之1號",
    "pkey": "017567",
    "tel": "06-2495741"
}, {
    "name": "全家仁德德南店",
    "addr": "台南市仁德區德南路22巷1號1樓",
    "pkey": "015442",
    "tel": "06-2498364"
}, {
    "name": "全家仁德德洋店",
    "addr": "台南市仁德區德洋路248之1號一樓",
    "pkey": "014976",
    "tel": "06-2692842"
}, {
    "name": "全家仁德新德店",
    "addr": "台南市仁德區德善路279-3號",
    "pkey": "014899",
    "tel": "06-2792875"
}, ], [{
    "name": "全家關廟南雄店",
    "addr": "台南市關廟區中央路246號",
    "pkey": "016429",
    "tel": "06-5955835"
}, {
    "name": "全家關廟旺萊店",
    "addr": "台南市關廟區旺萊路127號",
    "pkey": "016966",
    "tel": "06-5954243"
}, {
    "name": "全家關廟英雄店",
    "addr": "台南市關廟區南雄路一段1133號1樓",
    "pkey": "017673",
    "tel": "06-5951217"
}, ], [{
    "name": "全家官田新田店",
    "addr": "台南市官田區中山路一段35號",
    "pkey": "016981",
    "tel": "06-5794440"
}, ], [{
    "name": "全家麻豆新樓店",
    "addr": "台南市麻豆區小埤里苓子林20號",
    "pkey": "014433",
    "tel": "06-5702893"
}, {
    "name": "全家麻豆興中店",
    "addr": "台南市麻豆區興中路228號",
    "pkey": "017133",
    "tel": "06-5711047"
}, {
    "name": "全家麻豆興民店",
    "addr": "台南市麻豆區興中路51號",
    "pkey": "012250",
    "tel": "06-5711224"
}, {
    "name": "全家麻豆黎明店",
    "addr": "台南市麻豆區興國路46號1樓",
    "pkey": "012120",
    "tel": "06-5711104"
}, ], [{
    "name": "全家佳里中山店",
    "addr": "台南市佳里區中山路155號",
    "pkey": "016190",
    "tel": "06-7238351"
}, {
    "name": "全家佳里光復店",
    "addr": "台南市佳里區光復路327號",
    "pkey": "016011",
    "tel": "06-7237050"
}, {
    "name": "全家佳里佳興店",
    "addr": "台南市佳里區佳里興441-1號",
    "pkey": "013952",
    "tel": "06-7266943"
}, {
    "name": "全家佳里新平店",
    "addr": "台南市佳里區延平路267號",
    "pkey": "014951",
    "tel": "06-7234839"
}, {
    "name": "全家佳里延平店",
    "addr": "台南市佳里區延平路468-2號",
    "pkey": "012901",
    "tel": "06-7227976"
}, ], [{
    "name": "全家西港慶安店",
    "addr": "台南市西港區中山路263號",
    "pkey": "015020",
    "tel": "06-7952250"
}, {
    "name": "全家西港新興店",
    "addr": "台南市西港區新興街11號",
    "pkey": "015836",
    "tel": "06-7954217"
}, {
    "name": "全家西港南海店",
    "addr": "台南市西港區慶安路206號",
    "pkey": "016136",
    "tel": "06-7958252"
}, {
    "name": "全家西港港明店",
    "addr": "台南市西港區慶安路229號",
    "pkey": "015415",
    "tel": "06-7957204"
}, ], [{
    "name": "全家學甲狀元店",
    "addr": "台南市學甲區中山路183之6號1樓",
    "pkey": "017293",
    "tel": "06-7832360"
}, {
    "name": "全家學甲安得富店",
    "addr": "臺南市學甲區華宗路328號",
    "pkey": "015416",
    "tel": "06-7839207"
}, ], [{
    "name": "全家新營新興店",
    "addr": "台南市新營區中正路39之9號1樓",
    "pkey": "017711",
    "tel": "06-6326860"
}, {
    "name": "全家新營中興店",
    "addr": "台南市新營區中興路32號一樓",
    "pkey": "017269",
    "tel": "06-6334689"
}, {
    "name": "全家新營南新店",
    "addr": "台南市新營區民治路177號1樓",
    "pkey": "016451",
    "tel": "06-6591421"
}, {
    "name": "全家新營民興店",
    "addr": "台南市新營區民治路122號",
    "pkey": "015837",
    "tel": "06-6592241"
}, {
    "name": "全家新營百亨店",
    "addr": "台南市新營區民權路90號1樓",
    "pkey": "010710",
    "tel": "06-6350648"
}, {
    "name": "全家新營和平店",
    "addr": "台南市新營區和平路46號",
    "pkey": "012740",
    "tel": "06-6325617"
}, {
    "name": "全家新營東興店",
    "addr": "台南市新營區東興路188號1樓",
    "pkey": "016293",
    "tel": "06-6372731"
}, {
    "name": "全家新營南紙店",
    "addr": "台南市新營區建業路317號一樓",
    "pkey": "013316",
    "tel": "06-6595340"
}, {
    "name": "全家新營帝寶店",
    "addr": "台南市新營區復興路867號1樓",
    "pkey": "015697",
    "tel": "06-6523925"
}, {
    "name": "全家新營裕民店",
    "addr": "台南市新營區裕民路1號",
    "pkey": "017037",
    "tel": "06-6326426"
}, ], [{
    "name": "全家新營國道南店",
    "addr": "臺南市後壁區新厝69號",
    "pkey": "011489",
    "tel": "06-6328428"
}, {
    "name": "全家新營國道北店",
    "addr": "臺南市後壁區新厝72號",
    "pkey": "012784",
    "tel": "06-6321336"
}, {
    "name": "全家後壁茄苳店",
    "addr": "台南市後壁區嘉明里上茄苳146之33號32號",
    "pkey": "012726",
    "tel": "06-6881114"
}, ], [{
    "name": "全家白河昶興店",
    "addr": "台南市白河區中山路13號",
    "pkey": "016771",
    "tel": "06-6855541"
}, ], [{
    "name": "全家六甲民生附店",
    "addr": "台南市六甲區工研路8號",
    "pkey": "011344",
    "tel": "06-6986882"
}, {
    "name": "全家六甲新民店",
    "addr": "台南市六甲區中正路394號1樓",
    "pkey": "015739",
    "tel": "06-6984945"
}, ], [{
    "name": "全家下營中山店",
    "addr": "台南市下營區中山路二段32號",
    "pkey": "012517",
    "tel": "06-6893846"
}, ], [{
    "name": "全家柳營重溪店",
    "addr": "台南市柳營區重溪里小腳腿12號1樓",
    "pkey": "016311",
    "tel": "06-6234800"
}, {
    "name": "全家柳營敏惠店",
    "addr": "台南市柳營區中山東路二段1116號",
    "pkey": "013229",
    "tel": "06-6224748"
}, ], [{
    "name": "全家鹽水武廟店",
    "addr": "台南市鹽水區金和路2號1樓",
    "pkey": "017359",
    "tel": "06-6524945"
}, {
    "name": "全家鹽水朝琴店",
    "addr": "台南市鹽水區朝琴路140之2號一樓",
    "pkey": "012972",
    "tel": "06-6526857"
}, {
    "name": "全家鹽水清泉店",
    "addr": "台南市鹽水區朝琴路65號",
    "pkey": "017519",
    "tel": "06-6528354"
}, ], [{
    "name": "全家善化光文店",
    "addr": "台南市善化區中山路99號一樓",
    "pkey": "015478",
    "tel": "06-5854481"
}, {
    "name": "全家善化和平店",
    "addr": "臺南市善化區中山路231之6號1樓",
    "pkey": "015775",
    "tel": "06-5852942"
}, {
    "name": "全家善化正國店",
    "addr": "台南市善化區中正路160號一樓",
    "pkey": "017847",
    "tel": "06-5853799"
}, {
    "name": "全家善化啤酒店",
    "addr": "台南市善化區成功路1-1號",
    "pkey": "017330",
    "tel": "06-5853997"
}, {
    "name": "全家善化興華店",
    "addr": "台南市善化區建國路38號",
    "pkey": "016107",
    "tel": "06-5851143"
}, {
    "name": "全家善化住華店",
    "addr": "台南市善化區環東路二段32號1樓",
    "pkey": "010610",
    "tel": "06-5055430"
}, ], [{
    "name": "全家新市大社店",
    "addr": "台南市新市區大社里335號",
    "pkey": "016296",
    "tel": "06-5898187"
}, {
    "name": "全家新市華興店",
    "addr": "台南市新市區中正路252號1樓",
    "pkey": "014180",
    "tel": "06-5891477"
}, {
    "name": "全家新市遠科大店",
    "addr": "台南市新市區中華路49號",
    "pkey": "016046",
    "tel": "06-5977168"
}, {
    "name": "全家新市新和店",
    "addr": "台南市新市區民權路52號",
    "pkey": "015183",
    "tel": "06-5896607"
}, {
    "name": "全家新市光華店",
    "addr": "台南市新市區光華街135號",
    "pkey": "016902",
    "tel": "06-5899942"
}, {
    "name": "全家新市群創一店",
    "addr": "台南市新市區奇業路1號",
    "pkey": "017481",
    "tel": "06-5055039"
}, {
    "name": "全家新市聯科店",
    "addr": "臺南市新市區南科二路18號5F",
    "pkey": "011017",
    "tel": "06-5055013"
}, {
    "name": "全家新市群創六店",
    "addr": "台南市新市區紫楝路21號",
    "pkey": "017626",
    "tel": "06-5898611"
}, {
    "name": "全家新市群科店",
    "addr": "台南市新市區環西路一段3號B1FＡ店（原宿區）",
    "pkey": "017331",
    "tel": "06-5058324"
}, {
    "name": "全家新市群創四店",
    "addr": "台南市新市區環西路一段3號",
    "pkey": "017659",
    "tel": "06-5052175"
}, {
    "name": "全家新市群創七店",
    "addr": "台南市新市區環西路一段3號",
    "pkey": "017565",
    "tel": "06-5052173"
}, {
    "name": "全家新市群創二店",
    "addr": "台南市新市區環西路二段2號",
    "pkey": "017482",
    "tel": "06-5050307"
}, ], [{
    "name": "全家安定善高店",
    "addr": "台南市安定區蘇厝里293-68號",
    "pkey": "016811",
    "tel": "06-5975396"
}, {
    "name": "全家安定保安店",
    "addr": "台南市安定區保西里339之3號一樓",
    "pkey": "016165",
    "tel": "06-5976267"
}, {
    "name": "全家安定海寮店",
    "addr": "台南市安定區海寮10-2號1樓部分",
    "pkey": "016998",
    "tel": "06-5933959"
}, {
    "name": "全家安定港口店",
    "addr": "台南市安定區港口路244之28號1樓",
    "pkey": "016589",
    "tel": "06-5939547"
}, ], ], [[{
    "name": "全家高雄福華店",
    "addr": "高雄市新興區七賢一路301號壹樓角窗部份",
    "pkey": "015219",
    "tel": "07-2360858"
}, {
    "name": "全家高雄尚義店",
    "addr": "高雄市新興區中正二路220號1樓",
    "pkey": "014782",
    "tel": "07-2231461"
}, {
    "name": "全家高雄文橫店",
    "addr": "高雄市新興區文橫二路166之1號一樓",
    "pkey": "012405",
    "tel": "07-2820506"
}, {
    "name": "全家高雄民族店",
    "addr": "高雄市新興區民族二路100號",
    "pkey": "015243",
    "tel": "07-2231201"
}, {
    "name": "全家高雄林庭店",
    "addr": "高雄市新興區林森一路163-1號",
    "pkey": "017657",
    "tel": "07-2416656"
}, ], [{
    "name": "全家高雄瑞華店",
    "addr": "高雄市前金區七賢二路156號",
    "pkey": "017218",
    "tel": "07-2855228"
}, {
    "name": "全家高雄寶成店",
    "addr": "高雄市前金區七賢二路322號",
    "pkey": "015336",
    "tel": "07-2411037"
}, {
    "name": "全家高雄三鳳店",
    "addr": "高雄市前金區中華三路251號",
    "pkey": "015576",
    "tel": "07-2419155"
}, {
    "name": "全家高雄中華店",
    "addr": "高雄市前金區中華三路21號1樓",
    "pkey": "017171",
    "tel": "07-2829754"
}, {
    "name": "全家高雄錢櫃店",
    "addr": "高雄市前金區六合二路157號",
    "pkey": "013859",
    "tel": "07-2418122"
}, {
    "name": "全家高雄榮安店",
    "addr": "高雄市前金區自強一路60，62，64號1樓",
    "pkey": "012406",
    "tel": "07-2827415"
}, ], [{
    "name": "全家高雄三信店",
    "addr": "高雄市苓雅區三多一路186號（三信家商）",
    "pkey": "016906",
    "tel": "07-7241406"
}, {
    "name": "全家高雄忠孝店",
    "addr": "高雄市苓雅區三多三路168號壹樓",
    "pkey": "015983",
    "tel": "07-3317931"
}, {
    "name": "全家高雄亞太店",
    "addr": "高雄市苓雅區三多四路65號壹樓",
    "pkey": "016525",
    "tel": "07-2691476"
}, {
    "name": "全家高雄大遠百店",
    "addr": "高雄市苓雅區三多四路21號（12樓櫃位）",
    "pkey": "016768",
    "tel": "07-3387169"
}, {
    "name": "全家高雄五福店",
    "addr": "高雄市苓雅區五福一路153號",
    "pkey": "017336",
    "tel": "07-2290512"
}, {
    "name": "全家高雄四維店",
    "addr": "高雄市苓雅區四維四路5號",
    "pkey": "012905",
    "tel": "07-5350492"
}, {
    "name": "全家高雄輔仁店",
    "addr": "高雄市苓雅區正大路79號；輔仁路229號",
    "pkey": "017728",
    "tel": "07-7522089"
}, {
    "name": "全家高雄新義店",
    "addr": "高雄市苓雅區正義路176號壹樓",
    "pkey": "016880",
    "tel": "07-7491018"
}, {
    "name": "全家高雄永昌店",
    "addr": "高雄市苓雅區成功一路168之2號",
    "pkey": "015969",
    "tel": "07-3329586"
}, {
    "name": "全家高雄碼頭店",
    "addr": "高雄市苓雅區成功二路144號一樓三多四路13",
    "pkey": "015330",
    "tel": "07-2695101"
}, {
    "name": "全家高雄東榮店",
    "addr": "高雄市苓雅區自強三路16號",
    "pkey": "017077",
    "tel": "07-2693970"
}, {
    "name": "全家高雄實踐店",
    "addr": "高雄市苓雅區和平一路130號一樓",
    "pkey": "014157",
    "tel": "07-2265917"
}, {
    "name": "全家高雄華堂店",
    "addr": "高雄市苓雅區林森二路7-6號．7-7號",
    "pkey": "014952",
    "tel": "07-3348138"
}, {
    "name": "全家高雄武仁店",
    "addr": "高雄市苓雅區武仁街95號一樓",
    "pkey": "012350",
    "tel": "07-7238451"
}, {
    "name": "全家高雄心誠店",
    "addr": "高雄市苓雅區武廟路48號1樓",
    "pkey": "015717",
    "tel": "07-7174801"
}, {
    "name": "全家高雄武聖店",
    "addr": "高雄市苓雅區武廟路133號",
    "pkey": "017613",
    "tel": "07-7228004"
}, {
    "name": "全家高雄市府店",
    "addr": "高雄市苓雅區苓雅一路195號",
    "pkey": "012102",
    "tel": "07-5367610"
}, {
    "name": "全家高雄豐強店",
    "addr": "高雄市苓雅區苓雅二路108號一、二、三樓",
    "pkey": "012727",
    "tel": "07-3384961"
}, {
    "name": "全家高雄星光店",
    "addr": "高雄市苓雅區新光路26號1樓",
    "pkey": "015620",
    "tel": "07-3330514"
}, {
    "name": "全家高雄福山店",
    "addr": "高雄市苓雅區福德三路226號",
    "pkey": "015307",
    "tel": "07-7225460"
}, {
    "name": "全家高雄廣泉店",
    "addr": "高雄市苓雅區廣州一街127號一樓",
    "pkey": "017568",
    "tel": "07-7220774"
}, ], [{
    "name": "全家高雄大仁店",
    "addr": "高雄市鹽埕區大仁路59號",
    "pkey": "012403",
    "tel": "07-5316187"
}, {
    "name": "全家高雄福王店",
    "addr": "高雄市鹽埕區五福四路72號",
    "pkey": "014463",
    "tel": "07-5316702"
}, {
    "name": "全家高雄新樂店",
    "addr": "高雄市鹽埕區新樂街238號",
    "pkey": "010836",
    "tel": "07-5319796"
}, ], [{
    "name": "全家高雄國泰店",
    "addr": "高雄市鼓山區九如四路687，689號",
    "pkey": "015216",
    "tel": "07-5315985"
}, {
    "name": "全家高雄內惟店",
    "addr": "高雄市鼓山區九如四路1466號",
    "pkey": "014133",
    "tel": "07-5825460"
}, {
    "name": "全家高雄美美店",
    "addr": "高雄市鼓山區中華一路976號一樓",
    "pkey": "015383",
    "tel": "07-5528463"
}, {
    "name": "全家高雄文信店",
    "addr": "高雄市鼓山區文信路193號1樓及2樓",
    "pkey": "016065",
    "tel": "07-5533953"
}, {
    "name": "全家高雄明倫店",
    "addr": "高雄市鼓山區明倫路148號1樓",
    "pkey": "016611",
    "tel": "07-5547219"
}, {
    "name": "全家高雄華屏店",
    "addr": "高雄市鼓山區明華路280號",
    "pkey": "017539",
    "tel": "07-5526838"
}, {
    "name": "全家高雄南屏店",
    "addr": "高雄市鼓山區南屏路536號",
    "pkey": "014657",
    "tel": "07-5536031"
}, {
    "name": "全家高雄美明店",
    "addr": "高雄市鼓山區美明路102號",
    "pkey": "017615",
    "tel": "07-5537553"
}, {
    "name": "全家高雄美舞店",
    "addr": "高雄市鼓山區美術東五路118號",
    "pkey": "012135",
    "tel": "07-5224293"
}, {
    "name": "全家高雄美新店",
    "addr": "高雄市鼓山區美術南三路201號一樓",
    "pkey": "014672",
    "tel": "07-5549521"
}, {
    "name": "全家高雄美藝店",
    "addr": "高雄市鼓山區美術館路87號",
    "pkey": "016453",
    "tel": "07-5225401"
}, {
    "name": "全家高雄如逢店",
    "addr": "高雄市鼓山區逢甲路98號",
    "pkey": "016949",
    "tel": "07-5887028"
}, {
    "name": "全家高雄華漾店",
    "addr": "高雄市鼓山區華泰路152號",
    "pkey": "013268",
    "tel": "07-5524308"
}, {
    "name": "全家高雄鼓山店",
    "addr": "高雄市鼓山區鼓山二路43號壹樓",
    "pkey": "014047",
    "tel": "07-5217383"
}, {
    "name": "全家高雄西灣店",
    "addr": "高雄市鼓山區蓮海路70號（國立中山大學）",
    "pkey": "013317",
    "tel": "07-5250036"
}, {
    "name": "全家高雄龍勝店",
    "addr": "高雄市鼓山區龍勝路120號",
    "pkey": "015716",
    "tel": "07-5542963"
}, {
    "name": "全家高雄哈瑪星店",
    "addr": "高雄市鼓山區臨海二路52號",
    "pkey": "010848",
    "tel": "07-5319795"
}, ], [{
    "name": "全家高雄盛豐店",
    "addr": "高雄市前鎮區一心二路154號，156號1F",
    "pkey": "016013",
    "tel": "07-3369275"
}, {
    "name": "全家高雄二聖店",
    "addr": "高雄市前鎮區二聖一路67號，69號",
    "pkey": "011731",
    "tel": "07-7249692"
}, {
    "name": "全家高雄大魯閣店",
    "addr": "高雄市前鎮區中山四路100號（2F-13）",
    "pkey": "015149",
    "tel": "07-7915278"
}, {
    "name": "全家高雄皇家店",
    "addr": "高雄市前鎮區民權二路76、78號1樓",
    "pkey": "014405",
    "tel": "07-3318198"
}, {
    "name": "全家高雄西華店",
    "addr": "高雄市前鎮區光華二路76號",
    "pkey": "016907",
    "tel": "07-7264629"
}, {
    "name": "全家高雄明鳳店",
    "addr": "高雄市前鎮區明鳳三路65號",
    "pkey": "012496",
    "tel": "07-7935480"
}, {
    "name": "全家高雄華江店",
    "addr": "高雄市前鎮區長江街70號一樓",
    "pkey": "015676",
    "tel": "07-3359512"
}, {
    "name": "全家高雄草衙店",
    "addr": "高雄市前鎮區草衙二路403號",
    "pkey": "011859",
    "tel": "07-8157455"
}, {
    "name": "全家高雄瑞東店",
    "addr": "高雄市前鎮區崗山中街159號．161號",
    "pkey": "015187",
    "tel": "07-7260326"
}, {
    "name": "全家高雄聖心店",
    "addr": "高雄市前鎮區復興三路146號1樓",
    "pkey": "016191",
    "tel": "07-3387057"
}, {
    "name": "全家高雄錢證店",
    "addr": "高雄市前鎮區前鎮街196號一樓及地下室",
    "pkey": "017638",
    "tel": "07-8215676"
}, {
    "name": "全家高雄摩天店",
    "addr": "高雄市前鎮區新光路21號",
    "pkey": "015879",
    "tel": "07-5370771"
}, {
    "name": "全家高雄瑞北店",
    "addr": "高雄市前鎮區瑞北路213號",
    "pkey": "017240",
    "tel": "07-7165125"
}, {
    "name": "全家高雄瑞和店",
    "addr": "高雄市前鎮區瑞和街173號",
    "pkey": "014760",
    "tel": "07-7252435"
}, {
    "name": "全家高雄翠北店",
    "addr": "高雄市前鎮區翠亨北路562號",
    "pkey": "017047",
    "tel": "07-8416158"
}, {
    "name": "全家高雄德安店",
    "addr": "高雄市前鎮區德昌路141號",
    "pkey": "016373",
    "tel": "07-8318715"
}, {
    "name": "全家高雄鄭和店",
    "addr": "高雄市前鎮區鄭和南路420之1號",
    "pkey": "017001",
    "tel": "07-5369556"
}, {
    "name": "全家高雄高中店",
    "addr": "高雄市前鎮區鎮中路145號1樓",
    "pkey": "011951",
    "tel": "07-8218783"
}, ], [{
    "name": "全家高雄安康店",
    "addr": "高雄市三民區九如一路889—4號",
    "pkey": "015258",
    "tel": "07-3806874"
}, {
    "name": "全家高雄如順店",
    "addr": "高雄市三民區九如一路530號",
    "pkey": "016675",
    "tel": "07-3807586"
}, {
    "name": "全家高雄龍江店",
    "addr": "高雄市三民區九如二路138號",
    "pkey": "012802",
    "tel": "07-3219600"
}, {
    "name": "全家高雄力行店",
    "addr": "高雄市三民區力行路154號",
    "pkey": "017048",
    "tel": "07-3161730"
}, {
    "name": "全家高雄醫大店",
    "addr": "高雄市三民區十全一路100號",
    "pkey": "015080",
    "tel": "07-3223316"
}, {
    "name": "全家高雄得陽店",
    "addr": "高雄市三民區大昌二路309-1號",
    "pkey": "012495",
    "tel": "07-3819572"
}, {
    "name": "全家高雄褒忠店",
    "addr": "高雄市三民區大昌二路119之2號1樓",
    "pkey": "015418",
    "tel": "07-3954767"
}, {
    "name": "全家高雄大興店",
    "addr": "高雄市三民區大裕路38號",
    "pkey": "012442",
    "tel": "07-3955446"
}, {
    "name": "全家高雄新裕店",
    "addr": "高雄市三民區大裕路259號",
    "pkey": "016471",
    "tel": "07-3926084"
}, {
    "name": "全家高雄春豐店",
    "addr": "高雄市三民區大豐二路457號",
    "pkey": "016676",
    "tel": "07-3908499"
}, {
    "name": "全家高雄九華店",
    "addr": "高雄市三民區中華二路142號",
    "pkey": "014981",
    "tel": "07-3231347"
}, {
    "name": "全家高雄鼎新店",
    "addr": "高雄市三民區天祥一路42號1樓",
    "pkey": "014727",
    "tel": "07-3421085"
}, {
    "name": "全家高雄安和店",
    "addr": "高雄市三民區北平一街153號，155號，157號",
    "pkey": "016278",
    "tel": "07-3226098"
}, {
    "name": "全家高雄民如店",
    "addr": "高雄市三民區民族一路13號",
    "pkey": "017382",
    "tel": "07-3221178"
}, {
    "name": "全家高雄吉林店",
    "addr": "高雄市三民區吉林街155號．157號",
    "pkey": "016677",
    "tel": "07-3234557"
}, {
    "name": "全家高雄醫學店",
    "addr": "高雄市三民區三民區自由一路100號",
    "pkey": "016512",
    "tel": "07-3229985"
}, {
    "name": "全家高雄醫學二店",
    "addr": "高雄市三民區自由一路100號地下室",
    "pkey": "016546",
    "tel": "07-3223916"
}, {
    "name": "全家高雄運河店",
    "addr": "高雄市三民區自立一路71號",
    "pkey": "017233",
    "tel": "07-2858179"
}, {
    "name": "全家高雄延慶店",
    "addr": "高雄市三民區第二安發里延慶街113號一樓",
    "pkey": "016410",
    "tel": "07-3890250"
}, {
    "name": "全家高雄明哲店",
    "addr": "高雄市三民區明賢路38號一樓及地下室",
    "pkey": "015117",
    "tel": "07-3506241"
}, {
    "name": "全家高雄鼎中店",
    "addr": "高雄市三民區金鼎路358號",
    "pkey": "012801",
    "tel": "07-3493468"
}, {
    "name": "全家高雄建工店",
    "addr": "高雄市三民區建元路11號1樓",
    "pkey": "014479",
    "tel": "07-3924464"
}, {
    "name": "全家高雄鑫讚店",
    "addr": "高雄市三民區建國二路265之1號",
    "pkey": "013417",
    "tel": "07-2364102"
}, {
    "name": "全家高雄長明店",
    "addr": "高雄市三民區建國二路66號1樓",
    "pkey": "012539",
    "tel": "07-2366674"
}, {
    "name": "全家高雄建興店",
    "addr": "高雄市三民區建興路274號",
    "pkey": "015137",
    "tel": "07-3875891"
}, {
    "name": "全家高雄建武店",
    "addr": "高雄市三民區建興路79號1樓",
    "pkey": "014915",
    "tel": "07-3906846"
}, {
    "name": "全家高雄建德店",
    "addr": "高雄市三民區建興路151號",
    "pkey": "016452",
    "tel": "07-3854179"
}, {
    "name": "全家高雄重慶店",
    "addr": "高雄市三民區重慶街269號",
    "pkey": "013545",
    "tel": "07-3229637"
}, {
    "name": "全家高雄凱歌店",
    "addr": "高雄市三民區凱歌路87號",
    "pkey": "015839",
    "tel": "07-2255938"
}, {
    "name": "全家高雄陽明店",
    "addr": "高雄市三民區陽明路196號",
    "pkey": "017419",
    "tel": "07-3875240"
}, {
    "name": "全家高雄黃興店",
    "addr": "高雄市三民區陽明路418號，420號",
    "pkey": "017337",
    "tel": "07-3905476"
}, {
    "name": "全家高雄興融店",
    "addr": "高雄市三民區黃興路168號1樓",
    "pkey": "014009",
    "tel": "07-3811409"
}, {
    "name": "全家高雄義明店",
    "addr": "高雄市三民區義明街1號3號1樓",
    "pkey": "015618",
    "tel": "07-3854002"
}, {
    "name": "全家高雄鼎華店",
    "addr": "高雄市三民區鼎山街592號一樓",
    "pkey": "014201",
    "tel": "07-3945405"
}, {
    "name": "全家高雄鼎勇店",
    "addr": "高雄市三民區鼎山街300號．302號1樓",
    "pkey": "015937",
    "tel": "07-3943089"
}, {
    "name": "全家高雄鼎祥店",
    "addr": "高雄市三民區鼎祥街73號",
    "pkey": "015902",
    "tel": "07-3463667"
}, {
    "name": "全家高雄鼎貴店",
    "addr": "高雄市三民區鼎貴路208號1樓",
    "pkey": "015139",
    "tel": "07-3475162"
}, {
    "name": "全家高雄壽昌店",
    "addr": "高雄市三民區壽昌路93號1樓",
    "pkey": "015841",
    "tel": "07-3854009"
}, {
    "name": "全家高雄安東店",
    "addr": "高雄市三民區察哈爾一街50號",
    "pkey": "011266",
    "tel": "07-3226298"
}, {
    "name": "全家高雄清華店",
    "addr": "高雄市三民區澄和路65號1＆2樓",
    "pkey": "015949",
    "tel": "07-3986587"
}, {
    "name": "全家高雄覺禮店",
    "addr": "高雄市三民區覺民路38號",
    "pkey": "013071",
    "tel": "07-3947337"
}, ], [{
    "name": "全家高雄土庫店",
    "addr": "高雄市楠梓區土庫二路152號一樓、二樓",
    "pkey": "016258",
    "tel": "07-3537481"
}, {
    "name": "全家高雄清豐店",
    "addr": "高雄市楠梓區土庫路61號一樓",
    "pkey": "017570",
    "tel": "07-3530309"
}, {
    "name": "全家高雄高大店",
    "addr": "高雄市楠梓區大學路700號",
    "pkey": "015817",
    "tel": "07-3644465"
}, {
    "name": "全家日月光十一店",
    "addr": "高雄市楠梓區中央路22號十一樓",
    "pkey": "016085",
    "tel": "07-3640091"
}, {
    "name": "全家日月光十二店",
    "addr": "高雄市楠梓區內環北路115號",
    "pkey": "012328",
    "tel": "07-3649535"
}, {
    "name": "全家日月光七店",
    "addr": "高雄市楠梓區內環北路109號2樓",
    "pkey": "015905",
    "tel": "07-3640010"
}, {
    "name": "全家高雄加宏店",
    "addr": "高雄市楠梓區加宏路120＆122號",
    "pkey": "015501",
    "tel": "07-3656976"
}, {
    "name": "全家高雄右昌店",
    "addr": "高雄市楠梓區右昌街221號",
    "pkey": "015107",
    "tel": "07-3609679"
}, {
    "name": "全家日月光八店",
    "addr": "高雄市楠梓區西五街10號B1",
    "pkey": "010662",
    "tel": "07-3646310"
}, {
    "name": "全家高雄後新店",
    "addr": "高雄市楠梓區後昌新路1-1號",
    "pkey": "017658",
    "tel": "07-3645759"
}, {
    "name": "全家高雄後勁店",
    "addr": "高雄市楠梓區後昌路131號1樓",
    "pkey": "016567",
    "tel": "07-3657187"
}, {
    "name": "全家高雄德祥店",
    "addr": "高雄市楠梓區海專路401號",
    "pkey": "017281",
    "tel": "07-3650715"
}, {
    "name": "全家高雄常德店",
    "addr": "高雄市楠梓區常德路320號一樓與二樓四坪空間",
    "pkey": "013369",
    "tel": "07-3521889"
}, {
    "name": "全家高雄新創店",
    "addr": "高雄市楠梓區創新路86號",
    "pkey": "016725",
    "tel": "07-3539693"
}, {
    "name": "全家高雄德昌店",
    "addr": "高雄市楠梓區惠民路220號",
    "pkey": "014525",
    "tel": "07-3606402"
}, {
    "name": "全家高雄惠豐店",
    "addr": "高雄市楠梓區惠豐街166號168號一樓",
    "pkey": "016083",
    "tel": "07-3657425"
}, {
    "name": "全家日月光九店",
    "addr": "高雄市楠梓區開發路73號",
    "pkey": "010663",
    "tel": "07-3641704"
}, {
    "name": "全家日月光三店",
    "addr": "高雄市楠梓區開發路47號",
    "pkey": "010637",
    "tel": "07-3654946"
}, {
    "name": "全家高雄鑫昌店",
    "addr": "高雄市楠梓區新昌街39-1號",
    "pkey": "016666",
    "tel": "07-3636041"
}, {
    "name": "全家日月光一店",
    "addr": "高雄市楠梓區經三路26號地下一層",
    "pkey": "010561",
    "tel": "07-3655126"
}, {
    "name": "全家日月光五店",
    "addr": "高雄市楠梓區經六路66號",
    "pkey": "010562",
    "tel": "07-3624493"
}, {
    "name": "全家高雄德中店",
    "addr": "高雄市楠梓區德中路110號",
    "pkey": "014980",
    "tel": "07-5911758"
}, {
    "name": "全家高雄民昌店",
    "addr": "高雄市楠梓區德民路989之2號一樓",
    "pkey": "017231",
    "tel": "07-3635456"
}, {
    "name": "全家高雄東賢店",
    "addr": "高雄市楠梓區德賢路382、384號",
    "pkey": "011121",
    "tel": "07-3606800"
}, {
    "name": "全家高雄興德店",
    "addr": "高雄市楠梓區興楠路149—1號1樓",
    "pkey": "015740",
    "tel": "07-3535902"
}, {
    "name": "全家高雄興楠店",
    "addr": "高雄市楠梓區興楠路354號1樓",
    "pkey": "013072",
    "tel": "07-3541426"
}, {
    "name": "全家高雄藍天店",
    "addr": "高雄市楠梓區藍昌路358號",
    "pkey": "012620",
    "tel": "07-3659782"
}, ], [{
    "name": "全家高雄民益店",
    "addr": "高雄市小港區二苓路246號",
    "pkey": "017550",
    "tel": "07-8016432"
}, {
    "name": "全家高雄機場店",
    "addr": "高雄市小港區中山四路2號一樓部分",
    "pkey": "015522",
    "tel": "07-8068559"
}, {
    "name": "全家高雄旭日店",
    "addr": "高雄市小港區中安路926號",
    "pkey": "014649",
    "tel": "07-7930446"
}, {
    "name": "全家高雄山明店",
    "addr": "高雄市小港區松和路2號",
    "pkey": "017590",
    "tel": "07-8062353"
}, {
    "name": "全家高雄沿海店",
    "addr": "高雄市小港區沿海一路397之5號",
    "pkey": "014223",
    "tel": "07-8070902"
}, {
    "name": "全家高雄桂陽店",
    "addr": "高雄市小港區桂陽路210號",
    "pkey": "016129",
    "tel": "07-7934389"
}, {
    "name": "全家高雄大坪頂店",
    "addr": "高雄市小港區高坪二十二路471號一樓",
    "pkey": "017589",
    "tel": "07-8912787"
}, {
    "name": "全家高雄崇明店",
    "addr": "高雄市小港區崇明街160號1樓",
    "pkey": "017537",
    "tel": "07-8314833"
}, {
    "name": "全家高雄康莊店",
    "addr": "高雄市小港區康莊路183號",
    "pkey": "013752",
    "tel": "07-8070804"
}, {
    "name": "全家高雄中安店",
    "addr": "高雄市小港區廈莊一街168號",
    "pkey": "016867",
    "tel": "07-7932921"
}, {
    "name": "全家高雄漢民店",
    "addr": "高雄市小港區漢民路501號1樓",
    "pkey": "016812",
    "tel": "07-8032604"
}, {
    "name": "全家高雄漢中店",
    "addr": "高雄市小港區漢民路326、328號1樓",
    "pkey": "013990",
    "tel": "07-8068192"
}, {
    "name": "全家高雄漢苓店",
    "addr": "高雄市小港區漢民路169號",
    "pkey": "013418",
    "tel": "07-8023983"
}, {
    "name": "全家高雄宏光店",
    "addr": "高雄市小港區漢民路786號",
    "pkey": "015417",
    "tel": "07-8067310"
}, {
    "name": "全家高雄大林蒲店",
    "addr": "高雄市小港區鳳林路99號一樓",
    "pkey": "016558",
    "tel": "07-8715898"
}, {
    "name": "全家高雄金鋼店",
    "addr": "高雄市小港區鋼平街150號",
    "pkey": "014289",
    "tel": "07-8222473"
}, ], [{
    "name": "全家高雄蓮潭店",
    "addr": "高雄市左營區孔營路25號",
    "pkey": "015707",
    "tel": "07-5852747"
}, {
    "name": "全家高雄文萊店",
    "addr": "高雄市左營區文萊路325號",
    "pkey": "010592",
    "tel": "07-3503463"
}, {
    "name": "全家高雄左大店",
    "addr": "高雄市左營區左營大路248號．250號",
    "pkey": "017441",
    "tel": "07-5882327"
}, {
    "name": "全家高雄立信店",
    "addr": "高雄市左營區立信路209號",
    "pkey": "016982",
    "tel": "07-5565617"
}, {
    "name": "全家高雄光興店",
    "addr": "高雄市左營區光興街60號",
    "pkey": "017185",
    "tel": "07-5565991"
}, {
    "name": "全家高雄陸戰店",
    "addr": "高雄市左營區先鋒路9號",
    "pkey": "015156",
    "tel": "07-5871428"
}, {
    "name": "全家高雄孟文店",
    "addr": "高雄市左營區孟子路365號一樓",
    "pkey": "015356",
    "tel": "07-3453208"
}, {
    "name": "全家高雄孟立店",
    "addr": "高雄市左營區孟子路109號一樓",
    "pkey": "013130",
    "tel": "07-3500492"
}, {
    "name": "全家高雄孟子店",
    "addr": "高雄市左營區孟子路515號一樓",
    "pkey": "016613",
    "tel": "07-3105707"
}, {
    "name": "全家高雄富華店",
    "addr": "高雄市左營區明華一路199號1樓",
    "pkey": "014500",
    "tel": "07-5567836"
}, {
    "name": "全家高雄果豐店",
    "addr": "高雄市左營區果峰街12巷42號",
    "pkey": "016251",
    "tel": "07-5888743"
}, {
    "name": "全家高雄新勝店",
    "addr": "高雄市左營區南屏路313號",
    "pkey": "015997",
    "tel": "07-5226814"
}, {
    "name": "全家高雄重愛店",
    "addr": "高雄市左營區重愛路208號",
    "pkey": "015152",
    "tel": "07-3462436"
}, {
    "name": "全家高雄新海店",
    "addr": "高雄市左營區海功路2號1樓",
    "pkey": "017217",
    "tel": "07-5882056"
}, {
    "name": "全家高雄富國店",
    "addr": "高雄市左營區富國路48號一樓",
    "pkey": "011303",
    "tel": "07-5590732"
}, {
    "name": "全家高雄曾德店",
    "addr": "高雄市左營區曾子路501號1樓",
    "pkey": "016167",
    "tel": "07-3503824"
}, {
    "name": "全家高雄華山店",
    "addr": "高雄市左營區華夏路1761號壹樓",
    "pkey": "015077",
    "tel": "07-3418769"
}, {
    "name": "全家高雄華夏店",
    "addr": "高雄市左營區華夏路1168號1樓",
    "pkey": "010818",
    "tel": "07-3454328"
}, {
    "name": "全家高雄新庄店",
    "addr": "高雄市左營區新庄仔路700號",
    "pkey": "013953",
    "tel": "07-5565745"
}, {
    "name": "全家高雄華珍店",
    "addr": "高雄市左營區新莊一路143號",
    "pkey": "015355",
    "tel": "07-3412687"
}, {
    "name": "全家高雄佑德店",
    "addr": "高雄市左營區榮佑路67號，69號1樓",
    "pkey": "014850",
    "tel": "07-3420711"
}, {
    "name": "全家高雄福榮店",
    "addr": "高雄市左營區榮總路225號",
    "pkey": "016813",
    "tel": "07-3508483"
}, ], [{
    "name": "全家仁武八德店",
    "addr": "高雄市仁武區八德一路422號一樓",
    "pkey": "012418",
    "tel": "07-3758737"
}, {
    "name": "全家仁武仁龍店",
    "addr": "高雄市仁武區仁林路190號壹樓",
    "pkey": "004300",
    "tel": "07-3720423"
}, {
    "name": "全家仁武澄合店",
    "addr": "高雄市仁武區仁雄路35號一樓",
    "pkey": "015078",
    "tel": "07-3740898"
}, {
    "name": "全家仁武大灣店",
    "addr": "高雄市仁武區仁雄路92之3號一樓",
    "pkey": "011952",
    "tel": "07-3735879"
}, {
    "name": "全家仁武仁德店",
    "addr": "高雄市仁武區仁德巷68號",
    "pkey": "014248",
    "tel": "07-3732142"
}, {
    "name": "全家仁武仁塑店",
    "addr": "高雄市仁武區水管路181號",
    "pkey": "016015",
    "tel": "07-3747416"
}, {
    "name": "全家仁武鳳仁店",
    "addr": "高雄市仁武區鳳仁路45號",
    "pkey": "015136",
    "tel": "07-3741130"
}, {
    "name": "全家仁武澄觀店",
    "addr": "高雄市仁武區澄觀路一段1111號",
    "pkey": "013837",
    "tel": "07-3724926"
}, ], [{
    "name": "全家大社翠屏店",
    "addr": "高雄市大社區中山路350號",
    "pkey": "016110",
    "tel": "07-3551977"
}, ], [{
    "name": "全家岡山竹東店",
    "addr": "高雄市岡山區下竹圍東街167號",
    "pkey": "016339",
    "tel": "07-6214752"
}, {
    "name": "全家岡山飛行店",
    "addr": "高雄市岡山區久和路1之1號",
    "pkey": "016612",
    "tel": "07-6254866"
}, {
    "name": "全家岡山竹圍店",
    "addr": "高雄市岡山區中山北路158號1樓＆2樓",
    "pkey": "014410",
    "tel": "07-6227977"
}, {
    "name": "全家岡山忠誠店",
    "addr": "高雄市岡山區成功路97號一樓",
    "pkey": "014758",
    "tel": "07-6217220"
}, {
    "name": "全家岡山平和店",
    "addr": "高雄市岡山區岡山路277之1號1樓",
    "pkey": "014759",
    "tel": "07-6214732"
}, {
    "name": "全家岡山岡燕店",
    "addr": "高雄市岡山區岡燕路289號一至二樓",
    "pkey": "014135",
    "tel": "07-6228970"
}, {
    "name": "全家岡山壽峰店",
    "addr": "高雄市岡山區前峰路130-4號",
    "pkey": "013274",
    "tel": "07-6258232"
}, {
    "name": "全家岡山柳橋店",
    "addr": "高雄市岡山區柳橋西路一段27號",
    "pkey": "016908",
    "tel": "07-6259480"
}, {
    "name": "全家岡山嘉興店",
    "addr": "高雄市岡山區嘉興路374之10號1號",
    "pkey": "017616",
    "tel": "07-6211081"
}, ], [{
    "name": "全家路竹一甲店",
    "addr": "高雄市路竹區大仁路326號1樓",
    "pkey": "016526",
    "tel": "07-6970649"
}, {
    "name": "全家路竹竹東店",
    "addr": "高雄市路竹區中山路711號",
    "pkey": "014927",
    "tel": "07-6964823"
}, {
    "name": "全家路竹中興店",
    "addr": "高雄市路竹區中興路150-4號1樓",
    "pkey": "015447",
    "tel": "07-6962607"
}, {
    "name": "全家路竹樹人店",
    "addr": "高雄市路竹區21鄰環球路452號",
    "pkey": "015259",
    "tel": "07-6074623"
}, ], [{
    "name": "全家阿蓮忠孝店",
    "addr": "高雄市阿蓮區忠孝路232號。236號1樓",
    "pkey": "015677",
    "tel": "07-6311535"
}, ], [{
    "name": "全家高雄科大店",
    "addr": "高雄市燕巢區大學路1號學生活動中心一樓",
    "pkey": "013172",
    "tel": "07-6011838"
}, {
    "name": "全家燕巢新民店",
    "addr": "高雄市燕巢區中民路535號一樓",
    "pkey": "017297",
    "tel": "07-6142940"
}, {
    "name": "全家燕巢義大店",
    "addr": "高雄市燕巢區義大路8號",
    "pkey": "015838",
    "tel": "07-6152029"
}, {
    "name": "全家燕巢義醫店",
    "addr": "高雄市燕巢區義大路1號地下一樓",
    "pkey": "012770",
    "tel": "07-6156587"
}, ], [{
    "name": "全家橋頭建樹店",
    "addr": "高雄市橋頭區成功北路65、67、69號1樓",
    "pkey": "017538",
    "tel": "07-6128915"
}, {
    "name": "全家橋頭合興店",
    "addr": "高雄市橋頭區樹德路75-8號",
    "pkey": "016950",
    "tel": "07-6119030"
}, {
    "name": "全家橋頭糖廠店",
    "addr": "高雄市橋頭區糖廠路2-1號一樓",
    "pkey": "017232",
    "tel": "07-6118547"
}, ], [{
    "name": "全家梓官光明店",
    "addr": "高雄市梓官區光明路125號127號1樓",
    "pkey": "012779",
    "tel": "07-6109286"
}, {
    "name": "全家梓官梓興店",
    "addr": "高雄市梓官區進學路27號1樓",
    "pkey": "014035",
    "tel": "07-6103981"
}, {
    "name": "全家梓官蚵仔寮店",
    "addr": "高雄市梓官區漁港二路13號",
    "pkey": "017746",
    "tel": "07-6107313"
}, ], [{
    "name": "全家彌陀虱目魚店",
    "addr": "高雄市彌陀區中正路50號一樓",
    "pkey": "015776",
    "tel": "07-6101475"
}, ], [{
    "name": "全家永安保安店",
    "addr": "高雄市永安區保安路130-2號",
    "pkey": "016821",
    "tel": "07-6914009"
}, ], [{
    "name": "全家湖內大湖店",
    "addr": "高雄市湖內區中山路一段493號",
    "pkey": "014728",
    "tel": "07-6930921"
}, {
    "name": "全家湖內中華店",
    "addr": "高雄市湖內區中華街251號1樓",
    "pkey": "016001",
    "tel": "07-6994234"
}, {
    "name": "全家湖內正億店",
    "addr": "高雄市湖內區正義一路210號",
    "pkey": "011729",
    "tel": "07-6936985"
}, ], [{
    "name": "全家鳳山三誠店",
    "addr": "高雄市鳳山區三誠路99號",
    "pkey": "015217",
    "tel": "07-8154389"
}, {
    "name": "全家鳳山忠義店",
    "addr": "高雄市鳳山區中山西路366，368號",
    "pkey": "014901",
    "tel": "07-7471958"
}, {
    "name": "全家鳳山埤頂店",
    "addr": "高雄市鳳山區中山東路545號一樓",
    "pkey": "013127",
    "tel": "07-7021821"
}, {
    "name": "全家鳳山鳳翔店",
    "addr": "高雄市鳳山區中山東路234巷53號",
    "pkey": "012690",
    "tel": "07-7022294"
}, {
    "name": "全家鳳山鳳埤店",
    "addr": "高雄市鳳山區中山東路292號",
    "pkey": "016690",
    "tel": "07-7031187"
}, {
    "name": "全家鳳山繁華店",
    "addr": "高雄市鳳山區中山路151號壹樓",
    "pkey": "017049",
    "tel": "07-7406974"
}, {
    "name": "全家鳳山中崙店",
    "addr": "高雄市鳳山區中崙四路1號",
    "pkey": "012596",
    "tel": "07-7535784"
}, {
    "name": "全家鳳山光華店",
    "addr": "高雄市鳳山區五甲一路149號",
    "pkey": "016488",
    "tel": "07-7901684"
}, {
    "name": "全家鳳山甲二店",
    "addr": "高雄市鳳山區五甲二路99號",
    "pkey": "017502",
    "tel": "07-7685159"
}, {
    "name": "全家鳳山新福店",
    "addr": "高雄市鳳山區五福二路115號",
    "pkey": "015804",
    "tel": "07-7689717"
}, {
    "name": "全家鳳山天興店",
    "addr": "高雄市鳳山區天興街53號",
    "pkey": "017117",
    "tel": "07-8230826"
}, {
    "name": "全家鳳山平等店",
    "addr": "高雄市鳳山區平等路41-1號",
    "pkey": "016048",
    "tel": "07-7408446"
}, {
    "name": "全家鳳山鳳凌店",
    "addr": "高雄市鳳山區立志街166號1樓",
    "pkey": "015076",
    "tel": "07-7425341"
}, {
    "name": "全家鳳山聖王店",
    "addr": "高雄市鳳山區光復路一段52號一樓",
    "pkey": "015982",
    "tel": "07-7191152"
}, {
    "name": "全家鳳山興仁店",
    "addr": "高雄市鳳山區光華路67號",
    "pkey": "016211",
    "tel": "07-7194539"
}, {
    "name": "全家鳳山自強店",
    "addr": "高雄市鳳山區自強二路147號，149號",
    "pkey": "017636",
    "tel": "07-8314209"
}, {
    "name": "全家鳳山文華店",
    "addr": "高雄市鳳山區青年路二段171號",
    "pkey": "015719",
    "tel": "07-7805255"
}, {
    "name": "全家鳳山文山店",
    "addr": "高雄市鳳山區青年路二段460號一樓",
    "pkey": "014551",
    "tel": "07-7778107"
}, {
    "name": "全家鳳山華興店",
    "addr": "高雄市鳳山區南華路171號1樓",
    "pkey": "016557",
    "tel": "07-7260571"
}, {
    "name": "全家鳳山南華店",
    "addr": "高雄市鳳山區南華路83號",
    "pkey": "017805",
    "tel": "07-7277379"
}, {
    "name": "全家鳳山善美店",
    "addr": "高雄市鳳山區南榮路83號一樓",
    "pkey": "017469",
    "tel": "07-7160451"
}, {
    "name": "全家鳳山海洋店",
    "addr": "高雄市鳳山區海洋一路127號，129號",
    "pkey": "012728",
    "tel": "07-7666342"
}, {
    "name": "全家鳳山興昌店",
    "addr": "高雄市鳳山區國光路50號",
    "pkey": "015021",
    "tel": "07-7455277"
}, {
    "name": "全家鳳山凱旋店",
    "addr": "高雄市鳳山區凱旋路265號",
    "pkey": "014465",
    "tel": "07-7636049"
}, {
    "name": "全家鳳山武營店",
    "addr": "高雄市鳳山區凱旋路437號1樓",
    "pkey": "016239",
    "tel": "07-7671475"
}, {
    "name": "全家鳳山新富店",
    "addr": "高雄市鳳山區新富路398號1樓",
    "pkey": "016338",
    "tel": "07-7668853"
}, {
    "name": "全家鳳山新強店",
    "addr": "高雄市鳳山區新富路210號",
    "pkey": "015303",
    "tel": "07-7675827"
}, {
    "name": "全家鳳山瑞興店",
    "addr": "高雄市鳳山區瑞興路120號",
    "pkey": "017052",
    "tel": "07-7191407"
}, {
    "name": "全家鳳山力行店",
    "addr": "高雄市鳳山區經武路316號",
    "pkey": "014979",
    "tel": "07-7100523"
}, {
    "name": "全家鳳山誠義店",
    "addr": "高雄市鳳山區誠義路119號",
    "pkey": "011945",
    "tel": "07-7406564"
}, {
    "name": "全家鳳山頂庄店",
    "addr": "高雄市鳳山區過勇路111號",
    "pkey": "013743",
    "tel": "07-7925213"
}, {
    "name": "全家鳳山鎮北店",
    "addr": "高雄市鳳山區鳳北路63號1樓。2樓",
    "pkey": "014978",
    "tel": "07-7337069"
}, {
    "name": "全家鳳山鳳東店",
    "addr": "高雄市鳳山區鳳東路520號",
    "pkey": "014916",
    "tel": "07-7823186"
}, {
    "name": "全家鳳山老爺店",
    "addr": "高雄市鳳山區鳳南路19號",
    "pkey": "016486",
    "tel": "07-7170515"
}, {
    "name": "全家鳳山教勤店",
    "addr": "高雄市鳳山區鳳頂路1000號教勤營大樓",
    "pkey": "016369",
    "tel": "07-7408273"
}, {
    "name": "全家鳳山金湯店",
    "addr": "高雄市鳳山區鳳頂路1000號105大樓",
    "pkey": "016370",
    "tel": "07-7406140"
}, {
    "name": "全家鳳山五甲店",
    "addr": "高雄市鳳山區錦田路193號",
    "pkey": "015617",
    "tel": "07-8313940"
}, {
    "name": "全家鳳山濱山店",
    "addr": "高雄市鳳山區濱山街15巷2號",
    "pkey": "016691",
    "tel": "07-7779419"
}, ], [{
    "name": "全家大發中庄店",
    "addr": "高雄市大寮區八德路32號",
    "pkey": "015306",
    "tel": "07-7031937"
}, {
    "name": "全家大發開封店",
    "addr": "高雄市大寮區大寮路630號632號1樓",
    "pkey": "017118",
    "tel": "07-7888382"
}, {
    "name": "全家大發仁愛店",
    "addr": "高雄市大寮區仁愛路22號",
    "pkey": "014480",
    "tel": "07-7012590"
}, {
    "name": "全家大發輔大二店",
    "addr": "高雄市大寮區進學路151號",
    "pkey": "014370",
    "tel": "07-7826753"
}, {
    "name": "全家大發輔大店",
    "addr": "高雄市大寮區進學路151號",
    "pkey": "014761",
    "tel": "07-7833608"
}, {
    "name": "全家大發萬翁店",
    "addr": "高雄市大寮區萬丹路545號",
    "pkey": "017298",
    "tel": "07-7832602"
}, {
    "name": "全家大發新發店",
    "addr": "高雄市大寮區鳳林三路405號",
    "pkey": "017492",
    "tel": "07-7835368"
}, ], [{
    "name": "全家林園文林店",
    "addr": "高雄市林園區東林西路137號",
    "pkey": "011846",
    "tel": "07-6417056"
}, {
    "name": "全家林園鑫園店",
    "addr": "高雄市林園區林園北路439號一樓",
    "pkey": "014835",
    "tel": "07-6417592"
}, {
    "name": "全家林園海洋店",
    "addr": "高雄市林園區漁港路87號",
    "pkey": "017493",
    "tel": "07-6410558"
}, {
    "name": "全家林園鳳林店",
    "addr": "高雄市林園區鳳林路一段92號",
    "pkey": "017418",
    "tel": "07-6436091"
}, ], [{
    "name": "全家鳥松高庚店",
    "addr": "高雄市鳥松區鳥松區大華里大埤路123號B1",
    "pkey": "017080",
    "tel": "07-7355028"
}, {
    "name": "全家鳥松大仁店",
    "addr": "高雄市鳥松區大仁南路1號一樓",
    "pkey": "015698",
    "tel": "07-7353830"
}, {
    "name": "全家鳥松星光店",
    "addr": "高雄市鳥松區大埤路123號一樓",
    "pkey": "017649",
    "tel": "07-7354577"
}, {
    "name": "全家鳥松濱湖店",
    "addr": "高雄市鳥松區文前路3巷21-1號",
    "pkey": "012015",
    "tel": "07-7352906"
}, {
    "name": "全家鳥松觀湖店",
    "addr": "高雄市鳥松區松埔北巷4-205號",
    "pkey": "015138",
    "tel": "07-7354728"
}, {
    "name": "全家鳥松大華店",
    "addr": "高雄市鳥松區球場路75號1樓",
    "pkey": "014550",
    "tel": "07-3709772"
}, {
    "name": "全家鳥松仁美店",
    "addr": "高雄市鳥松區學堂路91-1號",
    "pkey": "013586",
    "tel": "07-7333641"
}, ], [{
    "name": "全家大樹水興店",
    "addr": "高雄市大樹區中山路174號",
    "pkey": "016017",
    "tel": "07-6526780"
}, {
    "name": "全家大樹鳳荔店",
    "addr": "高雄市大樹區實踐路61號（一二三四間）",
    "pkey": "010520",
    "tel": "07-6520498"
}, {
    "name": "全家大樹義城店",
    "addr": "高雄市大樹區學城路一段12號（商店街12，13號）",
    "pkey": "013801",
    "tel": "07-6568076"
}, {
    "name": "全家大樹義邦店",
    "addr": "高雄市大樹區學城路一段12號Ｃ3F08",
    "pkey": "013802",
    "tel": "07-6568082"
}, {
    "name": "全家大樹義大一店",
    "addr": "高雄市大樹區學城路一段1號（學生活動中心）",
    "pkey": "016487",
    "tel": "07-6578913"
}, {
    "name": "全家大樹義大二店",
    "addr": "高雄市大樹區學城路一段8巷2號地下1樓",
    "pkey": "016489",
    "tel": "07-6577938"
}, ], [{
    "name": "全家旗山車站店",
    "addr": "高雄市旗山區大同街23號",
    "pkey": "014290",
    "tel": "07-6626300"
}, ], [{
    "name": "全家美濃泰安店",
    "addr": "高雄市美濃區中正路一段53號",
    "pkey": "015113",
    "tel": "07-6812061"
}, {
    "name": "全家美濃中興店",
    "addr": "高雄市美濃區中興路一段819號",
    "pkey": "016063",
    "tel": "07-6816160"
}, ], [{
    "name": "全家六龜農會店",
    "addr": "高雄市六龜區光復路109號",
    "pkey": "015157",
    "tel": "07-6891095"
}, ], [{
    "name": "全家杉林農會店",
    "addr": "高雄市杉林區清水路45號",
    "pkey": "015948",
    "tel": "07-6774509"
}, ], [{
    "name": "全家茄萣民治店",
    "addr": "高雄市茄萣區民治路101號1＆2＆3樓",
    "pkey": "016863",
    "tel": "07-6988573"
}, {
    "name": "全家茄萣白砂崙店",
    "addr": "高雄市茄萣區白砂路243號1樓",
    "pkey": "014501",
    "tel": "07-6903182"
}, ], ], [[{
    "name": "全家屏東安心店",
    "addr": "屏東縣屏東市安心四橫巷449號",
    "pkey": "017629",
    "tel": "08-7215756"
}, {
    "name": "全家屏東大崇店",
    "addr": "屏東縣屏東市大同北路102號",
    "pkey": "015382",
    "tel": "08-7327312"
}, {
    "name": "全家屏東正裕店",
    "addr": "屏東縣屏東市中正路688-1號",
    "pkey": "014403",
    "tel": "08-7367146"
}, {
    "name": "全家屏東愛園店",
    "addr": "屏東縣屏東市公園路21號1樓",
    "pkey": "016057",
    "tel": "08-7329836"
}, {
    "name": "全家屏東民榮店",
    "addr": "屏東縣屏東市民生路12-2．12-3號",
    "pkey": "016225",
    "tel": "08-7224302"
}, {
    "name": "全家屏東大埔店",
    "addr": "屏東縣屏東市民族路303號一樓",
    "pkey": "011639",
    "tel": "08-7326415"
}, {
    "name": "全家屏東屏榮店",
    "addr": "屏東縣屏東市民學路148號一樓",
    "pkey": "013446",
    "tel": "08-7211895"
}, {
    "name": "全家屏東華盛店",
    "addr": "屏東縣屏東市永大路66號一樓",
    "pkey": "012598",
    "tel": "08-7517627"
}, {
    "name": "全家屏東長安店",
    "addr": "屏東縣屏東市光復路348號一樓",
    "pkey": "012563",
    "tel": "08-7321979"
}, {
    "name": "全家屏東中華店",
    "addr": "屏東縣屏東市自由路422號",
    "pkey": "016592",
    "tel": "08-7361342"
}, {
    "name": "全家屏東民享店",
    "addr": "屏東縣屏東市林森路23號1樓",
    "pkey": "016350",
    "tel": "08-7217523"
}, {
    "name": "全家屏東武成店",
    "addr": "屏東縣屏東市武成街82-5號",
    "pkey": "013463",
    "tel": "08-7515082"
}, {
    "name": "全家屏東昌賢店",
    "addr": "屏東縣屏東市建民路63號",
    "pkey": "016879",
    "tel": "08-7514933"
}, {
    "name": "全家屏東華敬店",
    "addr": "屏東縣屏東市莊敬街一段29號",
    "pkey": "017420",
    "tel": "08-7364107"
}, {
    "name": "全家屏東徐州店",
    "addr": "屏東縣屏東市勝利路197之6．197之7號",
    "pkey": "017635",
    "tel": "08-7322293"
}, {
    "name": "全家屏東瑞光店",
    "addr": "屏東縣屏東市瑞光路二段86號",
    "pkey": "013125",
    "tel": "08-7210590"
}, {
    "name": "全家屏東福光店",
    "addr": "屏東縣屏東市廣東南路90號1樓",
    "pkey": "014526",
    "tel": "08-7519167"
}, {
    "name": "全家屏東勝利店",
    "addr": "屏東縣屏東市廣東路961號",
    "pkey": "017053",
    "tel": "08-7323220"
}, {
    "name": "全家屏東豐榮店",
    "addr": "屏東縣屏東市廣東路458號一樓",
    "pkey": "014940",
    "tel": "08-7364252"
}, {
    "name": "全家屏東廣興店",
    "addr": "屏東縣屏東市廣東路722號",
    "pkey": "016277",
    "tel": "08-7364763"
}, {
    "name": "全家屏東公館店",
    "addr": "屏東縣屏東市龍華路178號",
    "pkey": "017696",
    "tel": "08-7518978"
}, {
    "name": "全家屏東歸來店",
    "addr": "屏東縣屏東市歸義巷34號一樓",
    "pkey": "013665",
    "tel": "08-7214149"
}, ], [{
    "name": "全家九如豐源店",
    "addr": "屏東縣九如鄉九如路二段173-1號",
    "pkey": "016432",
    "tel": "08-7395653"
}, {
    "name": "全家九如東寧店",
    "addr": "屏東縣九如鄉東寧路215號",
    "pkey": "015218",
    "tel": "08-7397995"
}, ], [{
    "name": "全家里港永樂店",
    "addr": "屏東縣里港鄉永樂路4＆6號",
    "pkey": "016371",
    "tel": "08-7756890"
}, ], [{
    "name": "全家高樹農會店",
    "addr": "屏東縣高樹鄉南興路141-5號",
    "pkey": "015196",
    "tel": "08-7967540"
}, ], [{
    "name": "全家鹽埔高朗店",
    "addr": "屏東縣鹽埔鄉高朗村三民路80-1號",
    "pkey": "013645",
    "tel": "08-7930385"
}, {
    "name": "全家鹽埔豐年店",
    "addr": "屏東縣鹽埔鄉光復路89號",
    "pkey": "015023",
    "tel": "08-7936175"
}, {
    "name": "全家鹽埔大仁店",
    "addr": "屏東縣鹽埔鄉維新路20號（學生餐廳）",
    "pkey": "014738",
    "tel": "08-7628180"
}, {
    "name": "全家鹽埔新圍店",
    "addr": "屏東縣鹽埔鄉維新路90之2號ㄧ樓",
    "pkey": "016967",
    "tel": "08-7937325"
}, ], [{
    "name": "全家長治繁華店",
    "addr": "屏東縣長治鄉繁華村中山路11-1號",
    "pkey": "016280",
    "tel": "08-7620282"
}, {
    "name": "全家長治交流店",
    "addr": "屏東縣長治鄉繁華村水源路195號",
    "pkey": "011220",
    "tel": "08-7626098"
}, {
    "name": "全家長治德和店",
    "addr": "屏東縣長治鄉德和路66號",
    "pkey": "016485",
    "tel": "08-7625826"
}, {
    "name": "全家長治合潭店",
    "addr": "屏東縣長治鄉潭頭路192-5號。192-6號",
    "pkey": "015840",
    "tel": "08-7216029"
}, ], [{
    "name": "全家麟洛麟趾店",
    "addr": "屏東縣麟洛鄉中山路417號",
    "pkey": "015718",
    "tel": "08-7212575"
}, ], [{
    "name": "全家竹田驛站店",
    "addr": "屏東縣竹田鄉中山路2號",
    "pkey": "016523",
    "tel": "08-7711776"
}, ], [{
    "name": "全家內埔豐田店",
    "addr": "屏東縣內埔鄉中正路453號",
    "pkey": "016089",
    "tel": "08-7783743"
}, {
    "name": "全家內埔文化店",
    "addr": "屏東縣內埔鄉中興路92號1樓",
    "pkey": "016866",
    "tel": "08-7782022"
}, {
    "name": "全家內埔光明店",
    "addr": "屏東縣內埔鄉內埔村光明路613號1樓",
    "pkey": "017296",
    "tel": "08-7789851"
}, {
    "name": "全家內埔埔勝店",
    "addr": "屏東縣內埔鄉南寧路164-1號",
    "pkey": "016865",
    "tel": "08-7784118"
}, {
    "name": "全家內埔壽比店",
    "addr": "屏東縣內埔鄉老埤村壽比路742號",
    "pkey": "015968",
    "tel": "08-7709493"
}, {
    "name": "全家內埔學苑店",
    "addr": "屏東縣內埔鄉壽比路228號一樓",
    "pkey": "016116",
    "tel": "08-7785950"
}, {
    "name": "全家內埔屏科大店",
    "addr": "屏東縣內埔鄉學府路1號",
    "pkey": "015878",
    "tel": "08-7740519"
}, ], [{
    "name": "全家萬丹萬鑫店",
    "addr": "屏東縣萬丹鄉萬丹路一段367號",
    "pkey": "014487",
    "tel": "08-7760552"
}, ], [{
    "name": "全家潮州三林店",
    "addr": "屏東縣潮州鎮三林路185號一樓",
    "pkey": "016535",
    "tel": "08-7898807"
}, {
    "name": "全家潮州長興店",
    "addr": "屏東縣潮州鎮長興路26號",
    "pkey": "016739",
    "tel": "08-7895965"
}, {
    "name": "全家潮州車頭店",
    "addr": "屏東縣潮州鎮新生路77號",
    "pkey": "014605",
    "tel": "08-7804081"
}, {
    "name": "全家潮州福星店",
    "addr": "屏東縣潮州鎮福星路351、353號1樓",
    "pkey": "016111",
    "tel": "08-7882133"
}, ], [{
    "name": "全家萬巒豬腳店",
    "addr": "屏東縣萬巒鄉民和路5號一樓、二樓部份",
    "pkey": "017136",
    "tel": "08-7813228"
}, ], [{
    "name": "全家崁頂文化店",
    "addr": "屏東縣崁頂鄉中正路188號",
    "pkey": "016622",
    "tel": "08-8635750"
}, ], [{
    "name": "全家新埤屏鵝店",
    "addr": "屏東縣新埤鄉新民路3號",
    "pkey": "017884",
    "tel": "08-7972105"
}, ], [{
    "name": "全家南州庄頭店",
    "addr": "屏東縣南州鄉三民路52之3號",
    "pkey": "015842",
    "tel": "08-8642843"
}, {
    "name": "全家南州壽元店",
    "addr": "屏東縣南州鄉勝利路5-10號1樓",
    "pkey": "010563",
    "tel": "08-8643455"
}, ], [{
    "name": "全家林邊中林店",
    "addr": "屏東縣林邊鄉中林路79號",
    "pkey": "015903",
    "tel": "08-8750150"
}, ], [{
    "name": "全家東港東隆店",
    "addr": "屏東縣東港鎮中正路55號1樓",
    "pkey": "013777",
    "tel": "08-8339381"
}, {
    "name": "全家東港安泰店",
    "addr": "屏東縣東港鎮中正路一段210號（安泰教學醫院）",
    "pkey": "011305",
    "tel": "08-8339579"
}, {
    "name": "全家東港長春店",
    "addr": "屏東縣東港鎮長春一路93號",
    "pkey": "014762",
    "tel": "08-8323957"
}, {
    "name": "全家東港東光店",
    "addr": "屏東縣東港鎮長春二路206號",
    "pkey": "012522",
    "tel": "08-8326703"
}, {
    "name": "全家東港碼頭店",
    "addr": "屏東縣東港鎮朝隆路6號",
    "pkey": "014249",
    "tel": "08-8323947"
}, {
    "name": "全家東港鮪魚店",
    "addr": "屏東縣東港鎮順漁路129號",
    "pkey": "017088",
    "tel": "08-8326592"
}, {
    "name": "全家東港興東店",
    "addr": "屏東縣東港鎮興東路49之2號",
    "pkey": "012655",
    "tel": "08-8338646"
}, ], [{
    "name": "全家琉球白沙店",
    "addr": "屏東縣琉球鄉民生路2之6號",
    "pkey": "017329",
    "tel": "08-8611797"
}, ], [{
    "name": "全家佳冬廣惠店",
    "addr": "屏東縣佳冬鄉中山路112號",
    "pkey": "015391",
    "tel": "08-8667881"
}, ], [{
    "name": "全家新園新東店",
    "addr": "屏東縣新園鄉新東路1號",
    "pkey": "014383",
    "tel": "08-8683432"
}, {
    "name": "全家新園興隆店",
    "addr": "屏東縣新園鄉鹽埔村鹽龍路158號。160號",
    "pkey": "016166",
    "tel": "08-8325028"
}, ], [{
    "name": "全家枋寮北店",
    "addr": "屏東縣枋寮鄉中山路二段180號",
    "pkey": "017300",
    "tel": "08-8716692"
}, {
    "name": "全家枋寮大嚮店",
    "addr": "屏東縣枋寮鄉中山路三段39號及其停車場",
    "pkey": "017283",
    "tel": "08-8713070"
}, {
    "name": "全家枋寮建興店",
    "addr": "屏東縣枋寮鄉建興路246號",
    "pkey": "016016",
    "tel": "08-8712053"
}, {
    "name": "全家枋寮隆山店",
    "addr": "屏東縣枋寮鄉隆山路80號",
    "pkey": "011165",
    "tel": "08-8787017"
}, {
    "name": "全家枋寮臨海店",
    "addr": "屏東縣枋寮鄉臨海路二段89號",
    "pkey": "015400",
    "tel": "08-8660321"
}, ], [{
    "name": "全家枋山觀海店",
    "addr": "屏東縣枋山鄉南和路80號",
    "pkey": "016279",
    "tel": "08-8761895"
}, ], [{
    "name": "全家獅子金流店",
    "addr": "屏東縣獅子鄉草埔村10鄰草埔6巷36號",
    "pkey": "017282",
    "tel": "08-8701236"
}, ], [{
    "name": "全家車城風車店",
    "addr": "屏東縣車城鄉中山路2-1號",
    "pkey": "016869",
    "tel": "08-8825476"
}, ], [{
    "name": "全家恆春麗園店",
    "addr": "屏東縣恆春鎮中正路128號",
    "pkey": "017216",
    "tel": "08-8880643"
}, {
    "name": "全家恆春北恆店",
    "addr": "屏東縣恆春鎮省北路37號",
    "pkey": "017114",
    "tel": "08-8880565"
}, {
    "name": "全家墾丁陽光店",
    "addr": "屏東縣恆春鎮墾丁路143號",
    "pkey": "010612",
    "tel": "08-8861316"
}, ], ], [[{
    "name": "全家澎湖鑫科店",
    "addr": "澎湖縣馬公市三多路118號",
    "pkey": "010949",
    "tel": "06-9265145"
}, {
    "name": "全家澎湖海洋店",
    "addr": "澎湖縣馬公市中正路46號",
    "pkey": "017155",
    "tel": "06-9269492"
}, {
    "name": "全家澎湖朝陽店",
    "addr": "澎湖縣馬公市中華路169號",
    "pkey": "017793",
    "tel": "06-9262242"
}, {
    "name": "全家澎湖民族店",
    "addr": "澎湖縣馬公市民族路58之2號",
    "pkey": "016719",
    "tel": "06-9266673"
}, {
    "name": "全家澎湖和田店",
    "addr": "澎湖縣馬公市民權路2號一樓",
    "pkey": "017342",
    "tel": "06-9267983"
}, {
    "name": "全家澎湖光復店",
    "addr": "澎湖縣馬公市光復路179號",
    "pkey": "014273",
    "tel": "06-9260775"
}, {
    "name": "全家澎湖馬公店",
    "addr": "澎湖縣馬公市重慶街61號",
    "pkey": "017142",
    "tel": "06-9266458"
}, {
    "name": "全家澎湖百利店",
    "addr": "澎湖縣馬公市新店路459號一樓",
    "pkey": "017623",
    "tel": "06-9213717"
}, ], [{
    "name": "全家澎湖外垵店",
    "addr": "澎湖縣西嶼鄉外垵村130號",
    "pkey": "016382",
    "tel": "06-9982869"
}, ], [{
    "name": "全家澎湖望安店",
    "addr": "澎湖縣望安鄉東安村2-13號",
    "pkey": "012984",
    "tel": "06-9991998"
}, ], [{
    "name": "全家澎湖七美店",
    "addr": "澎湖縣七美鄉南港村11鄰26-17號",
    "pkey": "014793",
    "tel": "06-9971863"
}, ], [{
    "name": "全家澎湖吉貝店",
    "addr": "澎湖縣白沙鄉吉貝183-9號",
    "pkey": "010781",
    "tel": "06-9911393"
}, ], [{
    "name": "全家澎湖湖西店",
    "addr": "澎湖縣湖西鄉湖西村湖西65號",
    "pkey": "017551",
    "tel": "06-9923338"
}, ], ], [], [[{
    "name": "全家台中狀元店",
    "addr": "台中市中區中山路19號21號1樓",
    "pkey": "015094",
    "tel": "04-22299329"
}, {
    "name": "全家台中鑫華店",
    "addr": "台中市中區中華路一段152號",
    "pkey": "017182",
    "tel": "04-22259116"
}, {
    "name": "全家台中日新店",
    "addr": "台中市中區中華路一段109號",
    "pkey": "017160",
    "tel": "04-22244999"
}, {
    "name": "全家台中新公園店",
    "addr": "台中市中區公園路19-2號壹樓及地下室",
    "pkey": "017490",
    "tel": "04-22231801"
}, {
    "name": "全家台中新興中店",
    "addr": "台中市中區公園路81號",
    "pkey": "012745",
    "tel": "04-22236602"
}, {
    "name": "全家台中建民店",
    "addr": "台中市中區民族路9號．11號",
    "pkey": "016956",
    "tel": "04-22203630"
}, {
    "name": "全家台中日日新店",
    "addr": "台中市中區民族路216號",
    "pkey": "013773",
    "tel": "04-22235772"
}, {
    "name": "全家台中新市府店",
    "addr": "台中市中區民權路86號",
    "pkey": "017533",
    "tel": "04-22291640"
}, {
    "name": "全家台中成功店",
    "addr": "台中市中區成功路66號",
    "pkey": "012851",
    "tel": "04-22250379"
}, {
    "name": "全家台中繼成店",
    "addr": "台中市中區成功路106號，108號一樓",
    "pkey": "017670",
    "tel": "04-22262519"
}, {
    "name": "全家台中福爾摩店",
    "addr": "台中市中區成功路11號",
    "pkey": "013699",
    "tel": "04-22253375"
}, {
    "name": "全家台中鑫貴店",
    "addr": "臺中市中區自由路二段103號壹樓",
    "pkey": "012920",
    "tel": "04-22232616"
}, ], [{
    "name": "全家台中力行店",
    "addr": "台中市東區力行路212號1樓",
    "pkey": "016185",
    "tel": "04-23602447"
}, {
    "name": "全家台中十甲店",
    "addr": "台中市東區十甲路262號一樓",
    "pkey": "015469",
    "tel": "04-22132931"
}, {
    "name": "全家台中鳳鳴店",
    "addr": "台中市東區大振街31號",
    "pkey": "016426",
    "tel": "04-22808292"
}, {
    "name": "全家台中金自由店",
    "addr": "台中市東區自由路三段95號",
    "pkey": "015495",
    "tel": "04-22136648"
}, {
    "name": "全家台中東英店",
    "addr": "台中市東區旱溪東路一段300號、301號1樓",
    "pkey": "011990",
    "tel": "04-22138121"
}, {
    "name": "全家台中金站二店",
    "addr": "台中市東區和平街119-4號",
    "pkey": "017135",
    "tel": "04-22280086"
}, {
    "name": "全家台中東園店",
    "addr": "台中市東區東光園路536號",
    "pkey": "013717",
    "tel": "04-22154768"
}, {
    "name": "全家台中金東門店",
    "addr": "台中市東區東門路118號",
    "pkey": "015398",
    "tel": "04-22806630"
}, {
    "name": "全家台中新富台店",
    "addr": "台中市東區富台東街72號1樓",
    "pkey": "015173",
    "tel": "04-22132761"
}, {
    "name": "全家台中金站店",
    "addr": "台中市東區復興路四段147號",
    "pkey": "017012",
    "tel": "04-22245956"
}, {
    "name": "全家台中新車頭店",
    "addr": "台中市東區新民街88號",
    "pkey": "015990",
    "tel": "04-22231850"
}, {
    "name": "全家台中長樂店",
    "addr": "台中市東區樂業路342號",
    "pkey": "014263",
    "tel": "04-22134614"
}, ], [{
    "name": "全家台中金大慶店",
    "addr": "台中市南區大慶街二段8號",
    "pkey": "017115",
    "tel": "04-22600280"
}, {
    "name": "全家台中新時代店",
    "addr": "台中市南區工學二街95號一樓",
    "pkey": "016039",
    "tel": "04-22608615"
}, {
    "name": "全家台中進步店",
    "addr": "台中市南區工學北路122號1樓",
    "pkey": "011279",
    "tel": "04-22650685"
}, {
    "name": "全家台中登陽店",
    "addr": "台中市南區文心南路548號",
    "pkey": "017076",
    "tel": "04-22654239"
}, {
    "name": "全家太平新興中店",
    "addr": "台中市太平區永平南路1號",
    "pkey": "017221",
    "tel": "04-22703497"
}, {
    "name": "全家台中忠孝夜店",
    "addr": "台中市南區忠孝路102號",
    "pkey": "017709",
    "tel": "04-22852580"
}, {
    "name": "全家台中大安店",
    "addr": "台中市南區忠明南路730巷23號1樓",
    "pkey": "017290",
    "tel": "04-22603275"
}, {
    "name": "全家台中金獅店",
    "addr": "台中市南區東興路一段16號",
    "pkey": "013438",
    "tel": "04-22633016"
}, {
    "name": "全家台中崇倫店",
    "addr": "台中市南區南屯路一段273號",
    "pkey": "015979",
    "tel": "04-23766132"
}, {
    "name": "全家台中金南門店",
    "addr": "台中市南區南門路57號1F",
    "pkey": "016427",
    "tel": "04-22856435"
}, {
    "name": "全家台中汝川店",
    "addr": "台中市南區建國北路一段110號（汝川醫療大樓B1）",
    "pkey": "015805",
    "tel": "04-24715784"
}, {
    "name": "全家台中新高橋店",
    "addr": "台中市南區建國北路一段250號",
    "pkey": "015645",
    "tel": "04-23726342"
}, {
    "name": "全家台中中山一店",
    "addr": "台中市南區建國北路一段110號",
    "pkey": "016683",
    "tel": "04-24718909"
}, {
    "name": "全家台中帝國店",
    "addr": "台中市南區美村南路153、155號1樓",
    "pkey": "016392",
    "tel": "04-22600448"
}, {
    "name": "全家台中柳川店",
    "addr": "台中市南區美村路二段16號、18號1樓",
    "pkey": "013291",
    "tel": "04-23756530"
}, {
    "name": "全家台中高工店",
    "addr": "台中市南區高工路92號",
    "pkey": "017352",
    "tel": "04-22653734"
}, {
    "name": "全家台中中興二店",
    "addr": "台中市南區國光路250號",
    "pkey": "013965",
    "tel": "04-22856331"
}, {
    "name": "全家台中中興店",
    "addr": "台中市南區國光路250號社管大樓1樓（110室）",
    "pkey": "013630",
    "tel": "04-22850205"
}, {
    "name": "全家台中興美店",
    "addr": "台中市南區復興路二段99巷18號",
    "pkey": "015280",
    "tel": "04-22600991"
}, {
    "name": "全家台中福田店",
    "addr": "台中市南區福田路15號1樓",
    "pkey": "015695",
    "tel": "04-22614416"
}, {
    "name": "全家台中金和店",
    "addr": "台中市南區學府路123號",
    "pkey": "017632",
    "tel": "04-22201810"
}, {
    "name": "全家台中興大店",
    "addr": "台中市南區學府路51號，53號",
    "pkey": "015770",
    "tel": "04-22851742"
}, {
    "name": "全家台中新學府店",
    "addr": "台中市南區學府路168巷2號",
    "pkey": "016737",
    "tel": "04-22206022"
}, ], [{
    "name": "全家台中四維店",
    "addr": "台中市西區三民路一段172—5、172—6號",
    "pkey": "014267",
    "tel": "04-22208900"
}, {
    "name": "全家台中署醫店",
    "addr": "台中市西區三民路一段199號",
    "pkey": "012681",
    "tel": "04-22294799"
}, {
    "name": "全家台中正點店",
    "addr": "臺中市西區三民路一段46號全部",
    "pkey": "016852",
    "tel": "04-23760313"
}, {
    "name": "全家台中精誠店",
    "addr": "台中市西區大業路1號",
    "pkey": "017040",
    "tel": "04-23208160"
}, {
    "name": "全家台中全球店",
    "addr": "台中市西區中華路一段1-59號（全球影城）",
    "pkey": "014176",
    "tel": "04-22255085"
}, {
    "name": "全家台中金五廊店",
    "addr": "台中市西區五廊街6號",
    "pkey": "017600",
    "tel": "04-22249566"
}, {
    "name": "全家台中五權五店",
    "addr": "台中市西區五權五街143號1樓",
    "pkey": "015582",
    "tel": "04-23750622"
}, {
    "name": "全家台中金可店",
    "addr": "台中市西區五權路205號",
    "pkey": "016973",
    "tel": "04-22061722"
}, {
    "name": "全家台中市民店",
    "addr": "台中市西區公正路103號",
    "pkey": "013737",
    "tel": "04-23014035"
}, {
    "name": "全家草悟道店",
    "addr": "台中市西區公益路68號1樓",
    "pkey": "017495",
    "tel": "04-23210721"
}, {
    "name": "全家台中師院店",
    "addr": "台中市西區民權路189號",
    "pkey": "013258",
    "tel": "04-22294029"
}, {
    "name": "全家台中尚美店",
    "addr": "台中市西區向上北路192號．194號1樓",
    "pkey": "012662",
    "tel": "04-23013816"
}, {
    "name": "全家台中向上店",
    "addr": "台中市西區向上路一段36號",
    "pkey": "014243",
    "tel": "04-23017496"
}, {
    "name": "全家台中京華店",
    "addr": "台中市西區西屯路一段156號",
    "pkey": "016649",
    "tel": "04-22022137"
}, {
    "name": "全家台中後龍店",
    "addr": "台中市西區後龍街58號民權路302號",
    "pkey": "003244",
    "tel": "04-23012618"
}, {
    "name": "全家台中鑫美店",
    "addr": "台中市西區美村路一段22號",
    "pkey": "015177",
    "tel": "04-23284015"
}, {
    "name": "全家台中綠園道店",
    "addr": "台中市西區健行路1049號1樓",
    "pkey": "016571",
    "tel": "04-23233938"
}, {
    "name": "全家台中科博館店",
    "addr": "台中市西區博館路117號",
    "pkey": "015380",
    "tel": "04-23297287"
}, {
    "name": "全家台中高昇店",
    "addr": "台中市西區華美街149之1號",
    "pkey": "014313",
    "tel": "04-23015087"
}, {
    "name": "全家台中樂群店",
    "addr": "台中市西區樂群街61之4號",
    "pkey": "015548",
    "tel": "04-23712316"
}, ], [{
    "name": "全家台中一中街店",
    "addr": "台中市北區一中街129號",
    "pkey": "015512",
    "tel": "04-22257909"
}, {
    "name": "全家台中一中讚店",
    "addr": "台中市北區一中街253號1樓",
    "pkey": "016252",
    "tel": "04-22250622"
}, {
    "name": "全家台中一中一店",
    "addr": "台中市北區一中街1號1樓．地下1樓",
    "pkey": "017302",
    "tel": "04-22250678"
}, {
    "name": "全家台中學友店",
    "addr": "台中市北區三民路三段215號",
    "pkey": "017631",
    "tel": "04-22252991"
}, {
    "name": "全家台中嘉勝店",
    "addr": "台中市北區大德街47號壹樓",
    "pkey": "016779",
    "tel": "04-22069198"
}, {
    "name": "全家台中高雅店",
    "addr": "台中市北區中清路一段720號、722號",
    "pkey": "011038",
    "tel": "04-22916368"
}, {
    "name": "全家台中五億店",
    "addr": "臺中市北區五義街132號1樓",
    "pkey": "014398",
    "tel": "04-22077256"
}, {
    "name": "全家台中大功店",
    "addr": "台中市北區公園路146號一樓",
    "pkey": "017318",
    "tel": "04-22064420"
}, {
    "name": "全家台中太陽店",
    "addr": "台中市北區太原路一段450-1號",
    "pkey": "013394",
    "tel": "04-22022098"
}, {
    "name": "全家台中水莊店",
    "addr": "台中市北區文化街13、15、17號1樓",
    "pkey": "015253",
    "tel": "04-22065321"
}, {
    "name": "全家台中北屯店",
    "addr": "台中市北區北屯路45號",
    "pkey": "017033",
    "tel": "04-22332903"
}, {
    "name": "全家台中嘉農店",
    "addr": "台中市北區北平路二段8號",
    "pkey": "015977",
    "tel": "04-22937917"
}, {
    "name": "全家台中育德店",
    "addr": "台中市北區育德路108號，篤行路369號，371號",
    "pkey": "016391",
    "tel": "04-22039666"
}, {
    "name": "全家台中微笑店",
    "addr": "台中市北區育樂街37號1樓",
    "pkey": "016418",
    "tel": "04-22330806"
}, {
    "name": "全家台中東成店",
    "addr": "台中市北區東成路20，22號1號",
    "pkey": "017736",
    "tel": "04-22345768"
}, {
    "name": "全家台中新東義店",
    "addr": "台中市北區青島路一段12號",
    "pkey": "014842",
    "tel": "04-22913297"
}, {
    "name": "全家台中金美德店",
    "addr": "台中市北區美德街184號",
    "pkey": "016588",
    "tel": "04-22070089"
}, {
    "name": "全家台中喜樂店",
    "addr": "台中市北區英才路266號",
    "pkey": "017285",
    "tel": "04-22070206"
}, {
    "name": "全家台中福多店",
    "addr": "台中市北區陜西路63號",
    "pkey": "014966",
    "tel": "04-22929761"
}, {
    "name": "全家台中健興店",
    "addr": "台中市北區健行路786號一樓",
    "pkey": "012369",
    "tel": "04-22085683"
}, {
    "name": "全家台中永興店",
    "addr": "台中市北區健行路375號1F",
    "pkey": "012696",
    "tel": "04-22360356"
}, {
    "name": "全家台中梅亭東店",
    "addr": "台中市北區梅亭東街62號1樓及地下室",
    "pkey": "014871",
    "tel": "04-22372543"
}, {
    "name": "全家台中館東店",
    "addr": "台中市北區博館東街48號1樓",
    "pkey": "015240",
    "tel": "04-23272118"
}, {
    "name": "全家台中一中漾店",
    "addr": "台中市北區尊賢街22-3號1樓、地下1樓",
    "pkey": "016599",
    "tel": "04-22292029"
}, {
    "name": "全家台中新大衛店",
    "addr": "台中市北區進化北路365號1樓之2",
    "pkey": "017263",
    "tel": "04-22025829"
}, {
    "name": "全家台中遠大店",
    "addr": "台中市北區綏遠路一段8號1樓",
    "pkey": "017686",
    "tel": "04-22383593"
}, {
    "name": "全家台中上發店",
    "addr": "台中市北區漢口路三段88號",
    "pkey": "016236",
    "tel": "04-22914739"
}, {
    "name": "全家台中漢文店",
    "addr": "台中市北區漢口路四段57號",
    "pkey": "015875",
    "tel": "04-22928648"
}, {
    "name": "全家台中漢口店",
    "addr": "台中市北區漢口路四段56，58，60號1樓",
    "pkey": "016607",
    "tel": "04-22922475"
}, {
    "name": "全家台中漢強店",
    "addr": "台中市北區漢口路四段284之1號",
    "pkey": "016669",
    "tel": "04-22372241"
}, {
    "name": "全家台中篤行店",
    "addr": "台中市西區篤行路188號",
    "pkey": "015932",
    "tel": "04-22023520"
}, ], [{
    "name": "全家台中興安店",
    "addr": "台中市北屯區大連路三段137號1F",
    "pkey": "015832",
    "tel": "04-22460995"
}, {
    "name": "全家台中山陽店",
    "addr": "台中市北屯區山西路二段222號1樓",
    "pkey": "015320",
    "tel": "04-22910486"
}, {
    "name": "全家台中新大昇店",
    "addr": "台中市北屯區中清路二段1250巷176弄31號",
    "pkey": "016900",
    "tel": "04-24260962"
}, {
    "name": "全家台中中泰店",
    "addr": "台中市北屯區中清路二段409號、411號",
    "pkey": "015766",
    "tel": "04-22956901"
}, {
    "name": "全家台中睿景店",
    "addr": "台中市北屯區太原路三段849號",
    "pkey": "013911",
    "tel": "04-24361805"
}, {
    "name": "全家台中金原店",
    "addr": "台中市北屯區太原路三段231號",
    "pkey": "016878",
    "tel": "04-22383255"
}, {
    "name": "全家台中新太原店",
    "addr": "台中市北屯區太原路三段152號",
    "pkey": "014965",
    "tel": "04-22331756"
}, {
    "name": "全家台中太順店",
    "addr": "台中市北屯區太順路103號",
    "pkey": "017073",
    "tel": "04-24361134"
}, {
    "name": "全家台中梅川東店",
    "addr": "台中市北屯區文心路四段268號",
    "pkey": "016947",
    "tel": "04-22360977"
}, {
    "name": "全家台中大向店",
    "addr": "台中市北屯區北屯路210之3號，210之5號1樓",
    "pkey": "016647",
    "tel": "04-22318703"
}, {
    "name": "全家台中北新店",
    "addr": "台中市北屯區北屯路288號，288之1號",
    "pkey": "017685",
    "tel": "04-22434763"
}, {
    "name": "全家台中四平店",
    "addr": "台中市北屯區四平路35之6號",
    "pkey": "013460",
    "tel": "04-22965197"
}, {
    "name": "全家台中和順店",
    "addr": "台中市北屯區和順路400號",
    "pkey": "014968",
    "tel": "04-24391336"
}, {
    "name": "全家台中仁美店",
    "addr": "台中市北屯區昌平東二路179號1樓",
    "pkey": "015319",
    "tel": "04-24226445"
}, {
    "name": "全家台中水景店",
    "addr": "台中市北屯區東山路196之1號",
    "pkey": "015468",
    "tel": "04-24362774"
}, {
    "name": "全家台中培鶯店",
    "addr": "台中市北屯區東山路二段51-11號",
    "pkey": "012547",
    "tel": "04-22392572"
}, {
    "name": "全家台中東光店",
    "addr": "台中市北屯區東光路886號1樓",
    "pkey": "016100",
    "tel": "04-24360567"
}, {
    "name": "全家台中豐源店",
    "addr": "台中市北屯區松竹北路150號",
    "pkey": "014780",
    "tel": "04-22410563"
}, {
    "name": "全家台中金強店",
    "addr": "台中市北屯區松竹路二段366-1號",
    "pkey": "017167",
    "tel": "04-22474880"
}, {
    "name": "全家台中真義店",
    "addr": "台中市北屯區松義街160號、162號",
    "pkey": "013790",
    "tel": "04-22479532"
}, {
    "name": "全家台中金河店",
    "addr": "台中市北屯區河北路二段98號",
    "pkey": "013212",
    "tel": "04-22345716"
}, {
    "name": "全家台中花見店",
    "addr": "台中市北屯區建和路一段420號",
    "pkey": "014823",
    "tel": "04-24361670"
}, {
    "name": "全家台中軍功店",
    "addr": "台中市北屯區軍功路一段497號、495號1樓",
    "pkey": "014496",
    "tel": "04-24374670"
}, {
    "name": "全家台中英皇店",
    "addr": "台中市北屯區軍福十六路277號",
    "pkey": "015583",
    "tel": "04-24361564"
}, {
    "name": "全家台中昌盛店",
    "addr": "台中市北屯區崇德二路一段257號、259號1樓",
    "pkey": "015409",
    "tel": "04-22479842"
}, {
    "name": "全家台中崇大店",
    "addr": "台中市北屯區崇德路二段276號",
    "pkey": "017319",
    "tel": "04-22477685"
}, {
    "name": "全家台中崇德店",
    "addr": "台中市北屯區崇德路二段351號",
    "pkey": "016559",
    "tel": "04-22429360"
}, {
    "name": "全家台中金頂店",
    "addr": "台中市北屯區部子路351、353號",
    "pkey": "013660",
    "tel": "04-24392609"
}, {
    "name": "全家台中敦化店",
    "addr": "台中市北屯區敦化路一段573號",
    "pkey": "013260",
    "tel": "04-22920301"
}, {
    "name": "全家台中樂樂店",
    "addr": "台中市北屯區熱河路二段119號",
    "pkey": "010905",
    "tel": "04-22365516"
}, {
    "name": "全家台中熱河店",
    "addr": "台中市北屯區熱河路二段164號、166號1樓",
    "pkey": "012279",
    "tel": "04-22438041"
}, {
    "name": "全家台中新崇河店",
    "addr": "台中市北屯區熱河路三段57號1樓",
    "pkey": "017509",
    "tel": "04-22413302"
}, {
    "name": "全家台中鼎安店",
    "addr": "台中市北屯區興安路一段233號",
    "pkey": "017669",
    "tel": "04-22412451"
}, {
    "name": "全家台中松茂店",
    "addr": "台中市北屯區興安路二段461巷2號463號一",
    "pkey": "014778",
    "tel": "04-22473340"
}, {
    "name": "全家台中遼寧店",
    "addr": "台中市北屯區遼寧路一段158號1樓",
    "pkey": "015993",
    "tel": "04-22471695"
}, {
    "name": "全家台中新豐樂店",
    "addr": "台中市北屯區豐樂路7-5號",
    "pkey": "016980",
    "tel": "04-24225917"
}, ], [{
    "name": "全家台中上安店",
    "addr": "台中市西屯區上安路136號一樓",
    "pkey": "016060",
    "tel": "04-24524993"
}, {
    "name": "全家台中福揚店",
    "addr": "台中市西屯區大墩十九街188號",
    "pkey": "016393",
    "tel": "04-23105615"
}, {
    "name": "全家台中樂活店",
    "addr": "台中市西屯區大墩19街18號、20號、22號1樓",
    "pkey": "015281",
    "tel": "04-23271767"
}, {
    "name": "全家台中福和店",
    "addr": "台中市西屯區工業三十八路3號",
    "pkey": "017168",
    "tel": "04-23595806"
}, {
    "name": "全家台中金工店",
    "addr": "台中市西屯區工業區一路98-130號",
    "pkey": "016125",
    "tel": "04-23598407"
}, {
    "name": "全家台中工三店",
    "addr": "台中市西屯區中工三路75號、77號",
    "pkey": "017517",
    "tel": "04-23507237"
}, {
    "name": "全家台中天保店",
    "addr": "台中市西屯區中工三路214之1號、之2號1樓",
    "pkey": "017265",
    "tel": "04-23587991"
}, {
    "name": "全家台中真安店",
    "addr": "台中市西屯區中清西二街79號1樓",
    "pkey": "014779",
    "tel": "04-22994955"
}, {
    "name": "全家台中福大店",
    "addr": "台中市西屯區文華路200號一樓",
    "pkey": "017559",
    "tel": "04-27068872"
}, {
    "name": "全家台中文華店",
    "addr": "台中市西屯區文華路3之3號",
    "pkey": "017266",
    "tel": "04-24514285"
}, {
    "name": "全家台中福氣店",
    "addr": "台中市西屯區文華路105之10號",
    "pkey": "015401",
    "tel": "04-24520407"
}, {
    "name": "全家台中新榮總店",
    "addr": "台中市西屯區台灣大道四段1650號第一醫療大樓1樓",
    "pkey": "014967",
    "tel": "04-23581973"
}, {
    "name": "全家台中金豹店",
    "addr": "台中市西屯區四川一街26號",
    "pkey": "012493",
    "tel": "04-23128382"
}, {
    "name": "全家台中新桂冠店",
    "addr": "台中市西屯區四川路67號",
    "pkey": "015931",
    "tel": "04-23124958"
}, {
    "name": "全家台中豐邑店",
    "addr": "台中市西屯區市政路392號1樓及招牌",
    "pkey": "017573",
    "tel": "04-22540607"
}, {
    "name": "全家台中新福樂店",
    "addr": "台中市西屯區永福路122號1樓",
    "pkey": "014408",
    "tel": "04-24633853"
}, {
    "name": "全家台中惠安店",
    "addr": "台中市西屯區甘肅路一段18號1樓",
    "pkey": "017761",
    "tel": "04-23154623"
}, {
    "name": "全家台中成長店",
    "addr": "台中市西屯區成都路368號",
    "pkey": "014828",
    "tel": "04-22969883"
}, {
    "name": "全家台中至真店",
    "addr": "台中市西屯區至善路236號、238號、234巷1號",
    "pkey": "016608",
    "tel": "04-24527522"
}, {
    "name": "全家台中至善店",
    "addr": "台中市西屯區至善路105號",
    "pkey": "017039",
    "tel": "04-27014306"
}, {
    "name": "全家台中西屯店",
    "addr": "台中市西屯區西屯路二段90之22，23號",
    "pkey": "014492",
    "tel": "04-23179256"
}, {
    "name": "全家台中至尊店",
    "addr": "台中市西屯區西屯路二段268-12，13號",
    "pkey": "013443",
    "tel": "04-27087147"
}, {
    "name": "全家台中豐盛店",
    "addr": "台中市西屯區西屯路二段126-13號126-15號",
    "pkey": "014097",
    "tel": "04-23179406"
}, {
    "name": "全家台中福鄰店",
    "addr": "台中市西屯區西屯路三段166之25號1樓",
    "pkey": "016778",
    "tel": "04-24616177"
}, {
    "name": "全家台中福科店",
    "addr": "台中市西屯區西屯路三段159之80號",
    "pkey": "014723",
    "tel": "04-24615098"
}, {
    "name": "全家台中福美店",
    "addr": "台中市西屯區西安街91號，西屯區烈美街171號1樓",
    "pkey": "013185",
    "tel": "04-27069053"
}, {
    "name": "全家台中河南店",
    "addr": "台中市西屯區河南路二段325號",
    "pkey": "016648",
    "tel": "04-27079502"
}, {
    "name": "全家台中惠慶店",
    "addr": "台中市西屯區河南路二段301巷76號1樓",
    "pkey": "015493",
    "tel": "04-24527462"
}, {
    "name": "全家台中海派店",
    "addr": "台中市西屯區青海南街157號",
    "pkey": "016627",
    "tel": "04-24524792"
}, {
    "name": "全家台中儷晶店",
    "addr": "台中市西屯區青海路二段153號",
    "pkey": "008854",
    "tel": "04-24525281"
}, {
    "name": "全家台中國安一店",
    "addr": "台中市西屯區國安一路169號",
    "pkey": "017609",
    "tel": "04-24610062"
}, {
    "name": "全家台中金航發店",
    "addr": "台中市西屯區逢大路5號",
    "pkey": "016170",
    "tel": "04-24520722"
}, {
    "name": "全家台中藍天店",
    "addr": "台中市西屯區惠來路二段240號1樓",
    "pkey": "016555",
    "tel": "04-22519236"
}, {
    "name": "全家台中朝貴店",
    "addr": "台中市西屯區朝馬路139號、141號，143號一樓",
    "pkey": "015389",
    "tel": "04-22511253"
}, {
    "name": "全家台中朝富店",
    "addr": "台中市西屯區朝富路176號",
    "pkey": "014972",
    "tel": "04-22547347"
}, {
    "name": "全家台中世貿店",
    "addr": "台中市西屯區朝富路18-5號",
    "pkey": "013475",
    "tel": "04-22541296"
}, {
    "name": "全家台中世貿二店",
    "addr": "台中市西屯區朝富路16號．18號",
    "pkey": "015935",
    "tel": "04-22548942"
}, {
    "name": "全家台中新大富店",
    "addr": "台中市西屯區朝富路100號1樓",
    "pkey": "013565",
    "tel": "04-22550091"
}, {
    "name": "全家台中漢翔店",
    "addr": "台中市西屯區漢翔路295號1樓",
    "pkey": "012049",
    "tel": "04-24520234"
}, {
    "name": "全家台中福華店",
    "addr": "台中市西屯區福安路57號",
    "pkey": "014910",
    "tel": "04-24635723"
}, {
    "name": "全家台中好市店",
    "addr": "台中市西屯區福星路330之6號",
    "pkey": "015876",
    "tel": "04-24528914"
}, {
    "name": "全家台中福滿店",
    "addr": "台中市西屯區福星路301號",
    "pkey": "013259",
    "tel": "04-24529228"
}, {
    "name": "全家台中金福星店",
    "addr": "台中市西屯區福星路601號",
    "pkey": "016123",
    "tel": "04-24521858"
}, {
    "name": "全家台中福雅店",
    "addr": "台中市西屯區福雅路693號一樓",
    "pkey": "015933",
    "tel": "04-24632785"
}, {
    "name": "全家台中新福瑞店",
    "addr": "台中市西屯區福瑞街92號",
    "pkey": "012123",
    "tel": "04-24620357"
}, {
    "name": "全家台中新福聯店",
    "addr": "台中市西屯區福聯街23號",
    "pkey": "017528",
    "tel": "04-24621219"
}, {
    "name": "全家台中光明店",
    "addr": "台中市西屯區至善里臺灣大道三段730號",
    "pkey": "014586",
    "tel": "04-27069670"
}, {
    "name": "全家台中登峰店",
    "addr": "台中市西屯區至善里臺灣大道三段660號",
    "pkey": "016003",
    "tel": "04-24523433"
}, {
    "name": "全家台中澄清店",
    "addr": "台中市西屯區福林里臺灣大道四段966號1樓",
    "pkey": "017126",
    "tel": "04-24636832"
}, {
    "name": "全家台中民主店",
    "addr": "台中市西屯區黎明路二段779號",
    "pkey": "016609",
    "tel": "04-22518576"
}, {
    "name": "全家台中八寶店",
    "addr": "台中市西屯區寶慶街42之1號1樓及夾層",
    "pkey": "016332",
    "tel": "04-24522224"
}, {
    "name": "全家台中新惠來店",
    "addr": "台中市西屯區櫻花路129號",
    "pkey": "013091",
    "tel": "04-23155463"
}, ], [{
    "name": "全家台中大英店",
    "addr": "台中市南屯區大業路271號一樓",
    "pkey": "011828",
    "tel": "04-23106077"
}, {
    "name": "全家台中墩鴻店",
    "addr": "台中市南屯區大墩十一街288號、290號一樓",
    "pkey": "015995",
    "tel": "04-23207680"
}, {
    "name": "全家台中傑盛店",
    "addr": "台中市南屯區大墩十一街370號、372號",
    "pkey": "014247",
    "tel": "04-22525201"
}, {
    "name": "全家台中大河店",
    "addr": "台中市南屯區大墩十一街642號",
    "pkey": "016532",
    "tel": "04-22511440"
}, {
    "name": "全家台中墩陽店",
    "addr": "台中市南屯區大墩十七街119號1樓",
    "pkey": "016159",
    "tel": "04-23288661"
}, {
    "name": "全家台中田心店",
    "addr": "台中市南屯區大墩六街261號",
    "pkey": "011908",
    "tel": "04-24734909"
}, {
    "name": "全家台中大鼎店",
    "addr": "台中市南屯區大墩南路332號、336號一樓",
    "pkey": "012885",
    "tel": "04-24731752"
}, {
    "name": "全家台中敦親店",
    "addr": "台中市南屯區大墩路161號",
    "pkey": "016522",
    "tel": "04-24719372"
}, {
    "name": "全家台中十一街店",
    "addr": "台中市南屯區大墩路514號1樓",
    "pkey": "017028",
    "tel": "04-23206248"
}, {
    "name": "全家台中龍富二店",
    "addr": "台中市南屯區五權西路二段1172號",
    "pkey": "017143",
    "tel": "04-23807391"
}, {
    "name": "全家台中嶺南店",
    "addr": "台中市南屯區五權西路三段177號、179號",
    "pkey": "014725",
    "tel": "04-23861284"
}, {
    "name": "全家台中大進店",
    "addr": "台中市南屯區公益路二段39號",
    "pkey": "017291",
    "tel": "04-23192334"
}, {
    "name": "全家台中惠春店",
    "addr": "台中市南屯區公益路二段631號",
    "pkey": "014847",
    "tel": "04-22513414"
}, {
    "name": "全家台中親家店",
    "addr": "台中市南屯區文山八街66號，68號",
    "pkey": "011133",
    "tel": "04-23867500"
}, {
    "name": "全家台中鼎豐店",
    "addr": "台中市南屯區永春東一路719號一樓",
    "pkey": "016080",
    "tel": "04-23809208"
}, {
    "name": "全家台中嶺東店",
    "addr": "台中市南屯區永春南路125號",
    "pkey": "015643",
    "tel": "04-23829243"
}, {
    "name": "全家台中永春店",
    "addr": "台中市南屯區永春路37號",
    "pkey": "011062",
    "tel": "04-23861613"
}, {
    "name": "全家台中金勇店",
    "addr": "台中市南屯區忠勇路71-1號",
    "pkey": "015646",
    "tel": "04-23807836"
}, {
    "name": "全家台中新忠勇店",
    "addr": "台中市南屯區忠勇路76之3號",
    "pkey": "012451",
    "tel": "04-23801003"
}, {
    "name": "全家台中新東二店",
    "addr": "台中市南屯區東興路二段36號1樓",
    "pkey": "015016",
    "tel": "04-24731935"
}, {
    "name": "全家台中東興店",
    "addr": "台中市南屯區東興路二段281，283號1樓",
    "pkey": "016229",
    "tel": "04-24712047"
}, {
    "name": "全家台中惠文店",
    "addr": "台中市南屯區河南路四段326號",
    "pkey": "011630",
    "tel": "04-22584215"
}, {
    "name": "全家台中風華店",
    "addr": "台中市南屯區河南路四段692號一樓",
    "pkey": "015877",
    "tel": "04-23816211"
}, {
    "name": "全家台中金南屯店",
    "addr": "台中市南屯區南屯路二段159號",
    "pkey": "012515",
    "tel": "04-24734538"
}, {
    "name": "全家台中金美店",
    "addr": "台中市南屯區14鄰南屯路二段872號",
    "pkey": "017652",
    "tel": "04-23816217"
}, {
    "name": "全家台中建功店",
    "addr": "台中市南屯區建功路107之38號107之39號1樓",
    "pkey": "010773",
    "tel": "04-23817852"
}, {
    "name": "全家烏日火車頭店",
    "addr": "台中市烏日區高鐵東一路26號2樓",
    "pkey": "017684",
    "tel": "04-23384126"
}, {
    "name": "全家台中林新店",
    "addr": "台中市南屯區惠中路三段36號B棟1F商店2店面",
    "pkey": "015057",
    "tel": "04-22510100"
}, {
    "name": "全家台中惠中店",
    "addr": "台中市南屯區惠中路三段46號、48號、50號",
    "pkey": "004114",
    "tel": "04-23816112"
}, {
    "name": "全家台中圓滿店",
    "addr": "台中市南屯區惠文路499號",
    "pkey": "014032",
    "tel": "04-23808945"
}, {
    "name": "全家台中精密科店",
    "addr": "台中市南屯區精科東路17號B棟2樓",
    "pkey": "016018",
    "tel": "04-23554532"
}, {
    "name": "全家台中楓樹店",
    "addr": "台中市南屯區黎明路一段253號、255號",
    "pkey": "017412",
    "tel": "04-24700620"
}, {
    "name": "全家台中黎明店",
    "addr": "台中市南屯區黎明路二段406號",
    "pkey": "016189",
    "tel": "04-22540498"
}, {
    "name": "全家台中龍富店",
    "addr": "台中市南屯區龍富路四段2號1樓",
    "pkey": "016088",
    "tel": "04-23807235"
}, {
    "name": "全家台中新文山店",
    "addr": "台中市南屯區嶺東路730號",
    "pkey": "016038",
    "tel": "04-23805475"
}, ], [{
    "name": "全家太平東村店",
    "addr": "台中市太平區13鄰東村3街6號、8號",
    "pkey": "017054",
    "tel": "04-22764188"
}, {
    "name": "全家太平新豐年店",
    "addr": "台中市太平區大源十八街1號1樓",
    "pkey": "015410",
    "tel": "04-23936370"
}, {
    "name": "全家太平新興店",
    "addr": "台中市太平區大興11街207號",
    "pkey": "010862",
    "tel": "04-23912018"
}, {
    "name": "全家太平普拉斯店",
    "addr": "台中市太平區大興路127號",
    "pkey": "016920",
    "tel": "04-23937214"
}, {
    "name": "全家太平勤利店",
    "addr": "台中市太平區中山路一段215巷19號",
    "pkey": "015768",
    "tel": "04-23931412"
}, {
    "name": "全家太平水林店",
    "addr": "台中市太平區中山路二段118號，118號之1",
    "pkey": "016308",
    "tel": "04-23915427"
}, {
    "name": "全家太平中華店",
    "addr": "台中市太平區中山路二段441號",
    "pkey": "014896",
    "tel": "04-23936935"
}, {
    "name": "全家太平新凱悅店",
    "addr": "台中市太平區中平九街117號",
    "pkey": "013422",
    "tel": "04-22778617"
}, {
    "name": "全家太平永平店",
    "addr": "台中市太平區永平路一段65號1樓",
    "pkey": "014109",
    "tel": "04-22732879"
}, {
    "name": "全家太平新永成店",
    "addr": "台中市太平區永成北路160號一樓至四樓全部",
    "pkey": "016449",
    "tel": "04-22767929"
}, {
    "name": "全家太平永豐店",
    "addr": "台中市太平區永豐路81號、83號1樓",
    "pkey": "011805",
    "tel": "04-22786202"
}, {
    "name": "全家太平光德店",
    "addr": "台中市太平區光德路101號1樓",
    "pkey": "017781",
    "tel": "04-22712683"
}, {
    "name": "全家太平光興店",
    "addr": "台中市太平區光興路1072號",
    "pkey": "016789",
    "tel": "04-22704228"
}, {
    "name": "全家太平金盛店",
    "addr": "台中市太平區成功東路267號",
    "pkey": "016651",
    "tel": "04-22704717"
}, {
    "name": "全家太平曙光店",
    "addr": "台中市太平區育賢路348號",
    "pkey": "017398",
    "tel": "04-23910543"
}, {
    "name": "全家太平育賢店",
    "addr": "台中市太平區育賢路156號．158號",
    "pkey": "014819",
    "tel": "04-23935507"
}, {
    "name": "全家太平永益店",
    "addr": "台中市太平區長億六街53—27號",
    "pkey": "017277",
    "tel": "04-22774868"
}, {
    "name": "全家太平建興店",
    "addr": "台中市太平區建興路266，268號",
    "pkey": "016368",
    "tel": "04-22762588"
}, {
    "name": "全家太平再福店",
    "addr": "台中市太平區振福路427號．429號．431號",
    "pkey": "015771",
    "tel": "04-23950290"
}, {
    "name": "全家太平新甲店",
    "addr": "台中市太平區新仁路一段42號，44巷2號",
    "pkey": "013888",
    "tel": "04-22736455"
}, {
    "name": "全家太平建昌店",
    "addr": "台中市太平區新平路二段82號1樓",
    "pkey": "017560",
    "tel": "04-22737247"
}, {
    "name": "全家太平新平店",
    "addr": "台中市太平區新平路三段347號",
    "pkey": "014476",
    "tel": "04-23913674"
}, {
    "name": "全家太平育仁店",
    "addr": "台中市太平區新平路三段146號148號150號一樓",
    "pkey": "016958",
    "tel": "04-23912587"
}, {
    "name": "全家太平新福店",
    "addr": "台中市太平區新福路308號",
    "pkey": "015473",
    "tel": "04-23959213"
}, {
    "name": "全家太平廣三店",
    "addr": "台中市太平區廣三街33號",
    "pkey": "016428",
    "tel": "04-23955174"
}, {
    "name": "全家太平樹孝店",
    "addr": "台中市太平區樹孝路109號",
    "pkey": "016309",
    "tel": "04-23938633"
}, {
    "name": "全家太平金城店",
    "addr": "台中市太平區樹德路275號",
    "pkey": "016764",
    "tel": "04-23955137"
}, ], [{
    "name": "全家大里新榮店",
    "addr": "台中市大里區大里路65號",
    "pkey": "016975",
    "tel": "04-24830774"
}, {
    "name": "全家大里新捷勝店",
    "addr": "台中市大里區大明路512號1樓",
    "pkey": "017536",
    "tel": "04-24068605"
}, {
    "name": "全家大里大明店",
    "addr": "台中市大里區大明路168號1樓",
    "pkey": "015242",
    "tel": "04-24870979"
}, {
    "name": "全家大里永勝店",
    "addr": "台中市大里區大明路469號一樓",
    "pkey": "017013",
    "tel": "04-24061062"
}, {
    "name": "全家大里工業店",
    "addr": "台中市大里區工業路94號、96號",
    "pkey": "016689",
    "tel": "04-24918981"
}, {
    "name": "全家大里大發店",
    "addr": "台中市大里區中興路一段109之5號1樓",
    "pkey": "017279",
    "tel": "04-24964207"
}, {
    "name": "全家大里永興店",
    "addr": "台中市大里區中興路二段156號",
    "pkey": "017426",
    "tel": "04-24837840"
}, {
    "name": "全家大里金大發店",
    "addr": "台中市大里區仁化路343-1號",
    "pkey": "015325",
    "tel": "04-24914545"
}, {
    "name": "全家大里內新店",
    "addr": "台中市大里區內新街54，56號1樓",
    "pkey": "012997",
    "tel": "04-24866921"
}, {
    "name": "全家大里新日新店",
    "addr": "台中市大里區日新路586號",
    "pkey": "016482",
    "tel": "04-24833758"
}, {
    "name": "全家大里順發店",
    "addr": "台中市大里區永隆路209號壹樓",
    "pkey": "010459",
    "tel": "04-24069634"
}, {
    "name": "全家大里河堤店",
    "addr": "台中市大里區立中街9號",
    "pkey": "014442",
    "tel": "04-22751784"
}, {
    "name": "全家大里立仁店",
    "addr": "台中市大里區立仁路83號、85號1樓",
    "pkey": "014895",
    "tel": "04-22777327"
}, {
    "name": "全家大里立新店",
    "addr": "台中市大里區立新街321號1樓",
    "pkey": "017465",
    "tel": "04-22754133"
}, {
    "name": "全家大里西湖店",
    "addr": "台中市大里區西湖路337號",
    "pkey": "016481",
    "tel": "04-24962341"
}, {
    "name": "全家大里勝美店",
    "addr": "台中市大里區西榮路68號",
    "pkey": "015323",
    "tel": "04-24834377"
}, {
    "name": "全家大里東芳店",
    "addr": "台中市大里區東南路142之6號1樓",
    "pkey": "014110",
    "tel": "04-24953985"
}, {
    "name": "全家大里大金店",
    "addr": "台中市大里區長春路78巷50號",
    "pkey": "013718",
    "tel": "04-24963848"
}, {
    "name": "全家大里益民店",
    "addr": "台中市大里區益民路二段173號1樓",
    "pkey": "017170",
    "tel": "04-24813483"
}, {
    "name": "全家大里新大益店",
    "addr": "台中市大里區益民路二段35號1樓",
    "pkey": "016006",
    "tel": "04-24832179"
}, {
    "name": "全家大里東益店",
    "addr": "台中市大里區益民路二段280號",
    "pkey": "015326",
    "tel": "04-24820572"
}, {
    "name": "全家大里大功店",
    "addr": "台中市大里區國光路二段38號一樓",
    "pkey": "015386",
    "tel": "04-24821224"
}, {
    "name": "全家大里爽文店",
    "addr": "台中市大里區爽文路870-1號",
    "pkey": "015105",
    "tel": "04-24069756"
}, {
    "name": "全家大里新生店",
    "addr": "台中市大里區現岱路187號．189號1樓",
    "pkey": "017169",
    "tel": "04-24853381"
}, {
    "name": "全家大里善化店",
    "addr": "台中市大里區善化路146號",
    "pkey": "015472",
    "tel": "04-24918213"
}, {
    "name": "全家大里好美店",
    "addr": "台中市大里區塗城路230巷75號及75號之1",
    "pkey": "016253",
    "tel": "04-24962146"
}, {
    "name": "全家大里再發店",
    "addr": "台中市大里區塗城路681號",
    "pkey": "016937",
    "tel": "04-24953738"
}, {
    "name": "全家大里金城店",
    "addr": "台中市大里區塗城路537號",
    "pkey": "017321",
    "tel": "04-24935341"
}, {
    "name": "全家大里新城店",
    "addr": "台中市大里區塗城路291號",
    "pkey": "017351",
    "tel": "04-24935172"
}, {
    "name": "全家大里塗城店",
    "addr": "台中市大里區塗城路742號、744號1樓",
    "pkey": "017323",
    "tel": "04-24930415"
}, {
    "name": "全家大里愛心店",
    "addr": "台中市大里區愛心路75號",
    "pkey": "017471",
    "tel": "04-24067490"
}, {
    "name": "全家大里新光店",
    "addr": "台中市大里區新光路93號",
    "pkey": "015815",
    "tel": "04-24831925"
}, {
    "name": "全家大里新興店",
    "addr": "台中市大里區新興路47號",
    "pkey": "016990",
    "tel": "04-24063642"
}, {
    "name": "全家大里瑞城店",
    "addr": "台中市大里區瑞城一街2號、2-1號1樓",
    "pkey": "015471",
    "tel": "04-24968665"
}, ], [{
    "name": "全家霧峰金來店",
    "addr": "台中市霧峰區中正路803號一樓",
    "pkey": "017035",
    "tel": "04-23397586"
}, {
    "name": "全家霧峰中投店",
    "addr": "台中市霧峰區中投西路二段430號",
    "pkey": "017036",
    "tel": "04-23306848"
}, {
    "name": "全家霧峰五福店",
    "addr": "台中市霧峰區六股路292號",
    "pkey": "014846",
    "tel": "04-23332687"
}, {
    "name": "全家霧峰九德店",
    "addr": "台中市霧峰區四德路204號",
    "pkey": "017451",
    "tel": "04-23396632"
}, {
    "name": "全家霧峰金德店",
    "addr": "台中市霧峰區四德路576號",
    "pkey": "011686",
    "tel": "04-23392762"
}, {
    "name": "全家霧峰新六順店",
    "addr": "台中市霧峰區民生路201號",
    "pkey": "011848",
    "tel": "04-23391863"
}, {
    "name": "全家霧峰吉峰店",
    "addr": "台中市霧峰區民生路353號",
    "pkey": "013896",
    "tel": "04-23396552"
}, {
    "name": "全家霧峰朝科大店",
    "addr": "台中市霧峰區吉峰東路62號",
    "pkey": "015035",
    "tel": "04-23302271"
}, {
    "name": "全家霧峰金亞洲店",
    "addr": "台中市霧峰區南柳村柳豐路368號1樓",
    "pkey": "011289",
    "tel": "04-23309412"
}, {
    "name": "全家霧峰亞洲店",
    "addr": "台中市霧峰區柳豐路466．468號",
    "pkey": "014062",
    "tel": "04-23391650"
}, {
    "name": "全家霧峰新振興店",
    "addr": "台中市霧峰區草湖路49號",
    "pkey": "015056",
    "tel": "04-23303638"
}, {
    "name": "全家霧峰新錦峰店",
    "addr": "台中市霧峰區錦州路331號",
    "pkey": "012672",
    "tel": "04-23309776"
}, ], [{
    "name": "全家烏日高捷店",
    "addr": "台中市烏日區三榮路二段352號",
    "pkey": "016509",
    "tel": "04-23367147"
}, {
    "name": "全家烏日三民店",
    "addr": "台中市烏日區中山路二段220號，三民街136號",
    "pkey": "016103",
    "tel": "04-23382018"
}, {
    "name": "全家烏日成功店",
    "addr": "台中市烏日區中山路三段242-1號、242-2號",
    "pkey": "012887",
    "tel": "04-23365155"
}, {
    "name": "全家烏日新九德店",
    "addr": "台中市烏日區中華路326號",
    "pkey": "015575",
    "tel": "04-23373214"
}, {
    "name": "全家烏日金鴿店",
    "addr": "台中市烏日區五光路95之1號",
    "pkey": "014077",
    "tel": "04-23360452"
}, {
    "name": "全家烏日光日店",
    "addr": "台中市烏日區公園路306號",
    "pkey": "017027",
    "tel": "04-23369013"
}, {
    "name": "全家烏日高鐵店",
    "addr": "台中市烏日區光日路356、358號1樓",
    "pkey": "017070",
    "tel": "04-23387882"
}, {
    "name": "全家烏日新明道店",
    "addr": "台中市烏日區信義街157號",
    "pkey": "013882",
    "tel": "04-23372835"
}, {
    "name": "全家烏日高鐵一店",
    "addr": "臺中市烏日區站區二路8號2F",
    "pkey": "013922",
    "tel": "04-36000075"
}, {
    "name": "全家烏日高鐵二店",
    "addr": "台中市烏日區站區二路8號2樓",
    "pkey": "013923",
    "tel": "04-36000076"
}, {
    "name": "全家烏日快捷店",
    "addr": "台中市烏日區高鐵路一段70號1樓",
    "pkey": "015148",
    "tel": "04-23360842"
}, {
    "name": "全家烏日林新店",
    "addr": "台中市烏日區健行路177號1樓",
    "pkey": "016783",
    "tel": "04-23384645"
}, {
    "name": "全家烏日新溪南店",
    "addr": "台中市烏日區溪南路一段659號",
    "pkey": "012320",
    "tel": "04-23353211"
}, {
    "name": "全家烏日成嶺店",
    "addr": "台中市烏日區學田路719號",
    "pkey": "015279",
    "tel": "04-23383348"
}, ], [{
    "name": "全家豐原社皮店",
    "addr": "台中市豐原區大豐路五段450號1樓",
    "pkey": "015175",
    "tel": "04-25152711"
}, {
    "name": "全家豐原葫蘆墩店",
    "addr": "台中市豐原區中正路693號",
    "pkey": "015675",
    "tel": "04-25295497"
}, {
    "name": "全家豐原新水源店",
    "addr": "台中市豐原區水源路17號",
    "pkey": "012750",
    "tel": "04-25247522"
}, {
    "name": "全家豐原豐富店",
    "addr": "台中市豐原區水源路450-1號",
    "pkey": "016777",
    "tel": "04-25229385"
}, {
    "name": "全家豐原永康店",
    "addr": "台中市豐原區永康路215之1號一樓",
    "pkey": "015055",
    "tel": "04-25201374"
}, {
    "name": "全家豐原甜心店",
    "addr": "台中市豐原區田心路二段271號",
    "pkey": "016932",
    "tel": "04-25298399"
}, {
    "name": "全家豐原互助店",
    "addr": "台中市豐原區西勢路411號1樓",
    "pkey": "013775",
    "tel": "04-25346526"
}, {
    "name": "全家豐原社興店",
    "addr": "台中市豐原區社興五街1號、社興五街3號部份",
    "pkey": "015353",
    "tel": "04-25253429"
}, {
    "name": "全家豐原金美店",
    "addr": "台中市豐原區信義街60號1樓",
    "pkey": "013271",
    "tel": "04-25239760"
}, {
    "name": "全家豐原綠山店",
    "addr": "台中市豐原區南陽路60號一樓",
    "pkey": "014585",
    "tel": "04-25294152"
}, {
    "name": "全家豐原中興店",
    "addr": "台中市豐原區圓環南路76號",
    "pkey": "014096",
    "tel": "04-25263450"
}, {
    "name": "全家豐原榮豐店",
    "addr": "台中市豐原區豐中路79號1F",
    "pkey": "015276",
    "tel": "04-25151901"
}, {
    "name": "全家豐原金旺店",
    "addr": "台中市豐原區豐北街246號",
    "pkey": "016433",
    "tel": "04-25280211"
}, {
    "name": "全家豐原騰偉店",
    "addr": "台中市豐原區豐東路239號",
    "pkey": "014970",
    "tel": "04-25227617"
}, {
    "name": "全家豐原豐東店",
    "addr": "台中市豐原區豐東路122號",
    "pkey": "016933",
    "tel": "04-25294832"
}, {
    "name": "全家豐原豐南店",
    "addr": "台中市豐原區豐南街133號133之1號一樓",
    "pkey": "011837",
    "tel": "04-25200705"
}, {
    "name": "全家豐原大道店",
    "addr": "台中市豐原區北陽里13鄰豐原大道四段293號",
    "pkey": "015947",
    "tel": "04-25241890"
}, {
    "name": "全家豐原太陽店",
    "addr": "台中市豐原區豐陽路109號",
    "pkey": "012810",
    "tel": "04-25291026"
}, {
    "name": "全家豐原金睿店",
    "addr": "台中市豐原區豐勢路一段259號",
    "pkey": "017387",
    "tel": "04-25132799"
}, {
    "name": "全家豐原真樂店",
    "addr": "台中市豐原區豐勢路二段787號",
    "pkey": "016005",
    "tel": "04-25204834"
}, {
    "name": "全家豐原鎌村店",
    "addr": "台中市豐原區鎌村路649號",
    "pkey": "012936",
    "tel": "04-25391802"
}, ], [{
    "name": "全家后里旺安店",
    "addr": "台中市后里區公安路105號一樓",
    "pkey": "017592",
    "tel": "04-25586951"
}, {
    "name": "全家后里文明店",
    "addr": "台中市后里區文明路106號",
    "pkey": "017477",
    "tel": "04-25580098"
}, {
    "name": "全家后里新中興店",
    "addr": "台中市后里區甲后路一段362號",
    "pkey": "013497",
    "tel": "04-25581262"
}, {
    "name": "全家麗寶樂園店",
    "addr": "台中市后里區安眉路115-31號",
    "pkey": "015856",
    "tel": "04-25583161"
}, ], [{
    "name": "全家石岡登峰店",
    "addr": "台中市石岡區明德路179號1樓",
    "pkey": "012163",
    "tel": "04-25724246"
}, {
    "name": "全家石岡鐵馬店",
    "addr": "台中市石岡區豐勢路1103號",
    "pkey": "015872",
    "tel": "04-25724292"
}, ], [{
    "name": "全家東勢客進店",
    "addr": "台中市東勢區中正路1號",
    "pkey": "016101",
    "tel": "04-25880738"
}, {
    "name": "全家東勢東坑店",
    "addr": "台中市東勢區東坑路377號",
    "pkey": "017639",
    "tel": "04-25770076"
}, {
    "name": "全家東勢嶺先店",
    "addr": "台中市東勢區東崎路五段367號1樓",
    "pkey": "016187",
    "tel": "04-25774305"
}, {
    "name": "全家東勢勢林店",
    "addr": "台中市東勢區勢林街230號",
    "pkey": "016237",
    "tel": "04-25881752"
}, {
    "name": "全家東勢豐勢店",
    "addr": "台中市東勢區豐勢路482，484號1，2，3樓",
    "pkey": "014971",
    "tel": "04-25773245"
}, {
    "name": "全家東勢東豐店",
    "addr": "台中市東勢區豐勢路215號．217號1樓",
    "pkey": "015238",
    "tel": "04-25772350"
}, ], [{
    "name": "全家和平梨山店",
    "addr": "台中市和平區中正路88號",
    "pkey": "017353",
    "tel": "04-25980098"
}, {
    "name": "全家和平新谷關店",
    "addr": "台中市和平區東關路一段127-5號",
    "pkey": "012330",
    "tel": "04-25950073"
}, ], [{
    "name": "全家新社新中和店",
    "addr": "台中市新社區東新路二段35號",
    "pkey": "012841",
    "tel": "04-25825185"
}, {
    "name": "全家新社興安店",
    "addr": "台中市新社區興社街四段26之1號一樓",
    "pkey": "011567",
    "tel": "04-25823085"
}, ], [{
    "name": "全家潭子東寶店",
    "addr": "台中市潭子區大富路一段11號1樓",
    "pkey": "016688",
    "tel": "04-25358981"
}, {
    "name": "全家潭子大豐店",
    "addr": "台中市潭子區大豐路三段136號",
    "pkey": "013910",
    "tel": "04-25324851"
}, {
    "name": "全家潭子矽品店",
    "addr": "台中市潭子區中山路三段153號1樓（矽品中山廠）",
    "pkey": "010412",
    "tel": "04-25349128"
}, {
    "name": "全家潭子佳能店",
    "addr": "台中市潭子區北環路9號F棟5樓",
    "pkey": "011261",
    "tel": "04-25343199"
}, {
    "name": "全家潭子祥和店",
    "addr": "台中市潭子區祥和路62號、64號1樓",
    "pkey": "016663",
    "tel": "04-25365465"
}, {
    "name": "全家潭子甘蔗店",
    "addr": "台中市潭子區勝利路289號",
    "pkey": "017512",
    "tel": "04-25359637"
}, {
    "name": "全家潭子新圓通店",
    "addr": "台中市潭子區勝利路58號1樓",
    "pkey": "012305",
    "tel": "04-25343731"
}, {
    "name": "全家潭子真興店",
    "addr": "台中市潭子區復興路一段8號10號12號",
    "pkey": "016935",
    "tel": "04-25368963"
}, {
    "name": "全家潭子摘星店",
    "addr": "台中市潭子區雅豐街323號",
    "pkey": "012304",
    "tel": "04-25343750"
}, {
    "name": "全家潭子大茂店",
    "addr": "台中市潭子區雅豐街78號1樓",
    "pkey": "015797",
    "tel": "04-25352409"
}, {
    "name": "全家潭子金圓通店",
    "addr": "台中市潭子區圓通南路143號一樓",
    "pkey": "015457",
    "tel": "04-25369309"
}, {
    "name": "全家潭子榮興店",
    "addr": "台中市潭子區榮興街57巷1號",
    "pkey": "017510",
    "tel": "04-25351461"
}, {
    "name": "全家潭子潭興店",
    "addr": "台中市潭子區潭興路二段476號1樓",
    "pkey": "015239",
    "tel": "04-25362175"
}, {
    "name": "全家潭子金潭店",
    "addr": "台中市潭子區興華一路261號",
    "pkey": "016716",
    "tel": "04-25359975"
}, {
    "name": "全家潭子頭家店",
    "addr": "台中市潭子區頭張路二段112號",
    "pkey": "013891",
    "tel": "04-25348131"
}, ], [{
    "name": "全家大雅廣福店",
    "addr": "台中市大雅區二鄰中山路47號1樓",
    "pkey": "010297",
    "tel": "04-25681946"
}, {
    "name": "全家大雅好雅店",
    "addr": "台中市大雅區中清東路171號",
    "pkey": "016378",
    "tel": "04-25606984"
}, {
    "name": "全家大雅金交流店",
    "addr": "台中市大雅區中清路三段941號1樓",
    "pkey": "017470",
    "tel": "04-25602565"
}, {
    "name": "全家大雅中科店",
    "addr": "台中市大雅區中清路四段581號",
    "pkey": "012491",
    "tel": "04-25604708"
}, {
    "name": "全家大雅清泉店",
    "addr": "台中市大雅區中清路四段921號1樓",
    "pkey": "016700",
    "tel": "04-25652050"
}, {
    "name": "全家大雅楓林店",
    "addr": "台中市大雅區民生路三段458號",
    "pkey": "013658",
    "tel": "04-25684539"
}, {
    "name": "全家大雅上楓店",
    "addr": "台中市大雅區民生路四段151號一樓",
    "pkey": "014667",
    "tel": "04-25662482"
}, {
    "name": "全家大雅永和店",
    "addr": "台中市大雅區永和路89號1樓",
    "pkey": "015379",
    "tel": "04-25609441"
}, {
    "name": "全家大雅文雅店",
    "addr": "台中市大雅區永和路127-8號",
    "pkey": "016600",
    "tel": "04-25604511"
}, {
    "name": "全家大雅永勝店",
    "addr": "台中市大雅區科雅二路8號1樓",
    "pkey": "017199",
    "tel": "04-25602522"
}, {
    "name": "全家大雅矽品店",
    "addr": "台中市大雅區科雅路19號",
    "pkey": "014117",
    "tel": "04-25674213"
}, {
    "name": "全家大雅好神店",
    "addr": "台中市大雅區神林南路98號",
    "pkey": "016948",
    "tel": "04-25607958"
}, {
    "name": "全家大雅有春店",
    "addr": "台中市大雅區雅潭路四段296號",
    "pkey": "017735",
    "tel": "04-25676469"
}, {
    "name": "全家大雅雅環店",
    "addr": "台中市大雅區大雅村29鄰雅環路二段1，3號1樓",
    "pkey": "015277",
    "tel": "04-25663474"
}, {
    "name": "全家大雅金學府店",
    "addr": "台中市大雅區學府路176-3號",
    "pkey": "012870",
    "tel": "04-25671139"
}, ], [{
    "name": "全家神岡大漢店",
    "addr": "台中市神岡區大漢街72號",
    "pkey": "014583",
    "tel": "04-25206148"
}, {
    "name": "全家神岡工業店",
    "addr": "台中市神岡區中山路1120之2號1120之3",
    "pkey": "014245",
    "tel": "04-25616468"
}, {
    "name": "全家神岡陞灃店",
    "addr": "台中市神岡區中山路517號",
    "pkey": "017511",
    "tel": "04-25631309"
}, {
    "name": "全家神岡新社口店",
    "addr": "台中市神岡區昌平路五段289號",
    "pkey": "010613",
    "tel": "04-25634782"
}, ], [{
    "name": "全家大肚新市鎮店",
    "addr": "台中市大肚區大明三街152號",
    "pkey": "017413",
    "tel": "04-26999622"
}, {
    "name": "全家大肚高山店",
    "addr": "台中市大肚區大德三街38號",
    "pkey": "013123",
    "tel": "04-26993268"
}, {
    "name": "全家大肚大洋店",
    "addr": "台中市大肚區中沙路164巷3弄103號1樓",
    "pkey": "016168",
    "tel": "04-26911903"
}, {
    "name": "全家大肚王田店",
    "addr": "台中市大肚區沙田路一段144-1號",
    "pkey": "016989",
    "tel": "04-26934823"
}, {
    "name": "全家大肚火車頭店",
    "addr": "台中市大肚區沙田路二段771號",
    "pkey": "014726",
    "tel": "04-26990401"
}, {
    "name": "全家大肚瑞功店",
    "addr": "台中市大肚區遊園路一段69-1號",
    "pkey": "014475",
    "tel": "04-26918804"
}, {
    "name": "全家大肚台蔗店",
    "addr": "台中市大肚區遊園路二段2號",
    "pkey": "015103",
    "tel": "04-26912459"
}, ], [{
    "name": "全家沙鹿鑫車店",
    "addr": "台中市沙鹿區中正街48號",
    "pkey": "017127",
    "tel": "04-26628957"
}, {
    "name": "全家沙鹿飛航店",
    "addr": "台中市沙鹿區中清路43之52．53．55．56號",
    "pkey": "015796",
    "tel": "04-26153527"
}, {
    "name": "全家沙鹿靜宜店",
    "addr": "台中市沙鹿區中棲路200號-至善樓",
    "pkey": "015178",
    "tel": "04-26313790"
}, {
    "name": "全家沙鹿北勢東店",
    "addr": "台中市沙鹿區北勢東路646號一樓全部",
    "pkey": "015467",
    "tel": "04-26527983"
}, {
    "name": "全家沙鹿東家店",
    "addr": "台中市沙鹿區北勢東路411-2號",
    "pkey": "013895",
    "tel": "04-26318450"
}, {
    "name": "全家沙鹿英才店",
    "addr": "台中市沙鹿區北勢東路530號1樓",
    "pkey": "014825",
    "tel": "04-26326567"
}, {
    "name": "全家沙鹿弘光店",
    "addr": "台中市沙鹿區北勢東路263號1樓",
    "pkey": "017320",
    "tel": "04-26335938"
}, {
    "name": "全家沙鹿光榮店",
    "addr": "臺中市沙鹿區光華路359號361號",
    "pkey": "016290",
    "tel": "04-26628321"
}, {
    "name": "全家沙鹿金智店",
    "addr": "台中市沙鹿區成功東街42、44、46號",
    "pkey": "016045",
    "tel": "04-26620477"
}, {
    "name": "全家沙鹿大展店",
    "addr": "台中市沙鹿區自強路336號1樓",
    "pkey": "016270",
    "tel": "04-26526030"
}, {
    "name": "全家沙鹿沙田店",
    "addr": "台中市沙鹿區沙田路101號",
    "pkey": "016808",
    "tel": "04-26368565"
}, {
    "name": "全家沙鹿正德店",
    "addr": "台中市沙鹿區屏西路98號",
    "pkey": "013182",
    "tel": "04-26529713"
}, {
    "name": "全家沙鹿興安店",
    "addr": "台中市沙鹿區興安路53之3號",
    "pkey": "017442",
    "tel": "04-26625488"
}, {
    "name": "全家沙鹿鎮南店",
    "addr": "台中市沙鹿區鎮南路二段268號1樓",
    "pkey": "012803",
    "tel": "04-26337539"
}, {
    "name": "全家沙鹿鎮平店",
    "addr": "台中市沙鹿區鎮南路二段95號1樓",
    "pkey": "012536",
    "tel": "04-26362846"
}, ], [{
    "name": "全家龍井龍安店",
    "addr": "台中市龍井區中央路二段273號",
    "pkey": "014753",
    "tel": "04-26398795"
}, {
    "name": "全家龍井龍津店",
    "addr": "台中市龍井區中央路二段33號",
    "pkey": "014246",
    "tel": "04-26304049"
}, {
    "name": "全家龍井沙田店",
    "addr": "台中市龍井區沙田路六段187號",
    "pkey": "015413",
    "tel": "04-26367163"
}, {
    "name": "全家龍井茄投店",
    "addr": "台中市龍井區茄投路67之1號",
    "pkey": "014519",
    "tel": "04-26308407"
}, {
    "name": "全家龍井龍后店",
    "addr": "台中市龍井區新興路21號1樓",
    "pkey": "015573",
    "tel": "04-26522061"
}, {
    "name": "全家龍井新庄店",
    "addr": "台中市龍井區新興路224號1樓",
    "pkey": "015772",
    "tel": "04-26520796"
}, {
    "name": "全家龍井龍盈店",
    "addr": "台中市龍井區新興路49巷2號",
    "pkey": "016040",
    "tel": "04-26318790"
}, {
    "name": "全家龍井海大店",
    "addr": "台中市龍井區新興路東興巷46號、48號、50號",
    "pkey": "017450",
    "tel": "04-26312703"
}, {
    "name": "全家龍井遊園北店",
    "addr": "台中市龍井區遊園北路443號",
    "pkey": "017238",
    "tel": "04-26314971"
}, {
    "name": "全家龍井學園店",
    "addr": "台中市龍井區遊園南路297號",
    "pkey": "014912",
    "tel": "04-26521590"
}, {
    "name": "全家龍井新文勝店",
    "addr": "台中市龍井區臺灣大道五段3巷62弄49號",
    "pkey": "013313",
    "tel": "04-26319793"
}, {
    "name": "全家龍井龍山店",
    "addr": "台中市龍井區龍山街85號",
    "pkey": "016379",
    "tel": "04-26361524"
}, {
    "name": "全家龍井大火力店",
    "addr": "台中市龍井區龍昌路10號",
    "pkey": "013563",
    "tel": "04-26392523"
}, {
    "name": "全家龍井龍勝店",
    "addr": "台中市龍井區龍社路439號",
    "pkey": "014178",
    "tel": "04-26528249"
}, {
    "name": "全家龍井藝術店",
    "addr": "台中市龍井區10鄰藝術街92號1樓",
    "pkey": "015647",
    "tel": "04-26318703"
}, ], [{
    "name": "全家梧棲中和店",
    "addr": "台中市梧棲區中和街1號1樓",
    "pkey": "015547",
    "tel": "04-26568141"
}, {
    "name": "全家梧棲金牌店",
    "addr": "台中市梧棲區中華路一段1001號",
    "pkey": "017003",
    "tel": "04-26560358"
}, {
    "name": "全家梧棲海王子店",
    "addr": "台中市梧棲區四維路104號",
    "pkey": "017200",
    "tel": "04-26580706"
}, {
    "name": "全家梧棲正港店",
    "addr": "台中市梧棲區民生街61號一樓",
    "pkey": "013437",
    "tel": "04-26569265"
}, {
    "name": "全家梧棲自強店",
    "addr": "台中市梧棲區自強一街132號．134號",
    "pkey": "015423",
    "tel": "04-26392391"
}, {
    "name": "全家梧棲港埠店",
    "addr": "台中市梧棲區港埠路二段17號",
    "pkey": "013459",
    "tel": "04-26584770"
}, {
    "name": "全家梧棲大庄店",
    "addr": "台中市梧棲區大庄里臺灣大道八段506號1樓",
    "pkey": "015176",
    "tel": "04-26564091"
}, {
    "name": "全家梧棲金泰店",
    "addr": "台中市梧棲區臨港路三段9號",
    "pkey": "014617",
    "tel": "04-26392326"
}, ], [{
    "name": "全家清水中山店",
    "addr": "台中市清水區中山路110號",
    "pkey": "015470",
    "tel": "04-26221679"
}, {
    "name": "全家清水榮玉店",
    "addr": "台中市清水區中正街79號",
    "pkey": "013506",
    "tel": "04-26224952"
}, {
    "name": "全家清水德光店",
    "addr": "台中市清水區中清路九段442號",
    "pkey": "016767",
    "tel": "04-26268265"
}, {
    "name": "全家清水必成店",
    "addr": "台中市清水區民和路二段199號",
    "pkey": "015681",
    "tel": "04-26566100"
}, {
    "name": "全家清水高美店",
    "addr": "台中市清水區高美路560號1樓",
    "pkey": "016855",
    "tel": "04-26112405"
}, {
    "name": "全家清水好美店",
    "addr": "台中市清水區高美路308-1號",
    "pkey": "016853",
    "tel": "04-26261265"
}, {
    "name": "全家清水米糕店",
    "addr": "臺中市清水區新興路119號",
    "pkey": "012050",
    "tel": "04-26222901"
}, ], [{
    "name": "全家大甲鐵山店",
    "addr": "台中市大甲區中山路一段1549號",
    "pkey": "015599",
    "tel": "04-26804208"
}, {
    "name": "全家大甲水源店",
    "addr": "台中市大甲區水源路450號",
    "pkey": "014547",
    "tel": "04-26761668"
}, {
    "name": "全家大甲甲中店",
    "addr": "台中市大甲區水源路1號",
    "pkey": "017508",
    "tel": "04-26764822"
}, {
    "name": "全家大甲金雁店",
    "addr": "台中市大甲區信義路308號",
    "pkey": "016965",
    "tel": "04-26803407"
}, {
    "name": "全家大甲車頭店",
    "addr": "台中市大甲區蔣公路2號1樓",
    "pkey": "016665",
    "tel": "04-26760418"
}, {
    "name": "全家大甲甲讚店",
    "addr": "台中市大甲區蔣公路173號",
    "pkey": "016094",
    "tel": "04-26803391"
}, ], [{
    "name": "全家外埔皇后店",
    "addr": "台中市外埔區六分路237號1樓",
    "pkey": "017688",
    "tel": "04-26837583"
}, {
    "name": "全家外埔國王店",
    "addr": "台中市外埔區甲后路757之1號一樓",
    "pkey": "011338",
    "tel": "04-26804324"
}, ], [{
    "name": "全家大安海墘店",
    "addr": "台中市大安區大安港路1021號",
    "pkey": "017733",
    "tel": "04-26800086"
}, {
    "name": "全家大安全盈店",
    "addr": "台中市大安區中山南路334號1樓",
    "pkey": "013912",
    "tel": "04-26714756"
}, ], ], [[{
    "name": "全家彰化新三民店",
    "addr": "彰化縣彰化市三民路270號",
    "pkey": "017516",
    "tel": "04-7280542"
}, {
    "name": "全家彰化山中美店",
    "addr": "彰化縣彰化市山中街96號",
    "pkey": "017472",
    "tel": "04-7387141"
}, {
    "name": "全家彰化漢銘店",
    "addr": "彰化縣彰化市中山路一段366號",
    "pkey": "011968",
    "tel": "04-7138069"
}, {
    "name": "全家彰化大通店",
    "addr": "彰化縣彰化市中山路一段117之3號1F",
    "pkey": "015150",
    "tel": "04-7511811"
}, {
    "name": "全家彰化建台店",
    "addr": "彰化縣彰化市中興路103-8號1樓",
    "pkey": "015388",
    "tel": "04-7113410"
}, {
    "name": "全家彰化建國店",
    "addr": "彰化縣彰化市介壽北路1號．美育館1樓",
    "pkey": "015327",
    "tel": "04-7112631"
}, {
    "name": "全家彰化再安店",
    "addr": "彰化縣彰化市介壽南路16號、18號1樓",
    "pkey": "017515",
    "tel": "04-7114746"
}, {
    "name": "全家彰化八卦山店",
    "addr": "彰化縣彰化市公園路一段46號",
    "pkey": "015497",
    "tel": "04-7270402"
}, {
    "name": "全家彰化新天祥店",
    "addr": "彰化縣彰化市四維路69巷2號",
    "pkey": "016936",
    "tel": "04-7627152"
}, {
    "name": "全家彰化鐵皮店",
    "addr": "彰化縣彰化市平和十四街67號",
    "pkey": "017388",
    "tel": "04-7511950"
}, {
    "name": "全家彰化新再旺店",
    "addr": "彰化縣彰化市民族路439號",
    "pkey": "017083",
    "tel": "04-7289800"
}, {
    "name": "全家彰化自強店",
    "addr": "彰化縣彰化市自強南路61號一樓",
    "pkey": "015241",
    "tel": "04-7278997"
}, {
    "name": "全家彰化彰興店",
    "addr": "彰化縣彰化市延平路5號",
    "pkey": "017443",
    "tel": "04-7114730"
}, {
    "name": "全家彰化林森店",
    "addr": "彰化縣彰化市林森路197，199，201號",
    "pkey": "013662",
    "tel": "04-7638790"
}, {
    "name": "全家彰化再興店",
    "addr": "彰化縣彰化市南郭路一段191巷16號",
    "pkey": "014288",
    "tel": "04-7201278"
}, {
    "name": "全家彰化金泰店",
    "addr": "彰化縣彰化市泰和路一段182號1樓",
    "pkey": "016641",
    "tel": "04-7227346"
}, {
    "name": "全家彰化金平店",
    "addr": "彰化縣彰化市崙平北路108號",
    "pkey": "016857",
    "tel": "04-7616972"
}, {
    "name": "全家彰化新彰基店",
    "addr": "彰化縣彰化市博愛街101號1樓",
    "pkey": "014843",
    "tel": "04-7287141"
}, {
    "name": "全家彰化金師店",
    "addr": "彰化縣彰化市進德路27號壹樓",
    "pkey": "011316",
    "tel": "04-7289817"
}, {
    "name": "全家彰化順風店",
    "addr": "彰化縣彰化市實踐路48號",
    "pkey": "014816",
    "tel": "04-7289313"
}, {
    "name": "全家彰化香山店",
    "addr": "彰化縣彰化市彰南路二段352號1樓",
    "pkey": "016291",
    "tel": "04-7384385"
}, {
    "name": "全家彰化彰南店",
    "addr": "彰化縣彰化市彰南路三段302號、304號",
    "pkey": "012031",
    "tel": "04-7374666"
}, {
    "name": "全家彰化金馬店",
    "addr": "彰化縣彰化市彰馬路246之1號",
    "pkey": "012561",
    "tel": "04-7624805"
}, {
    "name": "全家彰化線東店",
    "addr": "彰化縣彰化市線東路一段567號",
    "pkey": "016273",
    "tel": "04-7635121"
}, ], [{
    "name": "全家芬園金馬店",
    "addr": "彰化縣芬園鄉信義路5號",
    "pkey": "016782",
    "tel": "0492510284"
}, ], [{
    "name": "全家花壇正花店",
    "addr": "彰化縣花壇鄉中山路一段380號",
    "pkey": "016292",
    "tel": "04-7867840"
}, {
    "name": "全家花壇金花店",
    "addr": "彰化縣花壇鄉中正路356號壹樓",
    "pkey": "013498",
    "tel": "04-7860631"
}, ], [{
    "name": "全家秀水金興店",
    "addr": "彰化縣秀水鄉番花路297號右17",
    "pkey": "016255",
    "tel": "04-7686346"
}, {
    "name": "全家秀水好水店",
    "addr": "彰化縣秀水鄉福安村22鄰彰水路二段628號",
    "pkey": "013742",
    "tel": "04-7689103"
}, ], [{
    "name": "全家鹿港車站店",
    "addr": "彰化縣鹿港鎮民權路202號",
    "pkey": "012081",
    "tel": "04-7740452"
}, {
    "name": "全家鹿港媽祖店",
    "addr": "彰化縣鹿港鎮光復路臨85號",
    "pkey": "017075",
    "tel": "04-7782548"
}, {
    "name": "全家鹿港天后店",
    "addr": "彰化縣鹿港鎮後寮巷92號1樓",
    "pkey": "015282",
    "tel": "04-7754523"
}, {
    "name": "全家鹿港祥園店",
    "addr": "彰化縣鹿港鎮海浴路208-1號1樓",
    "pkey": "015616",
    "tel": "04-7772617"
}, {
    "name": "全家鹿港柑仔店",
    "addr": "彰化縣鹿港鎮鹿和路三段423號",
    "pkey": "017237",
    "tel": "04-7719430"
}, {
    "name": "全家鹿港金寶店",
    "addr": "彰化縣鹿港鎮鹿和路四段10號",
    "pkey": "014399",
    "tel": "04-7720101"
}, {
    "name": "全家鹿港富麗店",
    "addr": "彰化縣鹿港鎮鹿東路二段541號",
    "pkey": "016628",
    "tel": "04-7787891"
}, {
    "name": "全家鹿港鹿鼎店",
    "addr": "彰化縣鹿港鎮鹿草路四段409號一樓",
    "pkey": "012059",
    "tel": "04-7712161"
}, ], [{
    "name": "全家福興福鹿店",
    "addr": "彰化縣福興鄉復興路120號",
    "pkey": "013208",
    "tel": "04-7773653"
}, {
    "name": "全家福興番花店",
    "addr": "彰化縣福興鄉番花路一段853號",
    "pkey": "014187",
    "tel": "04-7795343"
}, {
    "name": "全家福興福利店",
    "addr": "彰化縣福興鄉萬豐村彰水路50、52號1樓",
    "pkey": "016618",
    "tel": "04-7697552"
}, ], [{
    "name": "全家彰化線西店",
    "addr": "彰化縣線西鄉線西村中央路二段418號1樓",
    "pkey": "015693",
    "tel": "04-7589308"
}, ], [{
    "name": "全家和美金美店",
    "addr": "彰化縣和美鎮和厝路一段臨216號",
    "pkey": "013440",
    "tel": "04-7567100"
}, {
    "name": "全家和美德美店",
    "addr": "彰化縣和美鎮美寮路二段557號1樓",
    "pkey": "015102",
    "tel": "04-7556549"
}, {
    "name": "全家和美頂美店",
    "addr": "彰化縣和美鎮美寮路二段2號1樓",
    "pkey": "011838",
    "tel": "04-7350643"
}, {
    "name": "全家和美金好雅店",
    "addr": "彰化縣和美鎮鹿和路五段188巷3號",
    "pkey": "015912",
    "tel": "04-7556320"
}, {
    "name": "全家和美八大店",
    "addr": "彰化縣和美鎮鹿和路六段310號",
    "pkey": "017082",
    "tel": "04-7563372"
}, {
    "name": "全家和美家美店",
    "addr": "彰化縣和美鎮嘉佃路8號一樓",
    "pkey": "012060",
    "tel": "04-7636905"
}, {
    "name": "全家和美永美店",
    "addr": "彰化縣和美鎮彰新路二段163號",
    "pkey": "016188",
    "tel": "04-7359141"
}, {
    "name": "全家和美新矽品店",
    "addr": "彰化縣和美鎮彰新路二段8號",
    "pkey": "013560",
    "tel": "04-7350647"
}, {
    "name": "全家和美雙美店",
    "addr": "彰化縣和美鎮糖東1街21號、23號1樓",
    "pkey": "015329",
    "tel": "04-7366041"
}, ], [{
    "name": "全家伸港雙興店",
    "addr": "彰化縣伸港鄉七嘉村中華路463號一樓",
    "pkey": "011072",
    "tel": "04-7987049"
}, {
    "name": "全家伸港上旺店",
    "addr": "彰化縣伸港鄉大同村中興路二段317號1樓",
    "pkey": "010898",
    "tel": "04-7987095"
}, {
    "name": "全家伸港新港店",
    "addr": "彰化縣伸港鄉新港路308號",
    "pkey": "014452",
    "tel": "04-7987553"
}, {
    "name": "全家伸港新全興店",
    "addr": "彰化縣伸港鄉興工路736號",
    "pkey": "012216",
    "tel": "04-7989532"
}, ], [{
    "name": "全家員林正新店",
    "addr": "彰化縣員林市三民東街350號",
    "pkey": "012271",
    "tel": "04-8360774"
}, {
    "name": "全家員林大仁店",
    "addr": "彰化縣員林市大同路二段179號",
    "pkey": "017069",
    "tel": "04-8392979"
}, {
    "name": "全家員林新員山店",
    "addr": "彰化縣員林市山腳路三段臨269號",
    "pkey": "016887",
    "tel": "04-8367235"
}, {
    "name": "全家員林僑信店",
    "addr": "彰化縣員林市中山路二段281號1樓及地下室",
    "pkey": "016271",
    "tel": "04-8396842"
}, {
    "name": "全家員林富城店",
    "addr": "彰化縣員林市育英路24號",
    "pkey": "017513",
    "tel": "04-8334347"
}, {
    "name": "全家員林新育英店",
    "addr": "彰化縣員林市育英路106號",
    "pkey": "017738",
    "tel": "04-8334117"
}, {
    "name": "全家員林榮城店",
    "addr": "彰化縣員林市南平街188號",
    "pkey": "017496",
    "tel": "04-8339424"
}, {
    "name": "全家員林金牌店",
    "addr": "彰化縣員林市南昌路135號",
    "pkey": "017146",
    "tel": "04-8336323"
}, {
    "name": "全家員林黎明店",
    "addr": "彰化縣員林市員大路一段75號",
    "pkey": "014000",
    "tel": "04-8338536"
}, {
    "name": "全家員林新員農店",
    "addr": "彰化縣員林市員水路二段320號",
    "pkey": "016997",
    "tel": "04-8331925"
}, {
    "name": "全家員林安迪店",
    "addr": "彰化縣員林市員集路二段82號",
    "pkey": "013609",
    "tel": "04-8336605"
}, {
    "name": "全家員林金三橋店",
    "addr": "彰化縣員林市浮圳路二段168號",
    "pkey": "014315",
    "tel": "04-8334544"
}, {
    "name": "全家員林員基店",
    "addr": "彰化縣員林市莒光路456號",
    "pkey": "014150",
    "tel": "04-8394122"
}, {
    "name": "全家員林金萬年店",
    "addr": "彰化縣員林市萬年巷51之10號",
    "pkey": "014520",
    "tel": "04-8333271"
}, {
    "name": "全家員林車頭店",
    "addr": "彰化縣員林市28鄰靜修路52-1號",
    "pkey": "011798",
    "tel": "04-8396162"
}, {
    "name": "全家員林學友店",
    "addr": "彰化縣員林市靜修路74—12號",
    "pkey": "017633",
    "tel": "04-8371411"
}, ], [{
    "name": "全家社頭山腳店",
    "addr": "彰化縣社頭鄉山腳路四段183號",
    "pkey": "016381",
    "tel": "04-8713762"
}, {
    "name": "全家社頭金蟹店",
    "addr": "彰化縣社頭鄉中興路82號",
    "pkey": "010699",
    "tel": "04-8712664"
}, ], [{
    "name": "全家永靖永安店",
    "addr": "彰化縣永靖鄉中山路一段869號",
    "pkey": "015322",
    "tel": "04-8231800"
}, {
    "name": "全家永靖頂旺店",
    "addr": "彰化縣永靖鄉永福路一段157號1樓。2樓",
    "pkey": "017183",
    "tel": "04-8232751"
}, {
    "name": "全家永靖永興店",
    "addr": "彰化縣永靖鄉永興路三段臨50號",
    "pkey": "014845",
    "tel": "04-8234128"
}, ], [{
    "name": "全家埔心署醫店",
    "addr": "彰化縣埔心鄉舊館村中興路35號",
    "pkey": "016272",
    "tel": "04-8284693"
}, ], [{
    "name": "全家溪湖大發店",
    "addr": "彰化縣溪湖鎮大發路73號",
    "pkey": "013253",
    "tel": "04-8851667"
}, {
    "name": "全家彰化溪湖店",
    "addr": "彰化縣溪湖鎮大溪路二段404號",
    "pkey": "016008",
    "tel": "04-8817134"
}, {
    "name": "全家溪湖大竹店",
    "addr": "彰化縣溪湖鎮西環路243號245號一樓",
    "pkey": "011278",
    "tel": "04-8816507"
}, {
    "name": "全家溪湖再發店",
    "addr": "彰化縣溪湖鎮崙子腳路122號",
    "pkey": "012739",
    "tel": "04-8817290"
}, {
    "name": "全家溪湖雙溪店",
    "addr": "彰化縣溪湖鎮彰水路二段745號1樓",
    "pkey": "003564",
    "tel": "04-8851178"
}, ], [{
    "name": "全家大村寶山店",
    "addr": "彰化縣大村鄉山腳路98-20號",
    "pkey": "013093",
    "tel": "04-8525206"
}, {
    "name": "全家大村寶村店",
    "addr": "彰化縣大村鄉山腳路75-7號",
    "pkey": "013840",
    "tel": "04-8534456"
}, {
    "name": "全家彰化大村店",
    "addr": "彰化縣大村鄉中山路二段313號及中正西路1號",
    "pkey": "013822",
    "tel": "04-8539678"
}, {
    "name": "全家大村美港店",
    "addr": "彰化縣大村鄉美港路51號",
    "pkey": "015015",
    "tel": "04-8526080"
}, {
    "name": "全家大村茄苳店",
    "addr": "彰化縣大村鄉茄苳路二段2號",
    "pkey": "017611",
    "tel": "04-8521170"
}, ], [{
    "name": "全家田中金田店",
    "addr": "彰化縣田中鎮中州路一段76號一樓",
    "pkey": "015615",
    "tel": "04-8747821"
}, {
    "name": "全家田中金斗店",
    "addr": "彰化縣田中鎮斗中路一段232號",
    "pkey": "015600",
    "tel": "04-8748349"
}, {
    "name": "全家田中雙田店",
    "addr": "彰化縣田中鎮民族街2號1樓",
    "pkey": "015835",
    "tel": "04-8744418"
}, {
    "name": "全家田中新生店",
    "addr": "彰化縣田中鎮員集路二段566號",
    "pkey": "015278",
    "tel": "04-8748424"
}, {
    "name": "全家彰化高鐵店",
    "addr": "彰化縣田中鎮站區路二段99號",
    "pkey": "016996",
    "tel": "04-7009155"
}, ], [{
    "name": "全家北斗七星店",
    "addr": "彰化縣北斗鎮斗中路921號",
    "pkey": "017401",
    "tel": "04-8780886"
}, {
    "name": "全家北斗寶斗店",
    "addr": "彰化縣北斗鎮斗苑路一段193號",
    "pkey": "017399",
    "tel": "04-8872120"
}, ], [{
    "name": "全家田尾金園店",
    "addr": "彰化縣田尾鄉中山路一段577號",
    "pkey": "017463",
    "tel": "04-8837329"
}, ], [{
    "name": "全家埤頭大豐店",
    "addr": "彰化縣埤頭鄉斗苑東路2之5號",
    "pkey": "014225",
    "tel": "04-8876901"
}, {
    "name": "全家埤頭金農店",
    "addr": "彰化縣埤頭鄉彰水路三段265號",
    "pkey": "015132",
    "tel": "04-8924389"
}, ], [{
    "name": "全家溪州明道店",
    "addr": "彰化縣溪州鄉中央路三段225之6號1樓",
    "pkey": "016595",
    "tel": "04-8897642"
}, ], [{
    "name": "全家二林原斗店",
    "addr": "彰化縣二林鎮斗苑路二段6號",
    "pkey": "014298",
    "tel": "04-8901566"
}, {
    "name": "全家二林斗苑店",
    "addr": "彰化縣二林鎮斗苑路四段299號",
    "pkey": "010863",
    "tel": "04-8955612"
}, ], [{
    "name": "全家大城大功店",
    "addr": "彰化縣大城鄉大城村中平路8號",
    "pkey": "014533",
    "tel": "04-8944450"
}, ], [{
    "name": "全家芳苑寶成店",
    "addr": "彰化縣芳苑鄉三合村14鄰斗苑路三合段100號",
    "pkey": "017535",
    "tel": "04-8962501"
}, {
    "name": "全家芳苑王功店",
    "addr": "彰化縣芳苑鄉芳漢路王功段535號",
    "pkey": "015783",
    "tel": "04-8932205"
}, ], ], [[{
    "name": "全家南投新村店",
    "addr": "南投縣南投市中正路330之6號、之11號一樓",
    "pkey": "015521",
    "tel": "0492339180"
}, {
    "name": "全家南投光明店",
    "addr": "南投縣南投市中興路227號1樓",
    "pkey": "014973",
    "tel": "0492312857"
}, {
    "name": "全家南投金袋店",
    "addr": "南投縣南投市育樂路99號1樓",
    "pkey": "016520",
    "tel": "0492246829"
}, {
    "name": "全家南投南崗店",
    "addr": "南投縣南投市南崗二路403號一樓",
    "pkey": "017154",
    "tel": "0492202035"
}, {
    "name": "全家南投康金店",
    "addr": "南投縣南投市復興路342號",
    "pkey": "016521",
    "tel": "0492247360"
}, {
    "name": "全家南投署醫店",
    "addr": "南投縣南投市復興路478號",
    "pkey": "015359",
    "tel": "0492240220"
}, {
    "name": "全家南投車站店",
    "addr": "南投縣南投市復興路121號",
    "pkey": "017850",
    "tel": "0492242638"
}, {
    "name": "全家南投永順店",
    "addr": "南投縣南投市彰南路二段360號1樓及地下室",
    "pkey": "016650",
    "tel": "0492246582"
}, {
    "name": "全家南投仁和店",
    "addr": "南投縣南投市彰南路三段53號",
    "pkey": "017780",
    "tel": "0492252545"
}, {
    "name": "全家南投新中興店",
    "addr": "南投縣南投市學藝路3號",
    "pkey": "017005",
    "tel": "0492390012"
}, ], [{
    "name": "全家南投中寮店",
    "addr": "南投縣中寮鄉永安街98號",
    "pkey": "013868",
    "tel": "0492692671"
}, ], [{
    "name": "全家草屯同安店",
    "addr": "南投縣草屯鎮中山街247號",
    "pkey": "014132",
    "tel": "0492354555"
}, {
    "name": "全家草屯中正店",
    "addr": "南投縣草屯鎮中正路836號",
    "pkey": "017462",
    "tel": "0492304751"
}, {
    "name": "全家草屯雙冬店",
    "addr": "南投縣草屯鎮中正路43之43號",
    "pkey": "014199",
    "tel": "0492572861"
}, {
    "name": "全家草屯南開店",
    "addr": "南投縣草屯鎮中正路568號",
    "pkey": "016140",
    "tel": "0492568946"
}, {
    "name": "全家草屯稻豐店",
    "addr": "南投縣草屯鎮中正路1573號",
    "pkey": "017389",
    "tel": "0492307992"
}, {
    "name": "全家草屯金安全店",
    "addr": "南投縣草屯鎮中和路100號",
    "pkey": "015696",
    "tel": "0492565781"
}, {
    "name": "全家草屯敦和店",
    "addr": "南投縣草屯鎮仁愛街89號",
    "pkey": "015385",
    "tel": "0492313291"
}, {
    "name": "全家草屯太平店",
    "addr": "南投縣草屯鎮太平路一段498號",
    "pkey": "013013",
    "tel": "0492393238"
}, {
    "name": "全家草屯佑民店",
    "addr": "南投縣草屯鎮正興街78號",
    "pkey": "012823",
    "tel": "0492392916"
}, {
    "name": "全家草屯東寶店",
    "addr": "南投縣草屯鎮虎山路766號1樓",
    "pkey": "012093",
    "tel": "0492322734"
}, {
    "name": "全家草屯草狀元店",
    "addr": "南投縣草屯鎮草溪路605號1樓",
    "pkey": "016856",
    "tel": "0492312947"
}, {
    "name": "全家草屯金安店",
    "addr": "南投縣草屯鎮御富路218號",
    "pkey": "015321",
    "tel": "0492569945"
}, {
    "name": "全家草屯金昌店",
    "addr": "南投縣草屯鎮富林路一段320號",
    "pkey": "013999",
    "tel": "0492560184"
}, ], [{
    "name": "全家國姓水長流店",
    "addr": "南投縣國姓鄉長流村大長路577-17號",
    "pkey": "016786",
    "tel": "0492432846"
}, ], [{
    "name": "全家埔里安德店",
    "addr": "南投縣埔里鎮八德路38號",
    "pkey": "017322",
    "tel": "0492420684"
}, {
    "name": "全家埔里埔榮店",
    "addr": "南投縣埔里鎮中山路一段237之7號1樓",
    "pkey": "012168",
    "tel": "0492900366"
}, {
    "name": "全家埔里愛埔店",
    "addr": "南投縣埔里鎮中山路四段87號",
    "pkey": "016227",
    "tel": "0492917636"
}, {
    "name": "全家埔里東榮店",
    "addr": "南投縣埔里鎮中正路376號",
    "pkey": "017610",
    "tel": "0492994966"
}, {
    "name": "全家埔里新東興店",
    "addr": "南投縣埔里鎮中正路204號",
    "pkey": "017215",
    "tel": "0492987628"
}, {
    "name": "全家埔里金車店",
    "addr": "南投縣埔里鎮中正路534號",
    "pkey": "015211",
    "tel": "0492996831"
}, {
    "name": "全家埔里籃城店",
    "addr": "南投縣埔里鎮中正路981號",
    "pkey": "016787",
    "tel": "0492912500"
}, {
    "name": "全家埔里水頭店",
    "addr": "南投縣埔里鎮中正路160號",
    "pkey": "015857",
    "tel": "0492420783"
}, {
    "name": "全家埔里枇杷店",
    "addr": "南投縣埔里鎮中華路1-1號1樓",
    "pkey": "017213",
    "tel": "0492986650"
}, {
    "name": "全家埔里泰安店",
    "addr": "南投縣埔里鎮中華路170號1樓",
    "pkey": "012782",
    "tel": "0492903672"
}, {
    "name": "全家埔里埔大店",
    "addr": "南投縣埔里鎮民生路146號",
    "pkey": "015328",
    "tel": "0492906026"
}, {
    "name": "全家埔里牛埔店",
    "addr": "南投縣埔里鎮西安路二段90號",
    "pkey": "014653",
    "tel": "0492932897"
}, {
    "name": "全家埔里大坪頂店",
    "addr": "南投縣埔里鎮西安路三段286號一樓",
    "pkey": "015748",
    "tel": "0492933067"
}, {
    "name": "全家埔里高工店",
    "addr": "南投縣埔里鎮和平東路431號",
    "pkey": "013582",
    "tel": "0492999423"
}, {
    "name": "全家埔里金牛店",
    "addr": "南投縣埔里鎮桃米路23-7號",
    "pkey": "014518",
    "tel": "0492915827"
}, {
    "name": "全家埔里九龍店",
    "addr": "南投縣埔里鎮隆生路71號",
    "pkey": "015498",
    "tel": "0492996297"
}, {
    "name": "全家埔里鐵山店",
    "addr": "南投縣埔里鎮鐵山路9號．9-1號",
    "pkey": "013397",
    "tel": "0492916873"
}, {
    "name": "全家埔里埔基店",
    "addr": "南投縣埔里鎮鐵山路1-2號",
    "pkey": "011767",
    "tel": "0492915116"
}, ], [{
    "name": "全家仁愛賽德克店",
    "addr": "南投縣仁愛鄉南豐村中正路87-1號",
    "pkey": "015301",
    "tel": "0492920748"
}, {
    "name": "全家仁愛高山青店",
    "addr": "南投縣仁愛鄉大同村信義巷34之6號",
    "pkey": "017267",
    "tel": "0492803863"
}, ], [{
    "name": "全家名間松柏店",
    "addr": "南投縣名間鄉松山村名松路二段167號",
    "pkey": "016041",
    "tel": "0492583284"
}, {
    "name": "全家名間金交流店",
    "addr": "南投縣名間鄉彰南路243號",
    "pkey": "012198",
    "tel": "0492731964"
}, ], [{
    "name": "全家集集金集店",
    "addr": "南投縣集集鎮民生路69號",
    "pkey": "013696",
    "tel": "0492760170"
}, ], [{
    "name": "全家魚池水沙連店",
    "addr": "南投縣魚池鄉魚池村魚池街322號1、2樓",
    "pkey": "014818",
    "tel": "0492899432"
}, {
    "name": "全家魚池伊達邵店",
    "addr": "南投縣魚池鄉義勇街55號",
    "pkey": "013122",
    "tel": "0492850405"
}, ], [{
    "name": "全家竹山前山店",
    "addr": "南投縣竹山鎮大明路461號",
    "pkey": "016785",
    "tel": "0492632088"
}, {
    "name": "全家竹山金竹店",
    "addr": "南投縣竹山鎮竹山路1-6-2號",
    "pkey": "014655",
    "tel": "0492652785"
}, {
    "name": "全家竹山金溪店",
    "addr": "南投縣竹山鎮東鄉路5之73號1樓",
    "pkey": "016335",
    "tel": "0492653787"
}, {
    "name": "全家竹山紫南宮店",
    "addr": "南投縣竹山鎮集山路一段1637號",
    "pkey": "017145",
    "tel": "0492624966"
}, {
    "name": "全家竹山延和店",
    "addr": "南投縣竹山鎮集山路三段542號",
    "pkey": "014815",
    "tel": "0492630859"
}, {
    "name": "全家竹山夯蕃薯店",
    "addr": "南投縣竹山鎮集山路三段129號",
    "pkey": "017400",
    "tel": "0492657267"
}, ], [{
    "name": "全家鹿谷農會店",
    "addr": "南投縣鹿谷鄉中正路二段77號",
    "pkey": "014880",
    "tel": "0492750417"
}, {
    "name": "全家鹿谷溪頭店",
    "addr": "南投縣鹿谷鄉興產路2之3號1樓",
    "pkey": "016228",
    "tel": "0492612677"
}, ], ], ];

export default {
    area_city,
    area_district,
    area_store
}